var _style, _g, _g2, _g3, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g4, _line, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g5, _g6, _g7, _path62, _g8, _g9, _g0, _polygon2, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g1, _line2, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _g10, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _line3, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _g11, _g12, _path165, _path166, _path167, _path168, _g13, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _g14, _path183, _g15, _path184, _g16, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _g17, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _g18, _line4, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _g19, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _g20, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _line5, _line6, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _g21, _g22, _path305, _g23, _path306, _path307, _g24, _path308, _path309, _path310, _g25, _g26, _path311, _path312, _path313, _g27, _g28, _line7, _path314, _path315, _path316, _g29, _g30, _g31, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _g32, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _g33, _path344, _line8, _line9, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _g34, _g35, _path361, _path362, _path363, _path364, _g36, _g37, _path365, _g38, _path366, _path367, _g39, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _g40, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _g41, _path397, _line0, _line1, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _g42, _g43, _path414, _path415, _path416, _path417, _g44, _g45, _path418, _g46, _path419, _path420, _g47, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _g48, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _g49, _path450, _line10, _line11, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _g50, _g51, _path467, _path468, _path469, _path470, _g52, _g53, _path471, _g54, _g55, _g56, _g57, _polygon3, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _g58, _line12, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _g59, _g60, _g61, _path535;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1669 1200",
    style: {
      enableBackground: "new 0 0 1669 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#F0F1FC;stroke-width:1.0983;stroke-miterlimit:10;}\r\n\t.st1{opacity:0.1;fill:#37A000;enable-background:new    ;}\r\n\t.st2{fill:#686868;}\r\n\t.st3{fill:#B8E59E;}\r\n\t\r\n\t\t.st4{opacity:0.45;fill:none;stroke:#000000;stroke-width:0.5492;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{opacity:0.54;fill:#37A000;}\r\n\t.st6{fill:#37A000;}\r\n\t.st7{opacity:0.21;fill:#37A000;}\r\n\t.st8{opacity:0.25;fill:#37A000;}\r\n\t.st9{opacity:0.25;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{fill:#A8A8A8;}\r\n\t.st12{fill:url(#SVGID_1_);}\r\n\t.st13{fill:#2A246D;}\r\n\t.st14{fill:#565388;}\r\n\t.st15{fill:url(#SVGID_2_);}\r\n\t.st16{fill:#A66477;}\r\n\t.st17{fill:#7679B4;}\r\n\t.st18{fill:#A2A2F4;}\r\n\t.st19{fill:url(#SVGID_3_);}\r\n\t\r\n\t\t.st20{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5492;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st21{fill:url(#SVGID_4_);}\r\n\t.st22{fill:#CED2DF;}\r\n\t.st23{fill:#EBF1F6;}\r\n\t.st24{fill:url(#SVGID_5_);}\r\n\t.st25{fill:#565387;}\r\n\t.st26{fill:#444176;}\r\n\t.st27{fill:url(#SVGID_6_);}\r\n\t.st28{fill:url(#SVGID_7_);}\r\n\t.st29{fill:none;stroke:#FFFFFF;stroke-width:0.5492;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st30{fill:none;stroke:#FFFFFF;stroke-width:0.5492;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2.2059,2.2059;}\r\n\t\r\n\t\t.st31{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5492;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:2.1967;}\r\n\t.st32{opacity:0.25;fill:#FFFFFF;}\r\n\t.st33{fill:#88455E;}\r\n\t.st34{fill:url(#SVGID_8_);}\r\n\t.st35{fill:#493545;}\r\n\t.st36{fill:#3E3D77;}\r\n\t.st37{fill:#FFAAC4;}\r\n\t.st38{fill:url(#SVGID_9_);}\r\n\t.st39{fill:url(#SVGID_10_);}\r\n\t.st40{fill:url(#SVGID_11_);}\r\n\t.st41{fill:none;stroke:#2A246D;stroke-width:0.2746;stroke-miterlimit:10;}\r\n\t.st42{fill:none;stroke:#37A000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st43{fill:#F0F1FC;}\r\n\t.st44{fill:#8785C9;}\r\n\t.st45{fill:#E0DEFA;}\r\n\t.st46{fill:#C0BDF0;}\r\n\t.st47{fill:#B1ACE9;}\r\n\t.st48{fill:url(#SVGID_12_);}\r\n\t.st49{fill:url(#SVGID_13_);}\r\n\t.st50{fill:#04074A;}\r\n\t.st51{fill:#6752FF;}\r\n\t.st52{fill:url(#SVGID_14_);}\r\n\t.st53{fill:url(#SVGID_15_);}\r\n\t.st54{fill:url(#SVGID_16_);}\r\n\t.st55{fill:url(#SVGID_17_);}\r\n\t.st56{fill:#FFC200;}\r\n\t.st57{fill:url(#SVGID_18_);}\r\n\t.st58{fill:url(#SVGID_19_);}\r\n\t.st59{fill:url(#SVGID_20_);}\r\n\t.st60{fill:url(#SVGID_21_);}\r\n\t.st61{fill:url(#SVGID_22_);}\r\n\t.st62{fill:none;stroke:#FFFFFF;stroke-width:0.5492;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2.1734,2.1734;}\r\n\t.st63{fill:url(#SVGID_23_);}\r\n\t.st64{fill:#F4A531;}\r\n\t.st65{fill:url(#SVGID_24_);}\r\n\t.st66{fill:url(#SVGID_25_);}\r\n\t.st67{fill:url(#SVGID_26_);}\r\n\t.st68{fill:url(#SVGID_27_);}\r\n\t.st69{fill:url(#SVGID_28_);}\r\n\t.st70{fill:none;stroke:#BFBBEF;stroke-width:1.0983;stroke-miterlimit:10;}\r\n\t.st71{fill:#817BD4;}\r\n\t.st72{fill:#CECBFE;}\r\n\t.st73{fill:none;stroke:#817BD4;stroke-width:1.3729;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st74{fill:url(#SVGID_29_);}\r\n\t.st75{fill:url(#SVGID_30_);}\r\n\t\r\n\t\t.st76{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5514;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st77{fill:url(#SVGID_31_);}\r\n\t.st78{fill:url(#SVGID_32_);}\r\n\t.st79{fill:url(#SVGID_33_);}\r\n\t.st80{fill:url(#SVGID_34_);}\r\n\t\r\n\t\t.st81{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5092;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:1.7822;}\r\n\t.st82{fill:url(#SVGID_35_);}\r\n\t.st83{fill:url(#SVGID_36_);}\r\n\t.st84{fill:#4D3DFF;}\r\n\t.st85{fill:url(#SVGID_37_);}\r\n\t.st86{fill:#7367C9;}\r\n\t.st87{fill:#1B1A5B;}\r\n\t.st88{fill:url(#SVGID_38_);}\r\n\t.st89{fill:url(#SVGID_39_);}\r\n\t.st90{fill:url(#SVGID_40_);}\r\n\t.st91{fill:url(#SVGID_41_);}\r\n\t\r\n\t\t.st92{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5092;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st93{fill:url(#SVGID_42_);}\r\n\t.st94{fill:url(#SVGID_43_);}\r\n\t\r\n\t\t.st95{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5173;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st96{fill:url(#SVGID_44_);}\r\n\t.st97{fill:url(#SVGID_45_);}\r\n\t.st98{fill:url(#SVGID_46_);}\r\n\t.st99{fill:url(#SVGID_47_);}\r\n\t.st100{fill:url(#SVGID_48_);}\r\n\t.st101{fill:url(#SVGID_49_);}\r\n\t.st102{fill:url(#SVGID_50_);}\r\n\t.st103{fill:url(#SVGID_51_);}\r\n\t.st104{fill:url(#SVGID_52_);}\r\n\t\r\n\t\t.st105{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4921;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st106{fill:none;stroke:#FFFFFF;stroke-width:0.4921;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st107{fill:none;stroke:#FFFFFF;stroke-width:0.4921;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.7411,1.7411;}\r\n\t\r\n\t\t.st108{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4921;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:1.7223;}\r\n\t.st109{fill:url(#SVGID_53_);}\r\n\t.st110{fill:url(#SVGID_54_);}\r\n\t.st111{fill:url(#SVGID_55_);}\r\n\t.st112{fill:url(#SVGID_56_);}\r\n\t.st113{fill:url(#SVGID_57_);}\r\n\t.st114{fill:url(#SVGID_58_);}\r\n\t.st115{fill:url(#SVGID_59_);}\r\n\t.st116{fill:url(#SVGID_60_);}\r\n\t\r\n\t\t.st117{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5946;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st118{fill:url(#SVGID_61_);}\r\n\t.st119{fill:url(#SVGID_62_);}\r\n\t.st120{fill:url(#SVGID_63_);}\r\n\t.st121{fill:url(#SVGID_64_);}\r\n\t.st122{fill:url(#SVGID_65_);}\r\n\t.st123{fill:url(#SVGID_66_);}\r\n\t.st124{fill:url(#SVGID_67_);}\r\n\t\r\n\t\t.st125{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4465;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st126{fill:url(#SVGID_68_);}\r\n\t.st127{fill:url(#SVGID_69_);}\r\n\t.st128{fill:none;stroke:#F0F1FC;stroke-width:0.2232;stroke-miterlimit:10;}\r\n\t.st129{fill:none;stroke:#000000;stroke-width:0.2232;stroke-miterlimit:10;}\r\n\t.st130{fill:url(#SVGID_70_);}\r\n\t.st131{fill:url(#SVGID_71_);}\r\n\t.st132{fill:url(#SVGID_72_);}\r\n\t.st133{fill:none;}\r\n\t\r\n\t\t.st134{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4465;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:1.5627;}\r\n\t\r\n\t\t.st135{opacity:0.45;fill:none;stroke:#000000;stroke-width:0.4465;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st136{opacity:0.2;fill:#37A000;}\r\n\t.st137{fill:#EBF6E6;}\r\n\t.st138{fill:#3D9902;}\r\n\t.st139{fill:#D6D3D3;}\r\n\t.st140{fill:#F4F2F2;}\r\n\t.st141{fill:#785298;}\r\n\t.st142{fill:#FF7B5B;}\r\n\t.st143{fill:#F2A682;}\r\n\t.st144{fill:#112129;}\r\n\t.st145{fill:#22343D;}\r\n\t.st146{fill:#FFC5B1;}\r\n\t.st147{fill:#745360;}\r\n\t.st148{fill:#FFB19F;}\r\n\t.st149{fill:#FFA091;}\r\n\t.st150{fill:#654286;}\r\n\t.st151{fill:#5B5974;}\r\n\t.st152{fill:#EEFFF3;}\r\n\t.st153{fill:#68B480;}\r\n\t.st154{fill:none;stroke:#BABB87;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st155{fill:#519F8D;}\r\n\t.st156{fill:#192A40;}\r\n\t.st157{fill:#6DCC88;}\r\n\t.st158{fill:url(#SVGID_73_);}\r\n\t.st159{fill:url(#SVGID_74_);}\r\n\t.st160{fill:url(#SVGID_75_);}\r\n\t.st161{opacity:0.99;}\r\n\t.st162{fill:url(#SVGID_76_);}\r\n\t.st163{fill:url(#SVGID_77_);}\r\n\t.st164{fill:url(#SVGID_78_);}\r\n\t.st165{fill:url(#SVGID_79_);}\r\n\t.st166{fill:url(#SVGID_80_);}\r\n\t.st167{fill:url(#SVGID_81_);}\r\n\t.st168{fill:#98EDAF;}\r\n\t.st169{fill:#BAF4C4;}\r\n\t.st170{fill:#AAF2BB;}\r\n\t.st171{opacity:0.25;fill:#68B480;}\r\n\t.st172{fill:#D4F4C3;}\r\n\t.st173{opacity:0.25;fill:#D4F4C3;}\r\n\t.st174{fill:url(#SVGID_82_);}\r\n\t.st175{fill:url(#SVGID_83_);}\r\n\t.st176{fill:url(#SVGID_84_);}\r\n\t.st177{fill:url(#SVGID_85_);}\r\n\t.st178{fill:url(#SVGID_86_);}\r\n\t.st179{fill:url(#SVGID_87_);}\r\n\t.st180{fill:url(#SVGID_88_);}\r\n\t.st181{fill:url(#SVGID_89_);}\r\n\t.st182{fill:url(#SVGID_90_);}\r\n\t\r\n\t\t.st183{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.5946;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st184{fill:url(#SVGID_91_);}\r\n\t.st185{fill:url(#SVGID_92_);}\r\n\t.st186{fill:url(#SVGID_93_);}\r\n\t.st187{fill:url(#SVGID_94_);}\r\n\t.st188{fill:url(#SVGID_95_);}\r\n\t.st189{fill:url(#SVGID_96_);}\r\n\t\r\n\t\t.st190{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4465;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st191{fill:url(#SVGID_97_);}\r\n\t.st192{fill:url(#SVGID_98_);}\r\n\t.st193{fill:url(#SVGID_99_);}\r\n\t\r\n\t\t.st194{opacity:0.25;fill:none;stroke:#FFFFFF;stroke-width:0.4465;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:1.5627;enable-background:new    ;}\r\n\t\r\n\t\t.st195{opacity:0.45;fill:none;stroke:#000000;stroke-width:0.4465;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st196{opacity:0.25;enable-background:new    ;}\r\n\t.st197{opacity:0.25;fill:#68B480;enable-background:new    ;}\r\n\t.st198{opacity:0.25;fill:#D4F4C3;enable-background:new    ;}\r\n\t.st199{opacity:0.25;fill:#B8E59E;}\r\n\t.st200{fill:url(#SVGID_100_);}\r\n\t.st201{fill:url(#SVGID_101_);}\r\n\t.st202{fill:url(#SVGID_102_);}\r\n\t.st203{fill:url(#SVGID_103_);}\r\n\t.st204{fill:url(#SVGID_104_);}\r\n\t.st205{fill:url(#SVGID_105_);}\r\n\t.st206{fill:url(#SVGID_106_);}\r\n\t.st207{fill:url(#SVGID_107_);}\r\n\t.st208{fill:url(#SVGID_108_);}\r\n\t.st209{fill:url(#SVGID_109_);}\r\n\t.st210{fill:url(#SVGID_110_);}\r\n\t.st211{fill:none;stroke:#37A000;stroke-width:1.0983;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.4,1015.3c0,0,605.3-756.2,737.3-807c132-50.8,595.6,473.3,392.2,739.2S121.4,1015.3,121.4,1015.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,1040.3L100,1040.3c0-33.9,16.3-65.6,43.8-85.4L946,378.3c49.7-35.7,119.2-21.7,151.1,30.5L1450,985.4 c42.9,70.1-7.5,160.1-89.7,160.1H205.2C147.1,1145.5,100,1098.4,100,1040.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1474,
    y: 1105,
    className: "st2",
    width: 25.6,
    height: 40.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1569.8,
    y: 1102.1,
    className: "st2",
    width: 25.6,
    height: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1113.7,
    y: 1094.1,
    className: "st2",
    width: 25.6,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1209.5,
    y: 1090.5,
    className: "st2",
    width: 25.6,
    height: 54.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1483.1,751.7c-6.5,39.2-20.9,96.2-28.7,126.1c-3.2,12.4-5.4,20.1-5.4,20.1l-2.4,3.1l-55.5,72.6h-127.7 c0,0-1.4-42.7-1.3-93c0-4.4,0-8.8,0.1-13.3c0.6-65.2,4.2-137.6,17-144.4c23.8-12.8,190.3-20.5,204.6-12.8c0.4,0.2,0.8,0.6,1.1,1.1 C1487.8,715.7,1486.5,731.3,1483.1,751.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1296.1,
    y1: 770.6,
    x2: 1305.8,
    y2: 780.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1305.8,
    y1: 770.6,
    x2: 1296.1,
    y2: 780.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1336,
    y1: 770.6,
    x2: 1345.7,
    y2: 780.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1345.7,
    y1: 770.6,
    x2: 1336,
    y2: 780.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1376,
    y1: 770.6,
    x2: 1385.7,
    y2: 780.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1385.7,
    y1: 770.6,
    x2: 1376,
    y2: 780.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1415.9,
    y1: 770.6,
    x2: 1425.6,
    y2: 780.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1425.6,
    y1: 770.6,
    x2: 1415.9,
    y2: 780.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1293.8,
    y1: 809,
    x2: 1303.5,
    y2: 818.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1303.5,
    y1: 809,
    x2: 1293.8,
    y2: 818.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1333.7,
    y1: 809,
    x2: 1343.4,
    y2: 818.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1343.4,
    y1: 809,
    x2: 1333.7,
    y2: 818.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1373.7,
    y1: 809,
    x2: 1383.4,
    y2: 818.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1383.4,
    y1: 809,
    x2: 1373.7,
    y2: 818.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1413.6,
    y1: 809,
    x2: 1423.3,
    y2: 818.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1423.3,
    y1: 809,
    x2: 1413.6,
    y2: 818.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1291.5,
    y1: 847.4,
    x2: 1301.2,
    y2: 857.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1301.2,
    y1: 847.4,
    x2: 1291.5,
    y2: 857.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1331.4,
    y1: 847.4,
    x2: 1341.2,
    y2: 857.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1341.2,
    y1: 847.4,
    x2: 1331.4,
    y2: 857.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1371.4,
    y1: 847.4,
    x2: 1381.1,
    y2: 857.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1381.1,
    y1: 847.4,
    x2: 1371.4,
    y2: 857.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1411.3,
    y1: 847.4,
    x2: 1421.1,
    y2: 857.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1421.1,
    y1: 847.4,
    x2: 1411.3,
    y2: 857.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1289.2,
    y1: 885.7,
    x2: 1298.9,
    y2: 895.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1298.9,
    y1: 885.7,
    x2: 1289.2,
    y2: 895.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1338.9,
    y1: 885.7,
    x2: 1329.2,
    y2: 895.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1329.2,
    y1: 885.7,
    x2: 1338.9,
    y2: 895.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1369.1,
    y1: 885.7,
    x2: 1378.8,
    y2: 895.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1378.8,
    y1: 885.7,
    x2: 1369.1,
    y2: 895.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1409.1,
    y1: 885.7,
    x2: 1418.8,
    y2: 895.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1418.8,
    y1: 885.7,
    x2: 1409.1,
    y2: 895.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1286.9,
    y1: 924.1,
    x2: 1296.7,
    y2: 933.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1296.7,
    y1: 924.1,
    x2: 1286.9,
    y2: 933.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1326.9,
    y1: 924.1,
    x2: 1336.6,
    y2: 933.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1336.6,
    y1: 924.1,
    x2: 1326.9,
    y2: 933.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1366.8,
    y1: 924.1,
    x2: 1376.6,
    y2: 933.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1376.6,
    y1: 924.1,
    x2: 1366.8,
    y2: 933.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1406.8,
    y1: 924.1,
    x2: 1416.5,
    y2: 933.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1416.5,
    y1: 924.1,
    x2: 1406.8,
    y2: 933.8
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1551.9,886.4c-10-1.9-20.8,1-30.3,6c-12.9,6.7-23.3,17.3-26.5,24.9c-0.8,1.9-1.9,5.4-3.3,10.1 c-12,41.7-42.7,179.9-42.7,179.9s-71.1-0.1-150.7-1.5c-102.4-1.8-218.8-5.9-216.8-14.8c3.4-14.9,28.2-156.9,70.2-198.8 c2.5-2.5,5.1-4.7,7.8-6.4c39.3-25.8,88-20.7,102.7-18.4c-0.1,4.5-0.1,8.9-0.1,13.3c-51.9,5.6-65.1,66.9-68.4,103.9 c-1.3,14.8-1,25.7-0.9,27.6c0,0.2,0,0.3,0,0.3h171.3c0,0,3.7-17.5,10.2-38.9c8.1-26.8,20.4-59.8,35-72.2 c13.1-11.2,27.1-18.3,41-22.6c1.3-0.4,2.6-0.8,4-1.1c25.7-6.9,51.1-4.4,71,0.3C1536,880.6,1545.1,883.7,1551.9,886.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1606.8,1102.8l-157.8,4.5c0,0,38.1-171,46-190c5.5-13.2,33.2-35.3,56.8-30.9c4.7,0.9,9.2,2.8,13.3,6 c0,0,0,0,0,0c5,3.9,9.5,9.6,13.1,17.8C1600,959.4,1606.8,1102.8,1606.8,1102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1525.4,878.1c-20-4.7-45.4-7.2-71-0.3c11.9-45.5,38.8-153.5,30.6-166.6c15.5,3.2,57.3,14.4,62.4,42.8 C1551.1,774.7,1537.3,833.6,1525.4,878.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1374.4,973.7c-6.5,21.4-10.2,38.9-10.2,38.9h-171.3c0,0,0-0.1,0-0.3c20.4-17.6,70.6-38.6,70.6-38.6H1374.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1263.4,973.7c0,0-50.2,21-70.6,38.6c-0.2-6.8-3.3-123.8,69.3-131.5c0-4.4,0-8.8,0.1-13.3L1263.4,973.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1263,974l223.5-238.3c0,0-29.5,138.3-32.5,142.3s-36,74-36,74l-44,22H1263z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M258.2,976c0,0,6.5-51.7,33.3-73.2c26.8-21.4,28.6-54.7,28.6-54.7s36.3,126.1-10.1,149.3 C263.6,1020.6,258.2,976,258.2,976z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M320.1,848.2c0,0,12.5,111.2-56.2,163.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M246.3,384.5c0,0-67,218.4-16.3,406.7c50.8,188.4-19,257.6-19,257.6l52.8-53c0,0,22.5-166.8,17-251.5 l-17-8.6l17.8-15.1C281.7,720.6,234.8,525.8,246.3,384.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M246.3,384.5c-5.3,25-9.4,50.2-12.9,75.4c-3.4,25.3-6.2,50.6-8,76.1c-3.6,50.8-4,102.1,2.4,152.8 c0.4,3.2,0.8,6.3,1.3,9.5l1.5,9.4c1,6.3,2.1,12.6,3.2,18.9l1.6,9.4l1.5,9.4c1,6.3,2.1,12.6,3,18.9c4,25.2,7.4,50.5,10,75.9 c0.4,3.2,0.6,6.3,0.9,9.5l0.8,9.5c0.5,6.4,0.9,12.7,1.3,19.1l0.4,9.6c0.1,3.2,0.3,6.4,0.3,9.6c0.1,6.4,0.3,12.8,0.1,19.1 c-0.1,12.8-0.9,25.5-2,38.2l-1,9.5c-0.3,3.2-0.8,6.3-1.3,9.5l-0.7,4.7c-0.2,1.6-0.5,3.1-0.8,4.7l-1.6,9.4c0,0.1-0.2,0.3-0.3,0.2 c-0.1,0-0.3-0.2-0.2-0.3v0l0,0l1.6-9.4c0.3-1.6,0.6-3.1,0.8-4.7l0.7-4.7c0.4-3.2,0.9-6.3,1.3-9.5l1-9.5 c1.2-12.7,2-25.4,2.1-38.2c0.2-6.4,0-12.7-0.1-19.1c0-3.2-0.2-6.4-0.3-9.6l-0.4-9.6c-0.4-6.4-0.8-12.7-1.3-19.1l-0.8-9.5 c-0.3-3.2-0.5-6.4-0.9-9.5c-2.6-25.4-6-50.7-10-75.9c-0.9-6.3-2-12.6-3-18.9l-1.5-9.4l-1.6-9.4c-1.1-6.3-2.2-12.6-3.2-18.9 l-1.5-9.5c-0.5-3.1-0.8-6.3-1.3-9.5c-6.4-50.7-5.9-102-2.3-152.8c1.8-25.4,4.6-50.8,8.1-76.1 C236.9,434.7,241.1,409.5,246.3,384.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249.9,995.9c0,0,14.3-134-12.7-186.4h-17.4l10.3-18.2c0,0-56.3-123.3-214.1-171.5c0,0,99.5,65.8,140.2,188 c19.2-4.7,32.9-3.9,32.9-3.9l-14.4,19c0,0,58.7,95.2,50.8,184C217.4,1095.8,249.9,995.9,249.9,995.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16,619.8c0,0,243.5,99.3,224.4,372.9"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "345.1,1015.3 344.3,1037.3 340.1,1145.5 204.1,1145.5 184.9,1037.3 182.7,1024.8 274.6,1019.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.9,993.3v37.5c0,3.6-2.9,6.5-6.5,6.5H162.7c-4.3,0-7.4-4.1-6.3-8.2l10.2-37.5c0.8-2.8,3.4-4.8,6.3-4.8 h188.6C365,986.7,367.9,989.7,367.9,993.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 520.9216,
    y1: 462.6167,
    x2: 601.4245,
    y2: 530.4296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "593.2,506.2 575.1,529.7 565,521.2 521,484 520.6,483.6 520.6,440.8 521.9,442.1 541,459.3  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M668.7,540.5c0,0-0.4,2.5-0.8,6.5c-12.7,14.2-31.6,34-39.2,35.2c-3.4,0.5-10-3.8-17.9-10.3 c-19.8-16.5-47.2-47.3-47.3-49.9c-0.2-3.6,16.4-27,19.6-28.2c3.2-1.2,37.6,29.5,40,31.8c2.5,2.3,36.5-56.6,36.5-56.6 c4.6,5.4,7.3,13.2,8.9,21.8C672.6,513.3,668.7,540.5,668.7,540.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M826.9,629.1c-0.3,1-9.4,12.4-15.8,20.3c-3.5,4.3-6.2,7.6-6.2,7.6s-1-1.4-2.6-3.9c-0.7-1.1-1.6-2.5-2.6-4 c-0.3-0.5-0.6-1-1-1.5c-0.2-0.4-0.5-0.7-0.7-1.1c-1-1.5-2-3.2-3.1-4.9c-0.8-1.2-1.6-2.5-2.4-3.9c-1.8-3-3.7-6.1-5.6-9.4 c-2-3.4-4-6.9-5.8-10.4c-4.8-8.9-8.7-17.5-10.1-23.7c-3.8-17,2.5-93,4.1-112.1c0.2-2.8,0.4-4.3,0.4-4.3s1.2,1.2,3.3,4.6 c0.7,1.1,1.4,2.4,2.2,3.9c2.6,5,6,12.6,9.7,24c3.5,10.5,7.3,24.3,11.2,42.3c11.3,52.6,21.5,69.8,24.3,74.8 C826.7,628.3,826.9,628.8,826.9,629.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M796.2,684.4c-0.2,2-0.6,3.8-1.2,5.5c-0.2,0.6-0.4,1.2-0.7,1.8c-0.8,1.9-2.3,3.5-4.3,4.9 c-2.6,1.8-6.1,3.3-10.3,4.4c-3,0.8-6.4,1.5-10.1,2c-4.9,0.7-10.3,1-16,1.2c-30.7,0.7-69.9-5.9-87.2-15.5c-2.5-1.4-4.6-2.9-6-4.4 c-3.3-3.4-5.3-7.6-6.3-12.4c-1-4.7-1.1-10.1-0.6-16c0.9-11.6,4.1-25.2,7-40c1-5.2,2-10.4,2.9-15.9c1.4-8.7,2.4-17.7,2.6-26.8 c0.2-10.1,1.2-20,1.9-26.2c0-0.3,0.1-0.5,0.1-0.8c0.4-3.6,0.8-5.7,0.8-5.7s7.5-51.7-9.1-71.4c15.4-6.9,24.6-11.2,31.2-14.2 c10.3-4.6,14.1-5.7,25.3-7.8c0,0,20.6,4.4,39.7,15.4c7.5,4.3,14.9,9.6,20.6,16.1c1,1.2,2,2.4,3,3.6c0,0,0,0,0,0 c1.3,1.7,2.1,4.8,2.7,8.8c1.1,8,1,20,0.3,33.3c-0.2,4.2-0.5,8.5-0.8,12.9c-1.7,24.6-4.3,50.4-3.9,62.4c0.2,5.2,1.5,11.4,3.4,18.2 c4.3,15.6,11.5,34.1,14.3,49.9C796.4,673.8,796.8,679.4,796.2,684.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 755.664,
    y1: 351.2504,
    x2: 684.2836,
    y2: 486.8733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M742.7,438.1c0.3,12.6,3.5,38-17.8,37c-0.5,0-0.9,0-1.3-0.1c-20.6-1.8-12.7-21.8-14.7-27.9 c-1-3-3.6-3-6.8-3.2c-3.4-0.2-7.4-0.5-10.7-4.9c-3.7-4.8-5.8-18-6.9-28.4c-0.4-3.3-0.6-6.3-0.8-8.7c23.2-0.8,53.2-12.8,53.2-12.8 s-0.4,1.7-0.8,4.3c-0.4,3-0.9,7.3-0.7,11.7c0.3,8.3,4.2-10.4,10.7-6.8c6.5,3.6-0.9,17.9-5.4,22.8 C737.7,424.5,739.9,432.9,742.7,438.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M764.3,424c-8.3,10.7-16.4,18.4-17.7,18.5c-1,0.1-2.5-1.7-3.9-4.4c-2.7-5.2-5-13.6-2.1-16.9 c4.5-4.9,11.9-19.2,5.4-22.8c-6.6-3.6-10.4,15.2-10.7,6.8c-0.3-8.3,1.5-16.1,1.5-16.1s-30,12-53.2,12.8c-3.1,0.1-6.2,0-9-0.3 c-1.2-5.1-1.6-9.8-1.6-13.9c0-10.3,2.9-16.9,3.3-17.8c-0.5,0.7-3.1,4.9-7.7,17.8c3.9-36.5,16.7-45,49.1-48 c32.4-19.6,39.9,22,39.9,22s18.7-8.3,25,15.7C786.1,391.2,775.1,410.1,764.3,424z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M831.1,646.9c-2.5,4.3-8.3,9.4-13.5,13.3c-2.2,1.6-4.2,3-6,4c-2.2,1.3-3.9,2-4.6,1.8 c-2.8-0.8-6.1-5.4-6-10.1c0-0.6,0.5-1.6,1.2-2.8c1.3-2.1,3.4-5,5.9-8.1c6.8-8.4,16-18.2,16-18.2c0.7-0.2,1.4,0,2.1,0.7 c2.6,2.2,5.3,8.9,6.3,15C832.6,643.7,832.1,645.2,831.1,646.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M592.3,493.6c0,0-17.5,45-24.1,41.7c-6.5-3.3-13.4-9.8-10.7-17.9c2.7-8,18.1-31.5,27.1-28.6 C593.5,491.8,594.2,488.9,592.3,493.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M742.8,456.1c0,0-1.4,17.5-13.9,18.9c8.2,10.8,12.8,9,15.2,7.3C746.4,480.7,749.4,461.3,742.8,456.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M818.6,1098.3c-7.1,10.5-39.7,11.7-45.2,4c-5.6-7.8-11.1-250.8-35.5-336.2c-14.9,25.6-6.8,326.7-13,333.7 c-2.7,3.1-51.5,13.7-54.4-3.6c-14.4-86-9.6-277-5.8-368.7c0.7-16.6,1.3-30,1.8-38.8c26.3,14.7,103.3,22.1,123.7,8 c0.4,1.1,0.8,2.2,1.2,3.3C831.3,813.3,825.3,1088.5,818.6,1098.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M725.5,1145.2h-86c0,0,0.9-25.5,16.4-26.7c2.8-0.2,5.2,0.1,7.3,0.9c9.3,3.3,11.5,14.3,11.5,14.3h48.5 C723.1,1133.7,725.8,1139.9,725.5,1145.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M721.3,1133.7h-46.7c0,0-2.2-11-11.5-14.3c4.7-3.3,12.7-9.3,14.3-12.8c16.2-3.5,37.6-1.8,39.1,0 C718,1108.4,721.3,1133.7,721.3,1133.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M669.5,1114.6c0,0,9.9,2,13,1.6c3.1-0.4,14.4-26,12.9-29s-18.7-1.8-20.2,0 C673.7,1089,673,1108.5,669.5,1114.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M771.1,1145.5l86-0.4c0,0-1-25.5-16.5-26.7c-2.8-0.2-5.2,0.2-7.3,0.9c-9.3,3.3-11.4,14.3-11.4,14.3 l-48.5,0.2C773.4,1133.9,770.8,1140.1,771.1,1145.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M775.2,1133.8l46.7-0.2c0,0,2.1-11,11.4-14.3c-4.7-3.3-12.7-9.2-14.3-12.7c-16.3-3.5-37.7-1.6-39.1,0.2 C778.3,1108.6,775.2,1133.8,775.2,1133.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M826.9,1114.6c0,0-9.9,2.1-13,1.7c-3.1-0.4-14.5-25.9-13.1-28.9c1.5-3,18.7-1.9,20.2-0.1 C822.6,1089,823.3,1108.5,826.9,1114.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 798.1014,
    y1: 629.5598,
    x2: 939.6617,
    y2: 842.4954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M869.8,734c-0.1,11.3-10.2,12.2-17.3,8.3c-6.1-3.3-14.4-30.7-20.7-45.3c-1.1-2.5-2.1-4.6-3.1-6.2 c-4.2-6.9-12-19-17-26.7c1.7-1,3.8-2.4,6-4c5.3-3.9,11-9,13.5-13.3c4.7,10.8,14.8,33.3,17.5,35.3c3.6,2.7,20.2,21.1,21.1,26.5 c0.9,5.4-5.6,1.5-8.3,1.2C858.7,709.6,869.9,722.7,869.8,734z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M693,704.1c0,0,4.8,17.9-17.8,31.6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M771.8,710.2c0,0,1.5,20.8,26.5,25.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M682.3,753.3c0,0-21.2,210.5,0,328"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M749.5,766.1c0,0,38.1,212.7,30.9,332.3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M668.7,540.5c0,0-0.4,2.5-0.8,6.5c-12.7,14.2-31.6,34-39.2,35.2c-3.4,0.5-10-3.8-17.9-10.3 c4.7,0.2,10.8,0.1,16.7-0.4c10.8-1,37.9-57.6,41-80.6C672.6,513.3,668.7,540.5,668.7,540.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M709.1,448.6c0,0-1.8,22.7,15.8,26.6c-0.1,8.2-12.6,14.2-15.8,10.5C705.8,481.9,696.3,457.4,709.1,448.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.2146,
    y1: 563.3033,
    x2: 642.8981,
    y2: 493.7125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M680.9,470.9c-8.9,2.1-36.1,6.3-40.4,10.7c-0.5,0.5-1.4,2.2-2.7,5c-11.4,23.5-52.1,120.8-77,117.6 c-0.5,0-0.9-0.1-1.4-0.2c-13.9-3-27.8-23.5-37.9-42.9c-4.9-9.4-9-18.5-11.8-25.2c14.8-3.2,32.9-15.8,39.3-22 c0.6,1.4,1.1,2.8,1.6,4.2c4.2,11.2,8,23.9,9.5,29.1c0.4,1.5,0.7,2.4,0.7,2.4s1-1,2.6-2.8c9.2-9.9,39.8-43.9,44.2-58.7 c5.2-17.4,12.7-43.6,17.5-40.4c4.8,3.2,0.4,19,7.5,17.8C669.4,457,687.7,469.3,680.9,470.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M501.9,438.3c0,1.2,0,2.2,0,3c0,1-1.4,1.8-3.8,2.4c-18.3,5-97,1.2-109.7-15.5c-1.3-1.7-1.9-3.6-1.7-5.6 c0,0,16.7-39.5,67.2-34.2c41.1,4.4,47.2,30.6,47.9,45.2C501.9,435.4,501.9,437,501.9,438.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M551.3,510.5c0,0.6-0.8,1.7-2.3,3.2c-4.6,4.5-15.2,12.2-26.3,17.4c-2.8,1.3-5.6,2.5-8.3,3.3 c-1.3,0.4-2.6,0.8-3.9,1.1c-0.3,0.1-0.5,0.1-0.8,0.2c-1,0.2-2.1,0.4-3.1,0.6c0,0-0.1,0-0.1,0c-0.7,0.1-1.4,0.4-2.1,0.9 c-1,0.7-1.8,1.8-2.6,3.3c-2.4,4.7-3.8,13-4.5,23.3c-0.1,1.1-0.2,2.2-0.2,3.3c0,0.9-0.1,1.8-0.1,2.7c-0.1,1.1-0.1,2.2-0.1,3.3 c-0.3,7.3-0.3,15.2-0.1,23.3c0,1.1,0.1,2.2,0.1,3.3c0,0.9,0,1.8,0.1,2.7c0,1.1,0.1,2.2,0.1,3.3c0.3,7.9,0.7,15.8,1.2,23.3 c0.1,1.1,0.2,2.2,0.2,3.3c0.1,0.9,0.1,1.8,0.2,2.7c0.1,1.1,0.1,2.3,0.2,3.3c0.7,9.2,1.4,17.3,2,23.3c0,0.5,0.1,1,0.1,1.4 c0.1,0.7,0.1,1.3,0.2,1.9c0.1,1,0.2,1.9,0.3,2.7c0.2,1.4,0.3,2.5,0.4,3.3c0.1,0.9,0.2,1.4,0.3,1.6c0.3,1-12.2,4.1-29.4,6.1 c-14.7,1.8-32.9,2.7-49.4,0.9c-6.2-0.7-12.1-1.8-17.6-3.4c-4.7-1.3-8.9-3.1-12.7-5.2c-0.3-0.1-0.5-0.3-0.8-0.4 c-1.4-0.8-2.7-1.8-3.9-2.9c-0.9-0.8-1.8-1.7-2.6-2.7c-0.8-1-1.6-2.2-2.3-3.3c-0.1-0.2-0.3-0.4-0.4-0.7c-3.5-6.1-5.6-13.9-6.6-22.6 c-0.1-1.1-0.3-2.2-0.4-3.3c-0.1-0.9-0.2-1.8-0.2-2.7c-0.1-1.1-0.1-2.2-0.2-3.3c-0.3-7.6,0-15.5,0.6-23.3c0.1-1.1,0.2-2.2,0.3-3.3 c0.1-0.9,0.2-1.8,0.3-2.7c0.1-1.1,0.3-2.2,0.4-3.3c1-8.4,2.2-16.4,3.5-23.3c0.2-1.2,0.4-2.3,0.6-3.3c0.2-0.9,0.4-1.8,0.6-2.7 c0.2-1.2,0.5-2.3,0.7-3.3c1.8-8.6,3.3-14,3.3-14l-0.7-9.3l-0.3-3.3l-0.2-2.7l-0.3-3.3l-0.1-1.4l-0.8-10.1c0,0-2,5-4.6,11.5 c0,0.1-0.1,0.2-0.1,0.3c-0.4,1-0.8,2-1.3,3c-0.4,0.9-0.8,1.8-1.2,2.7c-0.4,0.9-0.8,1.7-1.1,2.6c-0.1,0.3-0.2,0.5-0.3,0.7 c-3.7,8.5-7.6,16.6-9.4,17.7c-0.4,0.2-1.1,0.3-1.9,0.2c-5.7-0.8-20.8-8.8-30.1-17.8c-1.1-1.1-2.2-2.2-3.1-3.3 c-0.5-0.6-1-1.2-1.4-1.7c-0.2-0.3-0.5-0.7-0.7-1c-0.8-1.1-1.4-2.2-1.8-3.3c-0.4-0.9-0.7-1.8-0.8-2.7c0,0,3.4-8.6,8.5-20.5 c0.5-1.1,1-2.2,1.4-3.3c0.4-0.9,0.8-1.8,1.2-2.7c0.5-1.1,1-2.2,1.5-3.3c1.6-3.5,3.2-7.2,4.9-10.8c1.9-4.2,3.9-8.4,6-12.4 c0.6-1.1,1.1-2.2,1.7-3.3c0.5-0.9,0.9-1.8,1.4-2.7c0.6-1.1,1.2-2.3,1.8-3.3c0.9-1.7,1.8-3.3,2.7-4.9c3.9-6.8,7.7-12.6,11-16.3 c0.3-0.4,0.6-0.7,1-1.1c0.3-0.3,0.6-0.7,1-1c1.2-1.1,2.4-2.2,3.8-3.3c1.1-0.9,2.3-1.8,3.6-2.7c1.6-1.2,3.3-2.3,5.1-3.3 c6.3-3.9,13.6-7.4,21.1-10.3c2.5-1,5.1-1.9,7.6-2.7c13.7-4.5,27.5-7.1,37.4-6.7c9,0.3,22.9,5,36.7,10.9c4.1,1.8,8.2,3.6,12.1,5.5 c2.3,1.1,4.5,2.2,6.7,3.3c2.2,1.1,4.4,2.2,6.4,3.3c1.7,0.9,3.4,1.9,4.9,2.7c0.7,0.4,1.3,0.8,2,1.1c1.3,0.8,2.5,1.5,3.7,2.2 c3.8,2.4,6.3,4.2,7.2,5.4c0.1,0.1,0.3,0.3,0.4,0.6c1.6,2.5,4.5,9.2,7.6,17.4c0.4,1.1,0.9,2.2,1.3,3.3c0.3,0.7,0.5,1.3,0.8,2 c0.1,0.2,0.2,0.5,0.3,0.7c0.4,1.1,0.8,2.2,1.2,3.3c3.1,8.2,6.1,16.7,8.3,23.3c0.4,1.2,0.8,2.3,1.1,3.3c0.3,1,0.6,1.9,0.9,2.7 c0.4,1.3,0.8,2.4,1,3.3C551.1,509.2,551.3,510.2,551.3,510.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.3556,
    y1: 653.9063,
    x2: 252.9451,
    y2: 583.3234
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M363.5,558.3c-2.2,5-6.2,14-10.8,23.9c-9.5,20.6-21.4,45.3-24.4,46.6c-5.2,2.3-79.3-3.4-88.8-1.1 c-9.5,2.3-33.7,34.1-45.6,32.7c-11.9-1.3-0.8-30.5,17.2-42.6c-9.5-0.1-12.2-3.3-12.6-8.1c2.8-3.1,17.5-0.7,28.6-3.1 c11.1-2.4,73.9-14.3,80.7-15l16.8-44.7l4.4-11.6C337,546.4,356.8,557.3,363.5,558.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M532.9,1086c-3,2.4-6.4,4-10.3,4.2c-10.4,0.6-21.1,0.3-29-3.8c-2.4-1.2-4.6-2.8-6.4-4.9 c-0.9-1-2.1-5.8-3.6-13.7c-5.3-27.9-13.8-93.8-21.4-157c-8.8-72.7-16.6-141.9-17.1-146.3l0-0.2c0,0-40.3,190.3-62.2,306.1 c-0.7,3.8-1.4,7.5-2.1,11.1c-2,3.4-4.8,6-8,7.9c-10.7,6.3-26.5,4.7-35.6-0.6c-3.4-2-5.9-4.5-6.9-7.3c-0.4-1.1-0.5-4.9-0.3-11 c1.5-52.5,21.6-273.6,29.9-364c0.7-7.4,1.3-13.9,1.8-19.3c13.8,14.8,36.9,10.8,41.6,3.9c0.7-1,1.5-6.3,2.4-14.8 c18.8,5.4,47.3,2.4,67.5,0c0.1,0.9,0.2,1.7,0.2,2.5c0,0.1,0,0.2,0,0.3c0.4,3.6,0.8,6,1.4,7.3c5.9,13.3,22.7,12.7,37.5,5.4 c7,81.1,27.7,321.3,31.3,363.7c0.3,3.4,0.5,5.6,0.5,6.2C544.7,1069.1,540.4,1080.1,532.9,1086z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M382,1145.2h-53.8c0,0,0.4-4,1.1-9c1-6.7,2.6-15.3,4.8-18.9c0.5-0.8,1-1.3,1.5-1.6c3.3-1.4,3.5-8.1,7.1-12.4 c1.7-2,4.2-3.5,8-3.7c2.7-0.1,4.7,0.5,6.4,1.5c5.8,3.8,6.1,13.2,8.2,14.8c0.8,0.6,2.1,0.9,3.7,1.8c3,1.6,7,5,10.3,15.9 C380.3,1136.9,381.2,1140.7,382,1145.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M602,1145.2H492.9c0,0,0.5-9.7,1.5-18.8c0.7-5.8,1.7-11.3,2.9-13.9c0.1-0.3,0.3-0.5,0.4-0.7 c4.1-5.2,20.3,7.2,24.8,6.6c4.8-0.6,5.7-12.8,10.4-15.5c0.1-0.1,0.3-0.1,0.4-0.2c1.2-0.3,3,0.6,5.1,2.3c6.8,5.2,17.8,17.5,29.9,19 c3.2,0.4,6.4,0.7,9.5,1.1c10.5,1.3,19.6,3.5,22.9,13C601.5,1140.3,601.9,1142.6,602,1145.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.643,
    y1: 919.7508,
    x2: 510.5057,
    y2: 1224.281
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M533.5,1102.9c-0.1,0-0.3,0.1-0.4,0.2c-4.8,2.7-5.6,14.9-10.4,15.5c-4.6,0.6-20.8-11.8-24.8-6.6 c-0.8-5-1.7-10.9-2.6-16.1c-0.6-3.6-1.2-6.9-1.6-9.4c7.9,4.1,18.6,4.5,29,3.8c3.9-0.2,7.3-1.8,10.3-4.2l0.3,10.8L533.5,1102.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.8065,
    y1: 916.0043,
    x2: 350.6692,
    y2: 1220.5369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M372.8,1089.4l-0.4,2.9l-3.4,25.6c-1.6-0.9-2.9-1.2-3.7-1.8c-2.1-1.6-2.4-11.1-8.2-14.8 c-1.6-1.1-3.7-1.7-6.4-1.5c-3.9,0.2-6.3,1.7-8,3.7c-3.7,4.3-3.9,11-7.1,12.4c-0.5,0.2-1,0.8-1.5,1.6l1.6-14.5l1.5-14.1 C346.3,1094.2,362.1,1095.7,372.8,1089.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M407.3,697.3c0,0-13.1,26.5-36.9,23"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 386.7,
    y1: 727.4,
    x2: 386.5,
    y2: 728.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 386.3,
    y1: 730.7,
    x2: 349.4,
    y2: 1076.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 349.2,
    y1: 1077.3,
    x2: 349.1,
    y2: 1078.3
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st31",
    x1: 451,
    y1: 766.1,
    x2: 504.5,
    y2: 1081.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M462.2,910.8c-8.8-72.7-16.6-141.9-17.1-146.3l0-0.2c0,0,11.5,0.6,32.6-11"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M382.9,1070.4c-0.7,3.8-1.4,7.5-2.1,11.1c-2,3.4-4.8,6-8,7.9c-10.7,6.3-26.5,4.7-35.6-0.6 c-3.4-2-5.9-4.5-6.9-7.3c-0.4-1.1-0.5-4.9-0.3-11C342.8,1075.2,362.6,1079.3,382.9,1070.4z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M532.9,1086c-3,2.4-6.4,4-10.3,4.2c-10.4,0.6-21.1,0.3-29-3.8c-2.4-1.2-4.6-2.8-6.4-4.9 c-0.9-1-2.1-5.8-3.6-13.7c13.3,6.1,41,14.3,60-12.3c0.3,3.4,0.5,5.6,0.5,6.2C544.7,1069.1,540.4,1080.1,532.9,1086z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M533.3,1096.9c-14.3,2.9-29.1,0.8-38.1-1.1c-0.6-3.6-1.2-6.9-1.6-9.4c7.9,4.1,18.6,4.5,29,3.8 c3.9-0.2,7.3-1.8,10.3-4.2L533.3,1096.9z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M577.9,1125.3c-6.8,6.5-37.3-4.3-40.3-7.4c-2.5-2.5-0.5-8.7,1-12.8c6.8,5.2,17.8,17.5,29.9,19 C571.6,1124.6,574.9,1124.9,577.9,1125.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M602,1145.2H492.9c0,0,0.5-9.7,1.5-18.8c3.4,4.1,8.8,9.6,15,11.5c8.4,2.6,69.3,1,91.4,0.3 C601.5,1140.3,601.9,1142.6,602,1145.2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M346.3,1105.1c0,0-6.1,8.1-6.1,12.8c0,4.7,4.6,11,9.9,12.2c5.4,1.2,9.5-5.6,9.9-10.1 C360.3,1115.4,360.2,1103.4,346.3,1105.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M382,1145.2h-53.8c0,0,0.4-4,1.1-9c11.1,0.9,39.4,2.6,50-2.5C380.3,1136.9,381.2,1140.7,382,1145.2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M372.8,1089.4l-0.4,2.9c-4.8,4.6-10.1,7.3-15.3,9c-1.6-1.1-3.7-1.7-6.4-1.5c-3.9,0.2-6.3,1.7-8,3.7 c-2.8,0-5.3-0.2-7.1-0.5l1.5-14.1C346.3,1094.2,362.1,1095.7,372.8,1089.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M411,587.3c-1,24.5-2.1,47.4-3.4,65.4c-0.6,9.3-1.3,17.3-1.9,23.6c-0.8,8.5-1.6,13.8-2.4,14.8 c-4.8,6.9-27.8,10.9-41.6-3.9c-1.8-1.9-3.4-4-4.8-6.5c-12.2-21.8,25.2-118.2,21.8-149.3c-0.1-0.7-0.2-1.4-0.3-2 c-4-21.4-16-53.5-21.8-68.5c-2-5.1-3.3-8.2-3.3-8.2c-2.4-19,42.8-46.4,55.9-39.3c0.6,1.6,1,3.8,1.5,6.8c0.4,2.6,0.7,5.7,1,9.2 C414.3,461.1,413.3,528.7,411,587.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M531.4,440.1c0,0-1,3.1-2.6,8.3c-5.3,17.5-16.9,59.1-17.7,87v0.2c0,1.2-0.1,2.4,0,3.6c0,0.7,0,1.4,0,2.1 c1.2,35.1,26.1,133.2,10.1,145.1c-2.6,1.9-5.4,3.6-8.2,5.1c-0.2,0.1-0.5,0.2-0.7,0.3c-14.7,7.3-31.6,7.8-37.5-5.4 c-0.6-1.3-1-3.9-1.4-7.6v-0.1c-0.1-0.7-0.1-1.6-0.2-2.4c-0.4-5-0.6-11.6-0.8-19.4c-0.3-18.1,0-42.7,0.8-69.1 c0.2-6.5,0.4-13.1,0.7-19.7c0.5-13.4,1.1-27.1,1.8-40.3c2.1-40.4,4.8-77.2,7.7-94.4c0.2-1.1,0.4-2.1,0.5-3.1c0-0.1,0-0.1,0-0.2 c0.4-2.1,0.8-3.8,1.3-5c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0.1-0.2,0.1-0.3c0.3-0.6,0.6-1.2,1-1.7 C496.5,407.6,532.7,435.9,531.4,440.1z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M411,587.3l-1.6,4.5c0,0-14.3-146.9-17.8-157.6c-3.6-10.7,17.8-20.9,17.8-20.9 C414.8,428.6,413.8,514.8,411,587.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M473.3,587.8c0.2-6.5,0.4-13.1,0.7-19.7c2.1-57.1,6-117.3,10-137.8c0-0.1,0-0.1,0-0.2c0.5-2.2,0.9-3.9,1.3-5 c0.1-0.3,0.2-0.6,0.3-0.9c0.3-0.6,0.6-1.2,1-1.7c5.1,1.4,11.8,5.2,15.4,15.8C506.1,450.7,491.3,535.6,473.3,587.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M393.9,608.2c0,0-1.8,13.6-20.8,20.9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M484.4,608.2c0,0,1.8,13.6,20.8,20.9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M563.4,546.6c-0.8,8-2.3,20.9-3.3,18.9c-1.5-3,0-18.4,0-18.4c0.4,1.5,0.7,2.4,0.7,2.4 S561.8,548.4,563.4,546.6z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M523.1,327.5c-3.9,7.2-8.9,15.2-16.4,20.5c-2.8,2-5.8,3.5-9.3,4.6c-5.4,1.6-11.7,1.9-19.1,0.1 c-5.6-1.3-7.9-3.6-7.9-3.6s0.9,6.6,14.9,11.7c-8.9-1.6-19-0.4-23.2-11.9c0,0-1.5,1.7-3.3,4.8c-2.5,4.2-5.5,11.1-6.2,19.8 c-11.1-17.3-11.3-22.2-20-19.8c-8.7,2.4-3.8,15.7,1.8,18.6c4.2,2.3,0.2,12.9-2.6,18c-0.9,1.6-1.2,3-1.2,3s-1.4-19.2-16.6-27.8 c-4.1-2.3-7.8-5.9-10.7-10.4c-8-12.2-10.4-30.4,0.2-42.2c14.5-16.1,29.5-6.7,29.5-6.7s-1.4-33.1,23.8-42.4 c-12.2,12.7-13.8,25.5-13.9,26.5c0.2-1.2,4.2-20.5,29.5-23.3c26.2-3,26.6,24.2,26.6,24.2s0.6-8.1,15.7-6.7 c6.3,0.6,10.1,5.7,11.9,12.5C529,306.5,527.5,319.3,523.1,327.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.4035,
    y1: 372.2072,
    x2: 511.0939,
    y2: 428.5181
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M497.5,352.6c0,3.6-0.2,8.8-0.9,14.7c-1.8,15.9-7.2,36.5-23,42.2c-3.5,1.2-6.1-0.4-8.2-1.6c0,0,0,0-0.1-0.1 c-1.3-0.7-2.3-1.1-3.2-0.6c-1.5,0.8,0.1,6,0.9,12c0.6,4.4,0.8,9.3-0.9,13.1c-4.1,8.9-8.3,12.5-19.6,12.1 c-11.3-0.4-17.4-10.3-14.1-22c1.7-5.8,2.3-13.9,2.4-21.2c0-3.9-0.1-7.6-0.4-10.6c2.8-5.1,8.2-16.1,4-18.3 c-5.5-3-10.5-16.3-1.8-18.6c3.8-1.1,6-0.7,8.2,1.5c2.8,2.8,5.6,8.6,11.8,18.3c0.7-8.7,3.8-15.6,6.2-19.8c0.9-1.6,1.7-2.8,2.3-3.6 c0.1-0.2,0.3-0.4,0.4-0.5c0.4-0.5,0.6-0.7,0.6-0.7c4.2,11.5,14.3,10.3,23.2,11.9c-14-5.1-14.9-11.7-14.9-11.7s2.4,2.3,7.9,3.6 C485.8,354.4,492.1,354.2,497.5,352.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M963.8,373.8c0,0-41.4-62.4,11-89.4c52.3-27,88.9,18.9,79.6,57.1c-3.5,14.3,20.9,11.8,19.8,35.6 c-1.1,23.9-2.2,37,25.4,55c27.5,18,41,50.5,33.9,89c-7.1,38.5,46.8,74.2,32.5,121.7c-14.3,47.6-100,64.2-131.7,26.5 c-31.7-37.6-55.8-178.6-55.8-178.6l30.7-62.9l-12.9-48.2L963.8,373.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M1115.9,1063.3c0,0-0.4,0.4-1.1,1c-4,3.6-18.6,14.9-31.5,6.1c-0.5-0.4-1.1-1.1-1.8-2.1c0,0,0,0,0,0 c-3-4.8-7.1-16.7-11.8-33.3c-23.7-82.9-63.9-281.6-63.9-281.6l-13.5,148.2l-13.4,147.3l-3.3,35.7c0,0-25.4,5.7-43.2-6.2 c-0.4-5.5-0.6-12.2-0.8-20c-2.1-105.2,12.3-398.4,12.4-401.4c3.2,8.2,10.2,15.5,23.3,20c0,0,0,0,0,0c0.5,0.1,1,0.3,1.5,0.5 c4.5,1.4,9.6,2.5,15.5,3.2c37.5,4.4,69-3.8,81.5-17.3c0.6-0.7,1.2-1.4,1.8-2c5.4,12.5,10,32,12.9,54.5c2.8,21.6,4,46.1,2.6,69.8 c-2.7,45.5,20.3,198.9,29.2,256C1114.6,1055.2,1115.9,1063.3,1115.9,1063.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M1085.6,440.3c-1.2,2.2-2.4,4.6-3.4,7.1c-0.4,1-0.9,2.1-1.3,3.1c-2.1,5.5-3.8,11.4-5.2,17.6 c-0.8,3.3-1.4,6.6-2,10c-0.3,1.4-0.5,2.9-0.7,4.3c-1.5,9.4-2.5,18.7-3.1,26.9c-0.1,1.4-0.2,2.8-0.3,4.1c-0.9,14-0.7,23.9-0.7,23.9 s-0.1,0.6-0.3,1.7c-0.2,1-0.4,2.5-0.7,4.3c-0.9,6-2.2,15.8-3.1,26.9c-0.1,1.3-0.2,2.7-0.3,4c-0.5,8.2-0.7,16.9-0.2,25.2 c0.1,1.3,0.2,2.5,0.3,3.8c0.5,5.5,1.3,10.7,2.5,15.3c0.7,2.6,1.3,4.9,1.9,7.1c0.3,1.2,0.6,2.3,0.9,3.3c3.3,11.8,5.1,17.6,3.7,22.8 c-0.5,1.8-1.4,3.6-2.7,5.5c-0.9,1.2-1.9,2.6-3.2,4c-0.6,0.6-1.2,1.3-1.8,2c-12.5,13.4-44,21.7-81.5,17.3 c-5.9-0.7-11.1-1.8-15.5-3.2c-14.1-4.4-21.5-12-24.9-20.5v0c-0.3-0.8-0.6-1.7-0.8-2.5c-0.4-1.1-0.6-2.3-0.8-3.4 c-0.8-4.2-0.7-8.4-0.2-12.6c0.5-3.5,1.6-8.3,3-14.2c0.4-1.4,0.7-2.9,1.1-4.5c1.6-6.7,3.5-14.4,5.2-22.5c0.3-1.1,0.5-2.3,0.7-3.5 c1.5-7.5,2.9-15.3,3.7-22.8c0.1-1.2,0.3-2.5,0.4-3.7c0.3-3.7,0.5-7.4,0.6-11c0-2.6,0-5.2-0.2-7.7c-0.2-2.3-0.5-4.5-0.8-6.7 c-0.3-1.6-0.6-3.1-1-4.5c0-0.1-0.1-0.3-0.1-0.4c-5.3-4.9-14.9-8.8-17.7-23.7c-0.2-0.9-0.3-1.9-0.5-2.9c0-0.2-0.1-0.5-0.1-0.7 c-0.5-4.4-0.4-9.8,0.4-16.2c0.5-3.5,0.8-6.8,1.2-9.9c0.2-1.4,0.3-2.8,0.4-4.1c1.1-10.9,1.5-19.5,2.3-26.5c0.2-1.5,0.4-2.9,0.6-4.2 c0.9-5.6,2.1-10.2,4.5-14.2c0.4-0.7,0.9-1.3,1.4-2c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.1-0.1 c6.4-7.5,21.1-14.1,37.8-19.2c6.1-1.8,12.4-3.4,18.7-4.8c12.6-2.8,23.9-2.2,33.8,0.2C1063.3,414.7,1079.6,433.1,1085.6,440.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M1105.6,525.7c-5.2,13.5-26.9,14.8-36.9,13.1c-2.3-0.4-3.9-0.9-4.7-1.4c-1.1-0.8-2.1-6.1-2.6-14.1 c-1.1-16.5-0.2-43.9,6-64.4c0.6-1.9,1.2-3.8,1.9-5.6c0.1-0.4,0.2-0.6,0.2-0.6c3-7.6,6.8-13.8,11.8-17.3c0,0,23.1,13.9,24.3,81.1 C1105.6,519.4,1105.7,522.5,1105.6,525.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M956.6,548.7c-0.9,0.6-2.8,1-5.3,1.1c-3.1,0.1-7.1-0.2-11.5-1c-9.4-1.7-20.5-5.8-27.6-12.8 c-1.6-1.6-3-3.3-4.1-5.2c0.9-3.4,1.8-6.7,2.7-9.9c6.3-22.2,12.2-39.2,17.5-52.1c9.8-24,17-33.7,18.9-35.9c-0.5,0.7-1,1.3-1.4,2 c-6.5,11.3-4.8,26.8-8.9,58.9c-4.1,31.7,10.3,36.7,17.5,43.2c0.1,0.1,0.2,0.2,0.3,0.3C955.7,540.7,956.3,544.6,956.6,548.7z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1037.9,408.5c-5.8,14-18.1,41.4-27,43.6c-12.1,3-28.6-4.8-30.4-13.5c-1.3-6.6,2.8-19.5,4.9-25.5 c6.1-1.8,12.4-3.4,18.7-4.8C1016.7,405.5,1028,406,1037.9,408.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1029.1862,
    y1: 363.5499,
    x2: 944.1288,
    y2: 401.6175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M1024.9,411.1c-0.3,3.1-1.2,8.8-8.9,21.1c-7.7,12.3-30.6,12.1-28,0c1.2-5.3,2.2-12.2,2.9-18.2 c1-7.7,1.6-14.1,1.6-14.1s-4.4,2.9-9.2,2.3c-0.1,0-0.2,0-0.2,0c-1.6-0.3-3.3-0.9-4.8-2.3c-13.1-11.2-16.8-32.2-17.5-48.7 c-0.6-13.2,0.8-23.6,0.8-23.6c19.9,19.3,44.6,10.7,48.5,11.6c0.9,0.2,2,0.7,3,1.4c3.3,2.3,6.5,7.4,4.4,15.6 c-2.7,10.7-5.7,12.5,7.4,23.5C1023.1,389.9,1025.2,408,1024.9,411.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.8728,
    y1: 491.6706,
    x2: 1201.8428,
    y2: 702.8223
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M1213.1,475.2c-3.1,9.1-20.2,8.8-37.3,24.2c-17.1,15.4-36.1,117.8-63.4,117.8c-29.8,0-41.8-31.4-46.7-56 c-0.2-0.9-0.4-1.8-0.5-2.7c-2.6-14.2-2.8-25.4-2.8-25.9c0.1,0.4,0.1,0.7,0.2,1c0,0.3,0.1,0.6,0.2,0.9c0,0.1,0.1,0.2,0.1,0.3 c0,0.2,0.1,0.5,0.2,0.7c0.2,0.6,0.4,1.1,0.6,1.5c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.6,2.5,1.1,4.7,1.4 c9.5,1.6,29.5,0.6,36-11c0.2-0.3,0.3-0.6,0.5-0.9c0.3,7.9,0.8,21.8,0.5,31.4c1.8-7.9,43-63.1,44.8-69.7c1.8-6.5-7.3-24.2,1.8-23.5 c9.1,0.8,11.3,16.1,15.5,16.1c4.2,0,15.2-5.8,23.3-7C1199.2,473,1214.7,470.5,1213.1,475.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 952.8363,
    y1: 606.3412,
    x2: 788.6726,
    y2: 398.5588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M951.4,549.7c-1.7,7.5-6.2,25.5-14.5,39.4c0,0,0,0,0,0c-6.1,10.1-14.2,18-24.6,18 c-24.7,0-44.3-53.8-61.9-116.3c-6.2-22.2-41-51.8-41.3-58.1c-0.3-6.3,34.2,9.1,46.1,15.8c7.1,4.1,4.2-14.2,9.8-17.3 c5.7-3.1,3.6,35.5,7.4,47.4c3.9,12,33.5,63.4,35.8,70c0.6-2.2,1.3-4.5,2.1-6.9c0.7-2,1.4-4,2-5.9c3.6,3.5,8.1,6.3,13,8.4 C934.6,548.4,945,550,951.4,549.7z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M1081.5,1068.2C1081.5,1068.2,1081.5,1068.2,1081.5,1068.2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1042.2,692.3c0,0,9.6,18.8,24.4,23.8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1061,720.6c0,0,34.5,296.7,44.7,319.7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M996.2,772.2c0,0-29.1,253.8-35.6,306.1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M975.6,1145.2H874.8c0,0-0.9-3.7-0.3-7.8c0.5-3.7,2.2-7.8,6.6-10.1c9.5-5,46-22.8,53.9-31.1 c7.9-8.3,6.3-12,10.1-12.2c0,0,21.7-1.7,24.2,1.5c2,2.5,4.5,36.3,5.6,52C975.4,1142.2,975.6,1145.2,975.6,1145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M905,1112c0,0,8.7,8.3,13.1,9.5c4.4,1.2,26.6-17.9,28.2-23.2c1.6-5.3,3.4-26.3,3.4-26.3s-13.5,0-18.1,0 c-4.6,0-4.1,24.8-4.1,24.8S902.9,1110.2,905,1112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M975.6,1145.2H874.8c0,0-0.9-3.7-0.3-7.8H975C975.4,1142.2,975.6,1145.2,975.6,1145.2z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M1140.9,1145.2c0,0-3.6,0-60.8,0c0.2-1.8,0.5-4.5,0.9-7.8c1.3-13.5,3-36.5,0.5-46.4c-3-12-0.1-22.3,0-22.8 c0.7,1.1,1.3,1.8,1.8,2.1c12.9,8.8,27.5-2.5,31.5-6.1c7.9,12,18.6,59.7,22.9,67.6c1.1,2.1,1.9,3.9,2.4,5.5 C1141.8,1142.6,1140.9,1145.2,1140.9,1145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M1084.2,1058.1c0,0,4,26.2,5.2,30.1c1.2,4,7.5,28.6,12.3,31c4.8,2.3,9.5,4.6,10.7-0.9c1.2-5.5,0-34,0-38.4 c0-4.4,2.6-26.2,0.5-27.8C1110.8,1050.6,1082.9,1049.9,1084.2,1058.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M1140.9,1145.2c0,0-3.6,0-60.8,0c0.2-1.8,0.5-4.5,0.9-7.8h59.2C1141.8,1142.6,1140.9,1145.2,1140.9,1145.2z "
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M769.7,76.5v132.1c0,19.2-15.5,34.7-34.7,34.7H565.8l-27.6,27.6c-3.9,3.9-10.5,1.1-10.5-4.3v-23.3h-83.2 c-3.4,0-6.1-2.8-6.1-6.1V105.1c0-19.2,15.5-34.7,34.7-34.7h290.5C767,70.4,769.7,73.1,769.7,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M1203.6,103.7v134.5c0,2.8-2.2,5-5,5h-105.9l-27.6,27.6c-3.9,3.9-10.5,1.1-10.5-4.3v-23.3h-149 c-18.4,0-33.4-14.9-33.4-33.4V75.4c0-2.8,2.2-5,5-5h292.9C1188.6,70.4,1203.6,85.3,1203.6,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1260.3,241.6c0,32-25.9,57.9-57.9,57.9c-31.4,0-57-25-57.9-56.2h54.2c2.8,0,5-2.2,5-5v-54.6 C1235,184.3,1260.3,210,1260.3,241.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1203.6,183.6v54.6c0,2.8-2.2,5-5,5h-54.2c0-0.6,0-1.1,0-1.7c0-32,25.9-57.9,57.9-57.9 C1202.7,183.6,1203.2,183.6,1203.6,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.4,48.8v21.5h-31.3c-19.2,0-34.7,15.5-34.7,34.7v37.2H411c-13.1,0-23.7-10.6-23.7-23.7V48.8 c0-13.1,10.6-23.7,23.7-23.7h69.7C493.8,25.1,504.4,35.7,504.4,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M504.4,70.4v48.1c0,13.1-10.6,23.7-23.7,23.7h-42.2v-37.2c0-19.2,15.5-34.7,34.7-34.7H504.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.7,
    y: 276.4,
    className: "st6",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.5,
    y: 301.8,
    className: "st3",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290,
    y: 564.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 2644.2349 1150.3147)",
    className: "st6",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1262.2,
    y: 590.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 2588.5781 1201.0699)",
    className: "st3",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 507.4,
    y1: 122.4,
    x2: 700.8,
    y2: 122.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 507.4,
    y1: 158.3,
    x2: 700.8,
    y2: 158.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 507.4,
    y1: 194.2,
    x2: 700.8,
    y2: 194.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 941.3,
    y1: 120.7,
    x2: 1134.6,
    y2: 120.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 941.3,
    y1: 156.6,
    x2: 1134.6,
    y2: 156.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 941.3,
    y1: 192.6,
    x2: 1134.6,
    y2: 192.6
  })))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1637.2,1171.4H58.1c-7.2,0-13-5.8-13-13l0,0c0-7.2,5.8-13,13-13h1579.1c7.2,0,13,5.8,13,13l0,0 C1650.2,1165.6,1644.4,1171.4,1637.2,1171.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1465.6-2052.7c0,0,283.3-354,345.1-377.8c61.8-23.8,278.8,221.6,183.6,346S-1465.6-2052.7-1465.6-2052.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M-1475.6-2041L-1475.6-2041c0-15.8,7.6-30.7,20.5-40l375.5-269.9c23.2-16.7,55.8-10.1,70.7,14.3l165.2,269.9 c20.1,32.8-3.5,74.9-42,74.9h-540.7C-1453.6-1991.8-1475.6-2013.8-1475.6-2041z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -832.5,
    y: -2010.8,
    className: "st44",
    width: 12,
    height: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -787.6,
    y: -2012.1,
    className: "st44",
    width: 12,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1001.1,
    y: -2015.9,
    className: "st44",
    width: 12,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: -956.3,
    y: -2017.5,
    className: "st44",
    width: 12,
    height: 25.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-828.2-2176.1c-3.1,18.3-9.8,45-13.4,59c-1.5,5.8-2.5,9.4-2.5,9.4l-1.1,1.5l-26,34H-931 c0,0-0.7-20-0.6-43.5c0-2,0-4.1,0-6.2c0.3-30.5,2-64.4,8-67.6c11.1-6,89.1-9.6,95.8-6c0.2,0.1,0.4,0.3,0.5,0.5 C-826-2193-826.6-2185.7-828.2-2176.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -915.7,
    y1: -2167.3,
    x2: -911.2,
    y2: -2162.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -911.2,
    y1: -2167.3,
    x2: -915.7,
    y2: -2162.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -897,
    y1: -2167.3,
    x2: -892.5,
    y2: -2162.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -892.5,
    y1: -2167.3,
    x2: -897,
    y2: -2162.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -878.3,
    y1: -2167.3,
    x2: -873.8,
    y2: -2162.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -873.8,
    y1: -2167.3,
    x2: -878.3,
    y2: -2162.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -859.6,
    y1: -2167.3,
    x2: -855.1,
    y2: -2162.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -855.1,
    y1: -2167.3,
    x2: -859.6,
    y2: -2162.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -916.8,
    y1: -2149.3,
    x2: -912.3,
    y2: -2144.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -912.3,
    y1: -2149.3,
    x2: -916.8,
    y2: -2144.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -898.1,
    y1: -2149.3,
    x2: -893.6,
    y2: -2144.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -893.6,
    y1: -2149.3,
    x2: -898.1,
    y2: -2144.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -879.4,
    y1: -2149.3,
    x2: -874.9,
    y2: -2144.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -874.9,
    y1: -2149.3,
    x2: -879.4,
    y2: -2144.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -860.7,
    y1: -2149.3,
    x2: -856.2,
    y2: -2144.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -856.2,
    y1: -2149.3,
    x2: -860.7,
    y2: -2144.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -917.9,
    y1: -2131.3,
    x2: -913.3,
    y2: -2126.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -913.3,
    y1: -2131.3,
    x2: -917.9,
    y2: -2126.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -899.2,
    y1: -2131.3,
    x2: -894.6,
    y2: -2126.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -894.6,
    y1: -2131.3,
    x2: -899.2,
    y2: -2126.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -880.5,
    y1: -2131.3,
    x2: -875.9,
    y2: -2126.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -875.9,
    y1: -2131.3,
    x2: -880.5,
    y2: -2126.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -861.8,
    y1: -2131.3,
    x2: -857.2,
    y2: -2126.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -857.2,
    y1: -2131.3,
    x2: -861.8,
    y2: -2126.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -918.9,
    y1: -2113.4,
    x2: -914.4,
    y2: -2108.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -914.4,
    y1: -2113.4,
    x2: -918.9,
    y2: -2108.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -895.7,
    y1: -2113.4,
    x2: -900.2,
    y2: -2108.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -900.2,
    y1: -2113.4,
    x2: -895.7,
    y2: -2108.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -881.5,
    y1: -2113.4,
    x2: -877,
    y2: -2108.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -877,
    y1: -2113.4,
    x2: -881.5,
    y2: -2108.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -862.8,
    y1: -2113.4,
    x2: -858.3,
    y2: -2108.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -858.3,
    y1: -2113.4,
    x2: -862.8,
    y2: -2108.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -920,
    y1: -2095.4,
    x2: -915.5,
    y2: -2090.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -915.5,
    y1: -2095.4,
    x2: -920,
    y2: -2090.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -901.3,
    y1: -2095.4,
    x2: -896.8,
    y2: -2090.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -896.8,
    y1: -2095.4,
    x2: -901.3,
    y2: -2090.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -882.6,
    y1: -2095.4,
    x2: -878.1,
    y2: -2090.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -878.1,
    y1: -2095.4,
    x2: -882.6,
    y2: -2090.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -863.9,
    y1: -2095.4,
    x2: -859.4,
    y2: -2090.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -859.4,
    y1: -2095.4,
    x2: -863.9,
    y2: -2090.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-796-2113.1c-4.7-0.9-9.7,0.5-14.2,2.8c-6,3.1-10.9,8.1-12.4,11.6c-0.4,0.9-0.9,2.5-1.5,4.7 c-5.6,19.5-20,84.2-20,84.2s-33.3,0-70.5-0.7c-47.9-0.9-102.4-2.7-101.5-6.9c1.6-7,13.2-73.5,32.9-93c1.2-1.2,2.4-2.2,3.6-3 c18.4-12.1,41.2-9.7,48.1-8.6c0,2.1,0,4.2,0,6.2c-24.3,2.6-30.5,31.3-32,48.6c-0.6,6.9-0.5,12-0.4,12.9c0,0.1,0,0.1,0,0.1h80.2 c0,0,1.8-8.2,4.8-18.2c3.8-12.6,9.6-28,16.4-33.8c6.1-5.2,12.7-8.6,19.2-10.6c0.6-0.2,1.2-0.4,1.9-0.5c12-3.2,23.9-2.1,33.3,0.1 C-803.4-2115.8-799.2-2114.3-796-2113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-770.3-2011.8l-73.9,2.1c0,0,17.8-80.1,21.5-88.9c2.6-6.2,15.5-16.5,26.6-14.5c2.2,0.4,4.3,1.3,6.2,2.8 c0,0,0,0,0,0c2.3,1.8,4.4,4.5,6.1,8.3C-773.5-2078.9-770.3-2011.8-770.3-2011.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-808.4-2117c-9.4-2.2-21.2-3.4-33.3-0.1c5.6-21.3,18.2-71.8,14.3-78c7.3,1.5,26.8,6.8,29.2,20 C-796.3-2165.4-802.8-2137.8-808.4-2117z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-879.1-2072.2c-3,10-4.8,18.2-4.8,18.2H-964c0,0,0,0,0-0.1c9.5-8.2,33-18.1,33-18.1H-879.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-931-2072.2c0,0-23.5,9.8-33,18.1c-0.1-3.2-1.5-57.9,32.5-61.6c0-2,0-4.1,0-6.2L-931-2072.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-828.2-2176.1c-3.1,18.3-9.8,45-13.4,59c-0.6,0.2-1.2,0.3-1.9,0.5c-6.5,2-13.1,5.3-19.2,10.6 c-6.8,5.8-12.6,21.2-16.4,33.8h-48.1L-828.2-2176.1z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-1401.5-2071.1c0,0,3.1-24.2,15.6-34.2c12.5-10,13.4-25.6,13.4-25.6s17,59-4.7,69.9 C-1399-2050.2-1401.5-2071.1-1401.5-2071.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1372.6-2131c0.7,7,0.6,14.1,0,21.1c-0.6,7-1.8,14-3.7,20.8c-2,6.8-4.7,13.3-8.4,19.3 c-1.8,3-4,5.8-6.3,8.5c-2.3,2.7-5,5-7.7,7.2c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.1-0.3,0-0.4l0,0l0,0c2.7-2.2,5.4-4.5,7.7-7.1 c2.3-2.6,4.5-5.4,6.3-8.4c3.7-5.9,6.5-12.5,8.5-19.2c2-6.7,3.2-13.7,3.9-20.7C-1372.1-2116.9-1372-2124-1372.6-2131z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-1407.1-2348c0,0-31.4,102.2-7.6,190.4c23.8,88.2-8.9,120.6-8.9,120.6l24.7-24.8c0,0,10.5-78.1,7.9-117.7 l-7.9-4l8.3-7.1C-1390.5-2190.7-1412.5-2281.9-1407.1-2348z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1407.1-2348c-2.5,11.7-4.4,23.5-6,35.3c-1.6,11.8-2.9,23.7-3.7,35.6c-0.1,1.5-0.2,3-0.3,4.5l-0.2,4.5 c-0.1,3-0.3,6-0.4,8.9c-0.1,6-0.3,11.9-0.2,17.9l0,4.5l0,2.2l0.1,2.2l0.4,8.9c0,0.7,0.1,1.5,0.1,2.2l0.2,2.2l0.4,4.5 c0.3,3,0.5,6,1,8.9l1.3,8.9c0.4,2.9,1,5.9,1.5,8.8c1,5.9,2,11.8,2.9,17.7c1.9,11.8,3.5,23.6,4.7,35.5c1.2,11.9,2,23.8,1.8,35.8 c0,6-0.4,11.9-0.9,17.9c-0.6,6-1.4,11.9-2.5,17.8c0,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.2-0.2-0.3l0,0c1-5.9,1.9-11.8,2.5-17.7 c0.5-5.9,0.9-11.9,1-17.9c0.2-11.9-0.6-23.9-1.8-35.7c-1.2-11.9-2.8-23.7-4.6-35.5c-0.9-5.9-1.8-11.8-2.9-17.7 c-0.5-2.9-1-5.9-1.5-8.8l-1.3-8.9c-0.5-2.9-0.7-5.9-1-8.9l-0.4-4.5l-0.2-2.2c-0.1-0.7-0.1-1.5-0.1-2.2l-0.4-8.9l-0.1-2.2l0-2.2 l0-4.5c-0.1-6,0.1-11.9,0.2-17.9c0.1-3,0.3-6,0.4-8.9l0.2-4.5c0.1-1.5,0.2-3,0.3-4.5c0.8-11.9,2.2-23.8,3.8-35.6 C-1411.5-2324.5-1409.6-2336.3-1407.1-2348z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-1405.4-2061.8c0,0,6.7-62.7-5.9-87.2h-8.2l4.8-8.5c0,0-26.4-57.7-100.2-80.3c0,0,46.6,30.8,65.6,88 c9-2.2,15.4-1.8,15.4-1.8l-6.8,8.9c0,0,27.5,44.6,23.8,86.1C-1420.7-2015.1-1405.4-2061.8-1405.4-2061.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1514.9-2237.9c4.2,1.8,8.2,3.9,12.1,6.1c4,2.2,7.8,4.5,11.6,7c7.6,5,14.8,10.4,21.7,16.3 c13.7,11.9,25.7,25.7,35.3,41.1c4.8,7.7,8.9,15.8,12.4,24.2l2.5,6.3c0.8,2.1,1.4,4.3,2.2,6.4l1.1,3.2c0.3,1.1,0.6,2.2,0.9,3.3 l1.7,6.6c3.9,17.7,5.1,36,4,54.1c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3l0,0c1.2-18,0.1-36.3-3.8-53.9l-1.7-6.6 c-0.3-1.1-0.6-2.2-0.9-3.3l-1-3.2c-0.7-2.1-1.3-4.3-2.1-6.4l-2.4-6.3c-3.5-8.3-7.5-16.5-12.3-24.2 c-9.6-15.4-21.5-29.2-35.2-41.1c-6.8-5.9-14.1-11.4-21.6-16.4c-3.8-2.5-7.6-4.8-11.6-7.1 C-1506.8-2234-1510.8-2236.1-1514.9-2237.9z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "-1360.9,-2052.7 -1361.3,-2042.4 -1363.2,-1991.8 -1426.9,-1991.8 -1435.9,-2042.4 -1436.9,-2048.3  -1393.9,-2050.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-1350.2-2063.1v17.6c0,1.7-1.4,3.1-3,3.1h-93c-2,0-3.5-1.9-2.9-3.9l4.8-17.6c0.4-1.3,1.6-2.3,2.9-2.3h88.3 C-1351.6-2066.1-1350.2-2064.7-1350.2-2063.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -1278.5807,
    y1: -2311.4412,
    x2: -1240.8977,
    y2: -2279.6982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "-1244.8,-2291.1 -1253.2,-2280 -1257.9,-2284 -1278.5,-2301.4 -1278.8,-2301.6 -1278.8,-2321.6  -1278.1,-2321.1 -1269.2,-2313  "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1209.4-2275c0,0-0.2,1.2-0.4,3c-5.9,6.6-14.8,15.9-18.4,16.5c-1.6,0.3-4.7-1.8-8.4-4.8 c-9.3-7.7-22.1-22.1-22.2-23.3c-0.1-1.7,7.7-12.6,9.2-13.2c1.5-0.6,17.6,13.8,18.7,14.9c1.1,1.1,17.1-26.5,17.1-26.5 c2.1,2.5,3.4,6.2,4.2,10.2C-1207.6-2287.7-1209.4-2275-1209.4-2275z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1135.4-2233.5c-0.1,0.5-4.4,5.8-7.4,9.5c-1.6,2-2.9,3.5-2.9,3.5s-0.5-0.7-1.2-1.8 c-0.3-0.5-0.7-1.1-1.2-1.9c-0.1-0.2-0.3-0.5-0.5-0.7c-0.1-0.2-0.2-0.3-0.3-0.5c-0.5-0.7-0.9-1.5-1.5-2.3c-0.4-0.6-0.7-1.2-1.1-1.8 c-0.9-1.4-1.7-2.9-2.6-4.4c-0.9-1.6-1.9-3.2-2.7-4.9c-2.2-4.2-4.1-8.2-4.7-11.1c-1.8-7.9,1.1-43.5,1.9-52.5c0.1-1.3,0.2-2,0.2-2 s0.6,0.5,1.6,2.1c0.3,0.5,0.7,1.1,1,1.8c1.2,2.3,2.8,5.9,4.5,11.2c1.6,4.9,3.4,11.4,5.2,19.8c5.3,24.6,10.1,32.7,11.4,35 C-1135.5-2233.9-1135.3-2233.6-1135.4-2233.5z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1149.7-2207.6c-0.1,0.9-0.3,1.8-0.6,2.6c-0.1,0.3-0.2,0.6-0.3,0.8c-0.4,0.9-1.1,1.6-2,2.3 c-1.2,0.8-2.9,1.5-4.8,2c-1.4,0.4-3,0.7-4.7,0.9c-2.3,0.3-4.8,0.5-7.5,0.5c-14.3,0.3-32.7-2.7-40.8-7.3c-1.2-0.7-2.1-1.3-2.8-2.1 c-1.5-1.6-2.5-3.5-3-5.8c-0.5-2.2-0.5-4.7-0.3-7.5c0.4-5.4,1.9-11.8,3.3-18.7c0.5-2.4,0.9-4.9,1.3-7.4c0.6-4.1,1.1-8.3,1.2-12.5 c0.1-4.7,0.6-9.4,0.9-12.3c0-0.1,0-0.3,0-0.4c0.2-1.7,0.4-2.7,0.4-2.7s3.5-24.2-4.3-33.4c7.2-3.2,11.5-5.3,14.6-6.6 c4.8-2.2,6.6-2.7,11.9-3.6c0,0,9.6,2.1,18.6,7.2c3.5,2,7,4.5,9.6,7.5c0.5,0.6,1,1.1,1.4,1.7c0,0,0,0,0,0c0.6,0.8,1,2.2,1.3,4.1 c0.5,3.8,0.5,9.4,0.2,15.6c-0.1,2-0.2,4-0.4,6c-0.8,11.5-2,23.6-1.8,29.2c0.1,2.4,0.7,5.3,1.6,8.5c2,7.3,5.4,15.9,6.7,23.4 C-1149.6-2212.6-1149.4-2210-1149.7-2207.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -1168.699,
    y1: -2363.571,
    x2: -1202.1118,
    y2: -2300.0867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M-1174.8-2322.9c0.1,5.9,1.7,17.8-8.3,17.3c-0.2,0-0.4,0-0.6,0c-9.7-0.9-5.9-10.2-6.9-13 c-0.5-1.4-1.7-1.4-3.2-1.5c-1.6-0.1-3.4-0.3-5-2.3c-1.7-2.2-2.7-8.4-3.2-13.3c-0.2-1.5-0.3-2.9-0.4-4.1c10.9-0.4,24.9-6,24.9-6 s-0.2,0.8-0.4,2c-0.2,1.4-0.4,3.4-0.3,5.5c0.1,3.9,1.9-4.9,5-3.2c3.1,1.7-0.4,8.4-2.5,10.7 C-1177.1-2329.3-1176.1-2325.3-1174.8-2322.9z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-1164.7-2329.5c-3.9,5-7.7,8.6-8.3,8.7c-0.5,0-1.2-0.8-1.8-2c-1.3-2.4-2.4-6.4-1-7.9 c2.1-2.3,5.6-9,2.5-10.7c-3.1-1.7-4.9,7.1-5,3.2c-0.1-3.9,0.7-7.5,0.7-7.5s-14,5.6-24.9,6c-1.5,0.1-2.9,0-4.2-0.2 c-0.6-2.4-0.8-4.6-0.8-6.5c0-4.8,1.4-7.9,1.6-8.4c-0.2,0.3-1.5,2.3-3.6,8.3c1.8-17.1,7.8-21.1,23-22.5 c15.2-9.2,18.7,10.3,18.7,10.3s8.8-3.9,11.7,7.4C-1154.5-2344.9-1159.6-2336-1164.7-2329.5z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1133.4-2225.2c-1.2,2-3.9,4.4-6.3,6.2c-1,0.7-2,1.4-2.8,1.9c-1,0.6-1.8,0.9-2.1,0.9 c-1.3-0.4-2.9-2.5-2.8-4.7c0-0.3,0.2-0.8,0.5-1.3c0.6-1,1.6-2.3,2.8-3.8c3.2-3.9,7.5-8.5,7.5-8.5c0.3-0.1,0.6,0,1,0.3 c1.2,1,2.5,4.2,2.9,7C-1132.7-2226.7-1132.9-2226-1133.4-2225.2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1245.2-2296.9c0,0-8.2,21-11.3,19.5c-3.1-1.5-6.3-4.6-5-8.4c1.3-3.8,8.5-14.8,12.7-13.4 C-1244.6-2297.8-1244.3-2299.1-1245.2-2296.9z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1174.7-2314.5c0,0-0.7,8.2-6.5,8.8c3.8,5,6,4.2,7.1,3.4C-1173-2303-1171.6-2312.1-1174.7-2314.5z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1139.3-2013.9c-3.3,4.9-18.6,5.5-21.2,1.9c-2.6-3.6-5.2-117.4-16.6-157.4c-7,12-3.2,152.9-6.1,156.2 c-1.3,1.4-24.1,6.4-25.5-1.7c-6.7-40.3-4.5-129.7-2.7-172.6c0.3-7.8,0.6-14,0.8-18.2c12.3,6.9,48.4,10.4,57.9,3.7 c0.2,0.5,0.4,1,0.6,1.6C-1133.3-2147.3-1136.1-2018.5-1139.3-2013.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1182.8-1991.9h-40.2c0,0,0.4-12,7.7-12.5c1.3-0.1,2.4,0.1,3.4,0.4c4.3,1.5,5.4,6.7,5.4,6.7h22.7 C-1184-1997.3-1182.7-1994.4-1182.8-1991.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -1212.0142,
    y1: -2004.1522,
    x2: -1184.7921,
    y2: -2004.1522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M-1184.8-1997.3h-21.9c0,0-1-5.1-5.4-6.7c2.2-1.6,5.9-4.4,6.7-6c7.6-1.7,17.6-0.8,18.3,0 C-1186.3-2009.2-1184.8-1997.3-1184.8-1997.3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1209-2006.2c0,0,4.6,0.9,6.1,0.7c1.5-0.2,6.7-12.2,6.1-13.6c-0.7-1.4-8.8-0.8-9.5,0 C-1207.1-2018.2-1207.4-2009.1-1209-2006.2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1161.5-1991.8l40.2-0.2c0,0-0.5-12-7.7-12.5c-1.3-0.1-2.4,0.1-3.4,0.4c-4.3,1.6-5.3,6.7-5.3,6.7l-22.7,0.1 C-1160.4-1997.2-1161.6-1994.3-1161.5-1991.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -1159.5575,
    y1: -2004.089,
    x2: -1132.3687,
    y2: -2004.089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M-1159.6-1997.2l21.9-0.1c0,0,1-5.1,5.3-6.7c-2.2-1.5-6-4.3-6.7-6c-7.6-1.6-17.6-0.8-18.3,0.1 C-1158.1-2009.1-1159.6-1997.2-1159.6-1997.2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1135.4-2006.3c0,0-4.6,1-6.1,0.8c-1.5-0.2-6.8-12.1-6.1-13.5c0.7-1.4,8.8-0.9,9.5,0 C-1137.4-2018.2-1137-2009.1-1135.4-2006.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -1148.8342,
    y1: -2233.2959,
    x2: -1082.5706,
    y2: -2133.6218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M-1115.3-2184.4c0,5.3-4.8,5.7-8.1,3.9c-2.9-1.5-6.7-14.4-9.7-21.2c-0.5-1.2-1-2.2-1.4-2.9 c-2-3.2-5.6-8.9-8-12.5c0.8-0.5,1.8-1.1,2.8-1.9c2.5-1.8,5.1-4.2,6.3-6.2c2.2,5.1,6.9,15.6,8.2,16.5c1.7,1.2,9.5,9.9,9.9,12.4 c0.4,2.5-2.6,0.7-3.9,0.6C-1120.5-2195.8-1115.2-2189.7-1115.3-2184.4z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1198-2198.4c0,0,2.2,8.4-8.4,14.8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1161.1-2195.6c0,0,0.7,9.7,12.4,12"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1203-2175.4c0,0-9.9,98.5,0,153.6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1171.6-2169.4c0,0,17.8,99.5,14.5,155.5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1209.4-2275c0,0-0.2,1.2-0.4,3c-5.9,6.6-14.8,15.9-18.4,16.5c-1.6,0.3-4.7-1.8-8.4-4.8 c2.2,0.1,5.1,0.1,7.8-0.2c5.1-0.5,17.7-27,19.2-37.7C-1207.6-2287.7-1209.4-2275-1209.4-2275z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1190.5-2318c0,0-0.8,10.6,7.4,12.4c-0.1,3.9-5.9,6.6-7.4,4.9C-1192-2302.4-1196.5-2313.9-1190.5-2318z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -1270.486,
    y1: -2264.3103,
    x2: -1221.4841,
    y2: -2296.8853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M-1203.7-2307.6c-4.2,1-16.9,3-18.9,5c-0.2,0.2-0.6,1-1.3,2.3c-5.3,11-24.4,56.5-36,55 c-0.2,0-0.4-0.1-0.6-0.1c-6.5-1.4-13-11-17.8-20.1c-2.3-4.4-4.2-8.7-5.5-11.8c6.9-1.5,15.4-7.4,18.4-10.3c0.3,0.6,0.5,1.3,0.8,2 c2,5.2,3.8,11.2,4.5,13.6c0.2,0.7,0.3,1.1,0.3,1.1s0.5-0.5,1.2-1.3c4.3-4.7,18.6-20.5,20.7-27.5c2.4-8.2,5.9-20.4,8.2-18.9 c2.2,1.5,0.2,8.9,3.5,8.4C-1209.1-2314.1-1200.5-2308.3-1203.7-2307.6z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1287.5-2322.8c0,0.6,0,1,0,1.4c0,0.5-0.6,0.8-1.8,1.1c-8.6,2.4-45.4,0.6-51.3-7.3 c-0.6-0.8-0.9-1.7-0.8-2.6c0,0,7.8-18.5,31.5-16c19.2,2,22.1,14.3,22.4,21.1C-1287.5-2324.2-1287.5-2323.4-1287.5-2322.8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-1264.4-2289c0,0.3-0.4,0.8-1.1,1.5c-2.1,2.1-7.1,5.7-12.3,8.2c-1.3,0.6-2.6,1.1-3.9,1.6 c-0.6,0.2-1.2,0.4-1.8,0.5c-0.1,0-0.2,0.1-0.4,0.1c-0.5,0.1-1,0.2-1.4,0.3c0,0,0,0-0.1,0c-0.3,0-0.7,0.2-1,0.4 c-0.4,0.3-0.8,0.9-1.2,1.6c-1.1,2.2-1.8,6.1-2.1,10.9c0,0.5-0.1,1-0.1,1.6c0,0.4,0,0.8-0.1,1.3c0,0.5,0,1-0.1,1.6 c-0.1,3.4-0.1,7.1,0,10.9c0,0.5,0,1,0,1.6c0,0.4,0,0.9,0,1.3c0,0.5,0,1,0.1,1.6c0.1,3.7,0.3,7.4,0.5,10.9c0,0.5,0.1,1,0.1,1.6 c0,0.4,0,0.9,0.1,1.3c0,0.5,0.1,1.1,0.1,1.6c0.3,4.3,0.6,8.1,0.9,10.9c0,0.2,0,0.5,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9 c0,0.5,0.1,0.9,0.1,1.3c0.1,0.7,0.1,1.2,0.2,1.6c0.1,0.4,0.1,0.7,0.1,0.7c0.1,0.5-5.7,1.9-13.7,2.9c-6.9,0.8-15.4,1.3-23.1,0.4 c-2.9-0.3-5.7-0.8-8.2-1.6c-2.2-0.6-4.2-1.4-5.9-2.4c-0.1-0.1-0.2-0.1-0.4-0.2c-0.6-0.4-1.2-0.8-1.8-1.4c-0.4-0.4-0.8-0.8-1.2-1.3 c-0.4-0.5-0.8-1-1.1-1.6c-0.1-0.1-0.1-0.2-0.2-0.3c-1.6-2.8-2.6-6.5-3.1-10.6c-0.1-0.5-0.1-1-0.2-1.6c0-0.4-0.1-0.8-0.1-1.3 c0-0.5-0.1-1-0.1-1.6c-0.1-3.5,0-7.2,0.3-10.9c0-0.5,0.1-1,0.1-1.6c0-0.4,0.1-0.9,0.1-1.3c0.1-0.5,0.1-1,0.2-1.6 c0.4-3.9,1-7.7,1.6-10.9c0.1-0.5,0.2-1.1,0.3-1.6c0.1-0.4,0.2-0.9,0.3-1.3c0.1-0.5,0.2-1.1,0.3-1.6c0.9-4,1.5-6.6,1.5-6.6 l-0.3-4.3l-0.1-1.6l-0.1-1.3l-0.1-1.6l-0.1-0.6l-0.4-4.7c0,0-0.9,2.4-2.2,5.4c0,0,0,0.1-0.1,0.1c-0.2,0.5-0.4,0.9-0.6,1.4 c-0.2,0.4-0.4,0.8-0.5,1.3c-0.2,0.4-0.4,0.8-0.5,1.2c0,0.1-0.1,0.2-0.1,0.3c-1.7,4-3.6,7.8-4.4,8.3c-0.2,0.1-0.5,0.1-0.9,0.1 c-2.7-0.4-9.7-4.1-14.1-8.4c-0.5-0.5-1-1-1.5-1.6c-0.2-0.3-0.4-0.5-0.6-0.8c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.5-0.6-1-0.9-1.6 c-0.2-0.4-0.3-0.9-0.4-1.3c0,0,1.6-4,4-9.6c0.2-0.5,0.4-1,0.7-1.6c0.2-0.4,0.4-0.8,0.6-1.3c0.2-0.5,0.5-1,0.7-1.6 c0.7-1.6,1.5-3.4,2.3-5.1c0.9-1.9,1.8-3.9,2.8-5.8c0.3-0.5,0.5-1,0.8-1.6c0.2-0.4,0.4-0.9,0.6-1.3c0.3-0.5,0.6-1.1,0.8-1.6 c0.4-0.8,0.9-1.6,1.3-2.3c1.8-3.2,3.6-5.9,5.2-7.6c0.1-0.2,0.3-0.3,0.5-0.5c0.1-0.1,0.3-0.3,0.5-0.5c0.5-0.5,1.1-1,1.8-1.6 c0.5-0.4,1.1-0.9,1.7-1.3c0.7-0.5,1.5-1.1,2.4-1.6c3-1.8,6.4-3.4,9.9-4.8c1.2-0.5,2.4-0.9,3.6-1.3c6.4-2.1,12.9-3.3,17.5-3.2 c4.2,0.2,10.7,2.4,17.2,5.1c1.9,0.8,3.8,1.7,5.7,2.6c1.1,0.5,2.1,1,3.1,1.5c1,0.5,2,1,3,1.6c0.8,0.4,1.6,0.9,2.3,1.3 c0.3,0.2,0.6,0.4,0.9,0.5c0.6,0.4,1.2,0.7,1.7,1c1.8,1.1,3,2,3.4,2.5c0.1,0.1,0.1,0.2,0.2,0.3c0.8,1.2,2.1,4.3,3.6,8.1 c0.2,0.5,0.4,1,0.6,1.6c0.1,0.3,0.2,0.6,0.4,0.9c0,0.1,0.1,0.2,0.1,0.3c0.2,0.5,0.4,1,0.6,1.6c1.4,3.8,2.8,7.8,3.9,10.9 c0.2,0.5,0.4,1.1,0.5,1.6c0.2,0.5,0.3,0.9,0.4,1.3c0.2,0.6,0.4,1.1,0.5,1.6C-1264.5-2289.6-1264.4-2289.2-1264.4-2289z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -1372.4646,
    y1: -2221.8994,
    x2: -1404.0192,
    y2: -2254.939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M-1352.2-2266.6c-1,2.3-2.9,6.5-5.1,11.2c-4.4,9.7-10,21.2-11.4,21.8c-2.4,1.1-37.1-1.6-41.6-0.5 c-4.5,1.1-15.8,16-21.3,15.3c-5.6-0.6-0.4-14.3,8-19.9c-4.5-0.1-5.7-1.6-5.9-3.8c1.3-1.5,8.2-0.3,13.4-1.5 c5.2-1.1,34.6-6.7,37.8-7l7.9-20.9l2-5.4C-1364.7-2272.2-1355.4-2267.1-1352.2-2266.6z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1273-2019.6c-1.4,1.1-3,1.9-4.8,2c-4.9,0.3-9.9,0.1-13.6-1.8c-1.1-0.6-2.1-1.3-3-2.3 c-0.4-0.5-1-2.7-1.7-6.4c-2.5-13.1-6.4-43.9-10-73.5c-4.1-34-7.7-66.4-8-68.5l0-0.1c0,0-18.8,89.1-29.1,143.3 c-0.3,1.8-0.7,3.5-1,5.2c-0.9,1.6-2.2,2.8-3.8,3.7c-5,2.9-12.4,2.2-16.7-0.3c-1.6-0.9-2.7-2.1-3.2-3.4c-0.2-0.5-0.2-2.3-0.1-5.2 c0.7-24.6,10.1-128.1,14-170.4c0.3-3.4,0.6-6.5,0.8-9c6.5,6.9,17.3,5,19.5,1.8c0.3-0.5,0.7-3,1.1-6.9c8.8,2.5,22.2,1.1,31.6,0 c0,0.4,0.1,0.8,0.1,1.2c0,0,0,0.1,0,0.1c0.2,1.7,0.4,2.8,0.6,3.4c2.8,6.2,10.6,6,17.5,2.5c3.3,37.9,13,150.4,14.6,170.2 c0.1,1.6,0.2,2.6,0.2,2.9C-1267.5-2027.6-1269.5-2022.4-1273-2019.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.7206,
    y1: -2034.0143,
    x2: -1353.5968,
    y2: -1960.2496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M-1343.6-1991.9h-25.2c0,0,0.2-1.9,0.5-4.2c0.5-3.1,1.2-7.2,2.2-8.8c0.2-0.4,0.5-0.6,0.7-0.7 c1.5-0.7,1.6-3.8,3.3-5.8c0.8-0.9,2-1.6,3.8-1.7c1.3-0.1,2.2,0.2,3,0.7c2.7,1.8,2.9,6.2,3.9,6.9c0.4,0.3,1,0.4,1.7,0.8 c1.4,0.7,3.3,2.4,4.8,7.4C-1344.4-1995.8-1344-1994-1343.6-1991.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -1269.5598,
    y1: -2032.9591,
    x2: -1263.4344,
    y2: -1959.1742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M-1240.6-1991.9h-51.1c0,0,0.2-4.5,0.7-8.8c0.3-2.7,0.8-5.3,1.4-6.5c0.1-0.1,0.1-0.2,0.2-0.3 c1.9-2.4,9.5,3.4,11.6,3.1c2.2-0.3,2.6-6,4.9-7.2c0.1,0,0.1-0.1,0.2-0.1c0.6-0.1,1.4,0.3,2.4,1.1c3.2,2.4,8.3,8.2,14,8.9 c1.5,0.2,3,0.3,4.5,0.5c4.9,0.6,9.2,1.6,10.7,6.1C-1240.9-1994.2-1240.7-1993.2-1240.6-1991.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -1280.1154,
    y1: -2097.459,
    x2: -1283.4563,
    y2: -1954.9099
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M-1272.7-2011.7c-0.1,0-0.1,0-0.2,0.1c-2.2,1.3-2.6,7-4.9,7.2c-2.1,0.3-9.7-5.5-11.6-3.1 c-0.4-2.3-0.8-5.1-1.2-7.5c-0.3-1.7-0.5-3.2-0.7-4.4c3.7,1.9,8.7,2.1,13.6,1.8c1.8-0.1,3.4-0.8,4.8-2l0.2,5.1L-1272.7-2011.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -1354.934,
    y1: -2099.2126,
    x2: -1358.275,
    y2: -1956.6626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M-1347.9-2018l-0.2,1.4l-1.6,12c-0.8-0.4-1.4-0.6-1.7-0.8c-1-0.8-1.1-5.2-3.9-6.9c-0.8-0.5-1.7-0.8-3-0.7 c-1.8,0.1-3,0.8-3.8,1.7c-1.7,2-1.8,5.1-3.3,5.8c-0.3,0.1-0.5,0.4-0.7,0.7l0.7-6.8l0.7-6.6 C-1360.3-2015.8-1352.9-2015.1-1347.9-2018z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1331.7-2201.6c0,0-6.1,12.4-17.3,10.7"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -1341.4,
    y1: -2187.5,
    x2: -1341.5,
    y2: -2186.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st62",
    x1: -1341.8,
    y1: -2184.2,
    x2: -1358.8,
    y2: -2025.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: -1358.9,
    y1: -2024.3,
    x2: -1359,
    y2: -2023.2
  })))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st31",
    x1: -1311.3,
    y1: -2169.4,
    x2: -1286.3,
    y2: -2021.8
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1306.1-2101.6c-4.1-34-7.7-66.4-8-68.5l0-0.1c0,0,5.4,0.3,15.2-5.2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1343.2-2027c-0.3,1.8-0.7,3.5-1,5.2c-0.9,1.6-2.2,2.8-3.8,3.7c-5,2.9-12.4,2.2-16.7-0.3 c-1.6-0.9-2.7-2.1-3.2-3.4c-0.2-0.5-0.2-2.3-0.1-5.2C-1362-2024.7-1352.7-2022.8-1343.2-2027z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1273-2019.6c-1.4,1.1-3,1.9-4.8,2c-4.9,0.3-9.9,0.1-13.6-1.8c-1.1-0.6-2.1-1.3-3-2.3 c-0.4-0.5-1-2.7-1.7-6.4c6.2,2.9,19.2,6.7,28.1-5.8c0.1,1.6,0.2,2.6,0.2,2.9C-1267.5-2027.6-1269.5-2022.4-1273-2019.6z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1272.8-2014.5c-6.7,1.4-13.6,0.4-17.8-0.5c-0.3-1.7-0.5-3.2-0.7-4.4c3.7,1.9,8.7,2.1,13.6,1.8 c1.8-0.1,3.4-0.8,4.8-2L-1272.8-2014.5z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-1251.9-2001.3c-3.2,3.1-17.5-2-18.9-3.4c-1.1-1.2-0.2-4.1,0.5-6c3.2,2.4,8.3,8.2,14,8.9 C-1254.8-2001.6-1253.3-2001.4-1251.9-2001.3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1240.6-1991.9h-51.1c0,0,0.2-4.5,0.7-8.8c1.6,1.9,4.1,4.5,7,5.4c3.9,1.2,32.4,0.4,42.8,0.1 C-1240.9-1994.2-1240.7-1993.2-1240.6-1991.9z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M-1360.3-2010.7c0,0-2.9,3.8-2.9,6c0,2.2,2.1,5.1,4.6,5.7c2.5,0.6,4.5-2.6,4.6-4.7 C-1353.7-2005.9-1353.8-2011.5-1360.3-2010.7z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1343.6-1991.9h-25.2c0,0,0.2-1.9,0.5-4.2c5.2,0.4,18.5,1.2,23.4-1.2 C-1344.4-1995.8-1344-1994-1343.6-1991.9z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1347.9-2018l-0.2,1.4c-2.2,2.1-4.7,3.4-7.2,4.2c-0.8-0.5-1.7-0.8-3-0.7c-1.8,0.1-3,0.8-3.8,1.7 c-1.3,0-2.5-0.1-3.3-0.2l0.7-6.6C-1360.3-2015.8-1352.9-2015.1-1347.9-2018z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1330.1-2253.1c-0.5,11.5-1,22.2-1.6,30.6c-0.3,4.4-0.6,8.1-0.9,11.1c-0.4,4-0.8,6.4-1.1,6.9 c-2.2,3.2-13,5.1-19.5-1.8c-0.8-0.9-1.6-1.9-2.2-3.1c-5.7-10.2,11.8-55.3,10.2-69.9c0-0.3-0.1-0.6-0.1-0.9 c-1.9-10-7.5-25.1-10.2-32.1c-0.9-2.4-1.5-3.9-1.5-3.9c-1.1-8.9,20-21.7,26.2-18.4c0.3,0.7,0.5,1.8,0.7,3.2 c0.2,1.2,0.3,2.7,0.5,4.3C-1328.5-2312.1-1329-2280.5-1330.1-2253.1z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1273.7-2322c0,0-0.5,1.4-1.2,3.9c-2.5,8.2-7.9,27.7-8.3,40.7v0.1c0,0.6,0,1.1,0,1.7c0,0.3,0,0.7,0,1 c0.6,16.4,12.2,62.4,4.7,67.9c-1.2,0.9-2.5,1.7-3.9,2.4c-0.1,0.1-0.2,0.1-0.3,0.2c-6.9,3.4-14.8,3.7-17.5-2.5 c-0.3-0.6-0.5-1.8-0.7-3.5v0c0-0.3-0.1-0.7-0.1-1.1c-0.2-2.3-0.3-5.4-0.4-9.1c-0.1-8.5,0-20,0.4-32.4c0.1-3,0.2-6.1,0.3-9.2 c0.2-6.3,0.5-12.7,0.8-18.9c1-18.9,2.3-36.1,3.6-44.2c0.1-0.5,0.2-1,0.2-1.4c0,0,0-0.1,0-0.1c0.2-1,0.4-1.8,0.6-2.4 c0-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0-0.1c0.1-0.3,0.3-0.6,0.4-0.8C-1290-2337.2-1273.1-2323.9-1273.7-2322z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1330.1-2253.1l-0.8,2.1c0,0-6.7-68.8-8.4-73.8c-1.7-5,8.4-9.8,8.4-9.8 C-1328.3-2327.3-1328.7-2287-1330.1-2253.1z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1300.9-2252.8c0.1-3,0.2-6.1,0.3-9.2c1-26.7,2.8-54.9,4.7-64.5c0,0,0-0.1,0-0.1c0.2-1,0.4-1.8,0.6-2.4 c0-0.2,0.1-0.3,0.1-0.4c0.1-0.3,0.3-0.6,0.4-0.8c2.4,0.6,5.5,2.4,7.2,7.4C-1285.5-2317-1292.5-2277.3-1300.9-2252.8z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1338.1-2243.3c0,0-0.8,6.4-9.7,9.8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1295.7-2243.3c0,0,0.8,6.4,9.7,9.8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1258.7-2272.1c-0.4,3.8-1.1,9.8-1.5,8.8c-0.7-1.4,0-8.6,0-8.6c0.2,0.7,0.3,1.1,0.3,1.1 S-1259.5-2271.3-1258.7-2272.1z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-1277.6-2374.7c-1.8,3.4-4.2,7.1-7.7,9.6c-1.3,0.9-2.7,1.7-4.4,2.1c-2.5,0.7-5.5,0.9-9,0.1 c-2.6-0.6-3.7-1.7-3.7-1.7s0.4,3.1,7,5.5c-4.2-0.7-8.9-0.2-10.9-5.6c0,0-0.7,0.8-1.5,2.2c-1.2,2-2.6,5.2-2.9,9.3 c-5.2-8.1-5.3-10.4-9.4-9.3c-4.1,1.1-1.8,7.3,0.8,8.7c2,1.1,0.1,6-1.2,8.4c-0.4,0.8-0.5,1.4-0.5,1.4s-0.6-9-7.8-13 c-1.9-1.1-3.6-2.8-5-4.9c-3.8-5.7-4.9-14.2,0.1-19.7c6.8-7.5,13.8-3.2,13.8-3.2s-0.6-15.5,11.1-19.9c-5.7,6-6.4,11.9-6.5,12.4 c0.1-0.6,2-9.6,13.8-10.9c12.3-1.4,12.4,11.3,12.4,11.3s0.3-3.8,7.3-3.2c2.9,0.3,4.7,2.7,5.6,5.9 C-1274.8-2384.5-1275.5-2378.5-1277.6-2374.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -1321.4198,
    y1: -2353.7612,
    x2: -1283.181,
    y2: -2327.4026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M-1289.6-2363c0,1.7-0.1,4.1-0.4,6.9c-0.8,7.5-3.4,17.1-10.8,19.7c-1.6,0.6-2.9-0.2-3.9-0.7c0,0,0,0,0,0 c-0.6-0.3-1.1-0.5-1.5-0.3c-0.7,0.4,0.1,2.8,0.4,5.6c0.3,2.1,0.4,4.4-0.4,6.1c-1.9,4.2-3.9,5.8-9.2,5.7c-5.3-0.2-8.2-4.8-6.6-10.3 c0.8-2.7,1.1-6.5,1.1-9.9c0-1.8-0.1-3.6-0.2-5c1.3-2.4,3.8-7.5,1.9-8.6c-2.6-1.4-4.9-7.6-0.8-8.7c1.8-0.5,2.8-0.3,3.8,0.7 c1.3,1.3,2.6,4,5.5,8.6c0.3-4.1,1.8-7.3,2.9-9.3c0.4-0.7,0.8-1.3,1.1-1.7c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.2,0.3-0.3,0.3-0.3 c1.9,5.4,6.7,4.8,10.9,5.6c-6.6-2.4-7-5.5-7-5.5s1.1,1.1,3.7,1.7C-1295-2362.1-1292.1-2362.2-1289.6-2363z"
  }))), /*#__PURE__*/React.createElement("g", null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-1071.3-2353c0,0-19.4-29.2,5.1-41.8s41.6,8.9,37.3,26.7c-1.6,6.7,9.8,5.5,9.3,16.7 c-0.5,11.2-1,17.3,11.9,25.8c12.9,8.4,19.2,23.6,15.8,41.7c-3.3,18,21.9,34.7,15.2,57c-6.7,22.3-46.8,30-61.6,12.4 s-26.1-83.6-26.1-83.6l14.4-29.4l-6-22.6L-1071.3-2353z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1000.1-2030.3c0,0-0.2,0.2-0.5,0.5c-1.9,1.7-8.7,7-14.8,2.9c-0.3-0.2-0.5-0.5-0.8-1c0,0,0,0,0,0 c-1.4-2.2-3.3-7.8-5.5-15.6c-11.1-38.8-29.9-131.8-29.9-131.8l-6.3,69.4l-6.3,69l-1.5,16.7c0,0-11.9,2.7-20.2-2.9 c-0.2-2.6-0.3-5.7-0.4-9.4c-1-49.3,5.8-186.5,5.8-187.9c1.5,3.8,4.8,7.3,10.9,9.4c0,0,0,0,0,0c0.2,0.1,0.5,0.1,0.7,0.2 c2.1,0.7,4.5,1.2,7.3,1.5c17.5,2.1,32.3-1.8,38.1-8.1c0.3-0.3,0.6-0.6,0.8-0.9c2.5,5.9,4.7,15,6.1,25.5 c1.3,10.1,1.9,21.6,1.2,32.7c-1.2,21.3,9.5,93.1,13.7,119.8C-1000.7-2034.1-1000.1-2030.3-1000.1-2030.3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1014.3-2321.9c-0.6,1-1.1,2.2-1.6,3.3c-0.2,0.5-0.4,1-0.6,1.5c-1,2.6-1.8,5.4-2.4,8.2 c-0.4,1.5-0.7,3.1-1,4.7c-0.1,0.7-0.2,1.4-0.3,2c-0.7,4.4-1.2,8.8-1.4,12.6c0,0.6-0.1,1.3-0.1,1.9c-0.4,6.6-0.3,11.2-0.3,11.2 s-0.1,0.3-0.1,0.8c-0.1,0.5-0.2,1.2-0.3,2c-0.4,2.8-1,7.4-1.4,12.6c0,0.6-0.1,1.2-0.1,1.9c-0.2,3.8-0.3,7.9-0.1,11.8 c0,0.6,0.1,1.2,0.1,1.8c0.2,2.6,0.6,5,1.2,7.2c0.3,1.2,0.6,2.3,0.9,3.3c0.2,0.5,0.3,1.1,0.4,1.6c1.5,5.5,2.4,8.2,1.7,10.7 c-0.2,0.9-0.6,1.7-1.3,2.6c-0.4,0.6-0.9,1.2-1.5,1.9c-0.3,0.3-0.5,0.6-0.8,0.9c-5.9,6.3-20.6,10.1-38.1,8.1 c-2.8-0.3-5.2-0.8-7.3-1.5c-6.6-2.1-10.1-5.6-11.6-9.6v0c-0.1-0.4-0.3-0.8-0.4-1.2c-0.2-0.5-0.3-1.1-0.4-1.6c-0.4-2-0.3-4-0.1-5.9 c0.2-1.6,0.7-3.9,1.4-6.6c0.2-0.7,0.3-1.4,0.5-2.1c0.8-3.1,1.6-6.7,2.5-10.5c0.1-0.5,0.2-1.1,0.3-1.6c0.7-3.5,1.3-7.1,1.7-10.7 c0.1-0.6,0.1-1.1,0.2-1.7c0.2-1.7,0.3-3.5,0.3-5.1c0-1.2,0-2.4-0.1-3.6c-0.1-1.1-0.2-2.1-0.4-3.1c-0.1-0.7-0.3-1.4-0.5-2.1 c0-0.1,0-0.1,0-0.2c-2.5-2.3-7-4.1-8.3-11.1c-0.1-0.4-0.2-0.9-0.2-1.3c0-0.1,0-0.2,0-0.3c-0.2-2.1-0.2-4.6,0.2-7.6 c0.2-1.6,0.4-3.2,0.5-4.6c0.1-0.7,0.1-1.3,0.2-1.9c0.5-5.1,0.7-9.1,1.1-12.4c0.1-0.7,0.2-1.4,0.3-2c0.4-2.6,1-4.8,2.1-6.6 c0.2-0.3,0.4-0.6,0.6-0.9c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c3-3.5,9.9-6.6,17.7-9 c2.8-0.9,5.8-1.6,8.7-2.2c5.9-1.3,11.2-1,15.8,0.1C-1024.7-2333.9-1017.1-2325.2-1014.3-2321.9z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M-1004.9-2281.9c-2.4,6.3-12.6,6.9-17.3,6.1c-1.1-0.2-1.8-0.4-2.2-0.7c-0.5-0.4-1-2.9-1.2-6.6 c-0.5-7.7-0.1-20.5,2.8-30.1c0.3-0.9,0.6-1.8,0.9-2.6c0.1-0.2,0.1-0.3,0.1-0.3c1.4-3.6,3.2-6.4,5.5-8.1c0,0,10.8,6.5,11.4,38 C-1004.9-2284.8-1004.9-2283.4-1004.9-2281.9z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M-1074.6-2271.1c-0.4,0.3-1.3,0.5-2.5,0.5c-1.4,0-3.3-0.1-5.4-0.5c-4.4-0.8-9.6-2.7-12.9-6 c-0.7-0.7-1.4-1.5-1.9-2.4c0.4-1.6,0.9-3.1,1.3-4.6c2.9-10.4,5.7-18.4,8.2-24.4c4.6-11.3,8-15.8,8.8-16.8 c-0.2,0.3-0.5,0.6-0.6,0.9c-3.1,5.3-2.2,12.5-4.2,27.6c-1.9,14.8,4.8,17.2,8.2,20.2c0,0,0.1,0.1,0.1,0.1 C-1075.1-2274.9-1074.8-2273.1-1074.6-2271.1z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-1036.6-2336.8c-2.7,6.6-8.5,19.4-12.7,20.4c-5.6,1.4-13.4-2.2-14.2-6.3c-0.6-3.1,1.3-9.1,2.3-11.9 c2.8-0.9,5.8-1.6,8.7-2.2C-1046.5-2338.2-1041.2-2337.9-1036.6-2336.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -1040.6647,
    y1: -2357.8137,
    x2: -1080.4795,
    y2: -2339.9946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M-1042.7-2335.5c-0.1,1.5-0.6,4.1-4.2,9.9c-3.6,5.8-14.3,5.7-13.1,0c0.6-2.5,1-5.7,1.4-8.5 c0.5-3.6,0.7-6.6,0.7-6.6s-2.1,1.4-4.3,1.1c-0.1,0-0.1,0-0.1,0c-0.8-0.1-1.5-0.4-2.3-1.1c-6.1-5.3-7.9-15.1-8.2-22.8 c-0.3-6.2,0.4-11,0.4-11c9.3,9.1,20.9,5,22.7,5.4c0.4,0.1,0.9,0.3,1.4,0.7c1.6,1.1,3,3.5,2.1,7.3c-1.3,5-2.6,5.9,3.5,11 C-1043.5-2345.5-1042.5-2337-1042.7-2335.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -993.5337,
    y1: -2297.8411,
    x2: -959.845,
    y2: -2199.0022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M-954.6-2305.6c-1.4,4.3-9.5,4.1-17.5,11.3c-8,7.2-16.9,55.1-29.7,55.1c-13.9,0-19.6-14.7-21.8-26.2 c-0.1-0.4-0.2-0.8-0.2-1.3c-1.2-6.6-1.3-11.9-1.3-12.1c0,0.2,0.1,0.3,0.1,0.5c0,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.3,0.7c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0.4,0.3,1.1,0.5,2.2,0.7 c4.5,0.7,13.8,0.3,16.8-5.2c0.1-0.1,0.1-0.3,0.2-0.4c0.1,3.7,0.4,10.2,0.2,14.7c0.8-3.7,20.1-29.6,21-32.6 c0.8-3.1-3.4-11.3,0.8-11c4.2,0.4,5.3,7.5,7.2,7.5c1.9,0,7.1-2.7,10.9-3.3C-961.1-2306.6-953.8-2307.8-954.6-2305.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -1076.4036,
    y1: -2244.1646,
    x2: -1153.2478,
    y2: -2341.4263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M-1077.1-2270.7c-0.8,3.5-2.9,12-6.8,18.4c0,0,0,0,0,0c-2.8,4.7-6.6,8.4-11.5,8.4c-11.6,0-20.7-25.2-29-54.4 c-2.9-10.4-19.2-24.2-19.3-27.2c-0.1-3,16,4.2,21.6,7.4c3.3,1.9,2-6.7,4.6-8.1c2.6-1.4,1.7,16.6,3.5,22.2 c1.8,5.6,15.7,29.7,16.7,32.7c0.3-1,0.6-2.1,1-3.2c0.3-0.9,0.6-1.9,1-2.7c1.7,1.7,3.8,3,6.1,3.9 C-1085-2271.3-1080.1-2270.6-1077.1-2270.7z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M-1016.2-2028C-1016.2-2028-1016.2-2028-1016.2-2028"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1034.6-2203.9c0,0,4.5,8.8,11.4,11.1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1025.8-2190.7c0,0,16.1,138.9,20.9,149.6"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-1056.1-2166.5c0,0-13.6,118.8-16.6,143.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -1113.1473,
    y1: -2006.3533,
    x2: -1065.7649,
    y2: -2006.3533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M-1065.8-1991.9h-47.1c0,0-0.4-1.7-0.1-3.7c0.2-1.7,1-3.6,3.1-4.7c4.5-2.3,21.5-10.7,25.2-14.6 c3.7-3.9,2.9-5.6,4.7-5.7c0,0,10.1-0.8,11.3,0.7c0.9,1.1,2.1,17,2.6,24.3C-1065.9-1993.3-1065.8-1991.9-1065.8-1991.9z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1098.8-2007.4c0,0,4.1,3.9,6.1,4.5s12.4-8.4,13.2-10.9c0.7-2.5,1.6-12.3,1.6-12.3s-6.3,0-8.5,0 c-2.2,0-1.9,11.6-1.9,11.6S-1099.8-2008.3-1098.8-2007.4z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1065.8-1991.9h-47.1c0,0-0.4-1.7-0.1-3.7h47C-1065.9-1993.3-1065.8-1991.9-1065.8-1991.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -1016.8045,
    y1: -2010.8542,
    x2: -988.2457,
    y2: -2010.8542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M-988.4-1991.9c0,0-1.7,0-28.4,0c0.1-0.9,0.2-2.1,0.4-3.7c0.6-6.3,1.4-17.1,0.2-21.7 c-1.4-5.6-0.1-10.4,0-10.7c0.3,0.5,0.6,0.8,0.8,1c6,4.1,12.9-1.2,14.8-2.9c3.7,5.6,8.7,28,10.7,31.6c0.5,1,0.9,1.8,1.1,2.6 C-987.9-1993.2-988.4-1991.9-988.4-1991.9z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1014.9-2032.7c0,0,1.9,12.3,2.4,14.1c0.6,1.9,3.5,13.4,5.8,14.5c2.2,1.1,4.5,2.1,5-0.4 c0.6-2.6,0-15.9,0-18c0-2,1.2-12.3,0.2-13C-1002.5-2036.2-1015.5-2036.6-1014.9-2032.7z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-988.4-1991.9c0,0-1.7,0-28.4,0c0.1-0.9,0.2-2.1,0.4-3.7h27.7C-987.9-1993.2-988.4-1991.9-988.4-1991.9z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M-1162.1-2492.2v61.8c0,9-7.3,16.2-16.2,16.2h-79.2l-12.9,12.9c-1.8,1.8-4.9,0.5-4.9-2v-10.9h-38.9 c-1.6,0-2.9-1.3-2.9-2.9v-61.8c0-9,7.3-16.2,16.2-16.2h136C-1163.4-2495-1162.1-2493.8-1162.1-2492.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M-959-2479.4v63c0,1.3-1,2.3-2.3,2.3h-49.6l-12.9,12.9c-1.8,1.8-4.9,0.5-4.9-2v-10.9h-69.7 c-8.6,0-15.6-7-15.6-15.6v-63c0-1.3,1-2.3,2.3-2.3h137.1C-966-2495-959-2488.1-959-2479.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M-932.5-2414.9c0,15-12.1,27.1-27.1,27.1c-14.7,0-26.7-11.7-27.1-26.3h25.3c1.3,0,2.3-1,2.3-2.3v-25.6 C-944.3-2441.7-932.5-2429.7-932.5-2414.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M-959-2442v25.6c0,1.3-1,2.3-2.3,2.3h-25.3c0-0.3,0-0.5,0-0.8c0-15,12.1-27.1,27.1-27.1 C-959.4-2442-959.2-2442-959-2442z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M-1286.3-2505.1v10.1h-14.6c-9,0-16.2,7.3-16.2,16.2v17.4h-12.8c-6.1,0-11.1-5-11.1-11.1v-32.6 c0-6.1,5-11.1,11.1-11.1h32.6C-1291.3-2516.2-1286.3-2511.3-1286.3-2505.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M-1286.3-2495v22.5c0,6.1-5,11.1-11.1,11.1h-19.8v-17.4c0-9,7.3-16.2,16.2-16.2H-1286.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1398,
    y: -2398.6,
    className: "st71",
    width: 30.1,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1385,
    y: -2386.7,
    className: "st72",
    width: 30.1,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -918.6,
    y: -2263.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -1807.09 -4517.5229)",
    className: "st71",
    width: 30.1,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -931.6,
    y: -2251.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -1833.1426 -4493.7646)",
    className: "st72",
    width: 30.1,
    height: 9.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st73",
    x1: -1284.9,
    y1: -2470.7,
    x2: -1194.4,
    y2: -2470.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st73",
    x1: -1284.9,
    y1: -2453.9,
    x2: -1194.4,
    y2: -2453.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st73",
    x1: -1284.9,
    y1: -2437.1,
    x2: -1194.4,
    y2: -2437.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st73",
    x1: -1081.8,
    y1: -2471.5,
    x2: -991.3,
    y2: -2471.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st73",
    x1: -1081.8,
    y1: -2454.7,
    x2: -991.3,
    y2: -2454.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st73",
    x1: -1081.8,
    y1: -2437.9,
    x2: -991.3,
    y2: -2437.9
  })))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-756-1979.7h-739.2c-3.4,0-6.1-2.7-6.1-6.1l0,0c0-3.4,2.7-6.1,6.1-6.1H-756c3.4,0,6.1,2.7,6.1,6.1l0,0 C-750-1982.4-752.7-1979.7-756-1979.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M-379.8-1411.8c0,0-127.9-90.4-90.7-227.2c37.1-136.8,260.9-250.9,376-191.6s310.5,412.7,310.5,412.7 L-379.8-1411.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-103.1-1439c-3.3,4.9-18.6,5.5-21.3,1.9c-2.6-3.7-5.2-117.8-16.7-158c-7,12-3.2,153.5-6.1,156.8 c-1.3,1.4-24.2,6.4-25.6-1.7c-6.8-40.4-4.5-130.2-2.7-173.3c0.3-7.8,0.6-14.1,0.8-18.2c12.3,6.9,48.6,10.4,58.1,3.8 c0.2,0.5,0.4,1,0.6,1.6C-97.2-1573-100-1443.6-103.1-1439z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-146.9-1417h-40.4c0,0,0.4-12,7.7-12.6c1.3-0.1,2.4,0.1,3.4,0.4c4.4,1.6,5.4,6.7,5.4,6.7h22.8 C-148-1422.4-146.7-1419.5-146.9-1417z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -176.1729,
    y1: -1429.2607,
    x2: -148.8419,
    y2: -1429.2607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M-148.8-1422.4h-21.9c0,0-1-5.2-5.4-6.7c2.2-1.6,6-4.4,6.7-6c7.6-1.7,17.7-0.8,18.4,0 C-150.4-1434.3-148.8-1422.4-148.8-1422.4z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-173.2-1431.4c0,0,4.6,0.9,6.1,0.7c1.5-0.2,6.8-12.2,6.1-13.6c-0.7-1.4-8.8-0.8-9.5,0 C-171.2-1443.4-171.5-1434.2-173.2-1431.4z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-125.4-1416.9l40.4-0.2c0,0-0.5-12-7.8-12.5c-1.3-0.1-2.4,0.1-3.4,0.4c-4.4,1.6-5.4,6.7-5.4,6.7l-22.8,0.1 C-124.3-1422.3-125.6-1419.4-125.4-1416.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -123.5065,
    y1: -1429.1974,
    x2: -96.2087,
    y2: -1429.1974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M-123.5-1422.3l21.9-0.1c0,0,1-5.2,5.4-6.7c-2.2-1.5-6-4.3-6.7-6c-7.6-1.6-17.7-0.8-18.4,0.1 C-122-1434.2-123.5-1422.3-123.5-1422.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-99.2-1431.4c0,0-4.6,1-6.1,0.8s-6.8-12.2-6.1-13.6c0.7-1.4,8.8-0.9,9.5,0 C-101.2-1443.4-100.9-1434.3-99.2-1431.4z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M-162.1-1624.3c0,0,2.2,8.4-8.4,14.9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M-125.1-1621.4c0,0,0.7,9.8,12.4,12"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M-167.2-1601.2c0,0-10,98.9,0,154.2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M-135.6-1595.2c0,0,17.9,99.9,14.5,156.1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: -85.2089,
    y1: -1688.6765,
    x2: -61.7084,
    y2: -1688.6765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M-85.2-1687.4c0,0,16.7-15.2,18.4-14.4c1.7,0.8,5.1,7.9,5.1,7.9l-19.8,18.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -187.0081,
    y1: -1600.0984,
    x2: -169.3107,
    y2: -1600.0984
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M-169.6-1592c-1.3,1.1-2.7-2.3-3.8-1.9c-1.1,0.4-4.2,24.5-9.4,22.5c-5.2-1.9-4.6-17.2-3.6-26.2 c0.8-7.3,0.3-25,0.1-31.3c4.2,0.6,13.7,1.7,14.9,1.9c-1.2,6.4-2.8,15.6-2.2,18.5C-172.6-1603.9-168.2-1593.2-169.6-1592z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-77.5-1676.3c-0.2,0.8-16.6,20.4-21.2,20.4c-4.6,0-12.8-10.5-12.8-10.5s-2,9.4-2,18 c0,8.6,4.2,18.3,4.2,21.8c0,3.4-5.7,15.7-27.7,16.8c-22,1.1-33.2-7.5-34.2-9.2c-1-1.7-0.2-8-0.2-8s0,0-0.1,0 c-1.2-0.2-10.7-1.3-14.9-1.9c-0.7-0.1-1.3-0.2-1.6-0.2c-0.2-6.5,7.6-50,17.2-62.6c9.6-12.6,35-10.7,35-10.7l8.8,1.1 c20.1,1.3,25.9,20.5,28,20.5c2.1,0,14.7-8.7,14.7-8.7S-77.3-1677.1-77.5-1676.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-110.4-1713.6c-0.3-0.1-0.7-0.2-1-0.3c-10.2-3.4-13.7-12.2-15.9-13.2c-2.3-1-4,1.7-3.6,7 c0.4,5.3-6.3,9-6.3,9s-0.2-0.8-0.5-2.2c-1.4-5.7-4.8-20.8-2.7-24.8c2.6-4.9,8.5-5,8.5-5s0.6-4.7,7.5-5.7c6.9-1,11,7.2,11,7.2 s2.3-3.7,7.7,0C-100.4-1737.9-101.7-1723.4-110.4-1713.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: -140.5396,
    y1: -1723.4415,
    x2: -112.8355,
    y2: -1689.4325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M-111.4-1714c-7.1,16.1-15.3,11.8-15.5,12.6c-0.1,0.8,0.6,10.4-3.3,11.7c-3.9,1.3-10.3-5.2-8.6-9.7 c1.7-4.6,1-13.8,1-13.8l0,0c0.3,1.4,0.5,2.2,0.5,2.2s6.7-3.7,6.3-9c-0.4-5.3,1.3-8,3.6-7C-125.1-1726.2-121.7-1717.4-111.4-1714z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-69.9-1719.4l-4.9-8.1l-3.9,2.4l4.9,8.1c1.1,1.8,1.6,3.9,1.3,6l0,0c-0.2,2.1,0.2,4.2,1.3,6l11.8,19.3 c0.8,1.3,2.5,1.7,3.8,0.9l6.1-3.7c1.3-0.8,1.7-2.5,0.9-3.8l-11.8-19.3c-1.1-1.8-2.8-3.2-4.8-4l0,0 C-67.1-1716.2-68.7-1717.6-69.9-1719.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -63.4716,
    y1: -1704.1469,
    x2: -53.8976,
    y2: -1704.1469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M-59.2-1709.6c0,0-4.7,4.5-4.2,5.8c0.5,1.3,5.7,5.2,8.3,5.2C-52.5-1698.7-54.1-1707.6-59.2-1709.6z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-85.2-1690.9c0,0,5.3,18.5,8.5,17.3s3.2-2.8,2.7-6.4c-0.4-3.6-6.7-13.1-8.6-13.3 C-84.5-1693.6-85.4-1691.7-85.2-1690.9z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-189.5-1628.1c0,0,18.5,5.3,19.2,2c0.7-3.3-0.7-4.2-4-5.7c-3.3-1.5-14.6-1.2-15.9,0.3 C-191.4-1630.1-190.3-1628.3-189.5-1628.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-25.3-1591l1.3-9.4l-4.6-0.7l-1.3,9.4c-0.3,2.1-1.3,4-2.8,5.5h0c-1.5,1.5-2.5,3.4-2.8,5.5l-3.2,22.3 c-0.2,1.5,0.8,2.9,2.3,3.1l7.1,1c1.5,0.2,2.9-0.8,3.1-2.3l3.2-22.3c0.3-2.1-0.1-4.2-1.2-6.1l0,0 C-25.2-1586.8-25.6-1588.9-25.3-1591z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-8.8-1544c0,0-79.3,16.3-91.9,22.4c-12.6,6-75.1,59.4-76.8,62.5c-1.7,3.2,16.4,17.6,18.4,17.8 c2,0.3,65.6-38.3,65.6-38.3l46.3-19.3c5.7-2.4,11.6-4.2,17.6-5.5l34.7-7.6L-8.8-1544z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: -161.4,
    y1: -1457.5,
    x2: -89.5,
    y2: -1507.3
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M81.5-1595.2c-0.6,2.1-19.2,48.7-19.2,48.7s-19.2,27.5-24.6,33.3c-5.4,5.8-25.3,4-37.6-1.5 c-12.3-5.4-17.5-22.9-5.7-32.7c5.3-4.4,12.1-16.8,19.1-30.1c0,0,0,0,0-0.1c8.5-16,17.6-33.4,25.2-39.5c3.7-3,7.4-5.2,10.8-6.8 c9.6-4.7,17.1-4.9,17.1-4.9c5.8-0.9,18.3,1,14.8,8.1C78.1-1613.6,82.1-1597.3,81.5-1595.2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M65.2-1637.8c-0.1,0.2-0.1,0.4-0.2,0.5c-7.3-4.9-9.5-7.7-7.4-11.2c2-3.4,2.4-9.3-3.3-8.2l-17.9,3.4l-6.1,1.2 c0,0-10.5-23,10.9-27.6c8-1.7,14,4,14,4s0.5-3,6.1-3.1c5.6-0.1,5.4,7.3,5.4,7.3s1.9-4.9,0.9-7.1c2.3,2.6,0.3,9.8,0.3,9.8 s7.2-2.3,9,7.6C78.5-1651.6,66.8-1641.3,65.2-1637.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.3387,
    y1: -1642.8146,
    x2: -23.8353,
    y2: -1635.9362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M66.7-1628.9c-0.1,0.3-14.4,3.4-14.4,3.4s-0.8-7.2-1.9-7.9c-1.1-0.8-5.6,2.7-8.8-1.5 c-2.7-3.6-4.8-15.1-5.3-18.3l17.9-3.4c5.7-1.1,5.3,4.8,3.3,8.2c-2,3.4,0.2,6.2,7.4,11.2c0-0.2,0.1-0.3,0.2-0.5 C65.7-1633.6,66.8-1629.1,66.7-1628.9z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M66.7-1605c-0.5,3.2-16.6,31.5-18.7,31.7c-0.2,0-0.4,0-0.8-0.2c-4.1-1.4-19.1-10.6-19.6-11.3 c-0.5-0.8,3.9-9.4,8.7-18.5c4.7-9.2,15.3-15.7,23.2-13.4C67.3-1614.4,66.7-1605,66.7-1605z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.4039,
    y1: -1570.8235,
    x2: -120.7957,
    y2: -1573.1161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M47.2-1573.5c-4,8.8-14.4,28.7-25,26.7c-13.6-2.5-45.9-32.7-48.9-32.7c-3.1,0-7.5-5-6.9-10.5 c0.6-5.5,2.5-7.6,8.7-5.3c6.2,2.3,7.3,8.7,10.4,10.5c3.1,1.7,32.3,17.2,34,17.6c1.7,0.4,8.1-17.6,8.1-17.6 C28.1-1584.1,43.1-1574.8,47.2-1573.5z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M42.8-1613.6c-11.7,8.1-28.2,34.4-29.3,36c8.5-16,17.6-33.4,25.2-39.5c3.7-3,7.4-5.2,10.8-6.8 C50.1-1621.2,48.4-1617.5,42.8-1613.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: -886.3153,
    y1: 432.9328,
    x2: -833.4168,
    y2: 432.9328,
    gradientTransform: "matrix(0.8301 0.5576 -0.5576 0.8301 766.0665 -1325.5428)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M-176.2-1417.5l-43.7-29.4c0,0,0.7-1.8,2.2-3.5c1.3-1.5,3.2-2.7,5.8-2.4c5.6,0.6,26.6,3.5,32.5,2.2 c5.9-1.3,6.2-3.4,7.9-2.4c0,0,9.9,5.6,10.1,7.7c0.1,1.6-8.6,17.1-12.7,24.2C-175.3-1418.9-176.2-1417.5-176.2-1417.5z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-197.1-1452.5c0,0,1.4,6.2,2.9,7.9c1.5,1.8,16.7,0,19-1.9c2.2-1.8,9.1-10.4,9.1-10.4s-5.9-3.9-7.9-5.3 c-2-1.4-9,9.6-9,9.6S-197.4-1453.9-197.1-1452.5z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-176.2-1417.5l-43.7-29.4c0,0,0.7-1.8,2.2-3.5l43.6,29.3C-175.3-1418.9-176.2-1417.5-176.2-1417.5z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-494.3-1481.6c0,0,2.5-19.6,12.6-27.7c10.1-8.1,10.8-20.7,10.8-20.7s13.7,47.7-3.8,56.5 C-492.3-1464.7-494.3-1481.6-494.3-1481.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-470.9-1530c0.5,5.7,0.5,11.4,0,17c-0.5,5.7-1.5,11.3-3,16.8c-1.6,5.5-3.8,10.8-6.8,15.7 c-1.5,2.4-3.2,4.7-5.1,6.9c-1.9,2.2-4,4.1-6.2,5.9c-0.1,0.1-0.3,0.1-0.4,0s-0.1-0.3,0-0.4l0,0l0,0c2.2-1.8,4.3-3.6,6.2-5.8 c1.9-2.1,3.6-4.4,5.1-6.8c3-4.8,5.2-10.1,6.8-15.5c1.6-5.5,2.6-11.1,3.1-16.7C-470.5-1518.6-470.4-1524.3-470.9-1530z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-498.8-1705.5c0,0-25.4,82.7-6.2,154c19.2,71.3-7.2,97.5-7.2,97.5l20-20.1c0,0,8.5-63.1,6.4-95.2 l-6.4-3.3l6.8-5.7C-485.4-1578.3-503.2-1652-498.8-1705.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-498.8-1705.5c-2,9.5-3.5,19-4.8,28.6c-1.3,9.6-2.4,19.2-3,28.8c-0.2,2.4-0.3,4.8-0.4,7.2 c-0.1,2.4-0.3,4.8-0.3,7.2c-0.1,4.8-0.3,9.7-0.1,14.5l0,3.6l0,1.8l0.1,1.8l0.4,7.2c0,1.2,0.1,2.4,0.3,3.6l0.3,3.6 c0.2,2.4,0.4,4.8,0.8,7.2l1,7.2c0.4,2.4,0.8,4.8,1.2,7.1c0.8,4.8,1.6,9.5,2.3,14.3c1.5,9.5,2.8,19.1,3.8,28.7 c1,9.6,1.6,19.3,1.5,28.9c-0.1,9.7-1,19.3-2.8,28.8c0,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.2-0.2-0.2-0.3l0,0 c1.7-9.5,2.7-19.1,2.8-28.8c0.2-9.6-0.5-19.3-1.4-28.9c-1-9.6-2.3-19.2-3.7-28.7c-0.7-4.8-1.5-9.5-2.3-14.3 c-0.4-2.4-0.8-4.8-1.2-7.1l-1-7.2c-0.4-2.4-0.5-4.8-0.8-7.2l-0.3-3.6c-0.1-1.2-0.2-2.4-0.3-3.6l-0.3-7.2l-0.1-1.8l0-1.8l0-3.6 c-0.1-4.8,0.1-9.7,0.2-14.5c0.1-2.4,0.2-4.8,0.3-7.2c0.1-2.4,0.2-4.8,0.5-7.2c0.7-9.6,1.8-19.2,3.1-28.8 C-502.4-1686.5-500.8-1696.1-498.8-1705.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-497.5-1474.1c0,0,5.4-50.7-4.8-70.6h-6.6l3.9-6.9c0,0-21.3-46.7-81.1-64.9c0,0,37.7,24.9,53.1,71.2 c7.3-1.8,12.4-1.5,12.4-1.5l-5.5,7.2c0,0,22.2,36,19.2,69.7C-509.8-1436.3-497.5-1474.1-497.5-1474.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-586-1616.5c3.4,1.4,6.6,3.1,9.8,4.9c3.2,1.8,6.3,3.7,9.4,5.7c6.1,4,12,8.4,17.5,13.2 c11.1,9.6,20.8,20.8,28.6,33.2c3.9,6.2,7.2,12.8,10,19.6l2,5.1c0.6,1.7,1.2,3.5,1.7,5.2l0.9,2.6l0.7,2.7l1.4,5.3 c3.2,14.3,4.2,29.1,3.2,43.7c0,0.1-0.1,0.2-0.3,0.2s-0.2-0.1-0.2-0.3l0,0c1-14.6,0.1-29.3-3.1-43.6l-1.4-5.3l-0.7-2.7l-0.8-2.6 c-0.6-1.7-1.1-3.5-1.7-5.2l-2-5.1c-2.8-6.7-6.1-13.3-9.9-19.5c-7.7-12.4-17.4-23.6-28.4-33.2c-5.5-4.8-11.4-9.2-17.5-13.2 c-3.1-2-6.2-3.9-9.4-5.7C-579.4-1613.3-582.7-1615-586-1616.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "-461.4,-1466.7 -461.7,-1458.4 -468.9,-1417.5 -514.8,-1417.5 -522.1,-1458.4 -522.9,-1463.1  -488.1,-1465.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-452.8-1475.1v14.2c0,1.4-1.1,2.5-2.5,2.5h-75.2c-1.6,0-2.8-1.5-2.4-3.1l3.8-14.2c0.3-1.1,1.3-1.8,2.4-1.8 h71.4C-453.9-1477.6-452.8-1476.4-452.8-1475.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M184.3-1481.6c0,0-2.5-19.6-12.6-27.7c-10.1-8.1-10.8-20.7-10.8-20.7s-13.7,47.7,3.8,56.5 C182.3-1464.7,184.3-1481.6,184.3-1481.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.9-1530c-0.5,5.7-0.4,11.4,0.1,17c0.5,5.7,1.6,11.3,3.1,16.7c1.6,5.4,3.8,10.7,6.8,15.5 c1.5,2.4,3.2,4.7,5.1,6.8c1.9,2.1,4,4,6.2,5.8l0,0c0.1,0.1,0.1,0.2,0,0.4c-0.1,0.1-0.2,0.1-0.4,0l0,0c-2.2-1.8-4.4-3.7-6.2-5.9 c-1.9-2.2-3.6-4.4-5.1-6.9c-3-4.9-5.2-10.2-6.8-15.7c-1.5-5.5-2.5-11.1-3-16.8C160.4-1518.6,160.3-1524.4,160.9-1530z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M188.8-1705.5c0,0,25.4,82.7,6.2,154c-19.2,71.3,7.2,97.5,7.2,97.5l-20-20.1c0,0-8.5-63.1-6.4-95.2 l6.4-3.3l-6.8-5.7C175.4-1578.3,193.1-1652,188.8-1705.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M188.8-1705.5c2,9.4,3.6,19,4.9,28.5c1.3,9.6,2.4,19.2,3.1,28.8c0.2,2.4,0.3,4.8,0.5,7.2 c0.1,2.4,0.3,4.8,0.3,7.2c0.1,4.8,0.3,9.7,0.2,14.5l0,3.6l0,1.8l-0.1,1.8l-0.3,7.2c0,1.2-0.1,2.4-0.3,3.6l-0.3,3.6 c-0.2,2.4-0.4,4.8-0.8,7.2l-1,7.2c-0.4,2.4-0.8,4.8-1.2,7.1c-0.8,4.8-1.6,9.5-2.3,14.3c-1.5,9.5-2.8,19.1-3.7,28.7 c-1,9.6-1.6,19.2-1.4,28.9c0.1,9.6,1.1,19.3,2.8,28.8c0,0.1-0.1,0.3-0.2,0.3c-0.1,0-0.3-0.1-0.3-0.2l0,0 c-1.7-9.5-2.7-19.2-2.8-28.8c-0.1-9.7,0.5-19.3,1.5-28.9c1-9.6,2.3-19.2,3.8-28.7c0.8-4.8,1.5-9.5,2.3-14.3 c0.4-2.4,0.8-4.8,1.2-7.1l1-7.2c0.4-2.4,0.5-4.8,0.8-7.2l0.3-3.6c0.1-1.2,0.2-2.4,0.3-3.6l0.4-7.2l0.1-1.8l0-1.8l0-3.6 c0.1-4.8,0-9.7-0.1-14.5c-0.1-2.4-0.2-4.8-0.3-7.2c-0.1-2.4-0.2-4.8-0.4-7.2c-0.6-9.6-1.7-19.2-3-28.8 C192.3-1686.5,190.8-1696.1,188.8-1705.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M187.4-1474.1c0,0-5.4-50.7,4.8-70.6h6.6l-3.9-6.9c0,0,21.3-46.7,81.1-64.9c0,0-37.7,24.9-53.1,71.2 c-7.3-1.8-12.4-1.5-12.4-1.5l5.5,7.2c0,0-22.2,36-19.2,69.7C199.7-1436.3,187.4-1474.1,187.4-1474.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M276-1616.5c-3.4,1.4-6.6,3.1-9.8,4.9c-3.2,1.8-6.3,3.7-9.4,5.7c-6.1,4-12,8.4-17.5,13.2 c-11,9.6-20.7,20.8-28.4,33.2c-3.9,6.2-7.1,12.8-9.9,19.5l-2,5.1c-0.6,1.7-1.1,3.5-1.7,5.2l-0.8,2.6l-0.7,2.7l-1.4,5.3 c-3.1,14.3-4.1,29-3.1,43.6c0,0.1-0.1,0.3-0.2,0.3c-0.1,0-0.3-0.1-0.3-0.2v0c-1-14.6,0-29.4,3.2-43.7l1.4-5.3l0.7-2.7l0.9-2.6 c0.6-1.7,1.1-3.5,1.7-5.2l2-5.1c2.8-6.8,6.1-13.3,10-19.6c7.8-12.4,17.5-23.6,28.6-33.2c5.5-4.8,11.4-9.2,17.5-13.2 c3.1-2,6.2-3.9,9.4-5.7C269.4-1613.3,272.6-1615,276-1616.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "151.4,-1466.7 151.7,-1458.4 158.9,-1417.5 204.8,-1417.5 212,-1458.4 212.9,-1463.1  178.1,-1465.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M142.8-1475.1v14.2c0,1.4,1.1,2.5,2.5,2.5h75.2c1.6,0,2.8-1.5,2.4-3.1l-3.8-14.2c-0.3-1.1-1.3-1.8-2.4-1.8 h-71.4C143.9-1477.6,142.8-1476.4,142.8-1475.1z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-298.1-1417.5h45.2h4.5c0,0-26.3-74.3-38.2-80.9c-11.8-6.6-19.6-10.3-32.2-10.7c-12.6-0.4-29.7,5-29.7,5 l20.9,31.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M-232.5-1417.6h-18.2c0,0-33.5-77-54.8-93.8c-4.1-3.2-9.3-5.1-15-6c12.3-1.4,24.9-0.6,33.2,6 C-266-1494.6-232.5-1417.6-232.5-1417.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-490.4-1616.5h96l43.9,92.9c0,0-74.5,18.6-79.9,29.4C-435.7-1483.4-490.4-1616.5-490.4-1616.5z"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M131.4-1417.6C131.4-1417.6,131.4-1417.6,131.4-1417.6l-77.2,0l11.7-56.5l4.6,4.2c0,0,58.3-162.7,29.1-167.2 c0,0,58.2-4.3,63.2,0C191.9-1632.6,132.2-1420.6,131.4-1417.6z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M70.5-1469.9l-4.6-4.2l-43.7-39.8c0,0,48.1-127.8,77.4-123.2C128.8-1632.5,70.5-1469.9,70.5-1469.9z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-116.5-1417.6c0,0-19.5-76.8,0-100.3c19.5-23.5,108.3-20.6,146.7,0c38.4,20.6,58.5,77.4,35.5,100.3H-116.5z"
  })), /*#__PURE__*/React.createElement("g", null, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M-404.8-1539.7c0,0-6.6,25.2,0,35.8c6.6,10.6,70.5,9.6,73.1,11.2c2.6,1.6,55.7,60.6,60,60.9 c4.3,0.3,14-11.6,14-13.2c0-1.6-52.5-79.6-58.3-81.6c-5.7-2-40.2-12.6-40.2-12.6L-404.8-1539.7z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M-260-1417.6l34.8-23.4c0,0-0.5-1.5-1.7-2.8c-1-1.2-2.5-2.2-4.6-1.9c-4.4,0.5-21.2,2.8-25.8,1.8 c-4.7-1-4.9-2.7-6.3-1.9c0,0-7.9,4.4-8,6.1c-0.1,1.3,6.8,13.5,10.1,19.2C-260.6-1418.7-260-1417.6-260-1417.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-243.2-1445.4c0,0-1.1,4.9-2.3,6.3c-1.2,1.4-13.3,0-15.1-1.4c-1.8-1.5-7.2-8.3-7.2-8.3s4.7-3.1,6.3-4.2 c1.6-1.1,7.2,7.6,7.2,7.6S-243-1446.5-243.2-1445.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-260-1417.6l34.8-23.4c0,0-0.5-1.5-1.7-2.8l-34.8,23.3C-260.6-1418.7-260-1417.6-260-1417.6z"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-419.7-1539.7c0,0-6.6,25.2,0,35.8c6.6,10.6,70.5,9.6,73.1,11.2c2.6,1.6,55.7,60.6,60,60.9 c4.3,0.3,14-11.6,14-13.2c0-1.6-52.5-79.6-58.3-81.6c-5.7-2-40.2-12.6-40.2-12.6L-419.7-1539.7z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-363.1-1641.5c0,0,13.6-25.9-8.9-31.4c-22.5-5.5-29.2,4.2-31,14.7s-27.3,23.5-27.5,41.1 c-0.2,17.6,1.3,30.4-5.7,41.8c-7.1,11.5-10.9,28.7,3.6,32.7c14.5,4,45.3-35.7,45.7-38c0.4-2.3,0.6-35,0-37.3s5.3-16,5.3-16 L-363.1-1641.5z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-350.8-1544.2l1.3-9.4l-4.6-0.7l-1.3,9.4c-0.3,2.1-1.3,4-2.8,5.5l0,0c-1.5,1.5-2.5,3.4-2.8,5.5l-3.2,22.3 c-0.2,1.5,0.8,2.9,2.3,3.1l7.1,1c1.5,0.2,2.9-0.8,3.1-2.3l3.2-22.3c0.3-2.1-0.1-4.2-1.2-6.1h0 C-350.7-1539.9-351.1-1542.1-350.8-1544.2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-365.3-1570.1c-1.4,9.4,4.3,20.3,4.8,23.9c0.6,3.6-2.5,6.9-11.3,9.6c-8.8,2.7-46.8,2.1-48-3.1 c-1.1-5.2,7.6-43.7,7.6-51.2s-2.1-26.9-2.1-26.9c7.6-5.9,21.6-8.6,21.6-8.6s21.2,5.2,25.2,8.4c0,0,0.1,0,0.2,0.1 c0.1,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1c4.1,3.9,10.4,17.7,9.4,27.1c-0.6,6.1-3,8.9-5.1,12.5 C-363.7-1575.9-364.8-1573.5-365.3-1570.1z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-340.9-1584.2c-5.3,5.6-12.6,11.1-15.4,13.1c-0.4,0.3-0.7,0.5-0.9,0.7c-0.8,0.5-3.2-3.7-5.2-7.6 c2.1-3.6,4.5-6.4,5.1-12.5c0.9-9.4-5.4-23.1-9.4-27.1C-364.2-1615.2-351.8-1603.4-340.9-1584.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: -356.343,
    y1: -1586.1865,
    x2: -309.4032,
    y2: -1586.1865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M-309.8-1606.4c-4.7,22.3-32.3,48.9-37.3,46.6c-3.7-1.7-7.5-8.2-9.3-11.4c2.8-2,10.1-7.5,15.4-13.1 c0,0,12.2-8.4,13.7-9.8c1.4-1.4,3.9-4.4,4.6-9s5.1-5.3,4.8-3.3c-0.3,2.4-0.8,7,1.1,5.4c1.9-1.6,4-12.1,5.7-11.7 C-309.3-1612.3-309-1610-309.8-1606.4z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-397.7-1580.7c0,0.5-0.8,1.2-2.1,2c-3.9,2.4-12.2,5.5-16,6.4c-0.9,0.2-1.5,0.3-1.8,0.2 c-1.9-0.6-9-42,3.4-45.7c9-2.6,10.9,9,12,17.6C-400.9-1591.7-397.7-1583.2-397.7-1580.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: -415.8029,
    y1: -1550.0032,
    x2: -344.6866,
    y2: -1550.0032
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M-345-1523.4c-2.5,3.4-21.6,1.9-22.9,1.1c-1.3-0.8-32.1-15.7-37.4-21.7c-4.5-5-9.1-22.7-10.5-28.4 c3.8-0.8,12.1-4,16-6.4c1.4,7.5,3.8,19.6,4.6,21.1c1.1,2.1,27.1,22.2,32.3,22.6C-357.8-1534.6-342.5-1526.9-345-1523.4z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-317.1-1599.7L-317.1-1599.7c-0.9,0-1.7-0.8-1.7-1.7v-30.2c0-0.9,0.8-1.7,1.7-1.7l0,0 c0.9,0,1.7,0.8,1.7,1.7v30.2C-315.3-1600.5-316.1-1599.7-317.1-1599.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: -394.3514,
    y1: -1634.7791,
    x2: -365.2779,
    y2: -1634.7791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M-365.4-1646.9c0,0-1-8.2-2.5-9.9c-3.4,4.2-4,4.6-8.2,5c-4.2,0.4-10.7,1.9-10.7,5c0,3.1,2.5,3.8,1.9,6.7 c-0.6,2.9-8.4,6.1-9.2,11.7c-0.8,5.5-0.4,14.7,5.7,15.7c6.1,1,6.1-4.2,6.3-6.7c0.2-2.5,1.2-6.1,2.1-5.7c0.9,0.4,2.4,1.5,5.5,1.3 C-371.3-1624.1-364.3-1636-365.4-1646.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 3049.8359,
    y1: -2027.6532,
    x2: 3089.8577,
    y2: -2027.6532,
    gradientTransform: "matrix(-0.8749 0.5877 0.5841 0.8696 3605.6511 -1480.8438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M-274.9-1417.6l34.8-23.4c0,0-0.5-1.5-1.7-2.8c-1-1.2-2.5-2.2-4.6-1.9c-4.4,0.5-21.2,2.8-25.8,1.8 c-4.7-1-4.9-2.7-6.3-1.9c0,0-7.9,4.4-8,6.1c-0.1,1.3,6.8,13.5,10.1,19.2C-275.5-1418.7-274.9-1417.6-274.9-1417.6z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-258.1-1445.4c0,0-1.1,4.9-2.3,6.3c-1.2,1.4-13.3,0-15.1-1.4c-1.8-1.5-7.2-8.3-7.2-8.3s4.7-3.1,6.3-4.2 c1.6-1.1,7.2,7.6,7.2,7.6S-257.9-1446.5-258.1-1445.4z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-274.9-1417.6l34.8-23.4c0,0-0.5-1.5-1.7-2.8l-34.8,23.3C-275.5-1418.7-274.9-1417.6-274.9-1417.6z"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M-400.7-1524.5c0,0,50.5,16.2,56.1,19.3c5.6,3.1,54.8,54.9,54.8,54.9"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M-309.4-1417.6h-135.5c0,0-74.2-157-70.7-176.4c3.4-19.4,25.2-22.5,25.2-22.5s3.2-3,9.5,2.7 c1.8,1.6,3.9,4,6.2,7.3c10.3,14.9,39.4,99.3,39.4,99.3s6.7-2.8,16.2-5.6c11.4-3.3,26.9-6.5,39.9-4.5c5.7,0.9,10.9,2.7,15,6 C-342.9-1494.6-309.4-1417.6-309.4-1417.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-291.2-1417.6h-18.2c0,0-33.5-77-54.8-93.8c-4.1-3.2-9.3-5.1-15-6c12.3-1.4,24.9-0.6,33.2,6 C-324.7-1494.6-291.2-1417.6-291.2-1417.6z"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M253.7-1406.2h-839.6c-3.1,0-5.6-2.5-5.6-5.6l0,0c0-3.1,2.5-5.6,5.6-5.6h839.6c3.1,0,5.6,2.5,5.6,5.6l0,0 C259.4-1408.7,256.8-1406.2,253.7-1406.2z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -452.8,
    y: -1803.8,
    className: "st46",
    width: 75.9,
    height: 121.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -445.4,
    y: -1791.9,
    className: "st45",
    width: 61,
    height: 97.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-408.8-1743.1c0,3.3-2.7,6-6.1,6c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6 C-411.5-1749.2-408.8-1746.4-408.8-1743.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -345.3,
    y: -1771.6,
    className: "st46",
    width: 75.9,
    height: 121.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -337.8,
    y: -1759.7,
    className: "st45",
    width: 61,
    height: 97.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-301.3-1710.8c0,3.3-2.7,6.1-6.1,6.1c-3.3,0-6-2.7-6-6.1c0-3.3,2.7-6,6-6 C-304-1716.9-301.3-1714.2-301.3-1710.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M-1459.4-1417.5c0,0-134.7-169.5,70.3-368.6c205-199.1,632.2,13,639.1,147.3c6.9,134.4-48.5,221.3-48.5,221.3 L-1459.4-1417.5z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-1442.2-1499.6c0,0,3.2-25.1,16.1-35.4c13-10.4,13.8-26.5,13.8-26.5s17.6,61.1-4.9,72.3 C-1439.6-1478-1442.2-1499.6-1442.2-1499.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1412.3-1561.6c0.7,7.2,0.6,14.6,0,21.8c-0.6,7.3-1.9,14.5-3.9,21.5c-2,7-4.8,13.8-8.7,20 c-1.9,3.1-4.1,6-6.5,8.8c-2.4,2.7-5.1,5.2-8,7.5c-0.1,0.1-0.3,0.1-0.3,0c-0.1-0.1-0.1-0.3,0-0.3l0,0l0,0c2.8-2.3,5.6-4.7,8-7.4 c2.4-2.7,4.6-5.6,6.5-8.7c3.8-6.2,6.7-12.9,8.7-19.9c2-7,3.3-14.2,4-21.4C-1411.8-1547-1411.6-1554.3-1412.3-1561.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-1448-1786.2c0,0-32.5,105.8-7.9,197c24.6,91.3-9.2,124.8-9.2,124.8l25.6-25.7c0,0,10.9-80.8,8.2-121.8 l-8.2-4.2l8.6-7.3C-1430.8-1623.4-1453.6-1717.7-1448-1786.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1448-1786.2c-2.5,12.1-4.5,24.3-6.2,36.5c-1.6,12.2-3,24.5-3.9,36.9c-0.1,1.5-0.3,3.1-0.3,4.6l-0.2,4.6 c-0.1,3.1-0.4,6.2-0.4,9.3c-0.1,6.2-0.3,12.4-0.2,18.5l0,4.6l0,2.3l0.1,2.3l0.4,9.3c0,0.8,0.1,1.5,0.1,2.3l0.2,2.3l0.4,4.6 c0.3,3.1,0.5,6.2,1,9.2l1.3,9.2c0.5,3.1,1,6.1,1.5,9.1c1.1,6.1,2,12.2,3,18.3c1.9,12.2,3.6,24.5,4.9,36.8 c0.3,3.1,0.6,6.2,0.9,9.2c0.3,3.1,0.4,6.2,0.6,9.3c0.3,6.2,0.5,12.4,0.4,18.5c0,6.2-0.4,12.4-1,18.5c-0.6,6.2-1.5,12.3-2.6,18.4 c0,0.1-0.2,0.2-0.3,0.2s-0.2-0.2-0.2-0.3l0,0c1.1-6.1,2-12.2,2.6-18.3c0.6-6.1,1-12.3,1-18.5c0.1-6.2-0.1-12.3-0.4-18.5 c-0.2-3.1-0.4-6.2-0.6-9.2c-0.3-3.1-0.5-6.2-0.8-9.2c-1.3-12.3-2.9-24.5-4.8-36.7c-1-6.1-1.9-12.2-3-18.3 c-0.5-3-1.1-6.1-1.5-9.1l-1.3-9.2c-0.5-3.1-0.7-6.1-1-9.2l-0.4-4.6l-0.2-2.3c-0.1-0.8-0.1-1.5-0.1-2.3l-0.4-9.3l-0.1-2.3l0-2.3 l0-4.6c-0.1-6.2,0.1-12.4,0.2-18.5c0.1-3.1,0.3-6.2,0.4-9.3l0.2-4.6c0.1-1.5,0.2-3.1,0.3-4.6c0.8-12.3,2.3-24.6,3.9-36.9 C-1452.5-1761.9-1450.5-1774.1-1448-1786.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-1446.3-1490c0,0,6.9-64.9-6.1-90.3h-8.5l5-8.8c0,0-27.3-59.7-103.7-83.1c0,0,48.2,31.9,67.9,91.1 c9.3-2.3,15.9-1.9,15.9-1.9l-7,9.2c0,0,28.4,46.1,24.6,89.2C-1462-1441.6-1446.3-1490-1446.3-1490z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-1559.6-1672.2c4.3,1.8,8.5,4,12.6,6.3c4.1,2.3,8.1,4.7,12,7.3c7.8,5.1,15.4,10.8,22.4,16.9 c14.2,12.3,26.6,26.6,36.5,42.5c5,8,9.2,16.4,12.8,25l2.6,6.6c0.8,2.2,1.5,4.5,2.2,6.7l1.1,3.3c0.3,1.1,0.6,2.3,0.9,3.4l1.8,6.8 c4.1,18.3,5.3,37.2,4.1,55.9c0,0.1-0.1,0.2-0.3,0.2s-0.2-0.1-0.2-0.3l0,0c1.3-18.7,0.1-37.5-4-55.8l-1.7-6.8 c-0.3-1.1-0.6-2.3-0.9-3.4l-1.1-3.3c-0.7-2.2-1.4-4.5-2.2-6.7l-2.5-6.5c-3.6-8.6-7.8-17-12.7-25c-9.9-15.9-22.3-30.2-36.4-42.5 c-7.1-6.2-14.6-11.8-22.4-16.9c-3.9-2.6-7.9-5-12-7.3C-1551.1-1668.2-1555.3-1670.4-1559.6-1672.2z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "-1400.1,-1480.6 -1400.6,-1469.9 -1409.7,-1417.5 -1468.4,-1417.5 -1477.7,-1469.9 -1478.8,-1476  -1434.3,-1478.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-1389.1-1491.3v18.2c0,1.7-1.4,3.2-3.2,3.2h-96.3c-2.1,0-3.6-2-3-4l4.9-18.2c0.4-1.4,1.6-2.3,3.1-2.3h91.4 C-1390.5-1494.4-1389.1-1493-1389.1-1491.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1022.5-1440.3c-3.1,4.6-17.5,5.2-19.9,1.7c-2.4-3.4-4.9-110.6-15.6-148.2c-6.6,11.3-3,144-5.8,147.1 c-1.2,1.3-22.7,6-24-1.6c-6.4-37.9-4.2-122.1-2.6-162.6c0.3-7.3,0.6-13.2,0.8-17.1c11.6,6.5,45.6,9.8,54.5,3.5 c0.2,0.5,0.4,1,0.5,1.5C-1016.9-1566-1019.6-1444.7-1022.5-1440.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1063.6-1419.6h-37.9c0,0,0.4-11.3,7.2-11.8c1.2-0.1,2.3,0.1,3.2,0.4c4.1,1.5,5.1,6.3,5.1,6.3h21.4 C-1064.6-1424.8-1063.4-1422-1063.6-1419.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -1091.0548,
    y1: -1431.1749,
    x2: -1065.4131,
    y2: -1431.1749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M-1065.4-1424.8h-20.6c0,0-1-4.8-5.1-6.3c2.1-1.5,5.6-4.1,6.3-5.7c7.2-1.6,16.6-0.8,17.3,0 C-1066.9-1435.9-1065.4-1424.8-1065.4-1424.8z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1088.2-1433.1c0,0,4.4,0.9,5.7,0.7s6.4-11.5,5.7-12.8c-0.7-1.3-8.3-0.8-8.9,0 C-1086.4-1444.4-1086.7-1435.8-1088.2-1433.1z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1043.5-1419.5l37.9-0.2c0,0-0.5-11.3-7.3-11.8c-1.2-0.1-2.3,0.1-3.2,0.4c-4.1,1.5-5,6.3-5,6.3l-21.4,0.1 C-1042.4-1424.7-1043.6-1421.9-1043.5-1419.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -1041.6438,
    y1: -1431.1155,
    x2: -1016.0333,
    y2: -1431.1155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M-1041.6-1424.7l20.6-0.1c0,0,0.9-4.8,5-6.3c-2.1-1.5-5.6-4.1-6.3-5.6c-7.2-1.5-16.6-0.7-17.3,0.1 C-1040.3-1435.8-1041.6-1424.7-1041.6-1424.7z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1018.8-1433.2c0,0-4.4,0.9-5.7,0.7c-1.4-0.2-6.4-11.4-5.8-12.7c0.6-1.3,8.3-0.8,8.9,0 C-1020.8-1444.4-1020.4-1435.9-1018.8-1433.2z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M-1077.9-1614.1c0,0,2.1,7.9-7.9,13.9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M-1043.1-1611.5c0,0,0.7,9.2,11.7,11.3"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M-1082.6-1592.5c0,0-9.4,92.8,0,144.6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M-1053-1586.8c0,0,16.8,93.8,13.6,146.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -1131.0737,
    y1: -1701.5681,
    x2: -1143.3167,
    y2: -1696.0358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M-1133.5-1688.8c0,0-8.9-13.6-8.1-17.6c0.8-4,5.5-4.7,7.1-2.7c1.6,2,8.6,14.4,8.6,14.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -1010.0128,
    y1: -1688.927,
    x2: -1001.1106,
    y2: -1732.9142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M-1017.4-1696.7c0,0,2.7-13.5,4.2-16c1.4-2.5,15.2-7.3,17.8-7.9c2.6-0.5-2.7,4.7-6.5,7.2 c-3.8,2.6-5.8,20-5.8,20"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1017.7-1649.8C-1017.7-1649.8-1017.7-1649.8-1017.7-1649.8c-6.2,8.7-13.6-2.2-17.4-9.4 c-0.6-1.2-2.5-0.6-2.3,0.7c1.4,13,5.6,33.9,7.3,42.1c0.4,2.1-1.1,4.1-3.2,4.3c-11.3,1-44,0.3-56.3-0.8c-2.4-0.2-4.3-2.3-4.1-4.8 c0.5-10.6,1.7-38.2-0.3-41.6c-2.1-3.5-8.1,5.6-19.2,1.5c-4.4-1.6-8-5-10.2-9.1c-5.6-10.4-9.6-18.5-9.3-18.9 c0.7-1.2,8.9-6.3,8.9-6.3s11.9,15.3,14.5,15.1c2.6-0.2,5.9-22.7,18-28.3c12-5.6,22.9-8,22.9-8c14-1.4,31.2,7.7,35.8,16.2 c4.5,8.6,6.1,23.4,7,24.1c0.9,0.7,5.4-22.1,7.7-22.1c2.3,0,10.7-0.9,11.4,0.8C-1006.4-1693.4-1012.3-1670.5-1017.7-1649.8z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1124.9-1721.3l5.1-7l-3.4-2.5l-5.1,7c-1.1,1.6-2.8,2.7-4.6,3.2l0,0c-1.9,0.5-3.5,1.7-4.6,3.2l-12.2,16.6 c-0.8,1.1-0.6,2.7,0.5,3.5l5.3,3.9c1.1,0.8,2.7,0.6,3.5-0.5l12.2-16.6c1.1-1.6,1.7-3.5,1.7-5.4l0,0 C-1126.7-1717.9-1126.1-1719.8-1124.9-1721.3z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-1061.5-1722.9C-1061.5-1722.9-1061.5-1722.9-1061.5-1722.9c-0.4-0.4-3.5-3.8-2.9-6.5 c0.7-2.9,3.8-4.2,3.4-6.4c-0.4-2.2-5.5-0.3-5.5-0.3l-0.7-5.4c-3.5,3.6-14,5.2-20.3,5.8c-3.1,0.3-5.2,0.4-5.2,0.4 s-4.2-13.6,2.1-20.7c6.3-7.1,18.2,0.9,18.2,0.9s1.6-4.6,6.7-5c5.1-0.4,5.9,9.8,5.9,9.8s8.1-1.8,8.6,5.8 C-1050.6-1736.9-1061.5-1722.9-1061.5-1722.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: -1061.3203,
    y1: -1725.3124,
    x2: -1092.6091,
    y2: -1711.1735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M-1062-1714.9c0.4,2,3,13.8-4.3,13.5c-7.3-0.3-7.7-9.3-8.1-11c-0.4-1.7-2.2-0.8-5.9-3.7 c-4.3-3.4-6.4-14.8-7.1-19.6c6.4-0.6,16.8-2.1,20.3-5.8l0.7,5.4c0,0,5.1-2,5.5,0.3c0.4,2.2-2.7,3.5-3.4,6.4 c-0.6,2.7,2.5,6.1,2.8,6.5C-1062.1-1719.6-1062.3-1716.1-1062-1714.9z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1074.2-1711.8c0,0-2.2,5.8-1.6,10.4c0.7,4.6,2.6,6.3,4.3,5.1c1.7-1.2,4.1-5.1,4.1-5.1 S-1073.4-1706.3-1074.2-1711.8z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1061.7-1713.3c0,0,1.1,8.9-3.8,11.9C-1060.4-1697.5-1053.4-1698-1061.7-1713.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1122.4-1692.1c0,0-9.9,11.3-11.9,9.2c-2-2.1-2.7-4.6,3.4-10.5C-1124.7-1699.3-1120.3-1696.3-1122.4-1692.1 z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1006.3-1692.6c0,0-15,1.1-14.9-1.8c0.1-2.9,1.2-5.2,9.8-5.1C-1002.9-1699.4-1001.8-1694.2-1006.3-1692.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: -1145.9542,
    y1: -1711.7134,
    x2: -1135.7042,
    y2: -1711.7134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M-1146-1708.9c0,0,1.8,3.4,3.7,3.1c1.8-0.3,7-6.3,6.6-8.4c-0.4-2.1-2.8-3.8-4.3-3.5 C-1141.6-1717.4-1146-1708.9-1146-1708.9z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-818.2-1417.5h-151.4c0,0-29.2-126.5,28.4-156.1c7-3.6,14.2-5.1,21.3-4.9c11.7,0.4,23.4,5.4,34.5,13.7 c14.8,11.1,28.4,28,39.6,47.5C-828.2-1486.4-817-1448.9-818.2-1417.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-750.1-1417.5h-68c1.2-31.4-10-68.9-27.6-99.7c-11.1-19.5-24.8-36.4-39.6-47.5 c-11.1-8.3-22.8-13.3-34.5-13.7h65.2c25.6-0.8,51.6,21.3,71.3,51.9c7.4,11.6,14,24.5,19.2,37.7 C-754.6-1465-749.3-1439.7-750.1-1417.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1237.1,
    y: -1489,
    className: "st44",
    width: 380.1,
    height: 20.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1237.1,
    y: -1468.8,
    className: "st45",
    width: 380.1,
    height: 51.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "-1417,-1622.1 -947,-1622.1 -934,-1524.4 -919,-1489 -1338.8,-1489  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-1365.5-1515.8c0,0-14.1-110.5-51.5-106.2c-37.4,4.3-33.2,35.2-15,75.4c18.3,40.2,54,94.2,54,94.2 L-1365.5-1515.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-1237.1-1417.5h-151.4c0,0-29.2-126.5,28.4-156.1c7-3.6,14.2-5.1,21.3-4.9c11.7,0.4,23.4,5.4,34.5,13.7 c14.8,11.1,28.4,28,39.6,47.5C-1247.1-1486.4-1236-1448.9-1237.1-1417.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-1169.1-1417.5h-68c1.2-31.4-10-68.9-27.6-99.7c-11.1-19.5-24.8-36.4-39.6-47.5 c-11.1-8.3-22.8-13.3-34.5-13.7h65.2c25.6-0.8,51.6,21.3,71.3,51.9c7.4,11.6,14,24.5,19.2,37.7 C-1173.6-1465-1168.3-1439.7-1169.1-1417.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -1113.743,
    y1: -1430.249,
    x2: -1066.9917,
    y2: -1430.249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M-1067-1421.7c-0.2,1.9-1.1,4.2-2.2,4.2h-44.5c0-1.3,0.1-2.7,0.2-4.2c0.9-10.1,3.8-21.1,3.8-21.1 s4-0.8,22.1,1.8c2.8,8.3,19.7,15.9,20.4,17.3C-1067-1423.4-1066.9-1422.6-1067-1421.7z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M-1155.8-1493.1c0,0-18.5,47.5-18.6,50.2c-0.2,2.8,21.2,3,21.8,3.1c0.6,0.2,26.8-42.8,26.8-42.8l-6.1-15.3 L-1155.8-1493.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: -1179.1027,
    y1: -1571.4116,
    x2: -1124.4034,
    y2: -1568.5035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M-1161.4-1579.4l7.1,12.9c0,0,26-23.7,27.4-25.3c1.4-1.7,4.8,6.1,4.8,6.1s-19.4,37.6-31.7,39.1 c-12.3,1.5-16.9-16.5-16.9-16.5l0.9-10.7L-1161.4-1579.4z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-1171.2-1609.9c0,0,8.3,10,12.2,29.6c-2.2,4.4-10,7.5-10,7.5l-2.2-36.5V-1609.9z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-1214.3-1584.5c-4.1,13.6-8.1,10.6-8.1,10.6s-0.2-0.1-0.5-0.4c-2.1-1.5-9.7-7.2-15.4-12.8 c-0.4-0.4-0.9-0.8-1.3-1.3c4.8-11.4,21.8-33.7,21.8-33.7C-1205.5-1624.2-1210.1-1598.1-1214.3-1584.5z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1212.1-1622.1c0,0-0.7-9.3,19.2-9.6c19.9-0.4-1.2,12.7-1.2,11.8 C-1194.1-1620.8-1212.1-1622.1-1212.1-1622.1z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-1203.8-1621.4c0,0,16.2-3.5,22.3,1.5s15,63.6,14.1,64.8c-1,1.1-7.8,22.7-7.8,22.7s-22.2,1.3-25.1,5.7 c-2.9,4.4,0-60.9,0-60.9L-1203.8-1621.4z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1174.1-1615.6c0,0,6.1,5.5,7,15.7c0.9,10.2-1.1,46.2,0,50.8c1.1,4.6,2.8,10,3.1,13.3 c0.4,3.3-8.7,4.2-11.3,3.5c-2.6-0.7-0.4-34.5-1.5-43.7c-1-9.3-4-27.6-4-27.6l1.9-8.8L-1174.1-1615.6z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-1217.7-1622.1c0,0,3.1-2.3,5.6,9.4c2.5,11.6-1.4,35.3-8.9,38.8c-2.2,9.9-0.9,23.2-0.9,23.2 s12,16.8,16.4,22c4.4,5.2,7.8,8.1,7.8,8.1l-0.9-9.8c0,0,5.8-31.2,5.8-41.1c0-9.9-7.6-53.5-7.6-53.5S-1211.4-1625.2-1217.7-1622.1z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M-1200.5-1624.9c0,0,10.9,28.4,6.8,64.3c-7.4-24.2-16.2-56.9-13.8-59.8 C-1205.1-1623.4-1200.5-1624.9-1200.5-1624.9z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M-1184.8-1622.1c0,0,8.4,32.3,8.8,58.9c3.3-15.9,4.1-49.1,1.8-52.4 C-1176.3-1619-1184.8-1622.1-1184.8-1622.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -1249.7131,
    y1: -1548.1881,
    x2: -1211.8037,
    y2: -1548.1881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M-1216.6-1509.3c-4.6,0-5.9-5.4-9-15.5c-3.1-10.2-22.9-38.2-24-41c-1-2.4,8.9-17.5,11.4-21.3 c5.7,5.5,13.3,11.3,15.4,12.8l-7.9,11.1c0,0,6.2,15,14.2,26.4C-1208.7-1525.4-1212-1509.3-1216.6-1509.3z"
  })), /*#__PURE__*/React.createElement("g", null, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-1167.9-1646.3c-0.4,0.1-0.8,0.1-1.1,0.1c-7.6,0.7-17.1-3.5-21.3-1.7c-4.4,1.9-0.7,7.5,0,8.6 c0.6,1-5.3,8.1-6.4,9.2c-0.1,0.1-0.1,0.2-0.1,0.2c-2.4-6.5-13.7-11.1-15.1-20.2c-1.4-9.1,7.1-9.7,7.1-9.7s-1.3-11.1,4.1-15.9 c-2.8,2.8-1.4,13.5-1.4,13.5s2.2-12.3,14.4-13.6c12.2-1.3,13.8,5.7,13.8,5.7s2.9-7.3,8.7-5.4 C-1150.4-1670.5-1160.1-1647.6-1167.9-1646.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: -1216.051,
    y1: -1676.2855,
    x2: -1165.4598,
    y2: -1605.3839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M-1182.9-1620.3c-1.8-0.2-2.4-0.7-2.4-0.7s0.3,5.3-0.5,7.3c-0.7,2-2.2,4.3-5.1,3.8 c-2.9-0.5-7.8-2-6.7-10.1c0.5-3.7,0.8-7.3,0.9-10c1-1.2,7-8.2,6.4-9.2c-0.7-1.1-4.3-6.7,0-8.6c4.2-1.8,13.7,2.3,21.3,1.7 C-1168.9-1639.2-1169.6-1618.9-1182.9-1620.3z"
  }))), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1127.1-1607.4l-4-8.3l-4,1.9l4,8.3c0.9,1.8,1.1,3.9,0.7,5.9l0,0c-0.4,2-0.2,4.1,0.7,5.9l9.4,19.7 c0.6,1.3,2.2,1.9,3.5,1.2l6.2-3c1.3-0.6,1.9-2.2,1.2-3.5l-9.4-19.7c-0.9-1.8-2.4-3.3-4.2-4.3l0,0 C-1124.7-1604-1126.2-1605.5-1127.1-1607.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: -1108.7992,
    y1: -1598.6171,
    x2: -1131.0944,
    y2: -1577.0143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M-1117.9-1598c0,0-4.4,2.3-3.7,5.3c0.7,3,3.4,7.6,8.8,6.3C-1107.4-1587.7-1117.9-1598-1117.9-1598z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1110.6-1439.7c-6-13.4-23.5-53.9-23.5-53.9s-25.1,5.7-48.9,4.8c-5.3-13.3-11.8-26.1-19.2-37.7 c0.7-0.8,1.3-1.4,1.9-1.5c0,0,19.6-6.8,44-4.1c24.4,2.7,44.8,15.5,47.4,17.9c2.5,2.5,22.1,69.9,22.7,72 C-1085.8-1440.1-1102.7-1439.7-1110.6-1439.7z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M-1176.9-1522.9c0,0-1.8,10.5-8.7,13"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M-1174.5-1514.8c0,0,0.3,0.1,0.8,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M-1171.9-1514.4c9.6,1.8,42.9,8,44.5,9.3c1.7,1.3,19,47.9,22.5,57.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M-1104.6-1447c0.2,0.5,0.3,0.8,0.3,0.8"
  })))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st108",
    x1: -1139.4,
    y1: -1489,
    x2: -1161.4,
    y2: -1446.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: -1178.5569,
    y1: -1430.249,
    x2: -1131.8054,
    y2: -1430.249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M-1131.9-1421.7c-0.2,1.9-1.1,4.2-2.2,4.2h-44.5c0-1.3,0.1-2.7,0.2-4.2c0.9-10.1,3.8-21.1,3.8-21.1 s4-0.8,22.1,1.8c2.8,8.3,19.7,15.9,20.4,17.3C-1131.8-1423.4-1131.8-1422.6-1131.9-1421.7z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1147.9-1446.9c0,0-2.8-1.5-4.2,0c-1.5,1.5-1.9,7.6-1.4,8.9c0.6,1.3,10.4,9.4,11.2,9.4 c0.7,0,1.4-0.9,1.4-0.9s-6.4-7-7.5-10.2C-1149.6-1442.9-1147.9-1446.9-1147.9-1446.9z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1178.3-1421.7h46.5c-0.2,1.9-1.1,4.2-2.2,4.2h-44.5L-1178.3-1421.7z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-1112.9-1421.7h46.5c-0.2,1.9-1.1,4.2-2.2,4.2h-44.5L-1112.9-1421.7z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-1083.1-1446.9c0,0-2.8-1.5-4.2,0c-1.5,1.5-1.9,7.6-1.4,8.9c0.6,1.3,10.4,9.4,11.2,9.4 c0.7,0,1.4-0.9,1.4-0.9s-6.4-7-7.5-10.2C-1084.8-1442.9-1083.1-1446.9-1083.1-1446.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-965.2-1631.6c0,0-10-10.5-3.7-23.8c6.2-13.3,35.2-12.5,38.6,2.5c3.5,15,6,21,11.9,25.9 c6,4.8,16.2,9.3,16.9,30.7c0.7,21.5,18.8,30.5,12.2,48.5c-6.6,18-38.8,17.3-50.9,1s-13.5-68.3-13.5-68.3L-965.2-1631.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M-943.2-1538.8c0,0,23.9,41.6,0,49.9c-6.5,2.2-56.3-2.5-56.3-2.5s33.7,42.4,38,53.7 c-0.4,5-23.2,2.6-25.6,2.3c-6.8-1-61.8-56-62.3-67.7c0-17.7,82.5-34.3,82.5-34.3L-943.2-1538.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 6548.4009,
    y1: -1426.9536,
    x2: 6595.1528,
    y2: -1426.9536,
    gradientTransform: "matrix(-1 0 0 1 5590.2256 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M-1004.9-1420.6c0.2,1.4,1.1,3.1,2.2,3.1h44.5c0-1-0.1-2-0.2-3.1c-0.9-7.5-3.8-15.7-3.8-15.7 s-4-0.6-22.1,1.3c-2.8,6.2-19.7,11.8-20.4,12.8C-1004.9-1421.9-1005-1421.3-1004.9-1420.6z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-958.2-1417.5h-44.5c-1.1,0-2-1.7-2.2-3.1h46.5L-958.2-1417.5z"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-992.9-1428.1c0,0,3,1.9,4.7,1.9c1.7-0.1,6.3-7.1,5.7-10.2c-0.6-3.2-6.4-6.6-10.4-4.6 c-3.9,2.1,3,4.5,3.8,7.1S-992.9-1428.8-992.9-1428.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-919-1538.8c0,0,23.9,41.6,0,49.9c-6.5,2.2-56.3-2.5-56.3-2.5s33.7,42.4,38,53.7c-0.4,5-23.2,2.6-25.6,2.3 c-6.8-1-61.8-56-62.3-67.7c0-17.7,82.5-34.3,82.5-34.3L-919-1538.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 6524.168,
    y1: -1426.9536,
    x2: 6570.9194,
    y2: -1426.9536,
    gradientTransform: "matrix(-1 0 0 1 5590.2256 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M-980.6-1420.6c0.2,1.4,1.1,3.1,2.2,3.1h44.5c0-1-0.1-2-0.2-3.1c-0.9-7.5-3.8-15.7-3.8-15.7 s-4-0.6-22.1,1.3c-2.8,6.2-19.7,11.8-20.4,12.8C-980.7-1421.9-980.7-1421.3-980.6-1420.6z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-934-1417.5h-44.5c-1.1,0-2-1.7-2.2-3.1h46.5L-934-1417.5z"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-968.6-1428.1c0,0,3,1.9,4.7,1.9c1.7-0.1,6.3-7.1,5.7-10.2c-0.6-3.2-6.4-6.6-10.4-4.6 c-3.9,2.1,3,4.5,3.8,7.1C-964.1-1431.4-968.6-1428.8-968.6-1428.1z"
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-966.9-1584.6c-0.3,9.4-8,24.2-8,24.2s-0.6-0.2-2-1.4c-2-1.6-5.7-4.9-11.9-11.6c-0.7-0.7-1.4-1.5-2.1-2.3 c2.8-5,18.5-29.7,18.5-29.7S-966.6-1594.1-966.9-1584.6z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-972.5-1605.5c0,0,19-18.6,53.5-2.6c-8.1,4.8-5.9,27.3-6.3,35.7c-0.4,8.4,8.7,29.7,7.8,34.5 c-0.9,4.8-40.7,13.6-53.7,5.1c-5.9-3.8,4.6-19.5,3.1-30.2c-1.5-10.7-8.1-13.5-8.5-21C-976.9-1591.7-975.2-1603.4-972.5-1605.5z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-918.6-1565.4c0,0,0,0.1-0.1,0.3c-0.1,0.3-0.2,0.6-0.3,0.8h0c-5.3,0.3-14.7-3.2-17.5-4.6 c-0.5-0.2-0.8-0.4-0.8-0.5c0-0.4,3.7-25.6,7.4-33.9c3.7-8.3,10.9-4.8,10.9-4.8C-909.9-1606.1-915.5-1575.4-918.6-1565.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: -991.0018,
    y1: -1542.3676,
    x2: -918.9611,
    y2: -1542.3676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M-919-1564.3c-1.6,4.9-8.1,24.1-9.4,26c-1.5,2.2-32.3,21.2-37.3,22.2c-5,0.9-26.4-0.2-25.3-4.8 c1.1-4.6,22.3-5.2,24-5.7c1.7-0.6,24.7-19,24.7-19l5.8-23.2C-933.7-1567.5-924.3-1564-919-1564.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: -1033.3127,
    y1: -1574.1244,
    x2: -976.9424,
    y2: -1574.1244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M-976.9-1561.8c-0.9,3.6-4,12.9-10.9,13.2c-8.5,0.4-25.7-34.9-29-36.4c-3.3-1.5-13.5-2.6-16.2-6.3 c-2.8-3.7,18.1-0.9,20.5-0.8c2.4,0.1,0-5.2,1.7-7.3c1.7-2,5.1,11.3,5.9,12.8c0.9,1.6,13.5,13.9,15.1,13.8c0.3,0,0.7-0.3,1-0.7 C-982.7-1566.7-979-1563.4-976.9-1561.8z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M-934-1524.4c0,0,4.3,10,12.4,11.4"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M-937.2-1516.4c0,0-54.7,14.5-56.8,16.7c-2.1,2.2,47,58,47,58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: -966.9313,
    y1: -1623.7284,
    x2: -940.1292,
    y2: -1623.7284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M-966.3-1645.1c0,0-3.7,19.8,6.4,29.9c2.8,2.8,5.4-1.5,6.2,0c0.8,1.5-2.4,12.2,7.5,12.7 c9.8,0.6,4.7-17.9,4.8-19.9c0.1-2.1-7.8-3.9-8-8.1c-0.1-2.3,2.3-8-0.1-9.3c-2.4-1.4-7.6,0.4-9.8-0.6 C-961.4-1641.3-966.3-1645.1-966.3-1645.1z"
  }))), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-725.7-1406.7h-774.5c-3,0-5.4-2.4-5.4-5.4l0,0c0-3,2.4-5.4,5.4-5.4h774.5c3,0,5.4,2.4,5.4,5.4l0,0 C-720.3-1409.1-722.7-1406.7-725.7-1406.7z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1371,
    y: -1765.7,
    className: "st46",
    width: 73.4,
    height: 117.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1363.8,
    y: -1754.2,
    className: "st45",
    width: 59,
    height: 94.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st44",
    cx: -1334.3,
    cy: -1707,
    r: 5.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1267.5,
    y: -1803.3,
    className: "st46",
    width: 73.4,
    height: 117.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1260.3,
    y: -1791.8,
    className: "st45",
    width: 59,
    height: 94.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st44",
    cx: -1230.8,
    cy: -1744.6,
    r: 5.8
  }))))), /*#__PURE__*/React.createElement("g", null, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M-476.6-1985.7c0,0-112.1-136.9-46.9-208.2c65.2-71.4,549-248.7,607.2-226.2 c132.4,51.3,28.3,406.6-19.2,429.5L-476.6-1985.7z"
  })), /*#__PURE__*/React.createElement("g", null, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-298.9-2014.5c-3.6,5.3-20.1,6-22.9,2c-2.8-3.9-5.6-127.1-18-170.4c-7.5,13-3.5,165.6-6.6,169.1 c-1.4,1.5-26.1,6.9-27.6-1.8c-7.3-43.6-4.8-140.4-2.9-186.9c0.3-8.4,0.7-15.2,0.9-19.7c13.3,7.4,52.4,11.2,62.7,4.1 c0.2,0.5,0.4,1.1,0.6,1.7C-292.4-2159-295.5-2019.5-298.9-2014.5z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-346-1990.8h-43.6c0,0,0.5-12.9,8.3-13.6c1.4-0.1,2.6,0.1,3.7,0.4c4.7,1.7,5.8,7.2,5.8,7.2h24.6 C-347.3-1996.6-345.9-1993.5-346-1990.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: -377.6319,
    y1: -2004.0242,
    x2: -348.1563,
    y2: -2004.0242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M-348.2-1996.6h-23.7c0,0-1.1-5.6-5.8-7.2c2.4-1.7,6.4-4.7,7.2-6.5c8.2-1.8,19.1-0.9,19.8,0 C-349.8-2009.4-348.2-1996.6-348.2-1996.6z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-374.4-2006.3c0,0,5,1,6.6,0.8c1.6-0.2,7.3-13.2,6.6-14.7c-0.8-1.5-9.5-0.9-10.3,0 C-372.3-2019.2-372.6-2009.4-374.4-2006.3z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-322.9-1990.7l43.6-0.2c0,0-0.5-12.9-8.4-13.5c-1.4-0.1-2.6,0.1-3.7,0.5c-4.7,1.7-5.8,7.3-5.8,7.3 l-24.6,0.1C-321.7-1996.5-323.1-1993.4-322.9-1990.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: -320.8327,
    y1: -2003.9558,
    x2: -291.3931,
    y2: -2003.9558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M-320.8-1996.5l23.7-0.1c0,0,1.1-5.6,5.8-7.3c-2.4-1.7-6.5-4.7-7.3-6.5c-8.2-1.8-19.1-0.8-19.8,0.1 C-319.2-2009.4-320.8-1996.5-320.8-1996.5z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-294.6-2006.3c0,0-5,1-6.6,0.8c-1.6-0.2-7.4-13.1-6.6-14.6s9.5-1,10.2-0.1 C-296.8-2019.3-296.4-2009.4-294.6-2006.3z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M-362.5-2214.3c0,0,2.4,9.1-9,16"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M-322.5-2211.3c0,0,0.7,10.6,13.4,13"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M-367.9-2189.4c0,0-10.8,106.7,0,166.3"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M-333.8-2182.9c0,0,19.3,107.8,15.7,168.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: -264.0196,
    y1: -2340.8479,
    x2: -234.3673,
    y2: -2394.1216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M-264.8-2356.8c0,0,16.3-19.5,17.6-21.7c1.3-2.2,4.2-13.7,8.2-14.5c4.1-0.8,8.6,1.9,9.8,5.1 c1.3,3.2-9.1,13.2-9.8,15.3c-0.7,2-19,27.3-19,27.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 5408.1621,
    y1: -1552.4247,
    x2: 5437.8145,
    y2: -1605.6981,
    gradientTransform: "matrix(-0.9598 -0.2807 -0.2807 0.9598 4386.4604 633.9061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M-363.3-2389.3c0,0-10.2-23.3-10.8-25.8c-0.6-2.4-0.2-14.4-3.8-16.2c-3.7-1.9-8.7-0.6-10.9,2.1 c-2.1,2.7,5,15.3,5.2,17.4s10.6,31.5,10.6,31.5"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-376.3-2215.9c-2.3-1-3.5-3.6-2.6-6c4.7-12,22.6-60.6,17.3-93.6c-6-37.9-16.1-76.5-16.1-76.5l11.7-4.3 c0,0,27.4,68.2,35.3,75.5c7.9,7.3,25,3.4,31.7-2.5c6.7-6,32.5-34.1,32.5-34.1l10.4,12.1c0,0-40.5,58.6-46.9,76.7 c-6.4,18.1,1.2,61.6-6.7,62.3C-316.3-2205.7-363.6-2210.6-376.3-2215.9z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-289.6-2342c0,0-1.5,1.3-7,1.8c-0.1,0-0.1,0-0.2,0c-13.2,1.2-19.8-11.2-22.4-11.2c-2.7,0-1.7,8.4-2,11.9 c-0.2,2.3-2.7,4.5-4.3,5.8c0,0,0,0,0,0c-0.9,0.7-1.5,1.1-1.5,1.1c0.8-12.4-9.4-22.9-6.9-30c2.5-7,8.2-6.7,8.2-6.7s-1-5.5,2-7.7 c3-2.2,10.9-2.7,17.1,4.7C-275.6-2375.7-289.6-2342-289.6-2342z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -328.8807,
    y1: -2330.2966,
    x2: -296.6383,
    y2: -2330.2966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M-296.6-2340.2c-1.3,4.7-5.7,16.8-15.1,18.8c-4.2,4.5-2.2,11.9-8.7,12.3c-6.5,0.3-10.1-3.5-7.6-9.9 c1.6-4.2,2.2-10.7,2.5-14.6c0,0,0,0,0,0c1.7-1.3,4.1-3.5,4.3-5.8c0.3-3.5-0.7-11.9,2-11.9c2.7,0,9.3,12.4,22.4,11.2 C-296.8-2340.2-296.7-2340.2-296.6-2340.2z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-269.4-2357.5c0,0,11.2,16.3,13.4,16.6c2.2,0.3,4.9-3.9,4.4-6.4c-0.5-2.5-10.7-14.2-13.2-14.2 C-267.2-2361.6-270.2-2358.8-269.4-2357.5z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-380.3-2387.9c0,0,19.2-4.7,20.3-6.7c1-1.9-1.9-6-4.4-6.4c-2.5-0.4-17.1,5-17.9,7.3 C-383.3-2391.3-381.8-2387.5-380.3-2387.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-136.8-2020.2c-0.4,3.1-23.1,3.2-24.1,0c-1-3.2-31.2-152.1-31.2-152.1l-26,152.1c0,0-22.8,1.8-22.8-5.2 c0-7,14.2-185.4,14.3-187.3c1.8,3.6,5.5,6.6,12.2,8.2c14.7,3.7,38.3,1.9,48.4-14.2C-160.9-2210.9-136.3-2023.3-136.8-2020.2z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M-162.4-1990.7h53.8c0,0,0.5-2,0.2-4.2c-0.3-2-1.2-4.1-3.5-5.4c-5.1-2.7-24.6-12.2-28.8-16.6 c-4.2-4.4-3.4-6.4-5.4-6.5c0,0-11.6-0.9-12.9,0.8c-1.1,1.3-2.4,19.4-3,27.7C-162.2-1992.3-162.4-1990.7-162.4-1990.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-124.7-2008.4c0,0-4.7,4.4-7,5.1c-2.3,0.6-14.2-9.6-15-12.4c-0.8-2.8-1.8-14.1-1.8-14.1s7.2,0,9.7,0 c2.5,0,2.2,13.2,2.2,13.2S-123.6-2009.4-124.7-2008.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-162.4-1990.7h53.8c0,0,0.5-2,0.2-4.2h-53.7C-162.2-1992.3-162.4-1990.7-162.4-1990.7z"
  }))), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-185.7-2340.7c0,0,16.6-18.2,1.6-27.4c-12.5-11.6-14.7-11.4-24.4-9.5c-9.7,1.8-18.3,10.7-17.8,27.8 c0.5,17.1-23.8,30.8-19.1,48.8c4.7,17.9-17.3,50.3-12.1,66.4c5.2,16,26.3,31.3,38.4,21.1c12.1-10.2,17.1-104.4,17.1-104.4 l8.5-18.2L-185.7-2340.7z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-172.3-2243.7c1.7,11.6,8.9,20.9,6.4,25c-10.1,16.2-33.7,17.9-48.4,14.2c-6.7-1.7-10.4-4.6-12.2-8.2 c-2.1-4.4-1.4-9.7,0.4-15c3.3-9.7,3.3-39.7-3.2-51.8c-6.5-12.1-13.9-16.5-10.1-22c3.9-5.5,30.1-26.5,30.1-26.5s32,5.9,34.7,6.8 c0.3,0.1,0.7,0.5,1.1,1.1c3.2,4.2,9,19.6,9.9,34.2c0.1,1,0.1,1.9,0.1,2.8C-162.9-2265.8-175.3-2263.8-172.3-2243.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: -212.1379,
    y1: -2334.5579,
    x2: -184.0855,
    y2: -2334.5579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M-185.5-2359.8c0,0,3.7,15.6-0.8,26.6c-4.5,11.1-8.4,10.7-8.4,10.7s1.8,11.1-3.9,12.6 c-5.7,1.5-12.1,1-13.6-14.6c5.7-6.9,7-9.2,5.9-13.1s-0.5-9,4.2-8.5C-197.4-2345.6-184.5-2343.7-185.5-2359.8z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-228-2262.6c-0.2,0.2-0.5,0.5-0.7,0.7c-6.1,5.9-13.5,8-17,7.3c-0.9-0.2-1.6-0.5-1.9-1 c-1.5-2.5-1.9-46.7,9.2-47.3C-229.4-2303.4-225.7-2286.2-228-2262.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.7092,
    y1: -2267.9702,
    x2: -201.6743,
    y2: -2267.9702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M-204-2277.3c-0.9,4.5-19,51.3-33.9,44.9c-6-2.6-7.5-17-7.9-22.1c3.5,0.6,10.9-1.4,17-7.3l-0.2,3.2 c0,0,16.7-21.9,16.7-24.8s0.1-21.1,1.6-20.7c1.5,0.4,1.9,15,3.8,14.6c1.9-0.4,2.5-10.6,4.4-10.7S-203.1-2281.8-204-2277.3z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-149-2283.5c-0.5,0.5-1,0.8-1.5,1.1c-2.7,1-8.2-1.2-12.9-3.7c-0.9-14.6-6.8-30-9.9-34.2 c6.6,3.3,26.1,13.2,28,16.1c0.5,0.7,0.8,1.9,0.9,3.5C-144.1-2295.4-145.8-2286.7-149-2283.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: -148.9818,
    y1: -2294.0933,
    x2: -88.337,
    y2: -2294.0933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M-88.3-2306.4c0,0-18.3,27.3-35.5,31.8c-2.3,1.6-16.1-4.6-25.1-8.9c3.2-3.2,4.9-12,4.5-17.2 c4.2,2.2,15.6,8.3,18.2,9.2c3.2,1.1,37-22.4,37-22.4L-88.3-2306.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.6042,
    y1: -2007.1396,
    x2: 132.6599,
    y2: -2007.1396,
    gradientTransform: "matrix(1 0 0 1 -348.2663 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M-215.6-1990.7h-53.8c0,0-0.5-2-0.2-4.2c0.3-2,1.2-4.1,3.5-5.4c5.1-2.7,24.6-12.2,28.8-16.6 c4.2-4.4,3.4-6.4,5.4-6.5c0,0,11.6-0.9,12.9,0.8c1.1,1.3,2.4,19.4,3,27.7C-215.7-1992.3-215.6-1990.7-215.6-1990.7z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-253.3-2008.4c0,0,4.7,4.4,7,5.1c2.3,0.6,14.2-9.6,15-12.4c0.8-2.8,1.8-14.1,1.8-14.1s-7.2,0-9.7,0 c-2.5,0-2.2,13.2-2.2,13.2S-254.4-2009.4-253.3-2008.4z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-215.6-1990.7h-53.8c0,0-0.5-2-0.2-4.2h53.7C-215.7-1992.3-215.6-1990.7-215.6-1990.7z"
  })))), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M-218-2201c0,0,1.8,7.5-5.7,12.1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st125",
    x1: -218,
    y1: -2188.9,
    x2: -232.7,
    y2: -2039.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st125",
    x1: -188.8,
    y1: -2171.8,
    x2: -154.8,
    y2: -2028.4
  }))), /*#__PURE__*/React.createElement("g", null, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M11.3-2028.4c-1.6,2.2-20.1,4.6-23.7,1.2c-3.6-3.4,0.2-52.9-3.7-67.7c-4-14.8-25.2-85.3-27.1-85.3 c-1.9,0-21.2,60.3-24.5,70c-3.3,9.7-42.3,82.5-43.7,83.8c-1.4,1.3-24.9,2.3-26.4-4.7c-1.5-7,33.5-79.1,37.4-109.6 c2.8-22,9.6-53.9,13.2-70c6.1,1.5,13.7,2.2,21.7,0.9c5.8-1,10.1-5.1,13.1-11.2c6,0.7,14.9,0,21.2-1.1c0.1,3.6,0.3,6,0.8,6.8 c2.8,4.2,12.5,2.7,18.9-0.7c6,22.5,20,74.7,24.8,89.9C19.6-2106.5,12.9-2030.6,11.3-2028.4z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M43.5-2356.1L43.5-2356.1c-0.8,0-1.5-0.7-1.5-1.5v-34c0-0.8,0.7-1.5,1.5-1.5l0,0c0.8,0,1.5,0.7,1.5,1.5v34 C45-2356.8,44.3-2356.1,43.5-2356.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: -21.6002,
    y1: -2316.3469,
    x2: 80.4237,
    y2: -2363.9243
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M1.3-2324.5c0,0,6,1.8,6.7,1.8c0.7,0,33.8-35,35-36.7c1.2-1.7,2.8-17.9,4.2-18.9c1.3-1,5.7,14.7,2.7,24.1 c-3.5,11.1-33,51.3-36.7,51.3c-3.7,0-20.9-3.5-20.9-3.5"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-77.4-2333.2c0,0,3-18.6,21.6-17.6c18.6,1,17.3,14.3,17.3,14.3L-77.4-2333.2z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-30.2-2265.7c0,0.9,0,1.8,0,2.7c0,1.1,0,2.2,0,3.3c0,2.8-0.1,5.5-0.2,8.2c0,0.4,0,0.8,0,1.3 c0,0.5,0,1,0,1.5c0,1-0.1,2-0.1,3c0,0.4,0,0.7,0,1.1c0,0.6,0,1.1,0,1.6c0,0.2,0,0.3,0,0.4c0,0.4,0,0.8,0,1.1 c0,0.9-0.1,1.8-0.1,2.7c0,0.4,0,0.8,0,1.3c-0.1,2-0.1,3.9-0.1,5.7c0,0.9,0,1.8,0,2.7v0.3c0,2.5,0,4.7,0,6.6 c-6.3,1.1-15.2,1.8-21.2,1.1c0.2-0.3,0.3-0.6,0.5-1c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.4,0.3-0.7,0.5-1.1c0,0,0,0,0-0.1 c0.2-0.4,0.3-0.8,0.5-1.2c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.2,0.1-0.3,0.2-0.5c0.2-0.5,0.3-1,0.5-1.6 c0.1-0.4,0.3-0.9,0.4-1.3c0.1-0.4,0.2-0.9,0.4-1.3c0.1-0.2,0.1-0.5,0.2-0.7c0.2-0.8,0.4-1.6,0.5-2.4c0.1-0.4,0.1-0.7,0.2-1.1 c0.1-0.3,0.1-0.6,0.2-0.9c0.1-0.6,0.2-1.1,0.3-1.7c0.1-0.5,0.2-1,0.2-1.5c0.1-0.7,0.2-1.4,0.3-2.2c0.1-1.2,0.3-2.3,0.4-3.5 c0.1-0.6,0.1-1.2,0.1-1.8c0,0,0,0,0-0.1c0,0,0,0,0,0c0.1-1.7,0.2-3.5,0.3-5.3c0-0.1,0-0.1,0-0.2c0.2-5.1,0.1-10.3-0.2-15.5 c-0.1-2.1-0.3-4.2-0.5-6.3c-2.3-26.1-22.9-56-26.8-61.4c4.5-1.9,20.1-8,30.9-3.6C-31.8-2327.3-30.1-2294.6-30.2-2265.7z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M-30-2367.8c-1.6,0.8-3.2,1.5-4.7,1.9c-8.5,2.6-15.1-0.1-15.1-0.1c-2.5,0.5-2.5,10.2-3.7,10.2 c-1.2,0-1.2-4-3.7-6c-2.5-1.9-6.7,1.4-4.5,5.4c2.2,4,0,11.2,0,11.2s-0.4-1.3-1.3-3.2c0,0,0,0,0,0c-0.6-1.3-1.5-2.9-2.7-4.5 c-3-4-18.1-13.9-13.2-23.1c4.9-9.2,14.1-7.2,14.1-7.2s0.5-13.1,6.7-18.3c-2.3,3.5-3,11.1-3,11.1s6-10.7,13.7-10.2 c7.7,0.5,10.4,7.9,10.4,7.9s3.2-5.4,9.9-1.8C-20.5-2391-19.5-2373.4-30-2367.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: -92.6813,
    y1: -2348.4172,
    x2: -10.0072,
    y2: -2345.1504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M-36.6-2345.1c-1.5,4.5-7.7,4-8.5,3.7c-0.8-0.3,1.2,9-1.2,12.2c-2.3,3.2-13.4,3.3-13.6-3.5 c-0.2-6.7-2.9-15.1-3.1-15.6c0.9,1.9,1.3,3.2,1.3,3.2s2.2-7.2,0-11.2c-2.2-4,2-7.4,4.5-5.4c2.5,1.9,2.5,6,3.7,6 c1.2,0,1.2-9.7,3.7-10.2c0,0,6.6,2.7,15.1,0.1C-34-2359.1-35.3-2348.9-36.6-2345.1z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M-63-2348.3C-63-2348.3-63-2348.3-63-2348.3"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-46.1-2252.2c0,0.1,0,0.1,0,0.2c-0.1,1.8-0.2,3.6-0.3,5.3c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.6-0.1,1.2-0.1,1.8 c-0.1,1.2-0.2,2.4-0.4,3.5c-0.1,0.7-0.2,1.4-0.3,2.2c-0.1,0.5-0.1,1-0.2,1.5c-0.1,0.6-0.2,1.1-0.3,1.7c-0.1,0.3-0.1,0.6-0.2,0.9 c-0.1,0.4-0.1,0.8-0.2,1.1c-0.2,0.8-0.3,1.6-0.5,2.4c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.5-0.2,0.9-0.4,1.3c-0.1,0.5-0.2,0.9-0.4,1.3 c-0.1,0.5-0.3,1.1-0.5,1.6c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.3-0.2,0.6-0.3,0.9c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.4-0.3,0.8-0.5,1.2 c0,0,0,0,0,0.1c-0.1,0.4-0.3,0.7-0.5,1.1c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.3-0.3,0.7-0.5,1c-3,6.1-7.3,10.2-13.1,11.2 c-8,1.4-15.7,0.7-21.7-0.9c-7.5-1.9-12.6-5.1-13.2-7.4c-1-4.3,16.8-49.3,18.1-61.6c1.3-12.3-6.8-35.7-5.5-41.7 c1-4.8,5.6-11.1,10.1-13.8c0.8-0.5,1.7-0.9,2.5-1.1h0c0.3-0.1,0.7-0.2,1-0.2c0,0,0.1,0.1,0.3,0.3c0.1,0.1,0.2,0.3,0.4,0.5 c3.9,5.4,24.5,35.3,26.8,61.4c0.2,2.1,0.3,4.2,0.5,6.3C-46.1-2262.6-46-2257.3-46.1-2252.2z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M-70.5-2269.6L-70.5-2269.6c0,0.3-0.1,0.5-0.1,0.5c0,0-0.1,0-0.2,0.1c-1.7,0.4-13.6,1-20.4,0.3 c-2.7-0.3-4.6-0.8-4.8-1.6c-0.5-3,3.8-48.5,8.3-51c0,0,12.3,3.5,14.6,13.3C-71.1-2298.9-70.1-2273.5-70.5-2269.6z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M-5.8-2221.3c-0.5,1.9-2.7,3.8-5.5,5.3c-6.3,3.4-16.1,4.9-18.9,0.7c-0.5-0.8-0.8-3.2-0.8-6.8 c0-1.9,0-4.1,0-6.6v-0.3c0-0.9,0-1.8,0-2.7c0-1.8,0.1-3.7,0.1-5.7c0-0.4,0-0.8,0-1.3c0-0.9,0-1.8,0.1-2.7c0-0.4,0-0.8,0-1.1 c0-0.1,0-0.3,0-0.4c0-0.5,0-1.1,0-1.6c0-0.4,0-0.7,0-1.1c0-1,0-2,0.1-3c0-0.5,0-1,0-1.5c0-0.4,0-0.8,0-1.3 c0.1-2.7,0.1-5.4,0.2-8.2c0-1.1,0-2.2,0-3.3c0-0.9,0-1.8,0-2.7c0.2-28.9-1.5-61.7-12.4-73.5c-0.2-0.2-0.3-0.4-0.5-0.5 c-0.6-0.6-1.3-1.2-1.9-1.7c0.2,0.1,2,0.8,4.6,2c0.6,0.3,1.3,0.6,1.9,1c0,0,0,0,0,0c0.8,0.4,1.6,0.9,2.5,1.4c4.4,2.5,9.3,6,11.4,10 c1.6,2.8,2.7,11.7,3.6,22.5c1.9,20.6,3.5,48.6,7.4,57.3C-7.6-2233.9-4.1-2227.6-5.8-2221.3z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M3.3-2325.3c-1.2,7.5-7.1,23.8-8.7,23.8c-1.2,0-10.9-1.2-15.7-3c-1-10.9-2.1-19.7-3.6-22.5 c-2.6-4.7-9-8.7-13.9-11.3C-38.2-2338.3-21.8-2336.2,3.3-2325.3z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M-38.6-2338.4C-38.6-2338.4-38.6-2338.4-38.6-2338.4"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M-46.4-2246.7c1.2-18.6-33.5-78-34.2-81.4c-0.5-2.3,1.6-5.3,3-7c0.8-0.5,1.7-0.9,2.5-1.1h0l1.3,0.2 c0.1,0.1,0.2,0.3,0.4,0.5c3.9,5.4,24.5,35.3,26.8,61.4C-46-2265-45.8-2255.5-46.4-2246.7z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M-30.5-2251.5c0.7-31.4,0.5-73.9-12.2-87.7c-0.2-0.2-0.3-0.4-0.5-0.5c0.6,0,1.5,0.1,2.6,0.4 c1.3,0.4,2.8,1,4.4,2.3c2.6,2.1,5.2,5.9,6.9,12.5C-25.3-2309-26.2-2259.2-30.5-2251.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: -41.8175,
    y1: -2322.5603,
    x2: -135.8,
    y2: -2145.6523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M-44-2294.9c-0.9,27.8-25.1,67.3-41.5,59c-5.1-2.6-5.7-27-5.8-32.8c6.8,0.7,18.7,0.1,20.4-0.3 c0.1,0,0.2,0,0.2-0.1c0,0,0.1-0.2,0.1-0.5v0c2.5-4.2,14.5-24.7,15.5-26.9c1.2-2.4,0.4-9.9,0.3-12.9c-0.1-3,0.9-13.5,1.9-13.2 c1,0.3,0.7,12.1,1.4,12c0.8-0.2,3.1-14.1,3.8-13.9c0.8,0.2-0.6,15.4-0.4,17C-47.7-2305.9-43.8-2302.4-44-2294.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 5208.3496,
    y1: -2009.5045,
    x2: 5270.1606,
    y2: -2009.5045,
    gradientTransform: "matrix(-1 0 0 1 5130.959 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M-139.2-1990.7h61.5c0,0,0.6-2.2,0.2-4.8c-0.3-2.3-1.3-4.7-4-6.2c-5.8-3-28.1-13.9-32.9-19 c-4.8-5.1-3.8-7.3-6.2-7.5c0,0-13.2-1-14.8,0.9c-1.2,1.5-2.8,22.2-3.4,31.7C-139.1-1992.5-139.2-1990.7-139.2-1990.7z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M-96.1-2010.9c0,0-5.3,5.1-8,5.8c-2.7,0.7-16.2-10.9-17.2-14.2c-1-3.2-2-16.1-2-16.1s8.3,0,11.1,0 c2.8,0,2.5,15.1,2.5,15.1S-94.8-2012.1-96.1-2010.9z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-139.2-1990.7h61.5c0,0,0.6-2.2,0.2-4.8h-61.4C-139.1-1992.5-139.2-1990.7-139.2-1990.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 5085.2173,
    y1: -2009.5045,
    x2: 5147.0283,
    y2: -2009.5045,
    gradientTransform: "matrix(-1 0 0 1 5130.959 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6A5CDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8470DF"
    }
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M-16.1-1990.7h61.5c0,0,0.6-2.2,0.2-4.8c-0.3-2.3-1.3-4.7-4-6.2c-5.8-3-28.1-13.9-32.9-19 c-4.8-5.1-3.8-7.3-6.2-7.5c0,0-13.2-1-14.8,0.9c-1.2,1.5-2.8,22.2-3.4,31.7C-15.9-1992.5-16.1-1990.7-16.1-1990.7z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M27-2010.9c0,0-5.3,5.1-8,5.8c-2.7,0.7-16.2-10.9-17.2-14.2c-1-3.2-2-16.1-2-16.1s8.3,0,11.1,0 c2.8,0,2.5,15.1,2.5,15.1S28.3-2012.1,27-2010.9z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-16.1-1990.7h61.5c0,0,0.6-2.2,0.2-4.8h-61.4C-15.9-1992.5-16.1-1990.7-16.1-1990.7z"
  }))), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M-84.8-2220.7c0,0-0.9,3.9-2.3,10.1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M-67.7-2205.5c0,0-1.2,10.3-12.3,11.6"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M-73.5-2190c0,0-13,64.9-17.7,73.9c-4.8,9-35.7,80.7-35.7,80.7"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M-36.2-2177.9c0,0,29.9,70.4,30.9,81.5c1,11.1,0,61.1,0,61.1"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -452.1,
    y: -2011.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -891.3635 -4002.4336)",
    className: "st44",
    width: 12.9,
    height: 20.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -500.6,
    y: -2012.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -988.1758 -4003.8616)",
    className: "st44",
    width: 12.9,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -270,
    y: -2016.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -527.1348 -4007.9424)",
    className: "st44",
    width: 12.9,
    height: 25.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -318.4,
    y: -2018.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -623.9468 -4009.7568)",
    className: "st44",
    width: 12.9,
    height: 27.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M-443.8-2190c3.3,19.8,10.6,48.6,14.5,63.8c1.6,6.3,2.7,10.2,2.7,10.2l1.2,1.6l28.1,36.7h64.5 c0,0,0.7-21.6,0.6-47c0-2.2,0-4.5,0-6.7c-0.3-33-2.1-69.5-8.6-73c-12-6.5-96.2-10.4-103.4-6.5c-0.2,0.1-0.4,0.3-0.5,0.5 C-446.2-2208.2-445.5-2200.3-443.8-2190z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -349.3,
    y1: -2180.4,
    x2: -354.2,
    y2: -2175.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -354.2,
    y1: -2180.4,
    x2: -349.3,
    y2: -2175.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -369.5,
    y1: -2180.4,
    x2: -374.4,
    y2: -2175.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -374.4,
    y1: -2180.4,
    x2: -369.5,
    y2: -2175.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -389.7,
    y1: -2180.4,
    x2: -394.6,
    y2: -2175.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -394.6,
    y1: -2180.4,
    x2: -389.7,
    y2: -2175.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -409.9,
    y1: -2180.4,
    x2: -414.8,
    y2: -2175.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -414.8,
    y1: -2180.4,
    x2: -409.9,
    y2: -2175.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -348.1,
    y1: -2161,
    x2: -353,
    y2: -2156.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -353,
    y1: -2161,
    x2: -348.1,
    y2: -2156.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -368.3,
    y1: -2161,
    x2: -373.2,
    y2: -2156.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -373.2,
    y1: -2161,
    x2: -368.3,
    y2: -2156.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -388.5,
    y1: -2161,
    x2: -393.4,
    y2: -2156.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -393.4,
    y1: -2161,
    x2: -388.5,
    y2: -2156.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -408.7,
    y1: -2161,
    x2: -413.6,
    y2: -2156.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -413.6,
    y1: -2161,
    x2: -408.7,
    y2: -2156.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -347,
    y1: -2141.6,
    x2: -351.9,
    y2: -2136.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -351.9,
    y1: -2141.6,
    x2: -347,
    y2: -2136.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -367.2,
    y1: -2141.6,
    x2: -372.1,
    y2: -2136.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -372.1,
    y1: -2141.6,
    x2: -367.2,
    y2: -2136.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -387.4,
    y1: -2141.6,
    x2: -392.3,
    y2: -2136.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -392.3,
    y1: -2141.6,
    x2: -387.4,
    y2: -2136.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -407.6,
    y1: -2141.6,
    x2: -412.5,
    y2: -2136.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -412.5,
    y1: -2141.6,
    x2: -407.6,
    y2: -2136.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -345.8,
    y1: -2122.2,
    x2: -350.7,
    y2: -2117.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -350.7,
    y1: -2122.2,
    x2: -345.8,
    y2: -2117.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -370.9,
    y1: -2122.2,
    x2: -366,
    y2: -2117.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -366,
    y1: -2122.2,
    x2: -370.9,
    y2: -2117.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -386.2,
    y1: -2122.2,
    x2: -391.1,
    y2: -2117.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -391.1,
    y1: -2122.2,
    x2: -386.2,
    y2: -2117.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -406.4,
    y1: -2122.2,
    x2: -411.3,
    y2: -2117.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -411.3,
    y1: -2122.2,
    x2: -406.4,
    y2: -2117.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -344.7,
    y1: -2102.8,
    x2: -349.6,
    y2: -2097.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -349.6,
    y1: -2102.8,
    x2: -344.7,
    y2: -2097.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -364.9,
    y1: -2102.8,
    x2: -369.8,
    y2: -2097.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -369.8,
    y1: -2102.8,
    x2: -364.9,
    y2: -2097.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -385.1,
    y1: -2102.8,
    x2: -390,
    y2: -2097.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -390,
    y1: -2102.8,
    x2: -385.1,
    y2: -2097.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -405.2,
    y1: -2102.8,
    x2: -410.2,
    y2: -2097.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: -410.2,
    y1: -2102.8,
    x2: -405.2,
    y2: -2097.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M-478.6-2121.9c5.1-0.9,10.5,0.5,15.3,3c6.5,3.4,11.8,8.7,13.4,12.6c0.4,1,1,2.7,1.6,5.1 c6.1,21.1,21.6,90.9,21.6,90.9s35.9,0,76.2-0.7c51.7-0.9,110.6-3,109.6-7.5c-1.7-7.6-14.2-79.3-35.5-100.5 c-1.3-1.3-2.6-2.4-3.9-3.2c-19.9-13-44.5-10.5-51.9-9.3c0,2.3,0,4.5,0,6.7c26.2,2.8,32.9,33.8,34.6,52.5c0.7,7.5,0.5,13,0.5,14 c0,0.1,0,0.2,0,0.2h-86.6c0,0-1.9-8.8-5.2-19.6c-4.1-13.6-10.3-30.2-17.7-36.5c-6.6-5.6-13.7-9.3-20.7-11.4 c-0.7-0.2-1.3-0.4-2-0.6c-13-3.5-25.8-2.2-35.9,0.1C-470.6-2124.8-475.1-2123.2-478.6-2121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-506.4-2012.5l79.8,2.3c0,0-19.2-86.5-23.3-96c-2.8-6.7-16.8-17.8-28.7-15.6c-2.4,0.4-4.6,1.4-6.7,3 c0,0,0,0,0,0c-2.5,2-4.8,4.9-6.6,9C-502.9-2085-506.4-2012.5-506.4-2012.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-465.2-2126.1c10.1-2.4,22.9-3.6,35.9-0.1c-6-23-19.6-77.6-15.5-84.2c-7.8,1.6-28.9,7.3-31.5,21.6 C-478.2-2178.3-471.2-2148.6-465.2-2126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M-388.9-2077.8c3.3,10.8,5.2,19.6,5.2,19.6h86.6c0,0,0-0.1,0-0.2c-10.3-8.9-35.7-19.5-35.7-19.5H-388.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M-332.8-2077.8c0,0,25.4,10.6,35.7,19.5c0.1-3.4,1.6-62.6-35-66.5c0-2.2,0-4.5,0-6.7L-332.8-2077.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-443.8-2190c3.3,19.8,10.6,48.6,14.5,63.8c0.7,0.2,1.3,0.4,2,0.6c7,2.2,14.1,5.8,20.7,11.4 c7.4,6.2,13.6,22.9,17.7,36.5h51.9L-443.8-2190z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M93.9-2065.1c0,0-2.9-22.7-14.6-32.2c-11.8-9.4-12.5-24.1-12.5-24.1s-15.9,55.4,4.4,65.6 C91.6-2045.5,93.9-2065.1,93.9-2065.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M66.8-2121.3c-0.6,6.6-0.4,13.2,0.2,19.8c0.6,6.6,1.8,13.1,3.6,19.4c1.9,6.3,4.4,12.5,7.9,18 c1.7,2.8,3.7,5.4,5.9,7.9c2.2,2.5,4.6,4.7,7.2,6.7l0,0c0.1,0.1,0.1,0.2,0,0.3c-0.1,0.1-0.2,0.1-0.3,0l0,0 c-2.6-2.1-5.1-4.3-7.2-6.8c-2.2-2.5-4.2-5.1-5.9-8c-3.5-5.6-6-11.8-7.9-18.2c-1.8-6.4-3-12.9-3.5-19.5 C66.2-2108.1,66.1-2114.8,66.8-2121.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M99.2-2325.1c0,0,29.5,96,7.1,178.8c-22.3,82.8,8.4,113.2,8.4,113.2l-23.2-23.3c0,0-9.9-73.3-7.5-110.6 l7.5-3.8l-7.8-6.7C83.6-2177.4,104.2-2263,99.2-2325.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M99.2-2325.1c2.3,11,4.1,22,5.7,33.1c1.5,11.1,2.8,22.3,3.6,33.4c0.2,2.8,0.4,5.6,0.5,8.4 c0.1,2.8,0.3,5.6,0.4,8.4c0.1,5.6,0.3,11.2,0.2,16.8l0,4.2l0,2.1l-0.1,2.1l-0.4,8.4c0,0.7-0.1,1.4-0.1,2.1l-0.2,2.1l-0.4,4.2 c-0.3,2.8-0.4,5.6-0.9,8.4l-1.2,8.3c-0.4,2.8-0.9,5.5-1.4,8.3c-1,5.5-1.8,11.1-2.7,16.6c-1.7,11.1-3.2,22.2-4.4,33.3 c-1.1,11.1-1.8,22.4-1.7,33.6c0,5.6,0.4,11.2,0.9,16.8c0.5,5.6,1.4,11.1,2.3,16.6c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2-0.1-0.3-0.2 l0,0c-1-5.5-1.8-11.1-2.3-16.7c-0.5-5.6-0.9-11.2-0.9-16.8c-0.2-11.2,0.6-22.4,1.7-33.6c1.2-11.2,2.7-22.3,4.4-33.4 c0.9-5.5,1.8-11.1,2.7-16.6c0.5-2.8,1-5.5,1.4-8.3l1.2-8.3c0.5-2.8,0.6-5.6,0.9-8.4l0.4-4.2l0.2-2.1c0.1-0.7,0.1-1.4,0.1-2.1 l0.4-8.4l0.1-2.1l0-2.1l0-4.2c0.1-5.6-0.1-11.2-0.2-16.8c-0.1-2.8-0.3-5.6-0.4-8.4c-0.1-2.8-0.3-5.6-0.5-8.4 c-0.7-11.2-2-22.3-3.5-33.4C103.3-2303.1,101.5-2314.2,99.2-2325.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M97.6-2056.4c0,0-6.3-58.9,5.6-81.9h7.7l-4.5-8c0,0,24.8-54.2,94.1-75.4c0,0-43.8,28.9-61.6,82.7 c-8.4-2.1-14.4-1.7-14.4-1.7l6.3,8.3c0,0-25.8,41.9-22.3,80.9C111.9-2012.5,97.6-2056.4,97.6-2056.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M200.4-2221.7c-3.9,1.7-7.7,3.6-11.4,5.7c-3.7,2.1-7.4,4.3-10.9,6.6c-7.1,4.7-13.9,9.8-20.3,15.4 c-12.8,11.2-24,24.2-33,38.6c-4.5,7.2-8.3,14.9-11.5,22.7l-2.3,5.9c-0.7,2-1.3,4-2,6l-1,3c-0.3,1-0.5,2.1-0.8,3.1l-1.6,6.2 c-3.6,16.6-4.7,33.7-3.6,50.6c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2v0c-1.1-17,0-34.1,3.7-50.8l1.6-6.2 c0.3-1,0.5-2.1,0.8-3.1l1-3c0.7-2,1.3-4.1,2-6.1l2.3-5.9c3.3-7.8,7.1-15.5,11.6-22.7c9-14.4,20.3-27.4,33.1-38.6 c6.4-5.6,13.2-10.7,20.4-15.3c3.6-2.3,7.2-4.5,10.9-6.6C192.8-2218.1,196.5-2220.1,200.4-2221.7z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "55.8,-2047.9 56.1,-2038.2 64.5,-1990.7 117.7,-1990.7 126.2,-2038.2 127.1,-2043.7 86.8,-2046.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M45.7-2057.6v16.5c0,1.6,1.3,2.9,2.9,2.9H136c1.9,0,3.2-1.8,2.8-3.6l-4.5-16.5c-0.3-1.2-1.5-2.1-2.8-2.1 H48.6C47-2060.4,45.7-2059.1,45.7-2057.6z"
  }))), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M149.6-1980.8h-668.2c-2.7,0-4.9-2.2-4.9-4.9l0,0c0-2.7,2.2-4.9,4.9-4.9h668.2c2.7,0,4.9,2.2,4.9,4.9l0,0 C154.6-1983,152.4-1980.8,149.6-1980.8z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -496.5,
    y: -2274.3,
    className: "st44",
    width: 46.5,
    height: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: -478.6,
    y: -2255.8,
    className: "st45",
    width: 46.5,
    height: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: -2265,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 88.9376 -4517.4736)",
    className: "st44",
    width: 46.5,
    height: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.3,
    y: -2246.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 53.0527 -4480.6182)",
    className: "st45",
    width: 46.5,
    height: 12.6
  }))), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-381-1994.8"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-434.6-1994.8"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3993.4-2182.6c0.2-0.1,1.2,1.2,2.6,3.8c1.5,2.6,3.3,6.5,5,11.5c3.5,10.1,5.7,24.9,4.4,41.1 c-1.3,16.2-5,30.4-7.9,40.6c-3,10.1-5.1,16.3-5.5,16.2c-0.4-0.1,1.1-6.5,3.5-16.7c2.4-10.2,5.7-24.4,7-40.2 c1.3-15.9-0.5-30.3-3.4-40.3C3996.2-2176.6,3992.9-2182.3,3993.4-2182.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4003.4-2263.7c0.2-0.1,1.4,2.1,3.4,6.2c2,4.1,4.8,10,8.2,17.4c6.6,14.8,15.5,35.4,22,59.4 c3.2,12,5.3,23.7,6.4,34.4c1.1,10.7,1.2,20.5,0.7,28.6c-0.5,8.1-1.6,14.7-2.6,19.1c-1,4.4-1.8,6.8-1.9,6.8 c-0.5-0.1,1.9-9.9,2.4-26c0.6-16.1-1.5-38.4-7.9-62.1c-6.4-23.7-14.9-44.4-21-59.4c-3.1-7.5-5.6-13.5-7.3-17.7 C4004-2261.2,4003.2-2263.6,4003.4-2263.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3633.8-2168.5c0.3,0.4-3,3.6-7.4,9.5c-1.1,1.5-2.3,3.1-3.4,5c-1.2,1.8-2.2,3.9-3.4,6 c-2.2,4.3-4.2,9.3-5.8,14.7c-1.5,5.4-2.4,10.7-2.9,15.5c-0.1,2.4-0.4,4.7-0.3,6.9c-0.1,2.2,0.1,4.2,0.2,6 c0.5,7.4,1.7,11.9,1.2,12c-0.3,0.1-2.2-4.2-3.3-11.8c-0.3-1.9-0.5-3.9-0.6-6.2c-0.2-2.2,0-4.6,0-7.1c0.3-5,1.2-10.5,2.8-16.1 c1.6-5.6,3.9-10.7,6.2-15.1c1.3-2.2,2.4-4.3,3.8-6.1c1.2-1.9,2.5-3.5,3.8-4.9C3629.7-2166,3633.6-2168.7,3633.8-2168.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3641.7-2142.5c0.2,0.4-1.6,1.8-4.1,4.6c-1.2,1.4-2.5,3.1-3.8,5.1c-1.2,2.1-2.4,4.4-3.3,7 c-0.9,2.6-1.4,5.2-1.7,7.6c-0.2,2.4-0.3,4.6-0.2,6.4c0.2,3.7,0.8,5.9,0.4,6.1c-0.3,0.1-1.7-2-2.5-5.8c-0.4-1.9-0.6-4.3-0.5-6.9 c0.2-2.6,0.7-5.5,1.6-8.3c1-2.9,2.4-5.4,3.9-7.6c1.5-2.1,3.1-3.9,4.6-5.1C3639.2-2142,3641.6-2142.8,3641.7-2142.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3532.3-2384.5c0.2-0.1,1.5,1.2,3.8,3.7c1.2,1.2,2.5,2.8,4,4.7c1.5,1.9,3.2,4,4.9,6.5 c0.9,1.2,1.7,2.6,2.7,3.9c0.9,1.4,1.8,2.9,2.7,4.4c1.9,3,3.6,6.4,5.5,10c3.5,7.2,6.8,15.4,9.5,24.2c2.6,8.9,4.2,17.5,5.2,25.5 c0.4,4,0.8,7.8,0.8,11.3c0,1.8,0.2,3.5,0.1,5.1c0,1.6-0.1,3.2-0.1,4.7c0,3-0.3,5.7-0.5,8.1c-0.2,2.4-0.5,4.4-0.8,6.1 c-0.6,3.3-1,5.1-1.2,5.1c-0.5-0.1,0.5-7.4,0.4-19.4c0-1.5-0.1-3-0.1-4.7c0-1.6-0.2-3.3-0.3-5.1c-0.1-3.5-0.7-7.2-1.1-11.1 c-1.1-7.8-2.8-16.3-5.3-25c-2.6-8.7-5.8-16.7-9.1-23.9c-1.8-3.5-3.3-6.9-5.1-9.9c-0.9-1.5-1.6-3-2.5-4.4c-0.9-1.4-1.7-2.7-2.5-4 C3536.7-2378.5,3531.9-2384.1,3532.3-2384.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3565.8-2370.6c0.3-0.2,3.7,3,8,9.1c2.2,3.1,4.5,6.9,6.7,11.3c2.2,4.5,4.2,9.5,5.9,15 c1.6,5.5,2.6,10.9,3.2,15.8c0.5,4.9,0.7,9.4,0.5,13.2c-0.3,7.5-1.4,12-1.8,12c-0.5-0.1-0.1-4.6-0.3-12c-0.1-3.7-0.5-8-1.1-12.8 c-0.7-4.8-1.8-10-3.4-15.3c-1.6-5.3-3.5-10.3-5.5-14.7c-2-4.4-4.1-8.2-6-11.4C3568.2-2366.7,3565.4-2370.3,3565.8-2370.6z"
  }))))), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M3299.4-2626.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H3299.4z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3615.4-2626.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H3615.4z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M673.3-948.3c18.6-4.1,70.7-15.5,124,7.4c24.4,10.5,26.9,17.8,43.8,26.7c49.2,25.8,99.4-12.8,196.2-51.3 c92.9-36.9,189.3-73.8,263.1-34.6c15.6,8.3,36.7,16.1,42.9,35.2c9.6,29.6-23.1,58.3-20.8,123.3c0.1,2,0.1,1.8,0.1,3.3 c1.1,41-23.1,55.7-25.1,85.2c-0.5,8,1.4,4.6,10.7,39.6c7.7,29.2,15.2,57.4,16.3,89.3c0,0,1,28.4-5.7,62 c-17,84.5-115.4,263.2-220.8,256.1c-29.8-2-32.9-17-97.5-31.7c-45.9-10.4-80-10.9-102.6-11.8c-109.4-4.3-236.6-9.4-323.9-82.8 c-33.7-28.3-51.5-58.4-60.2-73.4c-59.3-102.3-64.4-254.2,18.4-354.4C545.9-876.9,594.2-931,673.3-948.3z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1192.4-500.6c0.2-0.1,1.2,1.2,2.6,3.8c1.5,2.6,3.3,6.5,5,11.5c3.5,10.1,5.7,24.9,4.4,41.1 c-1.3,16.2-5,30.4-7.9,40.6c-3,10.1-5.1,16.3-5.5,16.2c-0.4-0.1,1.1-6.5,3.5-16.7c2.4-10.2,5.7-24.4,7-40.2 c1.3-15.9-0.5-30.3-3.4-40.3C1195.2-494.6,1191.9-500.3,1192.4-500.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1202.4-581.7c0.2-0.1,1.4,2.1,3.4,6.2c2,4.1,4.8,10,8.2,17.4c6.6,14.8,15.5,35.4,22,59.4 c3.2,12,5.3,23.7,6.4,34.4c1.1,10.7,1.2,20.5,0.7,28.6c-0.5,8.1-1.6,14.7-2.6,19.1c-1,4.4-1.8,6.8-1.9,6.8 c-0.5-0.1,1.9-9.9,2.4-26c0.6-16.1-1.5-38.4-7.9-62.1c-6.4-23.7-14.9-44.4-21-59.4c-3.1-7.5-5.6-13.5-7.3-17.7 C1203-579.2,1202.2-581.6,1202.4-581.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M832.8-486.5c0.3,0.4-3,3.6-7.4,9.5c-1.1,1.5-2.3,3.1-3.4,5c-1.2,1.8-2.2,3.9-3.4,6 c-2.2,4.3-4.2,9.3-5.8,14.7c-1.5,5.4-2.4,10.7-2.9,15.5c-0.1,2.4-0.4,4.7-0.3,6.9c-0.1,2.2,0.1,4.2,0.2,6 c0.5,7.4,1.7,11.9,1.2,12c-0.3,0.1-2.2-4.2-3.3-11.8c-0.3-1.9-0.5-3.9-0.6-6.2c-0.2-2.2,0-4.6,0-7.1c0.3-5,1.2-10.5,2.8-16.1 c1.6-5.6,3.9-10.7,6.2-15.1c1.3-2.2,2.4-4.3,3.8-6.1c1.2-1.9,2.5-3.5,3.8-4.9C828.7-484,832.6-486.7,832.8-486.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M840.7-460.5c0.2,0.4-1.6,1.8-4.1,4.6c-1.2,1.4-2.5,3.1-3.8,5.1c-1.2,2.1-2.4,4.4-3.3,7 c-0.9,2.6-1.4,5.2-1.7,7.6c-0.2,2.4-0.3,4.6-0.2,6.4c0.2,3.7,0.8,5.9,0.4,6.1c-0.3,0.1-1.7-2-2.5-5.8c-0.4-1.9-0.6-4.3-0.5-6.9 c0.2-2.6,0.7-5.5,1.6-8.3c1-2.9,2.4-5.4,3.9-7.6c1.5-2.1,3.1-3.9,4.6-5.1C838.2-460,840.6-460.8,840.7-460.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M731.3-702.5c0.2-0.1,1.5,1.2,3.8,3.7c1.2,1.2,2.5,2.8,4,4.7c1.5,1.9,3.2,4,4.9,6.5 c0.9,1.2,1.7,2.6,2.7,3.9c0.9,1.4,1.8,2.9,2.7,4.4c1.9,3,3.6,6.4,5.5,10c3.5,7.2,6.8,15.4,9.5,24.2c2.6,8.9,4.2,17.5,5.2,25.5 c0.4,4,0.8,7.8,0.8,11.3c0,1.8,0.2,3.5,0.1,5.1c0,1.6-0.1,3.2-0.1,4.7c0,3-0.3,5.7-0.5,8.1c-0.2,2.4-0.5,4.4-0.8,6.1 c-0.6,3.3-1,5.1-1.2,5.1c-0.5-0.1,0.5-7.4,0.4-19.4c0-1.5-0.1-3-0.1-4.7c0-1.6-0.2-3.3-0.3-5.1c-0.1-3.5-0.7-7.2-1.1-11.1 c-1.1-7.8-2.8-16.3-5.3-25c-2.6-8.7-5.8-16.7-9.1-23.9c-1.8-3.5-3.3-6.9-5.1-9.9c-0.9-1.5-1.6-3-2.5-4.4c-0.9-1.4-1.7-2.7-2.5-4 C735.7-696.5,730.9-702.1,731.3-702.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M764.8-688.6c0.3-0.2,3.7,3,8,9.1c2.2,3.1,4.5,6.9,6.7,11.3c2.2,4.5,4.2,9.5,5.9,15 c1.6,5.5,2.6,10.9,3.2,15.8c0.5,4.9,0.7,9.4,0.5,13.2c-0.3,7.5-1.4,12-1.8,12c-0.5-0.1-0.1-4.6-0.3-12c-0.1-3.7-0.5-8-1.1-12.8 c-0.7-4.8-1.8-10-3.4-15.3c-1.6-5.3-3.5-10.3-5.5-14.7c-2-4.4-4.1-8.2-6-11.4C767.2-684.7,764.4-688.3,764.8-688.6z"
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_24_",
    className: "st138",
    points: "649.6,-475.2 647,-480.5 575.2,-425.6 606.5,-374.9 678,-435.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_23_",
    className: "st139",
    points: "578.2,-424.4 605.7,-376.8 607.5,-377.6 583,-422.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st140",
    d: "M648.1-476.2l-70,51.8c0,0,0.3,1.1,2,1.8c1.7,0.7,2.7,0.5,2.7,0.5l73.5-50.3 c0,0-4.2-1-5.8-2.1C649.2-475.7,648.1-476.2,648.1-476.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st138",
    d: "M658.3-474.5l-76.7,51.2l24.9,47.2l4,6.5l76.7-56.7c0,0-8.1-12.1-12.9-19.3 c-4.8-7.3-14.4-24.4-14.9-25.5C658.9-472.3,658.3-474.5,658.3-474.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_20_",
    className: "st141",
    points: "1290.5,-828 1292.7,-832.4 1353,-786.3 1326.6,-743.7 1266.6,-794.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_19_",
    className: "st139",
    points: "1350.4,-785.4 1327.3,-745.4 1325.8,-746 1346.4,-783.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st140",
    d: "M1291.7-828.9l58.7,43.5c0,0-0.2,0.9-1.7,1.5c-1.5,0.6-2.3,0.4-2.3,0.4l-61.8-42.3 c0,0,3.6-0.8,4.9-1.8S1291.7-828.9,1291.7-828.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st141",
    d: "M1283.2-827.4l64.4,43l-20.9,39.6l-3.4,5.5l-64.4-47.6c0,0,6.8-10.1,10.9-16.2 c4.1-6.1,12.1-20.5,12.5-21.4C1282.7-825.5,1283.2-827.4,1283.2-827.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M563.8-910.9c0,0-4.6,3.2-2.3,8.4c2.3,5.3,12.3,20.8,25.7,20.3c0.6,0-17-28.7-17-28.7H563.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M543.2-623.6c0,0-16.9-15.1-22.3-12.4c-6.6,3.3-44.3,40.3-42.9,57.7c0.6,7.1,8.9,1,23.7-14.3 c14.8-15.4,33.4-8.8,33.4-8.8L543.2-623.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M584.2-598.2l-20.4-12.2c0,0-52.8,49.5-44.5,56.1c6.3,5,9.9,0.5,24.7-14.8c14.8-15.4,33.6-6.5,33.6-6.5 L584.2-598.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "708.5,-760.9 712.3,-706.7 627.6,-728.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M627.6-727c0,0,74.1,4.7,84,1.4c0,0,14.5,142.3-11.3,157.6c-25.8,15.4-83.6-7.1-83.6-7.1l15.6-30.7 L666-608v-54.8l-2.4,0.5L627.6-727z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M534.7-629.9c0,0-18.6,7.7-12.6,26.3c0,0,63.6,49.9,94.6,38.4c17.3-6.5,36-55.7,49-97.7l45.9-62.7 c0,0-21.6,1.1-28.9,1.1c-13.8-0.1-55.1-2.4-55.1-2.4S606-614,598.3-611.3C590.6-608.5,534.7-629.9,534.7-629.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M644.9-868.6c0,0,44.4-41.7,52.1-52.6c7.7-11,24.1-47.7,44.4-63.1l-9.9-20.8c0,0,6-3.3,9.9,5.5 c0,0,14.3-28.5,17.5-28c3.3,0.5-6.6,21.9-6.6,21.9s13.7-19.7,17.5-19.2c3.8,0.5-9.9,22.2-9.9,22.2s15.4-17.8,17.5-15.6 c2.2,2.2-12.1,15.6-12.1,15.6s15.4-8.8,17-5.9c1.6,2.9-15.4,10.6-15.4,10.6s-1.6,12.6-12.1,18.1c0,0-20.6,55.7-39.3,73.8 l-59.9,62.2L644.9-868.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M591.9-847c0,0-42.1,44-53.1,51.6c-11,7.6-47.9,23.7-63.5,43.8l-20.7-10.1c0,0-3.3,6,5.4,9.9 c0,0-28.6,14-28.1,17.3c0.5,3.3,22-6.4,22-6.4s-19.9,13.5-19.4,17.4c0.5,3.8,22.3-9.7,22.3-9.7s-17.9,15.2-15.8,17.4 c2.2,2.2,15.7-11.9,15.7-11.9s-9,15.3-6.1,16.9c2.9,1.7,10.7-15.3,10.7-15.3s12.6-1.5,18.2-11.9c0,0,52.8-21,71.1-39.5 l65.7-46.5L591.9-847z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M607.6-864.6l-21.3,20.8l5.4,23.5c0,0,21,50.3,24.1,62.6c4.9,19.1-3,48.2-3,48.2s35.6-3,67.9-4 c32.3-1.1,42.9-11.5,42.9-11.5s-28-93.4-47.4-119.5c-19.4-26.1-26.4-34.3-26.4-34.3l-28.5,6.2L607.6-864.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M670.1-847.6l22.2-14.2c0,0,3.4-15.2-23.4-33.1l-31.4,19.7L670.1-847.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M590.8-845.4c-12.2,1.7-34.4,32.5-36.9,32.5c0,0,15.6,25.5,28,26.3C582-786.6,636.5-851.8,590.8-845.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M633.7-865.4c0,0-17.7-13.2-17.1-18.5c0.2-1.3,2.6-3.5,3.2-5.4c3.4-10.3-13.1-36.8-23.2-42.4 c-8-4.4-4.5-4.8-21.3,5.2c-16.8,10-7.2,27.3,0.3,36.2c7.1,8.4,15.2,12.1,22.5,12.7l10.4,23.1L633.7-865.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M601.9-847.1c-3.3-8.2,3-18.5,14.1-23.1c11.2-4.6,22.9-1.6,26.3,6.6c3.3,8.2-7.9,20.5-14.1,23.1 C621.8-837.9,605.2-838.9,601.9-847.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M575.7-890.2c0,0-5.7-0.3-6.4,3.5c-0.6,3.8,10.5,3.8,14.6,1L575.7-890.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M578.5-886.7c-1.1-6.9-8.4-12-8.1-18.8c3.5,0,5.8-4.3,4.2-8.1c-0.6-1.5-1.7-2.7-2.4-4.2 c-0.7-1.4-0.9-3.3,0.2-4.2c0.5-0.4,1.2-0.5,1.8-0.5c5.2-0.5,14.2,1,19-0.8c4.6-1.7,9.5-5,9-10.6c-0.4-4.9-4.7-8.8-8.7-11.8 c-2.3-1.7-8.8-6.2-11.2-5.8c-3.7,0.6-4.6,5.6-4.9,9.8c-2.6-2.5-6.5-2.1-8.7-0.1c-2.3,2-3.3,5.2-4.3,8.3c-1,3.1-2,6.3-4.3,8.4 c-2.1,1.9-5.4,3.4-5,6.7c0.5,3.9,5.6,5.3,8,8.6c-0.6-0.8-1.1,4.4-0.7,5.3c1,2.7,3.5,4.4,5.3,6.5 C571.5-893.6,573.4-889.3,578.5-886.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M610.6-902.5l-13.1,6.8C597.5-895.8,613.2-884.4,610.6-902.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M592.6-899.9c0.7,1.4-0.3,3.3-2.4,4.4c-2,1.1-4.2,0.8-4.9-0.5c-0.7-1.4,0.3-3.3,2.4-4.4 C589.7-901.4,591.9-901.2,592.6-899.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M611.7-912.9c0.7,1.4-0.3,3.3-2.4,4.4c-2,1.1-4.2,0.8-4.9-0.5c-0.7-1.4,0.3-3.3,2.4-4.4 C608.7-914.5,610.9-914.2,611.7-912.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M601.4-903c-0.1-0.1,0.2-0.4,0.7-0.8c0.5-0.4,1.5-0.9,2.2-1.6c0.7-0.7,0.9-2.2-0.1-2.5 c-1.1-0.4-2.3,0.9-3.8,2.1c-0.4,0.3-0.7,0.6-1,0.9c-0.3,0.3-1,0.7-1.7,0.6c-1.3-0.2-1.9-1.1-2.4-1.7c-1-1.3-1.7-2.7-2-3.9 c-0.7-2.4-0.4-4-0.2-4c0.2,0,0.3,1.5,1.2,3.6c0.4,1.1,1.1,2.3,2.1,3.4c0.5,0.6,1.1,1.1,1.5,1.1c0.2,0,0.3-0.1,0.7-0.3 c0.3-0.3,0.7-0.6,1-0.9c0.7-0.6,1.3-1.2,2.2-1.7c0.8-0.5,1.9-0.9,3-0.5c1.1,0.3,1.7,1.6,1.5,2.4c-0.1,0.9-0.6,1.6-1.1,2.1 c-1.1,0.9-2,1.1-2.6,1.4C601.8-903.1,601.5-902.9,601.4-903z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M598.2-877.6c0,0,8.3,0,12.9-2.7c0,0-3.8,4.7-11.5,5.9L598.2-877.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M601.8-914.9c-0.1,0.4-1.2,0.5-2.5,1.1c-1.2,0.5-2.1,1.3-2.5,1c-0.4-0.2,0.2-1.7,1.9-2.4 C600.4-915.9,601.9-915.3,601.8-914.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M585.5-904.2c-0.3-0.2,0.2-1.6,1.4-2.9c1.2-1.4,2.8-1.8,2.9-1.4c0.2,0.4-0.8,1.2-1.8,2.4 C586.9-904.9,585.8-904,585.5-904.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M579.2-906.3c-0.7-0.5-1.2-2.6,1.4-5.5c2.6-3,5.5-2.4,5.9-1.6c0.4,0.8-0.6,1.9-2.9,4.5 C581.2-906.3,579.9-905.7,579.2-906.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M592.9-917.7c-0.4-0.7,0-2.7,3.4-4.1c3.4-1.5,5.7,0.1,5.6,1c0,0.8-1.3,1.4-4.3,2.7 C594.6-916.8,593.3-916.9,592.9-917.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M1309.5-897.4c0.2,0.2-3.4,4.3-10.9,8.7c-7.4,4.4-19.1,8.8-32.5,8.9c-13.4,0.1-25.2-4.1-32.6-8.4 c-7.6-4.3-11.3-8.3-11-8.6c0.3-0.4,4.4,3,12,6.7c7.5,3.7,18.8,7.4,31.6,7.3c12.8-0.1,24.1-4,31.5-7.8 C1305.1-894.4,1309.2-897.8,1309.5-897.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M1227.6-903.6c-0.2,0.5-4.2-1.2-11-2.7c-3.4-0.8-7.4-1.4-12-2c-4.6-0.5-9.6-0.9-14.9-1.3 c-5.3-0.4-10.4-0.8-15.1-1.4c-4.6-0.6-8.8-1.3-12.2-2.3c-6.9-1.8-10.8-3.9-10.6-4.2c0.2-0.5,4.3,0.9,11.1,2.2 c3.4,0.6,7.5,1.1,12.1,1.6c4.6,0.4,9.6,0.8,15,1.1c5.3,0.4,10.4,0.9,15.1,1.5c4.6,0.7,8.8,1.6,12.2,2.7 C1224-906.2,1227.8-903.9,1227.6-903.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M1146.4-991.2c12.8-2.7,26.1-0.4,39,1.8c12.9,2.2,26.3,4.1,38.9,0.6c22.8-6.3,40.1-29.3,63.7-29.1 c9.7,0.1,18.9,4.2,28.4,6.4c11.8,2.7,24,2.4,35.9,4.4c11.9,1.9,24.2,6.7,31,16.8c8,11.9,5.8,28.7-2.6,40.3 c-8.4,11.6-21.8,18.7-35.6,22.7c-9.6,2.8-19.8,4.4-28.1,10c-8.4,5.6-13.9,14.7-21.7,21.1c-19.6,16.1-50.2,11.5-70.5-3.8 c-5.1-3.8-9.8-8.3-15.6-11.1c-23.3-11.4-56.8,3.7-76.9-17.1C1112-949.1,1114.9-984.5,1146.4-991.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M1140-583.1c0,0,21.3,45.8,23.8,37.3c2.5-8.5,1.7-28.8,0.3-31.7c-1.3-2.9-10.1-15.7-10.1-15.7 L1140-583.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1294.4-953c2,2.5,0.7-0.2,2.9,3.5c9.3-0.3,15.5-8.2,15.5-8.2s14.8,0.4,14.6-2.2 c-0.2-2.6-14.1-1.7-14.1-1.7s14.8-4.6,14-7c-0.8-2.3-17.9,5.1-17.9,5.1s17.2-10.7,14.7-12.4c-2.5-1.7-19.1,7.6-19.1,7.6 s14.4-11.8,12.2-13.4c-2.2-1.5-22.1,13.9-22.1,13.9c0.3-7.6-5.1-7.3-5.1-7.3l0.2,18.5C1290.1-956.6,1293.5-954.2,1294.4-953z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1075.7-1036.7c-3.2,0.6-0.7-0.5-4.8,0.7c-6.7-6.4-5.8-16.5-5.8-16.5s-11.3-9.5-9.4-11.4 c1.9-1.9,11.7,8.2,11.7,8.2s-8-13.3-5.8-14.5c2.1-1.2,10,15.7,10,15.7s-5.8-19.4-2.7-19c3,0.4,9.2,18.4,9.2,18.4 s-2.9-18.4-0.3-18.1c2.6,0.3,7.3,25.1,7.3,25.1c4.8-5.9,8.7-2.1,8.7-2.1l-12.2,13.4C1081.5-1036.9,1077.2-1037,1075.7-1036.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1152.3-959.5c-4.1-0.7-14,5.9-18.9,16.6c-2.8,6-4.7,12.1-1.5,21.8c1.5,4.6,4.6,5.2,5.3,7.2 c0.9,2.6-2,10.8-2,10.8s11.7,4.7,11.7,4.7c0.8-5.6,1.6-11.3,7.3-13.7c2.1-0.9,4.4-1.5,6.5-2.7c5.5-3.1,8.4-10,10.6-15.6 C1172.9-934.6,1162.5-957.8,1152.3-959.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M1138.4-800.6l-19.5-7.8c0,0-57.9,107.4-57.7,137.2c0.2,29.8,79.6,89.5,79.6,89.5l13.4-11.6 c0,0-24.5-42.7-37.6-57.8C1103.5-666.1,1138.4-800.6,1138.4-800.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1235.3-678.2c0,0,43-20.4,34.4-22.2c-8.6-1.8-28.9,0.7-31.6,2.2c-2.8,1.6-14.9,11.3-14.9,11.3 L1235.3-678.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1157.6-801.5l-29.6,10.8c0,0-29.6,130.3-18.3,150.7c11.3,20.5,43.1,6.9,88.3-17.8 c37.9-20.7,37.9-20.7,37.9-20.7l-12.6-8.4c0,0-44.1,8.6-56.5,17.3c0,0,6.5-18.3,15.1-44.1 C1190.4-739.6,1196.4-766,1157.6-801.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1121.1-890.3c0-8.7,2.8-14.9,11.4-14.9c8.7,0,20.6,3,20.6,11.7c0,8.7-6.8,22.7-15.5,22.7 C1129.1-870.8,1121.1-881.6,1121.1-890.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1128-906.4c0,0-26.9-29.1-32.3-57.7c-5.4-28.5-14.5-74.8-14.5-74.8l-10.2,2.9c0,0-4.8,63.3,0,73 c4.8,9.7,28.5,74.2,35.7,91.2L1128-906.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1156.9-883.7c0,0,2.1-9.1,36.1-21.4c34-12.3,98.3-52.2,98.3-52.2l6.4,7.3c0,0-34.9,40.3-55.2,47.4 c-20.3,7.1-63.4,34.9-67.9,37.2C1167.9-862.1,1168-857.8,1156.9-883.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1128-906.4c0,0-27.3,8.9-27.3,50.5c0,0,0,57,6.5,67.4c0,0,10.5,2.7,23.5,0c13.7-2.8,27-12.9,27-12.9 l21.5-64.6l-2.6-30.3l-29.3-5.6c0,0,8.4,39.2-22,22.4c-5.9-3.3,8.7-25.5,8.7-25.5L1128-906.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1104.8-872.6l-13.5-28.1c0,0,1.9-17,26.7-23.1c0,0,2.5,8.6,5.2,11.9c2.7,3.3,10.7,6.8,10.7,6.8 L1104.8-872.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1155.8-861.3l42.9-8.8c0,0,7.5-15.4-10.2-33.8c0,0-33.4,2-37.8,2.4c-4.3,0.4-1.3,3.6-1.3,3.6 L1155.8-861.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1107-802.5c0,0-40.5,74.9-47.2,88.3c0,0,119.6,54.9,168.1-11.2c0,0-27.6-58.4-70.3-80.7l0,0l-18.4-5.5 l-31.5,8.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M1169.7-931.1c0,0,4.6-4.6,7.5-1.4c2.8,3.2-10.3,7.8-10.3,7.8L1169.7-931.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M1254.1-994c0,0.2-1.7,0.9-5.1,1.7c-3.4,0.8-8.4,1.6-14.7,1.7c-6.3,0.1-13.7-0.4-21.8-1.5 c-8.1-1.1-17-2.7-26.3-3.7c-9.3-1-18.2-1.2-26.2,0.1c-7.9,1.3-14.8,3.9-20,6.9c-5.2,3.1-8.9,6.4-11.1,9 c-2.3,2.6-3.3,4.2-3.5,4.1c-0.1-0.1,0.6-1.9,2.6-4.8c2-2.9,5.6-6.7,10.9-10.1c5.3-3.4,12.4-6.3,20.7-7.8 c8.2-1.5,17.5-1.4,26.9-0.4c9.5,1,18.3,2.7,26.4,3.9c8.1,1.2,15.3,2,21.5,2.1C1246.6-992.4,1254-994.6,1254.1-994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M1146.2-933.7c0,0.2-1.3,0.3-3.3-0.4c-0.5-0.2-1.1-0.4-1.6-0.9c-0.3-0.2-0.5-0.6-0.7-1 c-0.2-0.6-0.2-1.2,0-1.7c0.1-0.1,0.1-0.3,0.2-0.3l0.4,0c0.3,0,0.5,0,0.8,0.1c0.5,0.1,0.7,0.1,1.1,0.1c0.7,0,1.3-0.1,2-0.2 c2.8-0.6,4.7-2.6,5.5-4.3c0.9-1.7,1-3,1.2-2.9c0.2,0,0.5,1.3-0.2,3.4c-0.4,1-1,2.1-2.1,3.1c-1,1-2.5,1.8-4.1,2.2 c-0.8,0.2-1.6,0.2-2.4,0.2c-0.3,0-0.9-0.1-1-0.1c-0.1,0-0.1-0.1-0.2,0c0,0,0,0,0,0.1c0.1,0.2,0.2,0.4,0.3,0.5 c0.3,0.3,0.7,0.6,1.2,0.8C1145-934.2,1146.2-933.9,1146.2-933.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1136.6-933.2l15.8,6.2C1152.3-927,1138.5-917.4,1136.6-933.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M1159.1-930.2c-0.6,1.1-2.3,1.3-3.9,0.4c-1.6-0.8-2.4-2.4-1.9-3.4c0.6-1.1,2.3-1.3,3.9-0.4 C1158.8-932.8,1159.6-931.3,1159.1-930.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M1141.5-939.5c-0.5,1.1-2.2,1.4-3.8,0.7c-1.6-0.7-2.6-2.2-2.1-3.3c0.5-1.1,2.2-1.4,3.8-0.7 C1141-942.1,1141.9-940.7,1141.5-939.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M1135.6-915.9c0,0,5.5,4.6,11.3,3.1c0,0-2,3-9.7,1.9C1137.3-910.9,1137.9-914.1,1135.6-915.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1157.6-940.1c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.2,1.3-1.2 C1157-941.4,1157.6-940.8,1157.6-940.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st145",
    cx: 1146.1,
    cy: -943.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M1161.6-943.5c-0.4,0.2-1.1-0.7-2.3-1.5c-1.1-0.8-2.2-1.1-2.2-1.5c0-0.4,1.5-0.7,3,0.3 C1161.7-945.1,1162-943.6,1161.6-943.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M1143.5-949.5c0-0.4,1.3-0.9,3.1-0.8c1.8,0,3.2,0.9,3,1.3c-0.2,0.4-1.4,0.2-3.1,0.2 C1145-948.9,1143.6-949.1,1143.5-949.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1149.2-564.5c0,0,6.6,23.3,13.3,21.4c6.8-1.9,1.7-34.4,1.7-34.4l-6.8-10.7 C1157.4-588.2,1163.8-533.8,1149.2-564.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M1232-693.7c0,0,4.8-5.2,10.6-6.1s26.5-3.3,29.5-0.6c3,2.7-16.8,12-16.8,12s6.9-4.4,4-6 C1254.3-697.3,1232-693.7,1232-693.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "1223.8,-687.5 1230.3,-674.3 1233.8,-676.3 1225.1,-689.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "1151.3,-598.5 1135.4,-584.2 1140.1,-580.3 1153.5,-594.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M818.9-741.2c-4.5-11.2-6.3-23.7-13-33.8c-9.7-14.5-28.4-21.6-36.2-37.1c-3.3-6.6-4.4-14.1-4.4-21.5 c-0.1-14.6,4.3-30.2,15.6-39.5c13-10.7,32.5-10.5,47.7-3.4c15.2,7.2,26.8,20.2,36.7,33.8c9.9,13.6,18.5,28.2,30,40.5 c8.5,9.1,18.6,16.9,25.1,27.6c17.6,29.3-0.5,66.3-31.6,76.9C861.4-688.4,828.3-717.7,818.9-741.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M780-534.7c2.7,2.2-0.2,0.7,3.7,3.2c-0.9,9.8-10,16-10,16s-0.4,15.6-3.3,15.3 c-2.9-0.3-1.1-15.1-1.1-15.1s-6,15.4-8.5,14.4c-2.5-1,6.6-18.7,6.6-18.7s-12.8,17.7-14.6,14.9c-1.8-2.8,9.5-19.8,9.5-19.8 s-13.9,14.6-15.5,12.3c-1.6-2.4,16.6-22.7,16.6-22.7c-8.4-0.1-7.8-5.8-7.8-5.8l20.5,1.2C776.2-539.4,778.7-535.7,780-534.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M976.2-829.8c3.5,0.6,0.8-0.5,5.3,0.8c7.5-6.8,6.5-17.5,6.5-17.5s12.6-10.1,10.5-12 c-2.1-2-13,8.6-13,8.6s8.9-14.1,6.5-15.4c-2.4-1.3-11.1,16.6-11.1,16.6s6.4-20.6,3.1-20.2c-3.4,0.4-10.3,19.5-10.3,19.5 s3.2-19.5,0.3-19.2c-2.9,0.3-7.6,25.9-7.6,25.9c-6.9-5.6-11.7-2-11.7-2l15.1,14.8C969.7-829.9,974.6-830,976.2-829.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M890.2-744.3c6.4-1,25.7,11.6,20.8,37.1c-0.4,2.1-3.2,6.9-3.9,8.8c-0.9,2.5,6,11.5,6,11.5l-17.7,5.7 c-0.8-5.3,0.5-13.2-5.2-15.5c-2.1-0.9-4.4-1.4-6.4-2.5c-5.5-3-8.4-9.5-10.6-14.8c-1.7-4-2.9-8.3-2.9-12.6 C870.4-737.6,880-742.7,890.2-744.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M925.6-674.5c0-9.2-2.9-12.7-12.5-12.7c-9.6,0-22.4,3.5-22.4,12.7c0,9.2,6.8,20.7,16.4,20.7 C916.8-653.8,925.6-665.3,925.6-674.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M918-691.6c0,0,30-30.9,36-61.2c6-30.3,16.2-79.4,16.2-79.4l11.4,3.1c0,0,5.4,67.1,0,77.4 c-5.4,10.3-36,81.6-35.4,99.9L918-691.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M864.6-676.6c0,0-10.2,1.7-25.8,37.1c-15.6,35.4-63.5,101.3-63.5,101.3l7.8,7.2c0,0,46.7-34.8,55.7-55.9 c9-21.1,20.4-47.4,25.8-46.2C870-632.1,892.8-663.5,864.6-676.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M944.8-647l13.9-38.5c0,0-2.2-18.1-29.7-24.5l-15.6,22.5L944.8-647z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M869.3-679.6c0,0-16.5,1.4-29.8,30.7c0,0,14.7,20.3,25.4,20.9C864.9-628,904.7-662,869.3-679.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M914.5-332.1c0,0-23.8,48.5-26.5,39.5c-2.8-9-1.9-30.6-0.4-33.6c1.5-3.1,11.2-16.7,11.2-16.7 L914.5-332.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M916.3-562.8l21.7-8.3c0,0,64.5,113.9,64.2,145.5c-0.3,31.6-88.6,94.9-88.6,94.9l-14.9-12.3 c0,0,41.8-61.5,56.4-77.5c7.3-8-44.9-47.1-52.8-84.8C894.5-542.8,916.3-562.8,916.3-562.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M785.7-357.5c0,0-44.4,32.8-42.6,23.6c1.9-9.2,13-28,15.8-30.1c2.8-2.1,18-9.9,18-9.9L785.7-357.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M857.2-522.4l64.3-37.3c0,0,2.6,129.4-12.9,157.4c-15.4,28-124.3,45.7-124.3,45.7l-7.3-17.4 c0,0,67.2-40,87.8-47.9C885.4-429.7,857.2-522.4,857.2-522.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M895.5-585.2c0,0-47.3,16.8-38.3,62.7c9,46,24.1,54.6,24.1,54.6l27.1-44.5l27.3-58.3l-27.3-3.5 L895.5-585.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M918-691.6c0,0,34.8,19.5,34.8,63.7c0,0-4.4,50.3-11.6,61.3c0,0-11.7,2.8-26.2,0c-15.2-3-30-13.7-30-13.7 l-11.9-61.6l-9.3-36l5-1.7l26.2-2.9c0,0-3.8,39.1,25.5,19.7c6.2-4.1-7.7-24.5-7.7-24.5L918-691.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "939.4,-858.3 1012.4,-815.7 1053.5,-893.4 985,-931.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1041,-486.7 1093.3,-519.1 1050.1,-594.4 1002.3,-563.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M783.7-807.8c0.1-0.1,1.7,1.3,4.3,4.3c2.5,3,6,7.5,9.5,13.7c3.5,6.1,6.9,13.9,9.4,22.9 c2.6,8.9,4.3,19,8.2,28.7c2,4.8,4.5,9.2,7.4,13.2c3,3.9,6.3,7.3,9.6,10.3c6.9,5.8,14.2,9.8,20.6,12.1c6.5,2.3,12,3.4,15.8,3.8 c3.8,0.4,6,0.5,6,0.7c0,0.2-2.2,0.5-6.1,0.4c-3.9,0-9.7-0.8-16.4-2.9c-6.8-2.1-14.4-6.1-21.7-12c-3.6-3.1-7.1-6.6-10.2-10.7 c-3.1-4.1-5.7-8.8-7.9-13.8c-4.1-10.1-5.7-20.2-8.1-29.1c-2.3-8.8-5.4-16.5-8.6-22.6c-3.2-6.1-6.3-10.8-8.6-14 C784.9-806,783.6-807.7,783.7-807.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M873.5-857.7c0.5-0.1,1.1,7.1,5.1,17.7c2,5.3,5,11.4,9.3,17.5c2.1,3.1,4.6,6.1,7.4,9.1 c2.8,3,5.8,6.1,8.7,9.5c5.7,6.9,9.7,14.4,13.4,21.1c3.7,6.7,6.6,13,8.1,18.7c1.6,5.7,1.6,10.5,1.2,13.8 c-0.5,3.3-1.3,4.9-1.5,4.9c-0.3-0.1,0.2-1.8,0.3-5c0.1-3.1-0.3-7.7-2-13.1c-1.7-5.4-4.7-11.4-8.5-18 c-3.8-6.5-7.8-13.9-13.3-20.5c-2.7-3.3-5.7-6.4-8.5-9.5c-2.8-3.1-5.4-6.3-7.5-9.5c-4.3-6.4-7.2-12.8-9-18.4 c-1.8-5.5-2.6-10.2-3-13.4C873.2-855.9,873.3-857.7,873.5-857.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M895.9-716.6c0-0.2,1.2-0.4,2.3-1.7c0.3-0.3,0.5-0.7,0.5-1c0-0.3-0.2-0.8-0.5-1c-0.3-0.3-0.7-0.5-1.2-0.4 c-0.5,0-1.2,0.3-2,0.4c-1.8,0.2-3.3-0.8-4.2-1.6c-1-0.9-1.7-1.8-2.3-2.6c-1.1-1.6-1.4-2.8-1.3-2.9c0.2-0.1,0.9,0.9,2.1,2.2 c0.6,0.7,1.4,1.4,2.3,2.2c0.9,0.7,2,1.4,3.1,1.2c0.6-0.1,1.3-0.3,2.1-0.4c0.8-0.1,1.8,0.3,2.3,0.9c0.6,0.6,0.9,1.3,0.8,2.1 c-0.2,0.9-0.6,1.2-1,1.6C897.3-716.2,895.8-716.4,895.9-716.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M904.5-715.4l-14,5.1C890.5-710.3,902.4-699.9,904.5-715.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M889.1-716.2c0.6,1.1-0.3,2.6-1.9,3.4c-1.6,0.8-3.3,0.6-3.9-0.4c-0.6-1.1,0.3-2.6,1.9-3.4 C886.8-717.5,888.5-717.3,889.1-716.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M905.7-724.8c0.5,1.1-0.5,2.6-2.2,3.3c-1.7,0.7-3.4,0.3-3.8-0.8c-0.5-1.1,0.5-2.6,2.2-3.3 C903.6-726.2,905.3-725.9,905.7-724.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M890.9-696.4c0,0,4.7,1,10.7-0.5c0,0-3,2.9-7.8,3.5C893.8-693.4,892.7-695.4,890.9-696.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M895.7-727.9c0.5,0.4,0.6,1.2,0.1,1.8c-0.4,0.5-1.2,0.6-1.8,0.1c-0.5-0.4-0.6-1.2-0.1-1.8 C894.4-728.3,895.2-728.4,895.7-727.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M886.3-722.5c0.5,0.4,0.6,1.2,0.1,1.8c-0.4,0.5-1.2,0.6-1.8,0.1c-0.5-0.4-0.6-1.2-0.1-1.8 C885-722.9,885.7-722.9,886.3-722.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M895.8-733.1c-0.1,0.4-1.3,0.4-2.6,0.8c-1.3,0.4-2.3,1-2.6,0.7c-0.3-0.2,0.4-1.6,2.2-2.1 C894.5-734.3,895.9-733.5,895.8-733.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M879.5-723.3c-0.3-0.2,0.2-1.6,1.4-2.9c1.2-1.4,2.8-1.8,2.9-1.4c0.2,0.4-0.8,1.2-1.8,2.4 C880.9-724,879.8-723,879.5-723.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M874.2-712.9c0,0-4.5-3.8-6.7-0.4c-2.2,3.4,9.7,5.2,9.7,5.2L874.2-712.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M766-368.2c0,0-6.5,2.8-8.1,4.5c-1.7,1.7-17.1,28.3-15.1,31.7s17.4-8.1,17.4-8.1S747.2-337.6,766-368.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M891.9-332.9c0,0-4.6,5-5.3,7.2c-0.7,2.3-2,33,1.3,35.1c3.3,2.1,12.3-14.9,12.3-14.9 S889.4-297.1,891.9-332.9"
  }))))), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M476.4-1028.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H476.4z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M792.4-1028.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H792.4z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M-337.7-968.3c18.6-4.1,70.7-15.5,124,7.4c24.4,10.5,26.9,17.8,43.8,26.7c49.2,25.8,99.4-12.8,196.2-51.3 c92.9-36.9,189.3-73.8,263.1-34.6c15.6,8.3,36.7,16.1,42.9,35.2c9.6,29.6-23.1,58.3-20.8,123.3c0.1,2,0.1,1.8,0.1,3.3 c1.1,41-23.1,55.7-25.1,85.2c-0.5,8,1.4,4.6,10.7,39.6c7.7,29.2,15.2,57.4,16.3,89.3c0,0,1,28.4-5.7,62 C290.8-497.7,192.4-319,87-326c-29.8-2-32.9-17-97.5-31.7c-45.9-10.4-80-10.9-102.6-11.8c-109.4-4.3-236.6-9.4-323.9-82.8 c-33.7-28.3-51.5-58.4-60.2-73.4c-59.3-102.3-64.4-254.2,18.4-354.4C-465.1-896.9-416.8-951-337.7-968.3z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M181.4-520.6c0.2-0.1,1.2,1.2,2.6,3.8c1.5,2.6,3.3,6.5,5,11.5c3.5,10.1,5.7,24.9,4.4,41.1 c-1.3,16.2-5,30.4-7.9,40.6c-3,10.1-5.1,16.3-5.5,16.2c-0.4-0.1,1.1-6.5,3.5-16.7c2.4-10.2,5.7-24.4,7-40.2 c1.3-15.9-0.5-30.3-3.4-40.3C184.2-514.6,180.9-520.3,181.4-520.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M191.4-601.7c0.2-0.1,1.4,2.1,3.4,6.2c2,4.1,4.8,10,8.2,17.4c6.6,14.8,15.5,35.4,22,59.4 c3.2,12,5.3,23.7,6.4,34.4c1.1,10.7,1.2,20.5,0.7,28.6c-0.5,8.1-1.6,14.7-2.6,19.1c-1,4.4-1.8,6.8-1.9,6.8 c-0.5-0.1,1.9-9.9,2.4-26c0.6-16.1-1.5-38.4-7.9-62.1c-6.4-23.7-14.9-44.4-21-59.4c-3.1-7.5-5.6-13.5-7.3-17.7 C192-599.2,191.2-601.6,191.4-601.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-178.2-506.5c0.3,0.4-3,3.6-7.4,9.5c-1.1,1.5-2.3,3.1-3.4,5c-1.2,1.8-2.2,3.9-3.4,6 c-2.2,4.3-4.2,9.3-5.8,14.7c-1.5,5.4-2.4,10.7-2.9,15.5c-0.1,2.4-0.4,4.7-0.3,6.9c-0.1,2.2,0.1,4.2,0.2,6 c0.5,7.4,1.7,11.9,1.2,12c-0.3,0.1-2.2-4.2-3.3-11.8c-0.3-1.9-0.5-3.9-0.6-6.2c-0.2-2.2,0-4.6,0-7.1c0.3-5,1.2-10.5,2.8-16.1 c1.6-5.6,3.9-10.7,6.2-15.1c1.3-2.2,2.4-4.3,3.8-6.1c1.2-1.9,2.5-3.5,3.8-4.9C-182.3-504-178.4-506.7-178.2-506.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-170.3-480.5c0.2,0.4-1.6,1.8-4.1,4.6c-1.2,1.4-2.5,3.1-3.8,5.1c-1.2,2.1-2.4,4.4-3.3,7 c-0.9,2.6-1.4,5.2-1.7,7.6c-0.2,2.4-0.3,4.6-0.2,6.4c0.2,3.7,0.8,5.9,0.4,6.1c-0.3,0.1-1.7-2-2.5-5.8c-0.4-1.9-0.6-4.3-0.5-6.9 c0.2-2.6,0.7-5.5,1.6-8.3c1-2.9,2.4-5.4,3.9-7.6c1.5-2.1,3.1-3.9,4.6-5.1C-172.8-480-170.4-480.8-170.3-480.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-279.7-722.5c0.2-0.1,1.5,1.2,3.8,3.7c1.2,1.2,2.5,2.8,4,4.7c1.5,1.9,3.2,4,4.9,6.5 c0.9,1.2,1.7,2.6,2.7,3.9c0.9,1.4,1.8,2.9,2.7,4.4c1.9,3,3.6,6.4,5.5,10c3.5,7.2,6.8,15.4,9.5,24.2c2.6,8.9,4.2,17.5,5.2,25.5 c0.4,4,0.8,7.8,0.8,11.3c0,1.8,0.2,3.5,0.1,5.1c0,1.6-0.1,3.2-0.1,4.7c0,3-0.3,5.7-0.5,8.1c-0.2,2.4-0.5,4.4-0.8,6.1 c-0.6,3.3-1,5.1-1.2,5.1c-0.5-0.1,0.5-7.4,0.4-19.4c0-1.5-0.1-3-0.1-4.7c0-1.6-0.2-3.3-0.3-5.1c-0.1-3.5-0.7-7.2-1.1-11.1 c-1.1-7.8-2.8-16.3-5.3-25c-2.6-8.7-5.8-16.7-9.1-23.9c-1.8-3.5-3.3-6.9-5.1-9.9c-0.9-1.5-1.6-3-2.5-4.4c-0.9-1.4-1.7-2.7-2.5-4 C-275.3-716.5-280.1-722.1-279.7-722.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-246.2-708.6c0.3-0.2,3.7,3,8,9.1c2.2,3.1,4.5,6.9,6.7,11.3c2.2,4.5,4.2,9.5,5.9,15 c1.6,5.5,2.6,10.9,3.2,15.8c0.5,4.9,0.7,9.4,0.5,13.2c-0.3,7.5-1.4,12-1.8,12c-0.5-0.1-0.1-4.6-0.3-12c-0.1-3.7-0.5-8-1.1-12.8 c-0.7-4.8-1.8-10-3.4-15.3c-1.6-5.3-3.5-10.3-5.5-14.7c-2-4.4-4.1-8.2-6-11.4C-243.8-704.7-246.6-708.3-246.2-708.6z"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_16_",
    className: "st138",
    points: "-361.4,-495.2 -364,-500.5 -435.8,-445.6 -404.5,-394.9 -333,-455.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_15_",
    className: "st139",
    points: "-432.8,-444.4 -405.3,-396.8 -403.5,-397.6 -428,-442.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st140",
    d: "M-362.9-496.2l-70,51.8c0,0,0.3,1.1,2,1.8c1.7,0.7,2.7,0.5,2.7,0.5l73.5-50.3 c0,0-4.2-1-5.8-2.1C-361.8-495.7-362.9-496.2-362.9-496.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st138",
    d: "M-352.7-494.5l-76.7,51.2l24.9,47.2l4,6.5l76.7-56.7c0,0-8.1-12.1-12.9-19.3 c-4.8-7.3-14.4-24.4-14.9-25.5C-352.1-492.3-352.7-494.5-352.7-494.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4_",
    className: "st141",
    points: "279.5,-848 281.7,-852.4 342,-806.3 315.6,-763.7 255.6,-814.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3_",
    className: "st139",
    points: "339.4,-805.4 316.3,-765.4 314.8,-766 335.4,-803.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st140",
    d: "M280.7-848.9l58.7,43.5c0,0-0.2,0.9-1.7,1.5s-2.3,0.4-2.3,0.4l-61.8-42.3 c0,0,3.6-0.8,4.9-1.8S280.7-848.9,280.7-848.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st141",
    d: "M272.2-847.4l64.4,43l-20.9,39.6l-3.4,5.5l-64.4-47.6c0,0,6.8-10.1,10.9-16.2 c4.1-6.1,12.1-20.5,12.5-21.4C271.7-845.5,272.2-847.4,272.2-847.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M-447.2-930.9c0,0-4.6,3.2-2.3,8.4c2.3,5.3,12.3,20.8,25.7,20.3c0.6,0-17-28.7-17-28.7H-447.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M-467.8-643.6c0,0-16.9-15.1-22.3-12.4c-6.6,3.3-44.3,40.3-42.9,57.7c0.6,7.1,8.9,1,23.7-14.3 c14.8-15.4,33.4-8.8,33.4-8.8L-467.8-643.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M-426.8-618.2l-20.4-12.2c0,0-52.8,49.5-44.5,56.1c6.3,5,9.9,0.5,24.7-14.8c14.8-15.4,33.6-6.5,33.6-6.5 L-426.8-618.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "-302.5,-780.9 -298.7,-726.7 -383.4,-748.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M-383.4-747c0,0,74.1,4.7,84,1.4c0,0,14.5,142.3-11.3,157.6c-25.8,15.4-83.6-7.1-83.6-7.1l15.6-30.7 l33.7-2.2v-54.8l-2.4,0.5L-383.4-747z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-476.3-649.9c0,0-18.6,7.7-12.6,26.3c0,0,63.6,49.9,94.6,38.4c17.3-6.5,36-55.7,49-97.7l45.9-62.7 c0,0-21.6,1.1-28.9,1.1c-13.8-0.1-55.1-2.4-55.1-2.4s-21.6,113-29.3,115.7C-420.4-628.5-476.3-649.9-476.3-649.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-366.1-888.6c0,0,44.4-41.7,52.1-52.6c7.7-11,24.1-47.7,44.4-63.1l-9.9-20.8c0,0,6-3.3,9.9,5.5 c0,0,14.3-28.5,17.5-28c3.3,0.5-6.6,21.9-6.6,21.9s13.7-19.7,17.5-19.2c3.8,0.5-9.9,22.2-9.9,22.2s15.4-17.8,17.5-15.6 c2.2,2.2-12.1,15.6-12.1,15.6s15.4-8.8,17-5.9c1.6,2.9-15.4,10.6-15.4,10.6s-1.6,12.6-12.1,18.1c0,0-20.6,55.7-39.3,73.8 l-59.9,62.2L-366.1-888.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-419.1-867c0,0-42.1,44-53.1,51.6c-11,7.6-47.9,23.7-63.5,43.8l-20.7-10.1c0,0-3.3,6,5.4,9.9 c0,0-28.6,14-28.1,17.3c0.5,3.3,22-6.4,22-6.4s-19.9,13.5-19.4,17.4c0.5,3.8,22.3-9.7,22.3-9.7s-17.9,15.2-15.8,17.4 c2.2,2.2,15.7-11.9,15.7-11.9s-9,15.3-6.1,16.9c2.9,1.7,10.7-15.3,10.7-15.3s12.6-1.5,18.2-11.9c0,0,52.8-21,71.1-39.5 l65.7-46.5L-419.1-867z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-403.4-884.6l-21.3,20.8l5.4,23.5c0,0,21,50.3,24.1,62.6c4.9,19.1-3,48.2-3,48.2s35.6-3,67.9-4 c32.3-1.1,42.9-11.5,42.9-11.5s-28-93.4-47.4-119.5c-19.4-26.1-26.4-34.3-26.4-34.3l-28.5,6.2L-403.4-884.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-340.9-867.6l22.2-14.2c0,0,3.4-15.2-23.4-33.1l-31.4,19.7L-340.9-867.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-420.2-865.4c-12.2,1.7-34.4,32.5-36.9,32.5c0,0,15.6,25.5,28,26.3C-429-806.6-374.5-871.8-420.2-865.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-377.3-885.4c0,0-17.7-13.2-17.1-18.5c0.2-1.3,2.6-3.5,3.2-5.4c3.4-10.3-13.1-36.8-23.2-42.4 c-8-4.4-4.5-4.8-21.3,5.2c-16.8,10-7.2,27.3,0.3,36.2c7.1,8.4,15.2,12.1,22.5,12.7l10.4,23.1L-377.3-885.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-409.1-867.1c-3.3-8.2,3-18.5,14.1-23.1c11.2-4.6,22.9-1.6,26.3,6.6c3.3,8.2-7.9,20.5-14.1,23.1 C-389.2-857.9-405.8-858.9-409.1-867.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-435.3-910.2c0,0-5.7-0.3-6.4,3.5c-0.6,3.8,10.5,3.8,14.6,1L-435.3-910.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M-432.5-906.7c-1.1-6.9-8.4-12-8.1-18.8c3.5,0,5.8-4.3,4.2-8.1c-0.6-1.5-1.7-2.7-2.4-4.2 c-0.7-1.4-0.9-3.3,0.2-4.2c0.5-0.4,1.2-0.5,1.8-0.5c5.2-0.5,14.2,1,19-0.8c4.6-1.7,9.5-5,9-10.6c-0.4-4.9-4.7-8.8-8.7-11.8 c-2.3-1.7-8.8-6.2-11.2-5.8c-3.7,0.6-4.6,5.6-4.9,9.8c-2.6-2.5-6.5-2.1-8.7-0.1c-2.3,2-3.3,5.2-4.3,8.3c-1,3.1-2,6.3-4.3,8.4 c-2.1,1.9-5.4,3.4-5,6.7c0.5,3.9,5.6,5.3,8,8.6c-0.6-0.8-1.1,4.4-0.7,5.3c1,2.7,3.5,4.4,5.3,6.5 C-439.5-913.6-437.6-909.3-432.5-906.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-400.4-922.5l-13.1,6.8C-413.5-915.8-397.8-904.4-400.4-922.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M-418.4-919.9c0.7,1.4-0.3,3.3-2.4,4.4c-2,1.1-4.2,0.8-4.9-0.5c-0.7-1.4,0.3-3.3,2.4-4.4 C-421.3-921.4-419.1-921.2-418.4-919.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M-399.3-932.9c0.7,1.4-0.3,3.3-2.4,4.4c-2,1.1-4.2,0.8-4.9-0.5c-0.7-1.4,0.3-3.3,2.4-4.4 C-402.3-934.5-400.1-934.2-399.3-932.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M-409.6-923c-0.1-0.1,0.2-0.4,0.7-0.8c0.5-0.4,1.5-0.9,2.2-1.6c0.7-0.7,0.9-2.2-0.1-2.5 c-1.1-0.4-2.3,0.9-3.8,2.1c-0.4,0.3-0.7,0.6-1,0.9c-0.3,0.3-1,0.7-1.7,0.6c-1.3-0.2-1.9-1.1-2.4-1.7c-1-1.3-1.7-2.7-2-3.9 c-0.7-2.4-0.4-4-0.2-4c0.2,0,0.3,1.5,1.2,3.6c0.4,1.1,1.1,2.3,2.1,3.4c0.5,0.6,1.1,1.1,1.5,1.1c0.2,0,0.3-0.1,0.7-0.3 c0.3-0.3,0.7-0.6,1-0.9c0.7-0.6,1.3-1.2,2.2-1.7c0.8-0.5,1.9-0.9,3-0.5c1.1,0.3,1.7,1.6,1.5,2.4c-0.1,0.9-0.6,1.6-1.1,2.1 c-1.1,0.9-2,1.1-2.6,1.4C-409.2-923.1-409.5-922.9-409.6-923z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M-412.8-897.6c0,0,8.3,0,12.9-2.7c0,0-3.8,4.7-11.5,5.9L-412.8-897.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-409.2-934.9c-0.1,0.4-1.2,0.5-2.5,1.1c-1.2,0.5-2.1,1.3-2.5,1c-0.4-0.2,0.2-1.7,1.9-2.4 C-410.6-935.9-409.1-935.3-409.2-934.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-425.5-924.2c-0.3-0.2,0.2-1.6,1.4-2.9c1.2-1.4,2.8-1.8,2.9-1.4c0.2,0.4-0.8,1.2-1.8,2.4 C-424.1-924.9-425.2-924-425.5-924.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M-431.8-926.3c-0.7-0.5-1.2-2.6,1.4-5.5c2.6-3,5.5-2.4,5.9-1.6c0.4,0.8-0.6,1.9-2.9,4.5 C-429.8-926.3-431.1-925.7-431.8-926.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M-418.1-937.7c-0.4-0.7,0-2.7,3.4-4.1c3.4-1.5,5.7,0.1,5.6,1c0,0.8-1.3,1.4-4.3,2.7 C-416.4-936.8-417.7-936.9-418.1-937.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M298.5-917.4c0.2,0.2-3.4,4.3-10.9,8.7c-7.4,4.4-19.1,8.8-32.5,8.9c-13.4,0.1-25.2-4.1-32.6-8.4 c-7.6-4.3-11.3-8.3-11-8.6c0.3-0.4,4.4,3,12,6.7c7.5,3.7,18.8,7.4,31.6,7.3c12.8-0.1,24.1-4,31.5-7.8 C294.1-914.4,298.2-917.8,298.5-917.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M216.6-923.6c-0.2,0.5-4.2-1.2-11-2.7c-3.4-0.8-7.4-1.4-12-2c-4.6-0.5-9.6-0.9-14.9-1.3 c-5.3-0.4-10.4-0.8-15.1-1.4c-4.6-0.6-8.8-1.3-12.2-2.3c-6.9-1.8-10.8-3.9-10.6-4.2c0.2-0.5,4.3,0.9,11.1,2.2 c3.4,0.6,7.5,1.1,12.1,1.6c4.6,0.4,9.6,0.8,15,1.1c5.3,0.4,10.4,0.9,15.1,1.5c4.6,0.7,8.8,1.6,12.2,2.7 C213-926.2,216.8-923.9,216.6-923.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M135.4-1011.2c12.8-2.7,26.1-0.4,39,1.8c12.9,2.2,26.3,4.1,38.9,0.6c22.8-6.3,40.1-29.3,63.7-29.1 c9.7,0.1,18.9,4.2,28.4,6.4c11.8,2.7,24,2.4,35.9,4.4c11.9,1.9,24.2,6.7,31,16.8c8,11.9,5.8,28.7-2.6,40.3 c-8.4,11.6-21.8,18.7-35.6,22.7c-9.6,2.8-19.8,4.4-28.1,10c-8.4,5.6-13.9,14.7-21.7,21.1c-19.6,16.1-50.2,11.5-70.5-3.8 c-5.1-3.8-9.8-8.3-15.6-11.1c-23.3-11.4-56.8,3.7-76.9-17.1C101-969.1,103.9-1004.5,135.4-1011.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M129-603.1c0,0,21.3,45.8,23.8,37.3c2.5-8.5,1.7-28.8,0.3-31.7c-1.3-2.9-10.1-15.7-10.1-15.7L129-603.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M283.4-973c2,2.5,0.7-0.2,2.9,3.5c9.3-0.3,15.5-8.2,15.5-8.2s14.8,0.4,14.6-2.2 c-0.2-2.6-14.1-1.7-14.1-1.7s14.8-4.6,14-7c-0.8-2.3-17.9,5.1-17.9,5.1s17.2-10.7,14.7-12.4c-2.5-1.7-19.1,7.6-19.1,7.6 s14.4-11.8,12.2-13.4c-2.2-1.5-22.1,13.9-22.1,13.9c0.3-7.6-5.1-7.3-5.1-7.3l0.2,18.5C279.1-976.6,282.5-974.2,283.4-973z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M64.7-1056.7c-3.2,0.6-0.7-0.5-4.8,0.7c-6.7-6.4-5.8-16.5-5.8-16.5s-11.3-9.5-9.4-11.4 c1.9-1.9,11.7,8.2,11.7,8.2s-8-13.3-5.8-14.5c2.1-1.2,10,15.7,10,15.7s-5.8-19.4-2.7-19c3,0.4,9.2,18.4,9.2,18.4 s-2.9-18.4-0.3-18.1c2.6,0.3,7.3,25.1,7.3,25.1c4.8-5.9,8.7-2.1,8.7-2.1l-12.2,13.4C70.5-1056.9,66.2-1057,64.7-1056.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M141.3-979.5c-4.1-0.7-14,5.9-18.9,16.6c-2.8,6-4.7,12.1-1.5,21.8c1.5,4.6,4.6,5.2,5.3,7.2 c0.9,2.6-2,10.8-2,10.8s11.7,4.7,11.7,4.7c0.8-5.6,1.6-11.3,7.3-13.7c2.1-0.9,4.4-1.5,6.5-2.7c5.5-3.1,8.4-10,10.6-15.6 C161.9-954.6,151.5-977.8,141.3-979.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M127.4-820.6l-19.5-7.8c0,0-57.9,107.4-57.7,137.2c0.2,29.8,79.6,89.5,79.6,89.5l13.4-11.6 c0,0-24.5-42.7-37.6-57.8C92.5-686.1,127.4-820.6,127.4-820.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M224.3-698.2c0,0,43-20.4,34.4-22.2c-8.6-1.8-28.9,0.7-31.6,2.2c-2.8,1.6-14.9,11.3-14.9,11.3 L224.3-698.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M146.6-821.5L117-810.7c0,0-29.6,130.3-18.3,150.7c11.3,20.5,43.1,6.9,88.3-17.8 c37.9-20.7,37.9-20.7,37.9-20.7l-12.6-8.4c0,0-44.1,8.6-56.5,17.3c0,0,6.5-18.3,15.1-44.1C179.4-759.6,185.4-786,146.6-821.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M110.1-910.3c0-8.7,2.8-14.9,11.4-14.9c8.7,0,20.6,3,20.6,11.7c0,8.7-6.8,22.7-15.5,22.7 C118.1-890.8,110.1-901.6,110.1-910.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M117-926.4c0,0-26.9-29.1-32.3-57.7c-5.4-28.5-14.5-74.8-14.5-74.8l-10.2,2.9c0,0-4.8,63.3,0,73 c4.8,9.7,28.5,74.2,35.7,91.2L117-926.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M145.9-903.7c0,0,2.1-9.1,36.1-21.4c34-12.3,98.3-52.2,98.3-52.2l6.4,7.3c0,0-34.9,40.3-55.2,47.4 c-20.3,7.1-63.4,34.9-67.9,37.2C156.9-882.1,157-877.8,145.9-903.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M117-926.4c0,0-27.3,8.9-27.3,50.5c0,0,0,57,6.5,67.4c0,0,10.5,2.7,23.5,0c13.7-2.8,27-12.9,27-12.9 l21.5-64.6l-2.6-30.3l-29.3-5.6c0,0,8.4,39.2-22,22.4c-5.9-3.3,8.7-25.5,8.7-25.5L117-926.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M93.8-892.6l-13.5-28.1c0,0,1.9-17,26.7-23.1c0,0,2.5,8.6,5.2,11.9c2.7,3.3,10.7,6.8,10.7,6.8 L93.8-892.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M144.8-881.3l42.9-8.8c0,0,7.5-15.4-10.2-33.8c0,0-33.4,2-37.8,2.4c-4.3,0.4-1.3,3.6-1.3,3.6 L144.8-881.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M96-822.5c0,0-40.5,74.9-47.2,88.3c0,0,119.6,54.9,168.1-11.2c0,0-27.6-58.4-70.3-80.7l0,0l-18.4-5.5 l-31.5,8.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M158.7-951.1c0,0,4.6-4.6,7.5-1.4c2.8,3.2-10.3,7.8-10.3,7.8L158.7-951.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M243.1-1014c0,0.2-1.7,0.9-5.1,1.7c-3.4,0.8-8.4,1.6-14.7,1.7c-6.3,0.1-13.7-0.4-21.8-1.5 c-8.1-1.1-17-2.7-26.3-3.7c-9.3-1-18.2-1.2-26.2,0.1c-7.9,1.3-14.8,3.9-20,6.9c-5.2,3.1-8.9,6.4-11.1,9 c-2.3,2.6-3.3,4.2-3.5,4.1c-0.1-0.1,0.6-1.9,2.6-4.8c2-2.9,5.6-6.7,10.9-10.1c5.3-3.4,12.4-6.3,20.7-7.8 c8.2-1.5,17.5-1.4,26.9-0.4c9.5,1,18.3,2.7,26.4,3.9c8.1,1.2,15.3,2,21.5,2.1C235.6-1012.4,243-1014.6,243.1-1014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M135.2-953.7c0,0.2-1.3,0.3-3.3-0.4c-0.5-0.2-1.1-0.4-1.6-0.9c-0.3-0.2-0.5-0.6-0.7-1 c-0.2-0.6-0.2-1.2,0-1.7c0.1-0.1,0.1-0.3,0.2-0.3l0.4,0c0.3,0,0.5,0,0.8,0.1c0.5,0.1,0.7,0.1,1.1,0.1c0.7,0,1.3-0.1,2-0.2 c2.8-0.6,4.7-2.6,5.5-4.3c0.9-1.7,1-3,1.2-2.9c0.2,0,0.5,1.3-0.2,3.4c-0.4,1-1,2.1-2.1,3.1c-1,1-2.5,1.8-4.1,2.2 c-0.8,0.2-1.6,0.2-2.4,0.2c-0.3,0-0.9-0.1-1-0.1c-0.1,0-0.1-0.1-0.2,0c0,0,0,0,0,0.1c0.1,0.2,0.2,0.4,0.3,0.5 c0.3,0.3,0.7,0.6,1.2,0.8C134-954.2,135.2-953.9,135.2-953.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M125.6-953.2l15.8,6.2C141.3-947,127.5-937.4,125.6-953.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M148.1-950.2c-0.6,1.1-2.3,1.3-3.9,0.4c-1.6-0.8-2.4-2.4-1.9-3.4c0.6-1.1,2.3-1.3,3.9-0.4 C147.8-952.8,148.6-951.3,148.1-950.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M130.5-959.5c-0.5,1.1-2.2,1.4-3.8,0.7c-1.6-0.7-2.6-2.2-2.1-3.3c0.5-1.1,2.2-1.4,3.8-0.7 C130-962.1,130.9-960.7,130.5-959.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M124.6-935.9c0,0,5.5,4.6,11.3,3.1c0,0-2,3-9.7,1.9C126.3-930.9,126.9-934.1,124.6-935.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M146.6-960.1c0,0.7-0.6,1.3-1.2,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.2,1.3-1.2 C146-961.4,146.6-960.8,146.6-960.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st145",
    cx: 135.1,
    cy: -963.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M150.6-963.5c-0.4,0.2-1.1-0.7-2.3-1.5c-1.1-0.8-2.2-1.1-2.2-1.5c0-0.4,1.5-0.7,3,0.3 C150.7-965.1,151-963.6,150.6-963.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M132.5-969.5c0-0.4,1.3-0.9,3.1-0.8c1.8,0,3.2,0.9,3,1.3c-0.2,0.4-1.4,0.2-3.1,0.2 C134-968.9,132.6-969.1,132.5-969.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M138.2-584.5c0,0,6.6,23.3,13.3,21.4c6.8-1.9,1.7-34.4,1.7-34.4l-6.8-10.7 C146.4-608.2,152.8-553.8,138.2-584.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M221-713.7c0,0,4.8-5.2,10.6-6.1s26.5-3.3,29.5-0.6c3,2.7-16.8,12-16.8,12s6.9-4.4,4-6 C243.3-717.3,221-713.7,221-713.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "212.8,-707.5 219.3,-694.3 222.8,-696.3 214.1,-709.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st145",
    points: "140.3,-618.5 124.4,-604.2 129.1,-600.3 142.5,-614.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-192.1-761.2c-4.5-11.2-6.3-23.7-13-33.8c-9.7-14.5-28.4-21.6-36.2-37.1c-3.3-6.6-4.4-14.1-4.4-21.5 c-0.1-14.6,4.3-30.2,15.6-39.5c13-10.7,32.5-10.5,47.7-3.4c15.2,7.2,26.8,20.2,36.7,33.8c9.9,13.6,18.5,28.2,30,40.5 c8.5,9.1,18.6,16.9,25.1,27.6c17.6,29.3-0.5,66.3-31.6,76.9C-149.6-708.4-182.7-737.7-192.1-761.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-231-554.7c2.7,2.2-0.2,0.7,3.7,3.2c-0.9,9.8-10,16-10,16s-0.4,15.6-3.3,15.3 c-2.9-0.3-1.1-15.1-1.1-15.1s-6,15.4-8.5,14.4c-2.5-1,6.6-18.7,6.6-18.7s-12.8,17.7-14.6,14.9c-1.8-2.8,9.5-19.8,9.5-19.8 s-13.9,14.6-15.5,12.3c-1.6-2.4,16.6-22.7,16.6-22.7c-8.4-0.1-7.8-5.8-7.8-5.8l20.5,1.2C-234.8-559.4-232.3-555.7-231-554.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-34.8-849.8c3.5,0.6,0.8-0.5,5.3,0.8c7.5-6.8,6.5-17.5,6.5-17.5s12.6-10.1,10.5-12 c-2.1-2-13,8.6-13,8.6s8.9-14.1,6.5-15.4c-2.4-1.3-11.1,16.6-11.1,16.6s6.4-20.6,3.1-20.2c-3.4,0.4-10.3,19.5-10.3,19.5 s3.2-19.5,0.3-19.2c-2.9,0.3-7.6,25.9-7.6,25.9c-6.9-5.6-11.7-2-11.7-2l15.1,14.8C-41.3-849.9-36.4-850-34.8-849.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-120.8-764.3c6.4-1,25.7,11.6,20.8,37.1c-0.4,2.1-3.2,6.9-3.9,8.8c-0.9,2.5,6,11.5,6,11.5l-17.7,5.7 c-0.8-5.3,0.5-13.2-5.2-15.5c-2.1-0.9-4.4-1.4-6.4-2.5c-5.5-3-8.4-9.5-10.6-14.8c-1.7-4-2.9-8.3-2.9-12.6 C-140.6-757.6-131-762.7-120.8-764.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-85.4-694.5c0-9.2-2.9-12.7-12.5-12.7c-9.6,0-22.4,3.5-22.4,12.7c0,9.2,6.8,20.7,16.4,20.7 C-94.2-673.8-85.4-685.3-85.4-694.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-93-711.6c0,0,30-30.9,36-61.2c6-30.3,16.2-79.4,16.2-79.4l11.4,3.1c0,0,5.4,67.1,0,77.4 c-5.4,10.3-36,81.6-35.4,99.9L-93-711.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-146.4-696.6c0,0-10.2,1.7-25.8,37.1c-15.6,35.4-63.5,101.3-63.5,101.3l7.8,7.2 c0,0,46.7-34.8,55.7-55.9c9-21.1,20.4-47.4,25.8-46.2C-141-652.1-118.2-683.5-146.4-696.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M-66.2-667l13.9-38.5c0,0-2.2-18.1-29.7-24.5l-15.6,22.5L-66.2-667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M-141.7-699.6c0,0-16.5,1.4-29.8,30.7c0,0,14.7,20.3,25.4,20.9C-146.1-648-106.3-682-141.7-699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-96.5-352.1c0,0-23.8,48.5-26.5,39.5c-2.8-9-1.9-30.6-0.4-33.6c1.5-3.1,11.2-16.7,11.2-16.7 L-96.5-352.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M-94.7-582.8l21.7-8.3c0,0,64.5,113.9,64.2,145.5c-0.3,31.6-88.6,94.9-88.6,94.9l-14.9-12.3 c0,0,41.8-61.5,56.4-77.5c7.3-8-44.9-47.1-52.8-84.8C-116.5-562.8-94.7-582.8-94.7-582.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-225.3-377.5c0,0-44.4,32.8-42.6,23.6c1.9-9.2,13-28,15.8-30.1c2.8-2.1,18-9.9,18-9.9L-225.3-377.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M-153.8-542.4l64.3-37.3c0,0,2.6,129.4-12.9,157.4c-15.4,28-124.3,45.7-124.3,45.7l-7.3-17.4 c0,0,67.2-40,87.8-47.9C-125.6-449.7-153.8-542.4-153.8-542.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M-115.5-605.2c0,0-47.3,16.8-38.3,62.7c9,46,24.1,54.6,24.1,54.6l27.1-44.5l27.3-58.3l-27.3-3.5 L-115.5-605.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st151",
    d: "M-93-711.6c0,0,34.8,19.5,34.8,63.7c0,0-4.4,50.3-11.6,61.3c0,0-11.7,2.8-26.2,0c-15.2-3-30-13.7-30-13.7 l-11.9-61.6l-9.3-36l5-1.7l26.2-2.9c0,0-3.8,39.1,25.5,19.7c6.2-4.1-7.7-24.5-7.7-24.5L-93-711.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "-71.6,-878.3 1.4,-835.7 42.5,-913.4 -26,-951.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "30,-506.7 82.3,-539.1 39.1,-614.4 -8.7,-583.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-227.3-827.8c0.1-0.1,1.7,1.3,4.3,4.3c2.5,3,6,7.5,9.5,13.7c3.5,6.1,6.9,13.9,9.4,22.9 c2.6,8.9,4.3,19,8.2,28.7c2,4.8,4.5,9.2,7.4,13.2c3,3.9,6.3,7.3,9.6,10.3c6.9,5.8,14.2,9.8,20.6,12.1c6.5,2.3,12,3.4,15.8,3.8 c3.8,0.4,6,0.5,6,0.7c0,0.2-2.2,0.5-6.1,0.4c-3.9,0-9.7-0.8-16.4-2.9c-6.8-2.1-14.4-6.1-21.7-12c-3.6-3.1-7.1-6.6-10.2-10.7 c-3.1-4.1-5.7-8.8-7.9-13.8c-4.1-10.1-5.7-20.2-8.1-29.1c-2.3-8.8-5.4-16.5-8.6-22.6c-3.2-6.1-6.3-10.8-8.6-14 C-226.1-826-227.4-827.7-227.3-827.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-137.5-877.7c0.5-0.1,1.1,7.1,5.1,17.7c2,5.3,5,11.4,9.3,17.5c2.1,3.1,4.6,6.1,7.4,9.1 c2.8,3,5.8,6.1,8.7,9.5c5.7,6.9,9.7,14.4,13.4,21.1c3.7,6.7,6.6,13,8.1,18.7c1.6,5.7,1.6,10.5,1.2,13.8 c-0.5,3.3-1.3,4.9-1.5,4.9c-0.3-0.1,0.2-1.8,0.3-5c0.1-3.1-0.3-7.7-2-13.1c-1.7-5.4-4.7-11.4-8.5-18 c-3.8-6.5-7.8-13.9-13.3-20.5c-2.7-3.3-5.7-6.4-8.5-9.5c-2.8-3.1-5.4-6.3-7.5-9.5c-4.3-6.4-7.2-12.8-9-18.4 c-1.8-5.5-2.6-10.2-3-13.4C-137.8-875.9-137.7-877.7-137.5-877.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M-115.1-736.6c0-0.2,1.2-0.4,2.3-1.7c0.3-0.3,0.5-0.7,0.5-1c0-0.3-0.2-0.8-0.5-1 c-0.3-0.3-0.7-0.5-1.2-0.4c-0.5,0-1.2,0.3-2,0.4c-1.8,0.2-3.3-0.8-4.2-1.6c-1-0.9-1.7-1.8-2.3-2.6c-1.1-1.6-1.4-2.8-1.3-2.9 c0.2-0.1,0.9,0.9,2.1,2.2c0.6,0.7,1.4,1.4,2.3,2.2c0.9,0.7,2,1.4,3.1,1.2c0.6-0.1,1.3-0.3,2.1-0.4c0.8-0.1,1.8,0.3,2.3,0.9 c0.6,0.6,0.9,1.3,0.8,2.1c-0.2,0.9-0.6,1.2-1,1.6C-113.7-736.2-115.2-736.4-115.1-736.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-106.5-735.4l-14,5.1C-120.5-730.3-108.6-719.9-106.5-735.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M-121.9-736.2c0.6,1.1-0.3,2.6-1.9,3.4c-1.6,0.8-3.3,0.6-3.9-0.4c-0.6-1.1,0.3-2.6,1.9-3.4 C-124.2-737.5-122.5-737.3-121.9-736.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M-105.3-744.8c0.5,1.1-0.5,2.6-2.2,3.3c-1.7,0.7-3.4,0.3-3.8-0.8c-0.5-1.1,0.5-2.6,2.2-3.3 C-107.4-746.2-105.7-745.9-105.3-744.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st149",
    d: "M-120.1-716.4c0,0,4.7,1,10.7-0.5c0,0-3,2.9-7.8,3.5C-117.2-713.4-118.3-715.4-120.1-716.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-115.3-747.9c0.5,0.4,0.6,1.2,0.1,1.8c-0.4,0.5-1.2,0.6-1.8,0.1c-0.5-0.4-0.6-1.2-0.1-1.8 C-116.6-748.3-115.8-748.4-115.3-747.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-124.7-742.5c0.5,0.4,0.6,1.2,0.1,1.8c-0.4,0.5-1.2,0.6-1.8,0.1c-0.5-0.4-0.6-1.2-0.1-1.8 C-126-742.9-125.3-742.9-124.7-742.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-115.2-753.1c-0.1,0.4-1.3,0.4-2.6,0.8c-1.3,0.4-2.3,1-2.6,0.7c-0.3-0.2,0.4-1.6,2.2-2.1 C-116.5-754.3-115.1-753.5-115.2-753.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M-131.5-743.3c-0.3-0.2,0.2-1.6,1.4-2.9c1.2-1.4,2.8-1.8,2.9-1.4c0.2,0.4-0.8,1.2-1.8,2.4 C-130.1-744-131.2-743-131.5-743.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st146",
    d: "M-136.8-732.9c0,0-4.5-3.8-6.7-0.4c-2.2,3.4,9.7,5.2,9.7,5.2L-136.8-732.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M-245-388.2c0,0-6.5,2.8-8.1,4.5c-1.7,1.7-17.1,28.3-15.1,31.7s17.4-8.1,17.4-8.1S-263.8-357.6-245-388.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M-119.1-352.9c0,0-4.6,5-5.3,7.2c-0.7,2.3-2,33,1.3,35.1c3.3,2.1,12.3-14.9,12.3-14.9 S-121.6-317.1-119.1-352.9"
  }))))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st154",
    x1: -513.3,
    y1: -241,
    x2: -226.7,
    y2: -240.9
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M-534.6-1048.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H-534.6z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M-218.6-1048.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H-218.6z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st155",
    d: "M-314.7-229.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H-314.7z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M-136.2-283c-0.6-10.5-5.5-19.8-13-26.2c2-5,3-10.5,3-16.2c0-12.5-5.2-23.8-13.4-31.8 c1-3.3,1.5-6.8,1.3-10.4c-0.9-16.2-14.8-28.5-30.9-27.5c-16.2,0.9-28.5,14.8-27.5,30.9c0.1,0.9,0.2,1.8,0.3,2.7 c-11.3,8.1-18.6,21.3-18.6,36.2c0,6.7,1.5,13,4.1,18.7c-7.1,6-11.7,15-11.7,25.1c0,18.1,14.7,32.8,32.8,32.8c4.6,0,9-1,13-2.7 c6.9,5.5,15.8,8.6,25.4,8C-150.8-244.7-135-262.4-136.2-283z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M-169.1-285.6c-2,4.4-3.9,8.9-5.9,13.3c-1.9,4.4-3.9,8.9-5.8,13.3l-3.4,7.9l-5-75.3l1.7,72.8 c-0.7-2.3-1.4-4.6-2.1-6.9l-3.6-11.4l0.1-0.2l-0.2-0.1l-1-3.2c-3.2-9.9-6.4-19.8-9.9-29.7c2.7,10.1,5.6,20.1,8.5,30.1l0.5,1.6 l-22.5-13.4l23.2,15.8l3.3,10.9c1.2,4.2,2.6,8.4,3.9,12.6l0.4,18.1l4.1-0.2l-1.2-18.1l4.5-10.9c1.9-4.5,3.7-9,5.5-13.4 c1.8-4.5,3.7-9,5.5-13.5l5.3-13.5L-169.1-285.6z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st155",
    cx: -340.4,
    cy: -387.6,
    r: 46.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st155",
    cx: -316.7,
    cy: -329.4,
    r: 46.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st155",
    cx: -376,
    cy: -340.3,
    r: 44.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "-348.2,-280.9 -347.5,-282.7 -346.3,-323 -362.4,-339.5 -346.2,-325.8 -345,-365.2 -342.9,-293.1  -326.4,-330.8 -342.8,-288.8 -341.7,-252.6 -348.4,-252.6 -347.6,-280.6  "
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: -431.9,
    cy: -376.6,
    r: 42.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: -410.1,
    cy: -323.2,
    r: 42.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st153",
    cx: -464.6,
    cy: -333.1,
    r: 40.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st156",
    points: "-439.1,-278.6 -438.4,-280.2 -437.3,-317.3 -452.1,-332.4 -437.2,-319.8 -436.1,-356 -434.2,-289.8  -419.1,-324.4 -434.1,-285.9 -433.1,-252.6 -439.2,-252.6 -438.4,-278.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M3338.5-1979.6c0,0-145.1-177.2-60.8-269.7c84.4-92.4,710.9-322,786.3-292.9 c171.5,66.4,36.6,526.5-24.8,556.1L3338.5-1979.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M3568.7-2016.9c-4.7,6.9-26,7.7-29.7,2.6c-3.6-5.1-7.3-164.6-23.3-220.7c-9.8,16.8-4.5,214.4-8.6,219 c-1.8,2-33.8,9-35.7-2.4c-9.5-56.5-6.3-181.8-3.8-242c0.4-10.9,0.9-19.7,1.2-25.5c17.2,9.6,67.8,14.5,81.2,5.2 c0.3,0.7,0.5,1.4,0.8,2.2C3577-2204,3573.1-2023.4,3568.7-2016.9z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3507.6-1986.1h-56.4c0,0,0.6-16.8,10.7-17.6c1.8-0.1,3.4,0.1,4.8,0.6c6.1,2.2,7.5,9.4,7.5,9.4h31.8 C3506-1993.8,3507.8-1989.7,3507.6-1986.1z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3504.8-1993.8h-30.6c0,0-1.4-7.2-7.5-9.4c3.1-2.2,8.3-6.1,9.4-8.4c10.7-2.3,24.7-1.2,25.7,0 C3502.7-2010.3,3504.8-1993.8,3504.8-1993.8z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3470.9-2006.2c0,0,6.5,1.3,8.5,1c2-0.3,9.5-17.1,8.5-19c-1-2-12.3-1.2-13.3,0 C3473.6-2023,3473.2-2010.3,3470.9-2006.2z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3537.5-1986l56.4-0.3c0,0-0.7-16.8-10.8-17.5c-1.8-0.1-3.4,0.1-4.8,0.6c-6.1,2.2-7.5,9.4-7.5,9.4 l-31.8,0.2C3539.1-1993.6,3537.3-1989.5,3537.5-1986z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3540.2-1993.6l30.6-0.2c0,0,1.4-7.2,7.5-9.4c-3.1-2.2-8.4-6.1-9.4-8.4c-10.7-2.3-24.7-1.1-25.7,0.1 C3542.3-2010.2,3540.2-1993.6,3540.2-1993.6z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3574.2-2006.3c0,0-6.5,1.4-8.5,1.1c-2-0.3-9.5-17-8.6-19c1-2,12.3-1.2,13.3-0.1 C3571.3-2023.1,3571.8-2010.3,3574.2-2006.3z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M3486.3-2275.7c0,0,3.1,11.8-11.7,20.7"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M3538-2271.7c0,0,1,13.7,17.4,16.8"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M3479.3-2243.4c0,0-13.9,138.1,0,215.3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M3523.4-2235c0,0,25,139.6,20.3,218.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 3613.8003,
    y1: -2439.4927,
    x2: 3652.199,
    y2: -2508.4805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M3612.7-2460.1c0,0,21.2-25.3,22.8-28.1c1.6-2.8,5.4-17.8,10.7-18.8c5.3-1,11.1,2.5,12.7,6.6 c1.7,4.1-11.8,17.2-12.7,19.8c-0.9,2.6-24.6,35.3-24.6,35.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 1746.299,
    y1: -2736.3823,
    x2: 1784.6976,
    y2: -2805.3696,
    gradientTransform: "matrix(-0.9598 -0.2807 -0.2807 0.9598 4386.4604 633.9061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M3485.3-2502.2c0,0-13.2-30.2-14-33.4c-0.8-3.2-0.2-18.6-5-21c-4.8-2.4-11.3-0.7-14.1,2.8 c-2.7,3.5,6.5,19.8,6.7,22.5c0.1,2.8,13.7,40.8,13.7,40.8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3468.5-2277.8c-3-1.3-4.5-4.7-3.3-7.7c6.1-15.5,29.2-78.4,22.4-121.2c-7.8-49.1-20.8-99.1-20.8-99.1 l15.2-5.6c0,0,35.5,88.3,45.7,97.8c10.2,9.4,32.4,4.4,41.1-3.3c8.7-7.7,42.1-44.2,42.1-44.2l13.5,15.7c0,0-52.5,75.9-60.7,99.3 c-8.2,23.4,1.5,79.7-8.7,80.7C3546.2-2264.4,3484.8-2270.8,3468.5-2277.8z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M3580.6-2441c0,0-1.9,1.7-9.1,2.4c-0.1,0-0.2,0-0.3,0c-17.1,1.5-25.6-14.5-29.1-14.5 c-3.5,0-2.2,10.8-2.6,15.4c-0.3,3-3.5,5.9-5.6,7.5c0,0,0,0,0,0c-1.1,0.8-2,1.4-2,1.4c1.1-16.1-12.2-29.7-8.9-38.8 c3.3-9.1,10.6-8.7,10.6-8.7s-1.3-7.1,2.6-9.9c3.9-2.8,14.1-3.5,22.1,6.1C3598.9-2484.7,3580.6-2441,3580.6-2441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 3529.8071,
    y1: -2425.8291,
    x2: 3571.5601,
    y2: -2425.8291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M3571.6-2438.7c-1.7,6-7.3,21.7-19.6,24.3c-5.4,5.8-2.8,15.5-11.3,15.9c-8.5,0.4-13.1-4.6-9.9-12.8 c2.1-5.4,2.9-13.8,3.2-19c0,0,0,0,0,0c2.2-1.6,5.3-4.5,5.6-7.5c0.4-4.6-0.9-15.4,2.6-15.4c3.5,0,12,16,29.1,14.5 C3571.4-2438.7,3571.5-2438.7,3571.6-2438.7z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3606.9-2461.1c0,0,14.5,21.2,17.4,21.5c2.8,0.3,6.4-5,5.7-8.3c-0.7-3.3-13.8-18.4-17.1-18.4 C3609.6-2466.3,3605.8-2462.7,3606.9-2461.1z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3463.2-2500.4c0,0,24.9-6.1,26.2-8.6c1.3-2.5-2.5-7.8-5.7-8.3c-3.3-0.5-22.1,6.4-23.2,9.5 C3459.3-2504.9,3461.3-2500,3463.2-2500.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3778.6-2024.3c-0.5,4-29.9,4.1-31.2,0c-1.3-4.1-40.4-197-40.4-197l-33.6,197c0,0-29.6,2.3-29.6-6.8 c0-9,18.4-240.1,18.6-242.5c2.3,4.7,7.1,8.5,15.8,10.7c19.1,4.8,49.6,2.5,62.7-18.4C3747.4-2271.2,3779.1-2028.3,3778.6-2024.3z"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "st161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3745.5-1986h69.7c0,0,0.6-2.5,0.2-5.4c-0.3-2.6-1.5-5.4-4.6-7c-6.6-3.4-31.8-15.8-37.3-21.5 c-5.5-5.8-4.4-8.3-7-8.4c0,0-15-1.2-16.7,1c-1.4,1.7-3.1,25.1-3.9,35.9C3745.6-1988.1,3745.5-1986,3745.5-1986z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3794.3-2009c0,0-6,5.8-9,6.6c-3,0.8-18.4-12.4-19.5-16.1c-1.1-3.7-2.3-18.2-2.3-18.2s9.3,0,12.6,0 s2.9,17.2,2.9,17.2S3795.7-2010.3,3794.3-2009z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3745.5-1986h69.7c0,0,0.6-2.5,0.2-5.4h-69.5C3745.6-1988.1,3745.5-1986,3745.5-1986z"
  }))), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M3715.3-2439.3c0,0,21.5-23.6,2-35.5c-16.2-15-19-14.8-31.6-12.4c-12.6,2.4-23.6,13.9-23,36 c0.7,22.1-30.8,39.9-24.7,63.1c6.1,23.2-22.3,65.2-15.6,86c6.7,20.8,34.1,40.5,49.7,27.3c15.6-13.2,22.1-135.2,22.1-135.2 l11.1-23.5L3715.3-2439.3z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M3732.6-2313.7c2.3,15.1,11.5,27.1,8.2,32.3c-13.1,20.9-43.6,23.2-62.7,18.4c-8.7-2.2-13.5-6-15.8-10.7 c-2.7-5.7-1.8-12.6,0.6-19.5c4.3-12.6,4.3-51.4-4.1-67.1c-8.5-15.7-18-21.4-13-28.5c5-7.2,39-34.3,39-34.3s41.5,7.6,45,8.8 c0.4,0.1,0.9,0.6,1.5,1.4c4.1,5.4,11.7,25.4,12.9,44.3c0.1,1.2,0.1,2.4,0.2,3.7C3744.8-2342.3,3728.7-2339.7,3732.6-2313.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 3680.9854,
    y1: -2431.3474,
    x2: 3717.3123,
    y2: -2431.3474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M3715.5-2464c0,0,4.8,20.2-1.1,34.5c-5.9,14.3-10.8,13.9-10.8,13.9s2.4,14.3-5,16.3 c-7.4,2-15.6,1.3-17.6-18.9c7.4-8.9,9.1-11.9,7.6-16.9c-1.5-5-0.7-11.7,5.4-11.1C3700.1-2445.6,3716.8-2443.2,3715.5-2464z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3660.5-2338.1c-0.3,0.3-0.6,0.6-0.9,0.9c-7.9,7.6-17.5,10.3-22,9.5c-1.2-0.2-2-0.7-2.4-1.3 c-2-3.3-2.4-60.4,12-61.3C3658.6-2391,3663.4-2368.7,3660.5-2338.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 3637.5117,
    y1: -2345.1184,
    x2: 3694.5354,
    y2: -2345.1184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st163",
    d: "M3691.6-2357.1c-1.1,5.9-24.6,66.4-43.8,58.1c-7.8-3.3-9.7-22.1-10.2-28.6c4.6,0.8,14.1-1.9,22-9.5 l-0.2,4.1c0,0,21.6-28.3,21.6-32.1s0.2-27.3,2.1-26.9c1.9,0.5,2.4,19.4,4.9,18.9c2.4-0.5,3.3-13.7,5.7-13.8 C3696.1-2387.1,3692.7-2363,3691.6-2357.1z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3762.8-2365.2c-0.6,0.6-1.3,1.1-2,1.4c-3.5,1.4-10.6-1.6-16.7-4.7c-1.2-18.9-8.8-38.9-12.9-44.3 c8.5,4.3,33.7,17.1,36.3,20.9c0.6,0.9,1,2.5,1.1,4.5C3769.1-2380.7,3766.9-2369.4,3762.8-2365.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 3762.7705,
    y1: -2378.9468,
    x2: 3841.3037,
    y2: -2378.9468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M3841.3-2394.8c0,0-23.6,35.4-46,41.2c-3,2-20.8-5.9-32.5-11.6c4.1-4.2,6.4-15.5,5.9-22.3 c5.4,2.9,20.3,10.8,23.6,11.9c4.1,1.4,47.9-29,47.9-29L3841.3-2394.8z"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "st161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3676.5-1986h-69.7c0,0-0.6-2.5-0.2-5.4c0.3-2.6,1.5-5.4,4.6-7c6.6-3.4,31.8-15.8,37.3-21.5 c5.5-5.8,4.4-8.3,7-8.4c0,0,15-1.2,16.7,1c1.4,1.7,3.1,25.1,3.9,35.9C3676.4-1988.1,3676.5-1986,3676.5-1986z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3627.7-2009c0,0,6,5.8,9,6.6c3,0.8,18.4-12.4,19.5-16.1c1.1-3.7,2.3-18.2,2.3-18.2s-9.3,0-12.6,0 c-3.2,0-2.9,17.2-2.9,17.2S3626.3-2010.3,3627.7-2009z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M3676.5-1986h-69.7c0,0-0.6-2.5-0.2-5.4h69.5C3676.4-1988.1,3676.5-1986,3676.5-1986z"
  })))), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M3673.4-2258.4c0,0,2.4,9.8-7.4,15.6"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st125",
    x1: 3673.4,
    y1: -2242.8,
    x2: 3654.3,
    y2: -2049.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st125",
    x1: 3711.2,
    y1: -2220.6,
    x2: 3755.2,
    y2: -2034.8
  }))), /*#__PURE__*/React.createElement("g", null, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3970.4-2034.8c-2.1,2.9-26,6-30.6,1.5c-4.6-4.4,0.3-68.5-4.8-87.7c-5.1-19.2-32.6-110.5-35.1-110.5 c-2.4,0-27.5,78.1-31.7,90.7c-4.2,12.6-54.7,106.9-56.5,108.5c-1.8,1.6-32.3,3-34.2-6.1c-2-9.1,43.4-102.4,48.4-141.9 c3.6-28.5,12.5-69.8,17.1-90.6c7.9,2,17.8,2.9,28.2,1.1c7.5-1.3,13.1-6.6,17-14.5c7.8,0.9,19.3-0.1,27.5-1.4 c0.1,4.7,0.4,7.8,1.1,8.8c3.6,5.4,16.2,3.5,24.4-0.9c7.8,29.1,25.9,96.7,32.1,116.4C3981.1-2136,3972.4-2037.7,3970.4-2034.8z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M4012-2459.3L4012-2459.3c-1.1,0-2-0.9-2-2v-44c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v44 C4014-2460.1,4013.1-2459.3,4012-2459.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 3927.7256,
    y1: -2407.7646,
    x2: 4059.8435,
    y2: -2469.376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st165",
    d: "M3957.4-2418.3c0,0,7.8,2.4,8.7,2.4c0.9,0,43.8-45.3,45.3-47.5c1.5-2.2,3.7-23.2,5.4-24.5s7.4,19,3.5,31.2 c-4.6,14.3-42.7,66.4-47.5,66.4c-4.8,0-27.1-4.6-27.1-4.6"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M3855.4-2429.5c0,0,3.9-24.1,28-22.8s22.3,18.5,22.3,18.5L3855.4-2429.5z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3916.5-2342.1c0,1.2,0,2.4,0,3.5c0,1.4,0,2.8-0.1,4.2c-0.1,3.6-0.1,7.1-0.2,10.6c0,0.5,0,1.1,0,1.6 c0,0.7,0,1.3,0,2c0,1.3-0.1,2.6-0.1,3.8c0,0.5,0,0.9,0,1.4c0,0.7,0,1.4-0.1,2.1c0,0.2,0,0.4,0,0.6c0,0.5,0,1,0,1.5 c0,1.2-0.1,2.4-0.1,3.6c0,0.5,0,1.1,0,1.6c-0.1,2.6-0.1,5.1-0.2,7.4c0,1.2,0,2.4-0.1,3.5v0.4c-0.1,3.2-0.1,6.1,0,8.6 c-8.2,1.4-19.7,2.3-27.5,1.4c0.2-0.4,0.4-0.8,0.6-1.3c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-0.9,0.6-1.4c0,0,0-0.1,0-0.1 c0.2-0.5,0.4-1.1,0.6-1.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.4,0.3-0.7,0.4-1.1c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.7,0.4-1.4,0.6-2 c0.2-0.6,0.3-1.2,0.5-1.7c0.2-0.6,0.3-1.1,0.5-1.7c0.1-0.3,0.1-0.6,0.2-0.9c0.2-1,0.5-2.1,0.7-3.1c0.1-0.5,0.2-1,0.3-1.5 c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.7,0.2-1.5,0.4-2.2c0.1-0.6,0.2-1.3,0.3-1.9c0.1-0.9,0.2-1.8,0.4-2.8c0.2-1.5,0.3-3,0.5-4.6 c0.1-0.8,0.1-1.5,0.2-2.3c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.2-2.3,0.3-4.6,0.4-6.9c0-0.1,0-0.2,0-0.2c0.2-6.6,0.1-13.4-0.3-20.1 c-0.2-2.7-0.3-5.5-0.6-8.2c-2.9-33.9-29.6-72.5-34.6-79.6c5.8-2.5,26-10.4,40-4.7C3914.6-2422,3916.8-2379.6,3916.5-2342.1z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M3916.8-2474.4c-2.1,1.1-4.1,1.9-6,2.5c-11,3.4-19.6-0.1-19.6-0.1c-3.3,0.6-3.3,13.2-4.8,13.2 c-1.5,0-1.5-5.2-4.8-7.7c-3.3-2.5-8.7,1.9-5.9,7.1c2.8,5.2,0,14.5,0,14.5s-0.5-1.7-1.7-4.1c0,0,0,0,0,0c-0.8-1.7-2-3.7-3.5-5.8 c-3.9-5.2-23.4-18-17.1-29.9c6.3-11.9,18.2-9.3,18.2-9.3s0.6-16.9,8.7-23.7c-3,4.6-3.9,14.3-3.9,14.3s7.8-13.9,17.8-13.2 c10,0.6,13.5,10.2,13.5,10.2s4.1-6.9,12.8-2.4C3929.2-2504.4,3930.5-2481.6,3916.8-2474.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 3835.678,
    y1: -2449.2947,
    x2: 3942.7383,
    y2: -2445.0645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st166",
    d: "M3908.3-2444.9c-2,5.9-10,5.2-11.1,4.8c-1.1-0.4,1.5,11.7-1.5,15.8c-3,4.1-17.4,4.3-17.6-4.6 c-0.2-8.6-3.8-19.5-4-20.2c1.2,2.5,1.7,4.1,1.7,4.1s2.8-9.3,0-14.5c-2.8-5.2,2.6-9.6,5.9-7.1c3.3,2.5,3.3,7.7,4.8,7.7 c1.5,0,1.5-12.6,4.8-13.2c0,0,8.6,3.4,19.6,0.1C3911.7-2463.1,3910-2449.9,3908.3-2444.9z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M3874.1-2449.1C3874.1-2449.1,3874.1-2449.1,3874.1-2449.1"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M3896-2324.8c0,0.1,0,0.2,0,0.2c-0.1,2.3-0.2,4.6-0.4,6.9c0,0,0,0,0,0c0,0,0,0.1,0,0.1 c-0.1,0.8-0.1,1.6-0.2,2.3c-0.1,1.5-0.3,3.1-0.5,4.6c-0.1,0.9-0.2,1.9-0.4,2.8c-0.1,0.6-0.2,1.3-0.3,1.9c-0.1,0.7-0.2,1.5-0.4,2.2 c-0.1,0.4-0.2,0.8-0.2,1.2c-0.1,0.5-0.2,1-0.3,1.5c-0.2,1.1-0.4,2.1-0.7,3.1c-0.1,0.3-0.2,0.6-0.2,0.9c-0.1,0.6-0.3,1.2-0.5,1.7 c-0.2,0.6-0.3,1.2-0.5,1.7c-0.2,0.7-0.4,1.4-0.6,2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.4-0.3,0.7-0.4,1.1c0,0.1-0.1,0.2-0.1,0.3 c-0.2,0.5-0.4,1.1-0.6,1.6c0,0,0,0.1,0,0.1c-0.2,0.5-0.4,1-0.6,1.4c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,0.4-0.4,0.8-0.6,1.3 c-3.9,7.9-9.4,13.2-17,14.5c-10.4,1.8-20.3,0.9-28.2-1.1c-9.7-2.4-16.4-6.6-17.1-9.6c-1.3-5.5,21.8-63.8,23.4-79.7 c1.6-15.9-8.8-46.2-7.2-54c1.3-6.2,7.3-14.4,13.1-17.9c1.1-0.6,2.2-1.1,3.2-1.4h0c0.4-0.1,0.9-0.2,1.3-0.2c0,0,0.1,0.2,0.3,0.4 c0.1,0.2,0.3,0.4,0.5,0.7c5,7,31.7,45.7,34.6,79.6c0.2,2.7,0.4,5.5,0.6,8.2C3896.1-2338.1,3896.2-2331.3,3896-2324.8z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3864.4-2347.2L3864.4-2347.2c0,0.4-0.1,0.6-0.2,0.6c0,0-0.1,0.1-0.3,0.1c-2.2,0.5-17.6,1.3-26.5,0.4 c-3.5-0.4-6-1-6.2-2.1c-0.6-3.9,4.9-62.8,10.7-66.1c0,0,15.9,4.6,18.8,17.2C3863.7-2385.2,3865-2352.3,3864.4-2347.2z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M3948.1-2284.7c-0.7,2.5-3.5,5-7.1,6.9c-8.2,4.4-20.8,6.3-24.4,0.9c-0.7-1-1-4.1-1.1-8.8c0-2.4,0-5.3,0-8.6 v-0.4c0-1.1,0-2.3,0.1-3.5c0.1-2.3,0.1-4.8,0.2-7.4c0-0.5,0-1.1,0-1.6c0-1.2,0.1-2.3,0.1-3.6c0-0.5,0-1,0-1.5c0-0.2,0-0.4,0-0.6 c0-0.7,0-1.4,0.1-2.1c0-0.5,0-0.9,0-1.4c0-1.3,0.1-2.5,0.1-3.8c0-0.7,0-1.3,0-2c0-0.5,0-1.1,0-1.6c0.1-3.4,0.1-7,0.2-10.6 c0-1.4,0-2.8,0.1-4.2c0-1.2,0-2.4,0-3.5c0.2-37.4-2-79.9-16-95.2c-0.2-0.2-0.4-0.5-0.7-0.7c-0.8-0.8-1.6-1.5-2.5-2.1 c0.2,0.1,2.6,1,5.9,2.6c0.8,0.4,1.6,0.8,2.5,1.3c0,0,0,0,0,0c1,0.5,2.1,1.1,3.2,1.8c5.7,3.3,12,7.8,14.8,12.9 c2,3.7,3.4,15.1,4.7,29.2c2.4,26.7,4.5,62.9,9.6,74.2C3945.9-2301,3950.4-2292.9,3948.1-2284.7z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3960-2419.3c-1.5,9.8-9.2,30.8-11.2,30.8c-1.6,0-14.2-1.6-20.3-3.9c-1.3-14.1-2.7-25.5-4.7-29.2 c-3.4-6.1-11.6-11.3-18-14.7C3906.3-2436.2,3927.4-2433.5,3960-2419.3z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M3905.7-2436.3C3905.7-2436.3,3905.7-2436.3,3905.7-2436.3"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M3895.6-2317.6c1.6-24.1-43.4-101.1-44.3-105.4c-0.6-3,2.1-6.9,3.9-9.1c1.1-0.6,2.2-1.1,3.2-1.4h0l1.6,0.2 c0.1,0.2,0.3,0.4,0.5,0.7c5,7,31.7,45.7,34.6,79.6C3896.1-2341.3,3896.4-2329,3895.6-2317.6z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M3916.2-2323.8c0.9-40.7,0.7-95.6-15.8-113.5c-0.2-0.2-0.4-0.5-0.7-0.7c0.8,0,2,0.1,3.4,0.5 c1.7,0.5,3.7,1.4,5.7,3c3.4,2.7,6.8,7.6,9,16.2C3923-2398.2,3921.7-2333.7,3916.2-2323.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 3901.5449,
    y1: -2415.811,
    x2: 3779.8406,
    y2: -2186.7207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st167",
    d: "M3898.7-2380c-1.2,35.9-32.5,87.1-53.7,76.4c-6.6-3.4-7.4-35-7.5-42.5c8.8,0.9,24.2,0.1,26.5-0.4 c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1-0.3,0.2-0.6v0c3.2-5.5,18.8-32,20.1-34.8c1.5-3.1,0.5-12.8,0.4-16.7c-0.1-3.9,1.2-17.5,2.5-17 c1.3,0.4,0.9,15.7,1.8,15.5c1-0.2,4-18.2,5-18c1,0.2-0.8,20-0.5,22C3893.9-2394.2,3899-2389.7,3898.7-2380z"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3775.4-1986h79.6c0,0,0.7-2.9,0.2-6.2c-0.4-2.9-1.7-6.1-5.2-8c-7.5-3.9-36.4-18-42.6-24.6 c-6.3-6.6-5-9.5-8-9.7c0,0-17.1-1.4-19.1,1.2c-1.6,1.9-3.6,28.7-4.4,41.1C3775.6-1988.4,3775.4-1986,3775.4-1986z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3831.2-2012.3c0,0-6.9,6.6-10.3,7.5c-3.4,0.9-21-14.2-22.3-18.4c-1.3-4.2-2.7-20.8-2.7-20.8 s10.7,0,14.4,0c3.7,0,3.3,19.6,3.3,19.6S3832.9-2013.7,3831.2-2012.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3775.4-1986h79.6c0,0,0.7-2.9,0.2-6.2h-79.5C3775.6-1988.4,3775.4-1986,3775.4-1986z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3934.9-1986h79.6c0,0,0.7-2.9,0.2-6.2c-0.4-2.9-1.7-6.1-5.2-8c-7.5-3.9-36.4-18-42.6-24.6 c-6.3-6.6-5-9.5-8-9.7c0,0-17.1-1.4-19.1,1.2c-1.6,1.9-3.6,28.7-4.4,41.1C3935-1988.4,3934.9-1986,3934.9-1986z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M3990.7-2012.3c0,0-6.9,6.6-10.3,7.5c-3.4,0.9-21-14.2-22.3-18.4c-1.3-4.2-2.7-20.8-2.7-20.8 s10.7,0,14.4,0c3.7,0,3.3,19.6,3.3,19.6S3992.3-2013.7,3990.7-2012.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3934.9-1986h79.6c0,0,0.7-2.9,0.2-6.2h-79.4C3935-1988.4,3934.9-1986,3934.9-1986z"
  }))), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M3845.9-2284c0,0-1.2,5-3,13.1"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M3868.1-2264.2c0,0-1.5,13.3-15.9,15"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M3860.5-2244.1c0,0-16.8,84-23,95.7c-6.2,11.7-46.2,104.5-46.2,104.5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M3908.8-2228.5c0,0,38.7,91.2,40,105.5c1.3,14.3,0,79.1,0,79.1"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3370.2,
    y: -2012.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 6757.1069 -3999.3625)",
    className: "st168",
    width: 16.7,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3307.5,
    y: -2014.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 6631.7383 -4001.2119)",
    className: "st168",
    width: 16.7,
    height: 28.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3606,
    y: -2020,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 7228.7715 -4006.4963)",
    className: "st168",
    width: 16.7,
    height: 33.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3543.3,
    y: -2022.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 7103.4033 -4008.8457)",
    className: "st168",
    width: 16.7,
    height: 35.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M3381-2244.1c4.3,25.7,13.7,63,18.8,82.6c2.1,8.1,3.5,13.2,3.5,13.2l1.6,2l36.3,47.5h83.6 c0,0,0.9-28,0.8-60.9c0-2.9,0-5.8-0.1-8.7c-0.4-42.7-2.8-90-11.2-94.6c-15.6-8.4-124.6-13.4-133.9-8.4c-0.3,0.1-0.5,0.4-0.7,0.7 C3377.9-2267.7,3378.7-2257.5,3381-2244.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3503.4,
    y1: -2231.7,
    x2: 3497,
    y2: -2225.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3497,
    y1: -2231.7,
    x2: 3503.4,
    y2: -2225.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3477.2,
    y1: -2231.7,
    x2: 3470.9,
    y2: -2225.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3470.9,
    y1: -2231.7,
    x2: 3477.2,
    y2: -2225.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3451.1,
    y1: -2231.7,
    x2: 3444.7,
    y2: -2225.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3444.7,
    y1: -2231.7,
    x2: 3451.1,
    y2: -2225.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3424.9,
    y1: -2231.7,
    x2: 3418.6,
    y2: -2225.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3418.6,
    y1: -2231.7,
    x2: 3424.9,
    y2: -2225.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3504.9,
    y1: -2206.6,
    x2: 3498.5,
    y2: -2200.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3498.5,
    y1: -2206.6,
    x2: 3504.9,
    y2: -2200.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3478.7,
    y1: -2206.6,
    x2: 3472.4,
    y2: -2200.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3472.4,
    y1: -2206.6,
    x2: 3478.7,
    y2: -2200.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3452.6,
    y1: -2206.6,
    x2: 3446.2,
    y2: -2200.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3446.2,
    y1: -2206.6,
    x2: 3452.6,
    y2: -2200.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3426.4,
    y1: -2206.6,
    x2: 3420.1,
    y2: -2200.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3420.1,
    y1: -2206.6,
    x2: 3426.4,
    y2: -2200.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3506.4,
    y1: -2181.5,
    x2: 3500,
    y2: -2175.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3500,
    y1: -2181.5,
    x2: 3506.4,
    y2: -2175.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3480.2,
    y1: -2181.5,
    x2: 3473.9,
    y2: -2175.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3473.9,
    y1: -2181.5,
    x2: 3480.2,
    y2: -2175.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3454.1,
    y1: -2181.5,
    x2: 3447.7,
    y2: -2175.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3447.7,
    y1: -2181.5,
    x2: 3454.1,
    y2: -2175.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3427.9,
    y1: -2181.5,
    x2: 3421.6,
    y2: -2175.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3421.6,
    y1: -2181.5,
    x2: 3427.9,
    y2: -2175.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3507.9,
    y1: -2156.4,
    x2: 3501.5,
    y2: -2150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3501.5,
    y1: -2156.4,
    x2: 3507.9,
    y2: -2150
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3475.4,
    y1: -2156.4,
    x2: 3481.7,
    y2: -2150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3481.7,
    y1: -2156.4,
    x2: 3475.4,
    y2: -2150
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3455.6,
    y1: -2156.4,
    x2: 3449.2,
    y2: -2150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3449.2,
    y1: -2156.4,
    x2: 3455.6,
    y2: -2150
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3429.4,
    y1: -2156.4,
    x2: 3423.1,
    y2: -2150
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3423.1,
    y1: -2156.4,
    x2: 3429.4,
    y2: -2150
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3509.4,
    y1: -2131.3,
    x2: 3503,
    y2: -2124.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3503,
    y1: -2131.3,
    x2: 3509.4,
    y2: -2124.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3483.2,
    y1: -2131.3,
    x2: 3476.9,
    y2: -2124.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3476.9,
    y1: -2131.3,
    x2: 3483.2,
    y2: -2124.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3457.1,
    y1: -2131.3,
    x2: 3450.7,
    y2: -2124.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3450.7,
    y1: -2131.3,
    x2: 3457.1,
    y2: -2124.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3430.9,
    y1: -2131.3,
    x2: 3424.6,
    y2: -2124.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 3424.6,
    y1: -2131.3,
    x2: 3430.9,
    y2: -2124.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M3336-2155.9c6.6-1.2,13.6,0.7,19.8,3.9c8.4,4.4,15.3,11.3,17.4,16.3c0.5,1.2,1.2,3.5,2.1,6.6 c7.8,27.3,28,117.8,28,117.8s46.5,0,98.6-1c67-1.2,143.2-3.8,141.9-9.7c-2.3-9.8-18.4-102.7-46-130.1c-1.7-1.6-3.4-3.1-5.1-4.2 c-25.7-16.9-57.6-13.6-67.2-12.1c0,2.9,0,5.8,0,8.7c34,3.6,42.6,43.8,44.8,68c0.9,9.7,0.7,16.8,0.6,18.1c0,0.1,0,0.2,0,0.2h-112.1 c0,0-2.4-11.4-6.7-25.4c-5.3-17.6-13.4-39.2-22.9-47.2c-8.6-7.3-17.7-12-26.9-14.8c-0.9-0.3-1.7-0.5-2.6-0.7 c-16.8-4.5-33.4-2.9-46.5,0.2C3346.3-2159.7,3340.4-2157.7,3336-2155.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M3300-2014.3l103.3,2.9c0,0-24.9-112-30.1-124.4c-3.6-8.7-21.7-23.1-37.2-20.2c-3.1,0.6-6,1.8-8.7,3.9 c0,0,0,0,0,0c-3.3,2.5-6.2,6.3-8.6,11.6C3304.4-2108.2,3300-2014.3,3300-2014.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M3353.3-2161.4c13.1-3.1,29.7-4.7,46.5-0.2c-7.8-29.8-25.4-100.4-20-109c-10.2,2.1-37.5,9.4-40.8,28 C3336.4-2229.1,3345.5-2190.5,3353.3-2161.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M3452.1-2098.8c4.2,14,6.7,25.4,6.7,25.4h112.1c0,0,0-0.1,0-0.2c-13.3-11.5-46.2-25.2-46.2-25.2H3452.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M3524.8-2098.8c0,0,32.9,13.7,46.2,25.2c0.2-4.4,2.1-81-45.4-86.1c0-2.9,0-5.8-0.1-8.7L3524.8-2098.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3381-2244.1c4.3,25.7,13.7,63,18.8,82.6c0.9,0.2,1.7,0.5,2.6,0.7c9.1,2.8,18.3,7.5,26.9,14.8 c9.5,8.1,17.6,29.7,22.9,47.2h67.2L3381-2244.1z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M4077.3-2082.4c0,0-3.7-29.5-19-41.6c-15.2-12.2-16.3-31.1-16.3-31.1s-20.7,71.8,5.8,85 C4074.3-2057.1,4077.3-2082.4,4077.3-2082.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M4042.1-2155.2c0,0-7.1,63.3,32,93.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M4084.1-2419.1c0,0,38.1,124.3,9.3,231.5c-28.9,107.2,10.8,146.6,10.8,146.6l-30.1-30.2 c0,0-12.8-94.9-9.6-143.2l9.6-4.9l-10.2-8.6C4064-2227.8,4090.7-2338.7,4084.1-2419.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4084.1-2419.1c3,14.2,5.3,28.5,7.4,42.9c2,14.4,3.6,28.8,4.6,43.3c0.1,1.8,0.3,3.6,0.4,5.4l0.3,5.4 c0.2,3.6,0.4,7.2,0.5,10.9c0.2,7.3,0.4,14.5,0.3,21.8l0,5.4l0,2.7l-0.1,2.7l-0.5,10.9c0,0.9-0.1,1.8-0.1,2.7l-0.2,2.7l-0.5,5.4 c-0.4,3.6-0.6,7.2-1.2,10.8l-1.6,10.8c-0.5,3.6-1.2,7.2-1.8,10.7c-0.6,3.6-1.2,7.2-1.8,10.7c-0.6,3.6-1.2,7.2-1.7,10.8 c-2.2,14.3-4.2,28.7-5.7,43.2c-0.4,3.6-0.7,7.2-1,10.8c-0.3,3.6-0.5,7.2-0.7,10.9c-0.3,7.2-0.6,14.5-0.4,21.8 c0,7.3,0.5,14.5,1.2,21.7c0.7,7.2,1.8,14.4,3,21.5c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2-0.1-0.3-0.2l0,0c-1.2-7.2-2.3-14.3-3-21.6 c-0.7-7.2-1.1-14.5-1.1-21.8c-0.1-7.3,0.1-14.5,0.5-21.8c0.3-3.6,0.5-7.2,0.8-10.9c0.3-3.6,0.6-7.2,1-10.8 c1.5-14.4,3.5-28.8,5.7-43.2c0.5-3.6,1.2-7.2,1.7-10.8s1.2-7.2,1.8-10.7c0.6-3.6,1.3-7.2,1.8-10.7l1.6-10.8 c0.6-3.6,0.8-7.2,1.2-10.8l0.5-5.4l0.3-2.7c0.1-0.9,0.1-1.8,0.1-2.7l0.5-10.9l0.1-2.7l0-2.7l0.1-5.4c0.2-7.3-0.1-14.5-0.2-21.8 c-0.1-3.6-0.3-7.3-0.5-10.9l-0.3-5.4c-0.1-1.8-0.3-3.6-0.4-5.4c-1-14.5-2.6-28.9-4.6-43.3 C4089.4-2390.6,4087.1-2404.9,4084.1-2419.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M4082.1-2071.2c0,0-8.1-76.3,7.2-106.1h9.9l-5.9-10.4c0,0,32.1-70.2,121.9-97.6c0,0-56.7,37.5-79.8,107 c-10.9-2.7-18.7-2.2-18.7-2.2l8.2,10.8c0,0-33.4,54.2-28.9,104.8S4082.1-2071.2,4082.1-2071.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M4215.3-2285.2c0,0-138.6,56.5-127.8,212.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "4027.9,-2060.1 4028.4,-2047.6 4039.2,-1986 4108.2,-1986 4119.1,-2047.6 4120.3,-2054.7  4068,-2057.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M4014.9-2072.6v21.4c0,2,1.7,3.7,3.7,3.7h113.1c2.4,0,4.2-2.3,3.6-4.7l-5.8-21.4c-0.4-1.6-1.9-2.7-3.6-2.7 h-107.3C4016.6-2076.4,4014.9-2074.7,4014.9-2072.6z"
  }))), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M4149.5-1973.2h-865.4c-3.5,0-6.4-2.9-6.4-6.4l0,0c0-3.5,2.9-6.4,6.4-6.4h865.4c3.5,0,6.4,2.9,6.4,6.4l0,0 C4155.9-1976.1,4153-1973.2,4149.5-1973.2z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3312.7,
    y: -2353.3,
    className: "st44",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3336,
    y: -2329.4,
    className: "st168",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3983.2,
    y: -2341.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 8026.5659 -4666.3228)",
    className: "st44",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3960,
    y: -2317.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 7980.0962 -4618.5962)",
    className: "st168",
    width: 60.2,
    height: 16.3
  }))), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3462.4-1991.4"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3392.9-1991.4"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2206.4-584.6c0.2-0.1,1.2,1.2,2.6,3.8c1.5,2.6,3.3,6.5,5,11.5c3.5,10.1,5.7,24.9,4.4,41.1 c-1.3,16.2-5,30.4-7.9,40.6c-3,10.1-5.1,16.3-5.5,16.2c-0.4-0.1,1.1-6.5,3.5-16.7c2.4-10.2,5.7-24.4,7-40.2 c1.3-15.9-0.5-30.3-3.4-40.3C2209.2-578.6,2205.9-584.3,2206.4-584.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2216.4-665.7c0.2-0.1,1.4,2.1,3.4,6.2c2,4.1,4.8,10,8.2,17.4c6.6,14.8,15.5,35.4,22,59.4 c3.2,12,5.3,23.7,6.4,34.4c1.1,10.7,1.2,20.5,0.7,28.6c-0.5,8.1-1.6,14.7-2.6,19.1c-1,4.4-1.8,6.8-1.9,6.8 c-0.5-0.1,1.9-9.9,2.4-26c0.6-16.1-1.5-38.4-7.9-62.1c-6.4-23.7-14.9-44.4-21-59.4c-3.1-7.5-5.6-13.5-7.3-17.7 C2217-663.2,2216.2-665.6,2216.4-665.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1846.8-570.5c0.3,0.4-3,3.6-7.4,9.5c-1.1,1.5-2.3,3.1-3.4,5c-1.2,1.8-2.2,3.9-3.4,6 c-2.2,4.3-4.2,9.3-5.8,14.7c-1.5,5.4-2.4,10.7-2.9,15.5c-0.1,2.4-0.4,4.7-0.3,6.9c-0.1,2.2,0.1,4.2,0.2,6 c0.5,7.4,1.7,11.9,1.2,12c-0.3,0.1-2.2-4.2-3.3-11.8c-0.3-1.9-0.5-3.9-0.6-6.2c-0.2-2.2,0-4.6,0-7.1c0.3-5,1.2-10.5,2.8-16.1 c1.6-5.6,3.9-10.7,6.2-15.1c1.3-2.2,2.4-4.3,3.8-6.1c1.2-1.9,2.5-3.5,3.8-4.9C1842.7-568,1846.6-570.7,1846.8-570.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1854.7-544.5c0.2,0.4-1.6,1.8-4.1,4.6c-1.2,1.4-2.5,3.1-3.8,5.1c-1.2,2.1-2.4,4.4-3.3,7 c-0.9,2.6-1.4,5.2-1.7,7.6c-0.2,2.4-0.3,4.6-0.2,6.4c0.2,3.7,0.8,5.9,0.4,6.1c-0.3,0.1-1.7-2-2.5-5.8c-0.4-1.9-0.6-4.3-0.5-6.9 c0.2-2.6,0.7-5.5,1.6-8.3c1-2.9,2.4-5.4,3.9-7.6c1.5-2.1,3.1-3.9,4.6-5.1C1852.2-544,1854.6-544.8,1854.7-544.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1745.3-786.5c0.2-0.1,1.5,1.2,3.8,3.7c1.2,1.2,2.5,2.8,4,4.7c1.5,1.9,3.2,4,4.9,6.5 c0.9,1.2,1.7,2.6,2.7,3.9c0.9,1.4,1.8,2.9,2.7,4.4c1.9,3,3.6,6.4,5.5,10c3.5,7.2,6.8,15.4,9.5,24.2c2.6,8.9,4.2,17.5,5.2,25.5 c0.4,4,0.8,7.8,0.8,11.3c0,1.8,0.2,3.5,0.1,5.1c0,1.6-0.1,3.2-0.1,4.7c0,3-0.3,5.7-0.5,8.1c-0.2,2.4-0.5,4.4-0.8,6.1 c-0.6,3.3-1,5.1-1.2,5.1c-0.5-0.1,0.5-7.4,0.4-19.4c0-1.5-0.1-3-0.1-4.7c0-1.6-0.2-3.3-0.3-5.1c-0.1-3.5-0.7-7.2-1.1-11.1 c-1.1-7.8-2.8-16.3-5.3-25c-2.6-8.7-5.8-16.7-9.1-23.9c-1.8-3.5-3.3-6.9-5.1-9.9c-0.9-1.5-1.6-3-2.5-4.4c-0.9-1.4-1.7-2.7-2.5-4 C1749.7-780.5,1744.9-786.1,1745.3-786.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1778.8-772.6c0.3-0.2,3.7,3,8,9.1c2.2,3.1,4.5,6.9,6.7,11.3c2.2,4.5,4.2,9.5,5.9,15 c1.6,5.5,2.6,10.9,3.2,15.8c0.5,4.9,0.7,9.4,0.5,13.2c-0.3,7.5-1.4,12-1.8,12c-0.5-0.1-0.1-4.6-0.3-12c-0.1-3.7-0.5-8-1.1-12.8 c-0.7-4.8-1.8-10-3.4-15.3c-1.6-5.3-3.5-10.3-5.5-14.7c-2-4.4-4.1-8.2-6-11.4C1781.2-768.7,1778.4-772.3,1778.8-772.6z"
  }))))), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M1512.4-1028.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H1512.4z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1828.4-1028.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H1828.4z"
  })), /*#__PURE__*/React.createElement("g", null, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M1551.5-381.6c0,0-145.1-177.2-60.8-269.7c84.4-92.4,710.9-322,786.3-292.9 c171.5,66.4,36.6,526.5-24.8,556.1L1551.5-381.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1781.7-418.9c-4.7,6.9-26,7.7-29.7,2.6c-3.6-5.1-7.3-164.6-23.3-220.7c-9.8,16.8-4.5,214.4-8.6,219 c-1.8,2-33.8,9-35.7-2.4c-9.5-56.5-6.3-181.8-3.8-242c0.4-10.9,0.9-19.7,1.2-25.5c17.2,9.6,67.8,14.5,81.2,5.2 c0.3,0.7,0.5,1.4,0.8,2.2C1790-606,1786.1-425.4,1781.7-418.9z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1720.6-388.1h-56.4c0,0,0.6-16.8,10.7-17.6c1.8-0.1,3.4,0.1,4.8,0.6c6.1,2.2,7.5,9.4,7.5,9.4h31.8 C1719-395.8,1720.8-391.7,1720.6-388.1z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1717.8-395.8h-30.6c0,0-1.4-7.2-7.5-9.4c3.1-2.2,8.3-6.1,9.4-8.4c10.7-2.3,24.7-1.2,25.7,0 C1715.7-412.3,1717.8-395.8,1717.8-395.8z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1683.9-408.2c0,0,6.5,1.3,8.5,1c2-0.3,9.5-17.1,8.5-19c-1-2-12.3-1.2-13.3,0 C1686.6-425,1686.2-412.3,1683.9-408.2z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1750.5-388l56.4-0.3c0,0-0.7-16.8-10.8-17.5c-1.8-0.1-3.4,0.1-4.8,0.6c-6.1,2.2-7.5,9.4-7.5,9.4l-31.8,0.2 C1752.1-395.6,1750.3-391.5,1750.5-388z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1753.2-395.6l30.6-0.2c0,0,1.4-7.2,7.5-9.4c-3.1-2.2-8.4-6.1-9.4-8.4c-10.7-2.3-24.7-1.1-25.7,0.1 C1755.3-412.2,1753.2-395.6,1753.2-395.6z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1787.2-408.3c0,0-6.5,1.4-8.5,1.1c-2-0.3-9.5-17-8.6-19c1-2,12.3-1.2,13.3-0.1 C1784.3-425.1,1784.8-412.3,1787.2-408.3z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M1699.3-677.7c0,0,3.1,11.8-11.7,20.7"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M1751-673.7c0,0,1,13.7,17.4,16.8"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M1692.3-645.4c0,0-13.9,138.1,0,215.3"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M1736.4-637c0,0,25,139.6,20.3,218.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 1826.8003,
    y1: -841.4928,
    x2: 1865.199,
    y2: -910.4803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M1825.7-862.1c0,0,21.2-25.3,22.8-28.1c1.6-2.8,5.4-17.8,10.7-18.8c5.3-1,11.1,2.5,12.7,6.6 c1.7,4.1-11.8,17.2-12.7,19.8c-0.9,2.6-24.6,35.3-24.6,35.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 3012.8921,
    y1: -701.0283,
    x2: 3051.2908,
    y2: -770.0156,
    gradientTransform: "matrix(-0.9598 -0.2807 -0.2807 0.9598 4386.4604 633.9061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M1698.3-904.2c0,0-13.2-30.2-14-33.4c-0.8-3.2-0.2-18.6-5-21c-4.8-2.4-11.3-0.7-14.1,2.8 c-2.7,3.5,6.5,19.8,6.7,22.5c0.1,2.8,13.7,40.8,13.7,40.8"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1681.5-679.8c-3-1.3-4.5-4.7-3.3-7.7c6.1-15.5,29.2-78.4,22.4-121.2c-7.8-49.1-20.8-99.1-20.8-99.1 l15.2-5.6c0,0,35.5,88.3,45.7,97.8c10.2,9.4,32.4,4.4,41.1-3.3c8.7-7.7,42.1-44.2,42.1-44.2l13.5,15.7c0,0-52.5,75.9-60.7,99.3 c-8.2,23.4,1.5,79.7-8.7,80.7C1759.2-666.4,1697.8-672.8,1681.5-679.8z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1793.6-843c0,0-1.9,1.7-9.1,2.4c-0.1,0-0.2,0-0.3,0c-17.1,1.5-25.6-14.5-29.1-14.5 c-3.5,0-2.2,10.8-2.6,15.4c-0.3,3-3.5,5.9-5.6,7.5c0,0,0,0,0,0c-1.1,0.8-2,1.4-2,1.4c1.1-16-12.2-29.7-8.9-38.8 c3.3-9.1,10.6-8.7,10.6-8.7s-1.3-7.1,2.6-9.9c3.9-2.8,14.1-3.5,22.1,6.1C1811.9-886.7,1793.6-843,1793.6-843z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 1742.8073,
    y1: -827.829,
    x2: 1784.5602,
    y2: -827.829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M1784.6-840.7c-1.7,6-7.3,21.7-19.6,24.3c-5.4,5.8-2.8,15.5-11.3,15.9c-8.5,0.4-13.1-4.6-9.9-12.8 c2.1-5.4,2.9-13.8,3.2-19c0,0,0,0,0,0c2.2-1.6,5.3-4.5,5.6-7.5c0.4-4.6-0.9-15.4,2.6-15.4c3.5,0,12,16,29.1,14.5 C1784.4-840.7,1784.5-840.7,1784.6-840.7z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1819.9-863.1c0,0,14.5,21.2,17.4,21.5c2.8,0.3,6.4-5,5.7-8.3c-0.7-3.3-13.8-18.4-17.1-18.4 C1822.6-868.3,1818.8-864.7,1819.9-863.1z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1676.2-902.4c0,0,24.9-6.1,26.2-8.6c1.3-2.5-2.5-7.8-5.7-8.3c-3.3-0.5-22.1,6.4-23.2,9.5 C1672.3-906.9,1674.3-902,1676.2-902.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1991.6-426.3c-0.5,4-29.9,4.1-31.2,0c-1.3-4.1-40.4-197-40.4-197l-33.6,197c0,0-29.6,2.3-29.6-6.8 c0-9,18.4-240.1,18.6-242.5c2.3,4.7,7.1,8.5,15.8,10.7c19.1,4.8,49.6,2.5,62.7-18.4C1960.4-673.2,1992.1-430.3,1991.6-426.3z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "st161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1958.5-388h69.7c0,0,0.6-2.5,0.2-5.4c-0.3-2.6-1.5-5.4-4.6-7c-6.6-3.4-31.8-15.8-37.3-21.5 c-5.5-5.8-4.4-8.3-7-8.4c0,0-15-1.2-16.7,1c-1.4,1.7-3.1,25.1-3.9,35.9C1958.6-390.1,1958.5-388,1958.5-388z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M2007.3-411c0,0-6,5.8-9,6.6c-3,0.8-18.4-12.4-19.5-16.1c-1.1-3.7-2.3-18.2-2.3-18.2s9.3,0,12.6,0 s2.9,17.2,2.9,17.2S2008.7-412.3,2007.3-411z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1958.5-388h69.7c0,0,0.6-2.5,0.2-5.4h-69.5C1958.6-390.1,1958.5-388,1958.5-388z"
  }))), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1928.3-841.3c0,0,21.5-23.6,2-35.5c-16.2-15-19-14.8-31.6-12.4c-12.6,2.4-23.6,13.9-23,36 c0.7,22.1-30.8,39.9-24.7,63.1c6.1,23.2-22.3,65.2-15.6,86c6.7,20.8,34.1,40.5,49.7,27.3c15.6-13.2,22.1-135.2,22.1-135.2 l11.1-23.5L1928.3-841.3z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1945.6-715.7c2.3,15.1,11.5,27.1,8.2,32.3c-13.1,20.9-43.6,23.2-62.7,18.4c-8.7-2.2-13.5-6-15.8-10.7 c-2.7-5.7-1.8-12.6,0.6-19.5c4.3-12.6,4.3-51.4-4.1-67.1c-8.5-15.7-18-21.4-13-28.5c5-7.2,39-34.3,39-34.3s41.5,7.6,45,8.8 c0.4,0.1,0.9,0.6,1.5,1.4c4.1,5.4,11.7,25.4,12.9,44.3c0.1,1.2,0.1,2.4,0.2,3.7C1957.8-744.3,1941.7-741.7,1945.6-715.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 1893.9855,
    y1: -833.3474,
    x2: 1930.3124,
    y2: -833.3474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M1928.5-866c0,0,4.8,20.2-1.1,34.5c-5.9,14.3-10.8,13.9-10.8,13.9s2.4,14.3-5,16.3 c-7.4,2-15.6,1.3-17.6-18.9c7.4-8.9,9.1-11.9,7.6-16.9s-0.7-11.7,5.4-11.1C1913.1-847.6,1929.8-845.2,1928.5-866z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1873.5-740.1c-0.3,0.3-0.6,0.6-0.9,0.9c-7.9,7.6-17.5,10.3-22,9.5c-1.2-0.2-2-0.7-2.4-1.3 c-2-3.2-2.4-60.4,12-61.3C1871.6-793,1876.4-770.7,1873.5-740.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 1850.5117,
    y1: -747.1185,
    x2: 1907.5354,
    y2: -747.1185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M1904.6-759.1c-1.1,5.9-24.6,66.4-43.8,58.1c-7.8-3.3-9.7-22.1-10.2-28.6c4.6,0.8,14.1-1.9,22-9.5 l-0.2,4.1c0,0,21.6-28.3,21.6-32.1c0-3.7,0.2-27.3,2.1-26.9c1.9,0.5,2.4,19.4,4.9,18.9c2.4-0.5,3.3-13.7,5.7-13.8 C1909.1-789.1,1905.7-765,1904.6-759.1z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1975.8-767.2c-0.6,0.6-1.3,1.1-2,1.4c-3.5,1.4-10.6-1.6-16.7-4.7c-1.2-18.9-8.8-38.9-12.9-44.3 c8.5,4.3,33.7,17.1,36.3,20.9c0.6,0.9,1,2.5,1.1,4.5C1982.1-782.7,1979.9-771.4,1975.8-767.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 1975.7705,
    y1: -780.9468,
    x2: 2054.3037,
    y2: -780.9468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "st179",
    d: "M2054.3-796.8c0,0-23.6,35.4-46,41.2c-3,2-20.8-5.9-32.5-11.6c4.1-4.2,6.4-15.5,5.9-22.3 c5.4,2.9,20.3,10.8,23.6,11.9c4.1,1.4,47.9-29,47.9-29L2054.3-796.8z"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "st161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1889.5-388h-69.7c0,0-0.6-2.5-0.2-5.4c0.3-2.6,1.5-5.4,4.6-7c6.6-3.4,31.8-15.8,37.3-21.5 c5.5-5.8,4.4-8.3,7-8.4c0,0,15-1.2,16.7,1c1.4,1.7,3.1,25.1,3.9,35.9C1889.4-390.1,1889.5-388,1889.5-388z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1840.7-411c0,0,6,5.8,9,6.6c3,0.8,18.4-12.4,19.5-16.1c1.1-3.7,2.3-18.2,2.3-18.2s-9.3,0-12.6,0 c-3.2,0-2.9,17.2-2.9,17.2S1839.3-412.3,1840.7-411z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1889.5-388h-69.7c0,0-0.6-2.5-0.2-5.4h69.5C1889.4-390.1,1889.5-388,1889.5-388z"
  })))), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M1886.4-660.4c0,0,2.4,9.8-7.4,15.6"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st125",
    x1: 1886.4,
    y1: -644.8,
    x2: 1867.3,
    y2: -451.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st125",
    x1: 1924.2,
    y1: -622.6,
    x2: 1968.2,
    y2: -436.8
  }))), /*#__PURE__*/React.createElement("g", null, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2183.4-436.8c-2.1,2.9-26,6-30.6,1.5c-4.6-4.4,0.3-68.5-4.8-87.7c-5.1-19.2-32.6-110.5-35.1-110.5 c-2.4,0-27.5,78.1-31.7,90.7c-4.2,12.6-54.7,106.9-56.5,108.5c-1.8,1.6-32.3,3-34.2-6.1c-2-9.1,43.4-102.4,48.4-141.9 c3.6-28.5,12.5-69.8,17.1-90.6c7.9,2,17.8,2.9,28.2,1.1c7.5-1.3,13.1-6.6,17-14.5c7.8,0.9,19.3-0.1,27.5-1.4 c0.1,4.7,0.4,7.8,1.1,8.8c3.6,5.4,16.2,3.5,24.4-0.9c7.8,29.1,25.9,96.7,32.1,116.4C2194.1-538,2185.4-439.7,2183.4-436.8z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M2225-861.3L2225-861.3c-1.1,0-2-0.9-2-2v-44c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v44 C2227-862.1,2226.1-861.3,2225-861.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 2140.7256,
    y1: -809.7646,
    x2: 2272.8435,
    y2: -871.3761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "st180",
    d: "M2170.4-820.3c0,0,7.8,2.4,8.7,2.4c0.9,0,43.8-45.3,45.3-47.5c1.5-2.2,3.7-23.2,5.4-24.5s7.4,19,3.5,31.2 c-4.6,14.3-42.7,66.4-47.5,66.4c-4.8,0-27.1-4.6-27.1-4.6"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2068.4-831.5c0,0,3.9-24.1,28-22.8s22.3,18.5,22.3,18.5L2068.4-831.5z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2129.5-744.1c0,1.2,0,2.4,0,3.5c0,1.4,0,2.8-0.1,4.2c-0.1,3.6-0.1,7.1-0.2,10.6c0,0.5,0,1.1,0,1.6 c0,0.7,0,1.3,0,2c0,1.3-0.1,2.6-0.1,3.8c0,0.5,0,0.9,0,1.4c0,0.7,0,1.4-0.1,2.1c0,0.2,0,0.4,0,0.6c0,0.5,0,1,0,1.5 c0,1.2-0.1,2.4-0.1,3.6c0,0.5,0,1.1,0,1.6c-0.1,2.6-0.1,5.1-0.2,7.4c0,1.2,0,2.4-0.1,3.5v0.4c-0.1,3.2-0.1,6.1,0,8.6 c-8.2,1.4-19.7,2.3-27.5,1.4c0.2-0.4,0.4-0.8,0.6-1.3c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-0.9,0.6-1.4c0,0,0-0.1,0-0.1 c0.2-0.5,0.4-1.1,0.6-1.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.4,0.3-0.7,0.4-1.1c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.7,0.4-1.4,0.6-2 c0.2-0.6,0.3-1.2,0.5-1.7c0.2-0.6,0.3-1.1,0.5-1.7c0.1-0.3,0.1-0.6,0.2-0.9c0.2-1,0.5-2.1,0.7-3.1c0.1-0.5,0.2-1,0.3-1.5 c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.7,0.2-1.5,0.4-2.2c0.1-0.6,0.2-1.3,0.3-1.9c0.1-0.9,0.2-1.8,0.4-2.8c0.2-1.5,0.3-3,0.5-4.6 c0.1-0.8,0.1-1.5,0.2-2.3c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.2-2.3,0.3-4.6,0.4-6.9c0-0.1,0-0.2,0-0.2c0.2-6.6,0.1-13.4-0.3-20.1 c-0.2-2.7-0.3-5.5-0.6-8.2c-2.9-33.9-29.6-72.5-34.6-79.6c5.8-2.5,26-10.4,40-4.7C2127.6-824,2129.8-781.6,2129.5-744.1z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M2129.8-876.4c-2.1,1.1-4.1,1.9-6,2.5c-11,3.4-19.6-0.1-19.6-0.1c-3.3,0.6-3.3,13.2-4.8,13.2 c-1.5,0-1.5-5.2-4.8-7.7c-3.3-2.5-8.7,1.9-5.9,7.1c2.8,5.2,0,14.5,0,14.5s-0.5-1.7-1.7-4.1c0,0,0,0,0,0c-0.8-1.7-2-3.7-3.5-5.8 c-3.9-5.2-23.4-18-17.1-29.9c6.3-11.9,18.2-9.3,18.2-9.3s0.6-16.9,8.7-23.7c-3,4.6-3.9,14.3-3.9,14.3s7.8-13.9,17.8-13.2 c10,0.6,13.5,10.2,13.5,10.2s4.1-6.9,12.8-2.4C2142.2-906.4,2143.5-883.6,2129.8-876.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 2048.678,
    y1: -851.2948,
    x2: 2155.7383,
    y2: -847.0645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M2121.3-846.9c-2,5.9-10,5.2-11.1,4.8c-1.1-0.4,1.5,11.7-1.5,15.8c-3,4.1-17.4,4.3-17.6-4.6 c-0.2-8.6-3.8-19.5-4-20.2c1.2,2.5,1.7,4.1,1.7,4.1s2.8-9.3,0-14.5c-2.8-5.2,2.6-9.6,5.9-7.1c3.3,2.5,3.3,7.7,4.8,7.7 c1.5,0,1.5-12.6,4.8-13.2c0,0,8.6,3.4,19.6,0.1C2124.7-865.1,2123-851.9,2121.3-846.9z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M2087.1-851.1C2087.1-851.1,2087.1-851.1,2087.1-851.1"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2109-726.8c0,0.1,0,0.2,0,0.2c-0.1,2.3-0.2,4.6-0.4,6.9c0,0,0,0,0,0c0,0,0,0.1,0,0.1 c-0.1,0.8-0.1,1.6-0.2,2.3c-0.1,1.5-0.3,3.1-0.5,4.6c-0.1,0.9-0.2,1.9-0.4,2.8c-0.1,0.6-0.2,1.3-0.3,1.9c-0.1,0.7-0.2,1.5-0.4,2.2 c-0.1,0.4-0.2,0.8-0.2,1.2c-0.1,0.5-0.2,1-0.3,1.5c-0.2,1.1-0.4,2.1-0.7,3.1c-0.1,0.3-0.2,0.6-0.2,0.9c-0.1,0.6-0.3,1.2-0.5,1.7 c-0.2,0.6-0.3,1.2-0.5,1.7c-0.2,0.7-0.4,1.4-0.6,2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.4-0.3,0.7-0.4,1.1c0,0.1-0.1,0.2-0.1,0.3 c-0.2,0.5-0.4,1.1-0.6,1.6c0,0,0,0.1,0,0.1c-0.2,0.5-0.4,1-0.6,1.4c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,0.4-0.4,0.8-0.6,1.3 c-3.9,7.9-9.4,13.2-17,14.5c-10.4,1.8-20.3,0.9-28.2-1.1c-9.7-2.4-16.4-6.6-17.1-9.6c-1.3-5.5,21.8-63.8,23.4-79.7 c1.6-15.9-8.8-46.2-7.2-54c1.3-6.2,7.3-14.4,13.1-17.9c1.1-0.6,2.2-1.1,3.2-1.4h0c0.4-0.1,0.9-0.2,1.3-0.2c0,0,0.1,0.2,0.3,0.4 c0.1,0.2,0.3,0.4,0.5,0.7c5,7,31.7,45.7,34.6,79.6c0.2,2.7,0.4,5.5,0.6,8.2C2109.1-740.1,2109.2-733.3,2109-726.8z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2077.4-749.2L2077.4-749.2c0,0.4-0.1,0.6-0.2,0.6c0,0-0.1,0.1-0.3,0.1c-2.2,0.5-17.6,1.3-26.5,0.4 c-3.5-0.4-6-1-6.2-2.1c-0.6-3.9,4.9-62.8,10.7-66.1c0,0,15.9,4.6,18.8,17.2C2076.7-787.2,2078-754.3,2077.4-749.2z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M2161.1-686.7c-0.7,2.5-3.5,5-7.1,6.9c-8.2,4.4-20.8,6.3-24.4,0.9c-0.7-1-1-4.1-1.1-8.8c0-2.4,0-5.3,0-8.6 v-0.4c0-1.1,0-2.3,0.1-3.5c0.1-2.3,0.1-4.8,0.2-7.4c0-0.5,0-1.1,0-1.6c0-1.2,0.1-2.3,0.1-3.6c0-0.5,0-1,0-1.5c0-0.2,0-0.4,0-0.6 c0-0.7,0-1.4,0.1-2.1c0-0.5,0-0.9,0-1.4c0-1.3,0.1-2.5,0.1-3.8c0-0.7,0-1.3,0-2c0-0.5,0-1.1,0-1.6c0.1-3.4,0.1-7,0.2-10.6 c0-1.4,0-2.8,0.1-4.2c0-1.2,0-2.4,0-3.5c0.2-37.4-2-79.9-16-95.2c-0.2-0.2-0.4-0.5-0.7-0.7c-0.8-0.8-1.6-1.5-2.5-2.1 c0.2,0.1,2.6,1,5.9,2.6c0.8,0.4,1.6,0.8,2.5,1.3c0,0,0,0,0,0c1,0.5,2.1,1.1,3.2,1.8c5.7,3.3,12,7.8,14.8,12.9 c2,3.7,3.4,15.1,4.7,29.2c2.4,26.7,4.5,62.9,9.6,74.2C2158.9-703,2163.4-694.9,2161.1-686.7z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2173-821.3c-1.5,9.8-9.2,30.8-11.2,30.8c-1.6,0-14.2-1.6-20.3-3.9c-1.3-14.1-2.7-25.5-4.7-29.2 c-3.4-6.1-11.6-11.3-18-14.7C2119.3-838.2,2140.4-835.5,2173-821.3z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M2118.7-838.3C2118.7-838.3,2118.7-838.3,2118.7-838.3"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M2108.6-719.6c1.6-24.1-43.4-101.1-44.3-105.4c-0.6-3,2.1-6.9,3.9-9.1c1.1-0.6,2.2-1.1,3.2-1.4h0l1.6,0.2 c0.1,0.2,0.3,0.4,0.5,0.7c5,7,31.7,45.7,34.6,79.6C2109.1-743.3,2109.4-731,2108.6-719.6z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M2129.2-725.8c0.9-40.7,0.7-95.6-15.8-113.5c-0.2-0.2-0.4-0.5-0.7-0.7c0.8,0,2,0.1,3.4,0.5 c1.7,0.5,3.7,1.4,5.7,3c3.4,2.7,6.8,7.6,9,16.2C2136-800.2,2134.7-735.7,2129.2-725.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 2114.5449,
    y1: -817.811,
    x2: 1992.8406,
    y2: -588.7207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M2111.7-782c-1.2,35.9-32.5,87.1-53.7,76.4c-6.6-3.4-7.4-35-7.5-42.5c8.8,0.9,24.2,0.1,26.5-0.4 c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1-0.3,0.2-0.6v0c3.2-5.5,18.8-32,20.1-34.8c1.5-3.1,0.5-12.8,0.4-16.7c-0.1-3.9,1.2-17.5,2.5-17 c1.3,0.4,0.9,15.7,1.8,15.5c1-0.2,4-18.2,5-18c1,0.2-0.8,20-0.5,22C2106.9-796.2,2112-791.7,2111.7-782z"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1988.4-388h79.6c0,0,0.7-2.9,0.2-6.2c-0.4-2.9-1.7-6.1-5.2-8c-7.5-3.9-36.4-18-42.6-24.6 c-6.3-6.6-5-9.5-8-9.7c0,0-17.1-1.4-19.1,1.2c-1.6,1.9-3.6,28.7-4.4,41.1C1988.6-390.4,1988.4-388,1988.4-388z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2044.2-414.3c0,0-6.9,6.6-10.3,7.5c-3.4,0.9-21-14.2-22.3-18.4c-1.3-4.2-2.7-20.8-2.7-20.8s10.7,0,14.4,0 c3.7,0,3.3,19.6,3.3,19.6S2045.9-415.7,2044.2-414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1988.4-388h79.6c0,0,0.7-2.9,0.2-6.2h-79.5C1988.6-390.4,1988.4-388,1988.4-388z"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2147.9-388h79.6c0,0,0.7-2.9,0.2-6.2c-0.4-2.9-1.7-6.1-5.2-8c-7.5-3.9-36.4-18-42.6-24.6 c-6.3-6.6-5-9.5-8-9.7c0,0-17.1-1.4-19.1,1.2c-1.6,1.9-3.6,28.7-4.4,41.1C2148-390.4,2147.9-388,2147.9-388z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2203.7-414.3c0,0-6.9,6.6-10.3,7.5c-3.4,0.9-21-14.2-22.3-18.4c-1.3-4.2-2.7-20.8-2.7-20.8s10.7,0,14.4,0 c3.7,0,3.3,19.6,3.3,19.6S2205.3-415.7,2203.7-414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M2147.9-388h79.6c0,0,0.7-2.9,0.2-6.2h-79.4C2148-390.4,2147.9-388,2147.9-388z"
  }))), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M2058.9-686c0,0-1.2,5-3,13.1"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M2081.1-666.2c0,0-1.5,13.3-15.9,15"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M2073.5-646.1c0,0-16.8,84-23,95.7c-6.2,11.7-46.2,104.5-46.2,104.5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M2121.8-630.5c0,0,38.7,91.2,40,105.5c1.3,14.3,0,79.1,0,79.1"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1583.2,
    y: -414.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3183.1072 -803.3625)",
    className: "st168",
    width: 16.7,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1520.5,
    y: -416.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3057.7383 -805.2118)",
    className: "st168",
    width: 16.7,
    height: 28.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1819,
    y: -422,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3654.7717 -810.4963)",
    className: "st168",
    width: 16.7,
    height: 33.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1756.3,
    y: -424.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 3529.4033 -812.8458)",
    className: "st168",
    width: 16.7,
    height: 35.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M1594-646.1c4.3,25.7,13.7,63,18.8,82.6c2.1,8.1,3.5,13.2,3.5,13.2l1.6,2l36.3,47.5h83.6 c0,0,0.9-28,0.8-60.9c0-2.9,0-5.8-0.1-8.7c-0.4-42.7-2.8-90-11.2-94.6c-15.6-8.4-124.6-13.4-133.9-8.4c-0.3,0.1-0.5,0.4-0.7,0.7 C1590.9-669.7,1591.7-659.5,1594-646.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1716.4,
    y1: -633.7,
    x2: 1710,
    y2: -627.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1710,
    y1: -633.7,
    x2: 1716.4,
    y2: -627.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1690.2,
    y1: -633.7,
    x2: 1683.9,
    y2: -627.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1683.9,
    y1: -633.7,
    x2: 1690.2,
    y2: -627.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1664.1,
    y1: -633.7,
    x2: 1657.7,
    y2: -627.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1657.7,
    y1: -633.7,
    x2: 1664.1,
    y2: -627.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1637.9,
    y1: -633.7,
    x2: 1631.6,
    y2: -627.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1631.6,
    y1: -633.7,
    x2: 1637.9,
    y2: -627.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1717.9,
    y1: -608.6,
    x2: 1711.5,
    y2: -602.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1711.5,
    y1: -608.6,
    x2: 1717.9,
    y2: -602.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1691.7,
    y1: -608.6,
    x2: 1685.4,
    y2: -602.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1685.4,
    y1: -608.6,
    x2: 1691.7,
    y2: -602.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1665.6,
    y1: -608.6,
    x2: 1659.2,
    y2: -602.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1659.2,
    y1: -608.6,
    x2: 1665.6,
    y2: -602.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1639.4,
    y1: -608.6,
    x2: 1633.1,
    y2: -602.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1633.1,
    y1: -608.6,
    x2: 1639.4,
    y2: -602.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1719.4,
    y1: -583.5,
    x2: 1713,
    y2: -577.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1713,
    y1: -583.5,
    x2: 1719.4,
    y2: -577.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1693.2,
    y1: -583.5,
    x2: 1686.9,
    y2: -577.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1686.9,
    y1: -583.5,
    x2: 1693.2,
    y2: -577.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1667.1,
    y1: -583.5,
    x2: 1660.7,
    y2: -577.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1660.7,
    y1: -583.5,
    x2: 1667.1,
    y2: -577.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1640.9,
    y1: -583.5,
    x2: 1634.6,
    y2: -577.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1634.6,
    y1: -583.5,
    x2: 1640.9,
    y2: -577.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1720.9,
    y1: -558.4,
    x2: 1714.5,
    y2: -552
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1714.5,
    y1: -558.4,
    x2: 1720.9,
    y2: -552
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1688.4,
    y1: -558.4,
    x2: 1694.7,
    y2: -552
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1694.7,
    y1: -558.4,
    x2: 1688.4,
    y2: -552
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1668.6,
    y1: -558.4,
    x2: 1662.2,
    y2: -552
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1662.2,
    y1: -558.4,
    x2: 1668.6,
    y2: -552
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1642.4,
    y1: -558.4,
    x2: 1636.1,
    y2: -552
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1636.1,
    y1: -558.4,
    x2: 1642.4,
    y2: -552
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1722.4,
    y1: -533.3,
    x2: 1716,
    y2: -526.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1716,
    y1: -533.3,
    x2: 1722.4,
    y2: -526.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1696.2,
    y1: -533.3,
    x2: 1689.9,
    y2: -526.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1689.9,
    y1: -533.3,
    x2: 1696.2,
    y2: -526.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1670.1,
    y1: -533.3,
    x2: 1663.7,
    y2: -526.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1663.7,
    y1: -533.3,
    x2: 1670.1,
    y2: -526.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1643.9,
    y1: -533.3,
    x2: 1637.6,
    y2: -526.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st135",
    x1: 1637.6,
    y1: -533.3,
    x2: 1643.9,
    y2: -526.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M1549-557.9c6.6-1.2,13.6,0.7,19.8,3.9c8.4,4.4,15.3,11.3,17.4,16.3c0.5,1.2,1.2,3.5,2.1,6.6 c7.8,27.3,28,117.8,28,117.8s46.5,0,98.6-1c67-1.2,143.2-3.8,141.9-9.7c-2.3-9.8-18.4-102.7-46-130.1c-1.7-1.6-3.4-3.1-5.1-4.2 c-25.7-16.9-57.6-13.6-67.2-12.1c0,2.9,0,5.8,0,8.7c34,3.6,42.6,43.8,44.8,68c0.9,9.7,0.7,16.8,0.6,18.1c0,0.1,0,0.2,0,0.2h-112.1 c0,0-2.4-11.4-6.7-25.4c-5.3-17.6-13.4-39.2-22.9-47.2c-8.6-7.3-17.7-12-26.9-14.8c-0.9-0.3-1.7-0.5-2.6-0.7 c-16.8-4.5-33.4-2.9-46.5,0.2C1559.3-561.7,1553.4-559.7,1549-557.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M1513-416.3l103.3,2.9c0,0-24.9-112-30.1-124.4c-3.6-8.7-21.7-23.1-37.2-20.2c-3.1,0.6-6,1.8-8.7,3.9 c0,0,0,0,0,0c-3.3,2.5-6.2,6.3-8.6,11.6C1517.4-510.2,1513-416.3,1513-416.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M1566.3-563.4c13.1-3.1,29.7-4.7,46.5-0.2c-7.8-29.8-25.4-100.4-20-109c-10.2,2.1-37.5,9.4-40.8,28 C1549.4-631.1,1558.5-592.5,1566.3-563.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M1665.1-500.8c4.2,14,6.7,25.4,6.7,25.4h112.1c0,0,0-0.1,0-0.2c-13.3-11.5-46.2-25.2-46.2-25.2H1665.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M1737.8-500.8c0,0,32.9,13.7,46.2,25.2c0.2-4.4,2.1-81-45.4-86.1c0-2.9,0-5.8-0.1-8.7L1737.8-500.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1594-646.1c4.3,25.7,13.7,63,18.8,82.6c0.9,0.2,1.7,0.5,2.6,0.7c9.1,2.8,18.3,7.5,26.9,14.8 c9.5,8.1,17.6,29.7,22.9,47.2h67.2L1594-646.1z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2290.3-484.4c0,0-3.7-29.5-19-41.6c-15.2-12.2-16.3-31.1-16.3-31.1s-20.7,71.8,5.8,85 C2287.3-459.1,2290.3-484.4,2290.3-484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M2255.1-557.2c0,0-7.1,63.3,32,93.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M2297.1-821.1c0,0,38.1,124.3,9.3,231.5s10.8,146.6,10.8,146.6l-30.1-30.2c0,0-12.8-94.9-9.6-143.2 l9.6-4.9l-10.2-8.6C2277-629.8,2303.7-740.7,2297.1-821.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2297.1-821.1c3,14.2,5.3,28.5,7.4,42.9c2,14.4,3.6,28.8,4.6,43.3c0.1,1.8,0.3,3.6,0.4,5.4l0.3,5.4 c0.2,3.6,0.4,7.2,0.5,10.9c0.2,7.3,0.4,14.5,0.3,21.8l0,5.4l0,2.7l-0.1,2.7l-0.5,10.9c0,0.9-0.1,1.8-0.1,2.7l-0.2,2.7l-0.5,5.4 c-0.4,3.6-0.6,7.2-1.2,10.8l-1.6,10.8c-0.5,3.6-1.2,7.2-1.8,10.7c-0.6,3.6-1.2,7.2-1.8,10.7c-0.6,3.6-1.2,7.2-1.7,10.8 c-2.2,14.3-4.2,28.7-5.7,43.2c-0.4,3.6-0.7,7.2-1,10.8c-0.3,3.6-0.5,7.2-0.7,10.9c-0.3,7.2-0.6,14.5-0.4,21.8 c0,7.3,0.5,14.5,1.2,21.7c0.7,7.2,1.8,14.4,3,21.5c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2-0.1-0.3-0.2l0,0c-1.2-7.2-2.3-14.3-3-21.6 c-0.7-7.2-1.1-14.5-1.1-21.8c-0.1-7.3,0.1-14.5,0.5-21.8c0.3-3.6,0.5-7.2,0.8-10.9c0.3-3.6,0.6-7.2,1-10.8 c1.5-14.4,3.5-28.8,5.7-43.2c0.5-3.6,1.2-7.2,1.7-10.8c0.6-3.6,1.2-7.2,1.8-10.7c0.6-3.6,1.3-7.2,1.8-10.7l1.6-10.8 c0.6-3.6,0.8-7.2,1.2-10.8l0.5-5.4l0.3-2.7c0.1-0.9,0.1-1.8,0.1-2.7l0.5-10.9l0.1-2.7l0-2.7l0.1-5.4c0.2-7.3-0.1-14.5-0.2-21.8 c-0.1-3.6-0.3-7.3-0.5-10.9l-0.3-5.4c-0.1-1.8-0.3-3.6-0.4-5.4c-1-14.5-2.6-28.9-4.6-43.3 C2302.4-792.6,2300.1-806.9,2297.1-821.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M2295.1-473.2c0,0-8.1-76.3,7.2-106.1h9.9l-5.9-10.4c0,0,32.1-70.2,121.9-97.6c0,0-56.7,37.5-79.8,107 c-10.9-2.7-18.7-2.2-18.7-2.2l8.2,10.8c0,0-33.4,54.2-28.9,104.8C2313.6-416.3,2295.1-473.2,2295.1-473.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M2428.3-687.2c0,0-138.6,56.5-127.8,212.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "2240.9,-462.1 2241.4,-449.6 2252.2,-388 2321.2,-388 2332.1,-449.6 2333.3,-456.7 2281,-459.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2227.9-474.6v21.4c0,2,1.7,3.7,3.7,3.7h113.1c2.4,0,4.2-2.3,3.6-4.7l-5.8-21.4c-0.4-1.6-1.9-2.7-3.6-2.7 h-107.3C2229.6-478.4,2227.9-476.7,2227.9-474.6z"
  }))), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M2362.5-375.2h-865.4c-3.5,0-6.4-2.9-6.4-6.4l0,0c0-3.5,2.9-6.4,6.4-6.4h865.4c3.5,0,6.4,2.9,6.4,6.4l0,0 C2368.9-378.1,2366-375.2,2362.5-375.2z"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1525.7,
    y: -755.3,
    className: "st44",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1549,
    y: -731.4,
    className: "st168",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2196.2,
    y: -743.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4452.5659 -1470.323)",
    className: "st44",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2173,
    y: -719.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 4406.0962 -1422.5961)",
    className: "st168",
    width: 60.2,
    height: 16.3
  }))), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1675.4-393.4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1605.9-393.4"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1401.4-1491.6c0.2-0.1,1.2,1.2,2.6,3.8c1.5,2.6,3.3,6.5,5,11.5c3.5,10.1,5.7,24.9,4.4,41.1 c-1.3,16.2-5,30.4-7.9,40.6c-3,10.1-5.1,16.3-5.5,16.2s1.1-6.5,3.5-16.7c2.4-10.2,5.7-24.4,7-40.2c1.3-15.9-0.5-30.3-3.4-40.3 C1404.2-1485.7,1400.9-1491.4,1401.4-1491.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1411.4-1572.7c0.2-0.1,1.4,2.1,3.4,6.2s4.8,10,8.2,17.4c6.6,14.8,15.5,35.4,22,59.4 c3.2,12,5.3,23.7,6.4,34.4c1.1,10.7,1.2,20.5,0.7,28.6s-1.6,14.7-2.6,19.1s-1.8,6.8-1.9,6.8c-0.5-0.1,1.9-9.9,2.4-26 c0.6-16.1-1.5-38.4-7.9-62.1s-14.9-44.4-21-59.4c-3.1-7.5-5.6-13.5-7.3-17.7C1412.1-1570.2,1411.2-1572.6,1411.4-1572.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1041.9-1477.5c0.3,0.4-3,3.6-7.4,9.5c-1.1,1.5-2.3,3.1-3.4,5c-1.2,1.8-2.2,3.9-3.4,6 c-2.2,4.3-4.2,9.3-5.8,14.7c-1.5,5.4-2.4,10.7-2.9,15.5c-0.1,2.4-0.4,4.7-0.3,6.9c-0.1,2.2,0.1,4.2,0.2,6 c0.5,7.4,1.7,11.9,1.2,12c-0.3,0.1-2.2-4.2-3.3-11.8c-0.3-1.9-0.5-3.9-0.6-6.2c-0.2-2.2,0-4.6,0-7.1c0.3-5,1.2-10.5,2.8-16.1 s3.9-10.7,6.2-15.1c1.3-2.2,2.4-4.3,3.8-6.1c1.2-1.9,2.5-3.5,3.8-4.9C1037.8-1475.1,1041.7-1477.8,1041.9-1477.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1049.8-1451.5c0.2,0.4-1.6,1.8-4.1,4.6c-1.2,1.4-2.5,3.1-3.8,5.1c-1.2,2.1-2.4,4.4-3.3,7s-1.4,5.2-1.7,7.6 c-0.2,2.4-0.3,4.6-0.2,6.4c0.2,3.7,0.8,5.9,0.4,6.1c-0.3,0.1-1.7-2-2.5-5.8c-0.4-1.9-0.6-4.3-0.5-6.9c0.2-2.6,0.7-5.5,1.6-8.3 c1-2.9,2.4-5.4,3.9-7.6c1.5-2.1,3.1-3.9,4.6-5.1C1047.3-1451,1049.6-1451.8,1049.8-1451.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M940.3-1693.5c0.2-0.1,1.5,1.2,3.8,3.7c1.2,1.2,2.5,2.8,4,4.7s3.2,4,4.9,6.5c0.9,1.2,1.7,2.6,2.7,3.9 c0.9,1.4,1.8,2.9,2.7,4.4c1.9,3,3.6,6.4,5.5,10c3.5,7.2,6.8,15.4,9.5,24.2c2.6,8.9,4.2,17.5,5.2,25.5c0.4,4,0.8,7.8,0.8,11.3 c0,1.8,0.2,3.5,0.1,5.1c0,1.6-0.1,3.2-0.1,4.7c0,3-0.3,5.7-0.5,8.1c-0.2,2.4-0.5,4.4-0.8,6.1c-0.6,3.3-1,5.1-1.2,5.1 c-0.5-0.1,0.5-7.4,0.4-19.4c0-1.5-0.1-3-0.1-4.7c0-1.6-0.2-3.3-0.3-5.1c-0.1-3.5-0.7-7.2-1.1-11.1c-1.1-7.8-2.8-16.3-5.3-25 c-2.6-8.7-5.8-16.7-9.1-23.9c-1.8-3.5-3.3-6.9-5.1-9.9c-0.9-1.5-1.6-3-2.5-4.4c-0.9-1.4-1.7-2.7-2.5-4 C944.7-1687.5,939.9-1693.2,940.3-1693.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M973.8-1679.6c0.3-0.2,3.7,3,8,9.1c2.2,3.1,4.5,6.9,6.7,11.3c2.2,4.5,4.2,9.5,5.9,15 c1.6,5.5,2.6,10.9,3.2,15.8c0.5,4.9,0.7,9.4,0.5,13.2c-0.3,7.5-1.4,12-1.8,12c-0.5-0.1-0.1-4.6-0.3-12c-0.1-3.7-0.5-8-1.1-12.8 c-0.7-4.8-1.8-10-3.4-15.3c-1.6-5.3-3.5-10.3-5.5-14.7s-4.1-8.2-6-11.4C976.3-1675.7,973.5-1679.3,973.8-1679.6z"
  }))))), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M707.4-1935.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H707.4L707.4-1935.6z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1023.4-1935.6c0.1-17.7,18-48.3,35.6-50.7c14.4-1.9,19.2,4.8,21.9,11.2c6.6-8.3,16.8-13.6,28.2-13.6 c12.3,0,19.7,6.4,26.2,15.9c4.5-3.5,21.9-12.5,34.3,2.9c8,9.9,4.8,17,4.8,17s0.6-7.1,12.2-7.1c25.9,0,23.4,25.6,23.4,25.6l-42.5-1.2 H1023.4L1023.4-1935.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M746.5-1288.6c0,0-145.1-177.2-60.8-269.7c84.4-92.4,710.9-322,786.3-292.9 c171.5,66.4,36.6,526.5-24.8,556.1L746.5-1288.6z"
  })), /*#__PURE__*/React.createElement("g", null, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M976.7-1326c-4.7,6.9-26,7.7-29.7,2.6c-3.6-5.1-7.3-164.6-23.3-220.7c-9.8,16.8-4.5,214.4-8.6,219 c-1.8,2-33.8,9-35.7-2.4c-9.5-56.5-6.3-181.8-3.8-242c0.4-10.9,0.9-19.7,1.2-25.5c17.2,9.6,67.8,14.5,81.2,5.2 c0.3,0.7,0.5,1.4,0.8,2.2C985.1-1513.1,981.1-1332.4,976.7-1326z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M915.6-1295.2h-56.4c0,0,0.6-16.8,10.7-17.6c1.8-0.1,3.4,0.1,4.8,0.6c6.1,2.2,7.5,9.4,7.5,9.4H914 C914.1-1302.8,915.8-1298.7,915.6-1295.2z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M912.9-1302.8h-30.6c0,0-1.4-7.2-7.5-9.4c3.1-2.2,8.3-6.1,9.4-8.4c10.7-2.3,24.7-1.2,25.7,0 C910.7-1319.4,912.9-1302.8,912.9-1302.8z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M878.9-1315.3c0,0,6.5,1.3,8.5,1c2-0.3,9.5-17.1,8.5-19c-1-2-12.3-1.2-13.3,0 C881.7-1332.1,881.2-1319.3,878.9-1315.3z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M945.6-1295l56.4-0.3c0,0-0.7-16.8-10.8-17.5c-1.8-0.1-3.4,0.1-4.8,0.6c-6.1,2.2-7.5,9.4-7.5,9.4l-31.8,0.2 C947.1-1302.6,945.4-1298.5,945.6-1295z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M948.3-1302.7l30.6-0.2c0,0,1.4-7.2,7.5-9.4c-3.1-2.2-8.4-6.1-9.4-8.4c-10.7-2.3-24.7-1.1-25.7,0.1 C950.3-1319.2,948.3-1302.7,948.3-1302.7z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M982.2-1315.3c0,0-6.5,1.4-8.5,1.1c-2-0.3-9.5-17-8.6-19c1-2,12.3-1.2,13.3-0.1 C979.4-1332.1,979.9-1319.3,982.2-1315.3z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M894.3-1584.7c0,0,3.1,11.8-11.7,20.7"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M946.1-1580.7c0,0,1,13.7,17.4,16.8"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M887.3-1552.4c0,0-13.9,138.1,0,215.3"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M931.4-1544c0,0,25,139.6,20.3,218.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 1021.8023,
    y1: 2950.4917,
    x2: 1060.2012,
    y2: 3019.4792,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M1020.8-1769.2c0,0,21.2-25.3,22.8-28.1c1.6-2.8,5.4-17.8,10.7-18.8c5.3-1,11.1,2.5,12.7,6.6 c1.7,4.1-11.8,17.2-12.7,19.8c-0.9,2.6-24.6,35.3-24.6,35.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.7033,
    y1: 3121.843,
    x2: 69.1019,
    y2: 3190.8306,
    gradientTransform: "matrix(-0.9598 -0.2807 0.2807 -0.9598 39.5891 1213.3137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "st185",
    d: "M893.3-1811.2c0,0-13.2-30.2-14-33.4c-0.8-3.2-0.2-18.6-5-21c-4.8-2.4-11.3-0.7-14.1,2.8 c-2.7,3.5,6.5,19.8,6.7,22.5c0.1,2.8,13.7,40.8,13.7,40.8"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M876.5-1586.8c-3-1.3-4.5-4.7-3.3-7.7c6.1-15.5,29.2-78.4,22.4-121.2c-7.8-49.1-20.8-99.1-20.8-99.1 l15.2-5.6c0,0,35.5,88.3,45.7,97.8c10.2,9.4,32.4,4.4,41.1-3.3s42.1-44.2,42.1-44.2l13.5,15.7c0,0-52.5,75.9-60.7,99.3 c-8.2,23.4,1.5,79.7-8.7,80.7C954.2-1573.5,892.8-1579.8,876.5-1586.8z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M988.7-1750.1c0,0-1.9,1.7-9.1,2.4c-0.1,0-0.2,0-0.3,0c-17.1,1.5-25.6-14.5-29.1-14.5s-2.2,10.8-2.6,15.4 c-0.3,3-3.5,5.9-5.6,7.5l0,0c-1.1,0.8-2,1.4-2,1.4c1.1-16-12.2-29.7-8.9-38.8c3.3-9.1,10.6-8.7,10.6-8.7s-1.3-7.1,2.6-9.9 c3.9-2.8,14.1-3.5,22.1,6.1C1006.9-1793.7,988.7-1750.1,988.7-1750.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 937.8073,
    y1: 2936.8132,
    x2: 979.5602,
    y2: 2936.8132,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M979.6-1747.7c-1.7,6-7.3,21.7-19.6,24.3c-5.4,5.8-2.8,15.5-11.3,15.9s-13.1-4.6-9.9-12.8 c2.1-5.4,2.9-13.8,3.2-19l0,0c2.2-1.6,5.3-4.5,5.6-7.5c0.4-4.6-0.9-15.4,2.6-15.4s12,16,29.1,14.5 C979.4-1747.7,979.5-1747.7,979.6-1747.7z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1014.9-1770.1c0,0,14.5,21.2,17.4,21.5c2.8,0.3,6.4-5,5.7-8.3c-0.7-3.3-13.8-18.4-17.1-18.4 S1013.8-1771.7,1014.9-1770.1z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M871.2-1809.4c0,0,24.9-6.1,26.2-8.6s-2.5-7.8-5.7-8.3c-3.3-0.5-22.1,6.4-23.2,9.5 C867.3-1813.9,869.3-1809,871.2-1809.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1186.7-1333.3c-0.5,4-29.9,4.1-31.2,0c-1.3-4.1-40.4-197-40.4-197l-33.6,197c0,0-29.6,2.3-29.6-6.8 c0-9,18.4-240.1,18.6-242.5c2.3,4.7,7.1,8.5,15.8,10.7c19.1,4.8,49.6,2.5,62.7-18.4C1155.4-1580.2,1187.2-1337.3,1186.7-1333.3z"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    className: "st161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1153.5-1295h69.7c0,0,0.6-2.5,0.2-5.4c-0.3-2.6-1.5-5.4-4.6-7c-6.6-3.4-31.8-15.8-37.3-21.5 c-5.5-5.8-4.4-8.3-7-8.4c0,0-15-1.2-16.7,1c-1.4,1.7-3.1,25.1-3.9,35.9C1153.6-1297.2,1153.5-1295,1153.5-1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1202.3-1318c0,0-6,5.8-9,6.6c-3,0.8-18.4-12.4-19.5-16.1c-1.1-3.7-2.3-18.2-2.3-18.2s9.3,0,12.6,0 c3.3,0,2.9,17.2,2.9,17.2S1203.7-1319.3,1202.3-1318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1153.5-1295h69.7c0,0,0.6-2.5,0.2-5.4h-69.5C1153.6-1297.2,1153.5-1295,1153.5-1295z"
  }))), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1123.3-1748.4c0,0,21.5-23.6,2-35.5c-16.2-15-19-14.8-31.6-12.4c-12.6,2.4-23.6,13.9-23,36 c0.7,22.1-30.8,39.9-24.7,63.1c6.1,23.2-22.3,65.2-15.6,86c6.7,20.8,34.1,40.5,49.7,27.3c15.6-13.2,22.1-135.2,22.1-135.2 l11.1-23.5L1123.3-1748.4z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1140.7-1622.7c2.3,15.1,11.5,27.1,8.2,32.3c-13.1,20.9-43.6,23.2-62.7,18.4c-8.7-2.2-13.5-6-15.8-10.7 c-2.7-5.7-1.8-12.6,0.6-19.5c4.3-12.6,4.3-51.4-4.1-67.1c-8.5-15.7-18-21.4-13-28.5c5-7.2,39-34.3,39-34.3s41.5,7.6,45,8.8 c0.4,0.1,0.9,0.6,1.5,1.4c4.1,5.4,11.7,25.4,12.9,44.3c0.1,1.2,0.1,2.4,0.2,3.7C1152.8-1651.4,1136.8-1648.8,1140.7-1622.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 1088.9596,
    y1: 2942.3499,
    x2: 1125.3009,
    y2: 2942.3499,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M1123.5-1773.1c0,0,4.8,20.2-1.1,34.5c-5.9,14.3-10.8,13.9-10.8,13.9s2.4,14.3-5,16.3s-15.6,1.3-17.6-18.9 c7.4-8.9,9.1-11.9,7.6-16.9s-0.7-11.7,5.4-11.1C1108.1-1754.6,1124.8-1752.2,1123.5-1773.1z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1068.5-1647.1c-0.3,0.3-0.6,0.6-0.9,0.9c-7.9,7.6-17.5,10.3-22,9.5c-1.2-0.2-2-0.7-2.4-1.3 c-2-3.2-2.4-60.4,12-61.3C1066.7-1700,1071.5-1677.7,1068.5-1647.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.5596,
    y1: 2856.1868,
    x2: 1102.5409,
    y2: 2856.1868,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M1099.6-1666.2c-1.1,5.9-24.6,66.4-43.8,58.1c-7.8-3.3-9.7-22.1-10.2-28.6c4.6,0.8,14.1-1.9,22-9.5 l-0.2,4.1c0,0,21.6-28.3,21.6-32.1c0-3.7,0.2-27.3,2.1-26.9c1.9,0.5,2.4,19.4,4.9,18.9c2.4-0.5,3.3-13.7,5.7-13.8 C1104.2-1696.1,1100.7-1672,1099.6-1666.2z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1170.8-1674.2c-0.6,0.6-1.3,1.1-2,1.4c-3.5,1.4-10.6-1.6-16.7-4.7c-1.2-18.9-8.8-38.9-12.9-44.3 c8.5,4.3,33.7,17.1,36.3,20.9c0.6,0.9,1,2.5,1.1,4.5C1177.2-1689.7,1174.9-1678.4,1170.8-1674.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 1170.7595,
    y1: 2890.0161,
    x2: 1249.2595,
    y2: 2890.0161,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "st189",
    d: "M1249.3-1703.9c0,0-23.6,35.4-46,41.2c-3,2-20.8-5.9-32.5-11.6c4.1-4.2,6.4-15.5,5.9-22.3 c5.4,2.9,20.3,10.8,23.6,11.9c4.1,1.4,47.9-29,47.9-29L1249.3-1703.9z"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    className: "st161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1084.5-1295h-69.7c0,0-0.6-2.5-0.2-5.4c0.3-2.6,1.5-5.4,4.6-7c6.6-3.4,31.8-15.8,37.3-21.5 c5.5-5.8,4.4-8.3,7-8.4c0,0,15-1.2,16.7,1c1.4,1.7,3.1,25.1,3.9,35.9C1084.4-1297.2,1084.5-1295,1084.5-1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1035.7-1318c0,0,6,5.8,9,6.6c3,0.8,18.4-12.4,19.5-16.1c1.1-3.7,2.3-18.2,2.3-18.2s-9.3,0-12.6,0 c-3.2,0-2.9,17.2-2.9,17.2S1034.3-1319.3,1035.7-1318z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M1084.5-1295h-69.7c0,0-0.6-2.5-0.2-5.4h69.5C1084.4-1297.2,1084.5-1295,1084.5-1295z"
  })))), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M1081.4-1567.4c0,0,2.4,9.8-7.4,15.6"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st190",
    x1: 1081.4,
    y1: -1551.8,
    x2: 1062.3,
    y2: -1358.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st190",
    x1: 1119.3,
    y1: -1529.7,
    x2: 1163.2,
    y2: -1343.8
  }))), /*#__PURE__*/React.createElement("g", null, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1378.4-1343.9c-2.1,2.9-26,6-30.6,1.5c-4.6-4.4,0.3-68.5-4.8-87.7c-5.1-19.2-32.6-110.5-35.1-110.5 c-2.4,0-27.5,78.1-31.7,90.7c-4.2,12.6-54.7,106.9-56.5,108.5c-1.8,1.6-32.3,3-34.2-6.1c-2-9.1,43.4-102.4,48.4-141.9 c3.6-28.5,12.5-69.8,17.1-90.6c7.9,2,17.8,2.9,28.2,1.1c7.5-1.3,13.1-6.6,17-14.5c7.8,0.9,19.3-0.1,27.5-1.4 c0.1,4.7,0.4,7.8,1.1,8.8c3.6,5.4,16.2,3.5,24.4-0.9c7.8,29.1,25.9,96.7,32.1,116.4C1389.1-1445,1380.5-1346.7,1378.4-1343.9z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1420.1-1768.3L1420.1-1768.3c-1.1,0-2-0.9-2-2v-44c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2v44 C1422-1769.2,1421.2-1768.3,1420.1-1768.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 1335.7252,
    y1: 2918.7659,
    x2: 1467.843,
    y2: 2980.3772,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M1365.4-1727.3c0,0,7.8,2.4,8.7,2.4s43.8-45.3,45.3-47.5c1.5-2.2,3.7-23.2,5.4-24.5 c1.7-1.3,7.4,19,3.5,31.2c-4.6,14.3-42.7,66.4-47.5,66.4c-4.8,0-27.1-4.6-27.1-4.6"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1263.4-1738.6c0,0,3.9-24.1,28-22.8c24.1,1.3,22.3,18.5,22.3,18.5L1263.4-1738.6z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1324.6-1651.2c0,1.2,0,2.4,0,3.5c0,1.4,0,2.8-0.1,4.2c-0.1,3.6-0.1,7.1-0.2,10.6c0,0.5,0,1.1,0,1.6 c0,0.7,0,1.3,0,2c0,1.3-0.1,2.6-0.1,3.8c0,0.5,0,0.9,0,1.4c0,0.7,0,1.4-0.1,2.1c0,0.2,0,0.4,0,0.6c0,0.5,0,1,0,1.5 c0,1.2-0.1,2.4-0.1,3.6c0,0.5,0,1.1,0,1.6c-0.1,2.6-0.1,5.1-0.2,7.4c0,1.2,0,2.4-0.1,3.5v0.4c-0.1,3.2-0.1,6.1,0,8.6 c-8.2,1.4-19.7,2.3-27.5,1.4c0.2-0.4,0.4-0.8,0.6-1.3c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-0.9,0.6-1.4v-0.1 c0.2-0.5,0.4-1.1,0.6-1.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.4,0.3-0.7,0.4-1.1c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.7,0.4-1.4,0.6-2 c0.2-0.6,0.3-1.2,0.5-1.7c0.2-0.6,0.3-1.1,0.5-1.7c0.1-0.3,0.1-0.6,0.2-0.9c0.2-1,0.5-2.1,0.7-3.1c0.1-0.5,0.2-1,0.3-1.5 c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.7,0.2-1.5,0.4-2.2c0.1-0.6,0.2-1.3,0.3-1.9c0.1-0.9,0.2-1.8,0.4-2.8c0.2-1.5,0.3-3,0.5-4.6 c0.1-0.8,0.1-1.5,0.2-2.3v-0.1l0,0c0.2-2.3,0.3-4.6,0.4-6.9c0-0.1,0-0.2,0-0.2c0.2-6.6,0.1-13.4-0.3-20.1 c-0.2-2.7-0.3-5.5-0.6-8.2c-2.9-33.9-29.6-72.5-34.6-79.6c5.8-2.5,26-10.4,40-4.7C1322.6-1731,1324.8-1688.6,1324.6-1651.2z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1324.8-1783.5c-2.1,1.1-4.1,1.9-6,2.5c-11,3.4-19.6-0.1-19.6-0.1c-3.3,0.6-3.3,13.2-4.8,13.2 s-1.5-5.2-4.8-7.7c-3.3-2.5-8.7,1.9-5.9,7.1c2.8,5.2,0,14.5,0,14.5s-0.5-1.7-1.7-4.1l0,0c-0.8-1.7-2-3.7-3.5-5.8 c-3.9-5.2-23.4-18-17.1-29.9c6.3-11.9,18.2-9.3,18.2-9.3s0.6-16.9,8.7-23.7c-3,4.6-3.9,14.3-3.9,14.3s7.8-13.9,17.8-13.2 c10,0.6,13.5,10.2,13.5,10.2s4.1-6.9,12.8-2.4C1337.2-1813.4,1338.5-1790.6,1324.8-1783.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 1243.6814,
    y1: 2960.3806,
    x2: 1350.7418,
    y2: 2956.1504,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M1316.4-1754c-2,5.9-10,5.2-11.1,4.8s1.5,11.7-1.5,15.8s-17.4,4.3-17.6-4.6c-0.2-8.6-3.8-19.5-4-20.2 c1.2,2.5,1.7,4.1,1.7,4.1s2.8-9.3,0-14.5c-2.8-5.2,2.6-9.6,5.9-7.1c3.3,2.5,3.3,7.7,4.8,7.7s1.5-12.6,4.8-13.2 c0,0,8.6,3.4,19.6,0.1C1319.7-1772.1,1318-1759,1316.4-1754z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M1282.2-1758.1L1282.2-1758.1"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1304-1633.8c0,0.1,0,0.2,0,0.2c-0.1,2.3-0.2,4.6-0.4,6.9l0,0v0.1c-0.1,0.8-0.1,1.6-0.2,2.3 c-0.1,1.5-0.3,3.1-0.5,4.6c-0.1,0.9-0.2,1.9-0.4,2.8c-0.1,0.6-0.2,1.3-0.3,1.9c-0.1,0.7-0.2,1.5-0.4,2.2c-0.1,0.4-0.2,0.8-0.2,1.2 c-0.1,0.5-0.2,1-0.3,1.5c-0.2,1.1-0.4,2.1-0.7,3.1c-0.1,0.3-0.2,0.6-0.2,0.9c-0.1,0.6-0.3,1.2-0.5,1.7c-0.2,0.6-0.3,1.2-0.5,1.7 c-0.2,0.7-0.4,1.4-0.6,2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.4-0.3,0.7-0.4,1.1c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.4,1.1-0.6,1.6v0.1 c-0.2,0.5-0.4,1-0.6,1.4c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,0.4-0.4,0.8-0.6,1.3c-3.9,7.9-9.4,13.2-17,14.5 c-10.4,1.8-20.3,0.9-28.2-1.1c-9.7-2.4-16.4-6.6-17.1-9.6c-1.3-5.5,21.8-63.8,23.4-79.7s-8.8-46.2-7.2-54 c1.3-6.2,7.3-14.4,13.1-17.9c1.1-0.6,2.2-1.1,3.2-1.4l0,0c0.4-0.1,0.9-0.2,1.3-0.2c0,0,0.1,0.2,0.3,0.4c0.1,0.2,0.3,0.4,0.5,0.7 c5,7,31.7,45.7,34.6,79.6c0.2,2.7,0.4,5.5,0.6,8.2C1304.1-1647.2,1304.2-1640.4,1304-1633.8z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1272.4-1656.2L1272.4-1656.2c0,0.4-0.1,0.6-0.2,0.6c0,0-0.1,0.1-0.3,0.1c-2.2,0.5-17.6,1.3-26.5,0.4 c-3.5-0.4-6-1-6.2-2.1c-0.6-3.9,4.9-62.8,10.7-66.1c0,0,15.9,4.6,18.8,17.2C1271.7-1694.2,1273-1661.3,1272.4-1656.2z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1356.2-1593.8c-0.7,2.5-3.5,5-7.1,6.9c-8.2,4.4-20.8,6.3-24.4,0.9c-0.7-1-1-4.1-1.1-8.8c0-2.4,0-5.3,0-8.6 v-0.4c0-1.1,0-2.3,0.1-3.5c0.1-2.3,0.1-4.8,0.2-7.4c0-0.5,0-1.1,0-1.6c0-1.2,0.1-2.3,0.1-3.6c0-0.5,0-1,0-1.5c0-0.2,0-0.4,0-0.6 c0-0.7,0-1.4,0.1-2.1c0-0.5,0-0.9,0-1.4c0-1.3,0.1-2.5,0.1-3.8c0-0.7,0-1.3,0-2c0-0.5,0-1.1,0-1.6c0.1-3.4,0.1-7,0.2-10.6 c0-1.4,0-2.8,0.1-4.2c0-1.2,0-2.4,0-3.5c0.2-37.4-2-79.9-16-95.2c-0.2-0.2-0.4-0.5-0.7-0.7c-0.8-0.8-1.6-1.5-2.5-2.1 c0.2,0.1,2.6,1,5.9,2.6c0.8,0.4,1.6,0.8,2.5,1.3l0,0c1,0.5,2.1,1.1,3.2,1.8c5.7,3.3,12,7.8,14.8,12.9c2,3.7,3.4,15.1,4.7,29.2 c2.4,26.7,4.5,62.9,9.6,74.2C1353.9-1610,1358.5-1601.9,1356.2-1593.8z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1368-1728.4c-1.5,9.8-9.2,30.8-11.2,30.8c-1.6,0-14.2-1.6-20.3-3.9c-1.3-14.1-2.7-25.5-4.7-29.2 c-3.4-6.1-11.6-11.3-18-14.7C1314.3-1745.2,1335.5-1742.5,1368-1728.4z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M1313.8-1745.3L1313.8-1745.3"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M1303.6-1626.7c1.6-24.1-43.4-101.1-44.3-105.4c-0.6-3,2.1-6.9,3.9-9.1c1.1-0.6,2.2-1.1,3.2-1.4l0,0l1.6,0.2 c0.1,0.2,0.3,0.4,0.5,0.7c5,7,31.7,45.7,34.6,79.6C1304.2-1650.3,1304.5-1638,1303.6-1626.7z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M1324.3-1632.8c0.9-40.7,0.7-95.6-15.8-113.5c-0.2-0.2-0.4-0.5-0.7-0.7c0.8,0,2,0.1,3.4,0.5 c1.7,0.5,3.7,1.4,5.7,3c3.4,2.7,6.8,7.6,9,16.2C1331-1707.2,1329.8-1642.8,1324.3-1632.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 1309.5308,
    y1: 2926.8186,
    x2: 1187.8264,
    y2: 2697.7283,
    gradientTransform: "matrix(1 0 0 -1 0 1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M1306.7-1689c-1.2,35.9-32.5,87.1-53.7,76.4c-6.6-3.4-7.4-35-7.5-42.5c8.8,0.9,24.2,0.1,26.5-0.4 c0.1,0,0.2-0.1,0.3-0.1s0.1-0.3,0.2-0.6l0,0c3.2-5.5,18.8-32,20.1-34.8c1.5-3.1,0.5-12.8,0.4-16.7s1.2-17.5,2.5-17 c1.3,0.4,0.9,15.7,1.8,15.5c1-0.2,4-18.2,5-18c1,0.2-0.8,20-0.5,22C1302-1703.2,1307.1-1698.8,1306.7-1689z"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1183.5-1295h79.6c0,0,0.7-2.9,0.2-6.2c-0.4-2.9-1.7-6.1-5.2-8c-7.5-3.9-36.4-18-42.6-24.6 c-6.3-6.6-5-9.5-8-9.7c0,0-17.1-1.4-19.1,1.2c-1.6,1.9-3.6,28.7-4.4,41.1C1183.6-1297.5,1183.5-1295,1183.5-1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1239.3-1321.3c0,0-6.9,6.6-10.3,7.5c-3.4,0.9-21-14.2-22.3-18.4c-1.3-4.2-2.7-20.8-2.7-20.8 s10.7,0,14.4,0c3.7,0,3.3,19.6,3.3,19.6S1240.9-1322.8,1239.3-1321.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1183.5-1295h79.6c0,0,0.7-2.9,0.2-6.2h-79.5C1183.6-1297.5,1183.5-1295,1183.5-1295z"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1342.9-1295h79.6c0,0,0.7-2.9,0.2-6.2c-0.4-2.9-1.7-6.1-5.2-8c-7.5-3.9-36.4-18-42.6-24.6 c-6.3-6.6-5-9.5-8-9.7c0,0-17.1-1.4-19.1,1.2c-1.6,1.9-3.6,28.7-4.4,41.1C1343.1-1297.5,1342.9-1295,1342.9-1295z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1398.7-1321.3c0,0-6.9,6.6-10.3,7.5c-3.4,0.9-21-14.2-22.3-18.4c-1.3-4.2-2.7-20.8-2.7-20.8 s10.7,0,14.4,0c3.7,0,3.3,19.6,3.3,19.6S1400.4-1322.8,1398.7-1321.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1342.9-1295h79.6c0,0,0.7-2.9,0.2-6.2h-79.4C1343.1-1297.5,1342.9-1295,1342.9-1295z"
  }))), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M1253.9-1593c0,0-1.2,5-3,13.1"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "st190",
    d: "M1276.1-1573.3c0,0-1.5,13.3-15.9,15"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M1268.5-1553.1c0,0-16.8,84-23,95.7c-6.2,11.7-46.2,104.5-46.2,104.5"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M1316.8-1537.6c0,0,38.7,91.2,40,105.5c1.3,14.3,0,79.1,0,79.1"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 778.2,
    y: -1321.9,
    className: "st168",
    width: 16.7,
    height: 26.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715.6,
    y: -1323.7,
    className: "st168",
    width: 16.7,
    height: 28.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014,
    y: -1329,
    className: "st168",
    width: 16.7,
    height: 33.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 951.3,
    y: -1331.4,
    className: "st168",
    width: 16.7,
    height: 35.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M789-1553.1c4.3,25.7,13.7,63,18.8,82.6c2.1,8.1,3.5,13.2,3.5,13.2l1.6,2l36.3,47.5h83.6 c0,0,0.9-28,0.8-60.9c0-2.9,0-5.8-0.1-8.7c-0.4-42.7-2.8-90-11.2-94.6c-15.6-8.4-124.6-13.4-133.9-8.4c-0.3,0.1-0.5,0.4-0.7,0.7 C785.9-1576.7,786.8-1566.5,789-1553.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 911.4,
    y1: -1540.7,
    x2: 905.1,
    y2: -1534.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 905.1,
    y1: -1540.7,
    x2: 911.4,
    y2: -1534.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 885.3,
    y1: -1540.7,
    x2: 878.9,
    y2: -1534.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 878.9,
    y1: -1540.7,
    x2: 885.3,
    y2: -1534.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 859.1,
    y1: -1540.7,
    x2: 852.8,
    y2: -1534.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 852.8,
    y1: -1540.7,
    x2: 859.1,
    y2: -1534.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 833,
    y1: -1540.7,
    x2: 826.6,
    y2: -1534.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 826.6,
    y1: -1540.7,
    x2: 833,
    y2: -1534.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 912.9,
    y1: -1515.6,
    x2: 906.6,
    y2: -1509.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 906.6,
    y1: -1515.6,
    x2: 912.9,
    y2: -1509.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 886.8,
    y1: -1515.6,
    x2: 880.4,
    y2: -1509.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 880.4,
    y1: -1515.6,
    x2: 886.8,
    y2: -1509.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 860.6,
    y1: -1515.6,
    x2: 854.3,
    y2: -1509.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 854.3,
    y1: -1515.6,
    x2: 860.6,
    y2: -1509.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 834.5,
    y1: -1515.6,
    x2: 828.1,
    y2: -1509.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 828.1,
    y1: -1515.6,
    x2: 834.5,
    y2: -1509.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 914.4,
    y1: -1490.5,
    x2: 908.1,
    y2: -1484.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 908.1,
    y1: -1490.5,
    x2: 914.4,
    y2: -1484.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 888.3,
    y1: -1490.5,
    x2: 881.9,
    y2: -1484.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 881.9,
    y1: -1490.5,
    x2: 888.3,
    y2: -1484.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 862.1,
    y1: -1490.5,
    x2: 855.8,
    y2: -1484.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 855.8,
    y1: -1490.5,
    x2: 862.1,
    y2: -1484.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 836,
    y1: -1490.5,
    x2: 829.6,
    y2: -1484.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 829.6,
    y1: -1490.5,
    x2: 836,
    y2: -1484.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 915.9,
    y1: -1465.4,
    x2: 909.6,
    y2: -1459
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 909.6,
    y1: -1465.4,
    x2: 915.9,
    y2: -1459
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 883.4,
    y1: -1465.4,
    x2: 889.8,
    y2: -1459
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 889.8,
    y1: -1465.4,
    x2: 883.4,
    y2: -1459
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 863.6,
    y1: -1465.4,
    x2: 857.3,
    y2: -1459
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 857.3,
    y1: -1465.4,
    x2: 863.6,
    y2: -1459
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 837.5,
    y1: -1465.4,
    x2: 831.1,
    y2: -1459
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 831.1,
    y1: -1465.4,
    x2: 837.5,
    y2: -1459
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 917.4,
    y1: -1440.3,
    x2: 911.1,
    y2: -1433.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 911.1,
    y1: -1440.3,
    x2: 917.4,
    y2: -1433.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 891.3,
    y1: -1440.3,
    x2: 884.9,
    y2: -1433.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 884.9,
    y1: -1440.3,
    x2: 891.3,
    y2: -1433.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 865.1,
    y1: -1440.3,
    x2: 858.7,
    y2: -1433.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 858.7,
    y1: -1440.3,
    x2: 865.1,
    y2: -1433.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 839,
    y1: -1440.3,
    x2: 832.6,
    y2: -1433.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st195",
    x1: 832.6,
    y1: -1440.3,
    x2: 839,
    y2: -1433.9
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M744-1465c6.6-1.2,13.6,0.7,19.8,3.9c8.4,4.4,15.3,11.3,17.4,16.3c0.5,1.2,1.2,3.5,2.1,6.6 c7.8,27.3,28,117.8,28,117.8s46.5,0,98.6-1c67-1.2,143.2-3.8,141.9-9.7c-2.3-9.8-18.4-102.7-46-130.1c-1.7-1.6-3.4-3.1-5.1-4.2 c-25.7-16.9-57.6-13.6-67.2-12.1c0,2.9,0,5.8,0,8.7c34,3.6,42.6,43.8,44.8,68c0.9,9.7,0.7,16.8,0.6,18.1c0,0.1,0,0.2,0,0.2h-112 c0,0-2.4-11.4-6.7-25.4c-5.3-17.6-13.4-39.2-22.9-47.2c-8.6-7.3-17.7-12-26.9-14.8c-0.9-0.3-1.7-0.5-2.6-0.7 c-16.8-4.5-33.4-2.9-46.5,0.2C754.4-1468.8,748.4-1466.7,744-1465z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M708-1323.3l103.3,2.9c0,0-24.9-112-30.1-124.4c-3.6-8.7-21.7-23.1-37.2-20.2c-3.1,0.6-6,1.8-8.7,3.9l0,0 c-3.3,2.5-6.2,6.3-8.6,11.6C712.5-1417.2,708-1323.3,708-1323.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M761.3-1470.4c13.1-3.1,29.7-4.7,46.5-0.2c-7.8-29.8-25.4-100.4-20-109c-10.2,2.1-37.5,9.4-40.8,28 C744.5-1538.1,753.5-1499.5,761.3-1470.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M860.2-1407.8c4.2,14,6.7,25.4,6.7,25.4H979c0,0,0-0.1,0-0.2c-13.3-11.5-46.2-25.2-46.2-25.2H860.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st170",
    d: "M932.8-1407.8c0,0,32.9,13.7,46.2,25.2c0.2-4.4,2.1-81-45.4-86.1c0-2.9,0-5.8-0.1-8.7L932.8-1407.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M789-1553.1c4.3,25.7,13.7,63,18.8,82.6c0.9,0.2,1.7,0.5,2.6,0.7c9.1,2.8,18.3,7.5,26.9,14.8 c9.5,8.1,17.6,29.7,22.9,47.2h67.2L789-1553.1z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1485.4-1391.5c0,0-3.7-29.5-19-41.6c-15.2-12.2-16.3-31.1-16.3-31.1s-20.7,71.8,5.8,85 C1482.3-1366.1,1485.4-1391.5,1485.4-1391.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st197",
    d: "M1450.2-1464.3c0,0-7.1,63.3,32,93.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M1492.2-1728.2c0,0,38.1,124.3,9.3,231.5c-28.8,107.2,10.8,146.6,10.8,146.6l-30.1-30.2 c0,0-12.8-94.9-9.6-143.2l9.6-4.9l-10.2-8.6C1472-1536.9,1498.7-1647.7,1492.2-1728.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1492.2-1728.2c3,14.2,5.3,28.5,7.4,42.9c2,14.4,3.6,28.8,4.6,43.3c0.1,1.8,0.3,3.6,0.4,5.4l0.3,5.4 c0.2,3.6,0.4,7.2,0.5,10.9c0.2,7.3,0.4,14.5,0.3,21.8v5.4v2.7l-0.1,2.7l-0.5,10.9c0,0.9-0.1,1.8-0.1,2.7l-0.2,2.7l-0.5,5.4 c-0.4,3.6-0.6,7.2-1.2,10.8l-1.6,10.8c-0.5,3.6-1.2,7.2-1.8,10.7c-0.6,3.6-1.2,7.2-1.8,10.7c-0.6,3.6-1.2,7.2-1.7,10.8 c-2.2,14.3-4.2,28.7-5.7,43.2c-0.4,3.6-0.7,7.2-1,10.8c-0.3,3.6-0.5,7.2-0.7,10.9c-0.3,7.2-0.6,14.5-0.4,21.8 c0,7.3,0.5,14.5,1.2,21.7c0.7,7.2,1.8,14.4,3,21.5c0,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.2-0.1-0.3-0.2l0,0c-1.2-7.2-2.3-14.3-3-21.6 c-0.7-7.2-1.1-14.5-1.1-21.8c-0.1-7.3,0.1-14.5,0.5-21.8c0.3-3.6,0.5-7.2,0.8-10.9c0.3-3.6,0.6-7.2,1-10.8 c1.5-14.4,3.5-28.8,5.7-43.2c0.5-3.6,1.2-7.2,1.7-10.8c0.6-3.6,1.2-7.2,1.8-10.7c0.6-3.6,1.3-7.2,1.8-10.7l1.6-10.8 c0.6-3.6,0.8-7.2,1.2-10.8l0.5-5.4l0.3-2.7c0.1-0.9,0.1-1.8,0.1-2.7l0.5-10.9l0.1-2.7v-2.7l0.1-5.4c0.2-7.3-0.1-14.5-0.2-21.8 c-0.1-3.6-0.3-7.3-0.5-10.9l-0.3-5.4c-0.1-1.8-0.3-3.6-0.4-5.4c-1-14.5-2.6-28.9-4.6-43.3 C1497.5-1699.6,1495.2-1714,1492.2-1728.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M1490.1-1380.2c0,0-8.1-76.3,7.2-106.1h9.9l-5.9-10.4c0,0,32.1-70.2,121.9-97.6c0,0-56.7,37.5-79.8,107 c-10.9-2.7-18.7-2.2-18.7-2.2l8.2,10.8c0,0-33.4,54.2-28.9,104.8C1508.6-1323.3,1490.1-1380.2,1490.1-1380.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st198",
    d: "M1623.3-1594.3c0,0-138.6,56.5-127.8,212.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st153",
    points: "1436,-1369.1 1436.4,-1356.6 1447.2,-1295 1516.2,-1295 1527.1,-1356.6 1528.4,-1363.7  1476.1,-1366.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M1423-1381.7v21.4c0,2,1.7,3.7,3.7,3.7h113.1c2.4,0,4.2-2.3,3.6-4.7l-5.8-21.4c-0.4-1.6-1.9-2.7-3.6-2.7 h-107.3C1424.6-1385.4,1423-1383.7,1423-1381.7z"
  }))), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M1557.5-1282.2H692.2c-3.5,0-6.4-2.9-6.4-6.4l0,0c0-3.5,2.9-6.4,6.4-6.4h865.4c3.5,0,6.4,2.9,6.4,6.4l0,0 C1563.9-1285.1,1561-1282.2,1557.5-1282.2z"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 720.8,
    y: -1662.3,
    className: "st44",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: -1638.4,
    className: "st168",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1391.2,
    y: -1650.2,
    className: "st44",
    width: 60.2,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1367.9,
    y: -1626.4,
    className: "st168",
    width: 60.2,
    height: 16.3
  })))), /*#__PURE__*/React.createElement("g", null, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2590.4-310.7c0,0,605.3-756.2,737.3-807c132-50.8,595.6,473.3,392.2,739.2S2590.4-310.7,2590.4-310.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2569-285.7L2569-285.7c0-33.9,16.3-65.6,43.8-85.4L3415-947.7c49.7-35.7,119.2-21.7,151.1,30.5L3919-340.6 c42.9,70.1-7.5,160.1-89.7,160.1H2674.2C2616.1-180.5,2569-227.6,2569-285.7z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3943,
    y: -221,
    className: "st2",
    width: 25.6,
    height: 40.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4038.8,
    y: -223.9,
    className: "st2",
    width: 25.6,
    height: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3582.7,
    y: -231.9,
    className: "st2",
    width: 25.6,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3678.5,
    y: -235.5,
    className: "st2",
    width: 25.6,
    height: 54.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3952.1-574.3c-6.5,39.2-20.9,96.2-28.7,126.1c-3.2,12.4-5.4,20.1-5.4,20.1l-2.4,3.1l-55.5,72.6h-127.7 c0,0-1.4-42.7-1.3-93c0-4.4,0-8.8,0.1-13.3c0.6-65.2,4.2-137.6,17-144.4c23.8-12.8,190.3-20.5,204.6-12.8c0.4,0.2,0.8,0.6,1.1,1.1 C3956.8-610.3,3955.5-594.7,3952.1-574.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3765.1,
    y1: -555.4,
    x2: 3774.8,
    y2: -545.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3774.8,
    y1: -555.4,
    x2: 3765.1,
    y2: -545.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3805,
    y1: -555.4,
    x2: 3814.7,
    y2: -545.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3814.7,
    y1: -555.4,
    x2: 3805,
    y2: -545.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3845,
    y1: -555.4,
    x2: 3854.7,
    y2: -545.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3854.7,
    y1: -555.4,
    x2: 3845,
    y2: -545.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3884.9,
    y1: -555.4,
    x2: 3894.6,
    y2: -545.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3894.6,
    y1: -555.4,
    x2: 3884.9,
    y2: -545.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3762.8,
    y1: -517,
    x2: 3772.5,
    y2: -507.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3772.5,
    y1: -517,
    x2: 3762.8,
    y2: -507.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3802.7,
    y1: -517,
    x2: 3812.4,
    y2: -507.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3812.4,
    y1: -517,
    x2: 3802.7,
    y2: -507.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3842.7,
    y1: -517,
    x2: 3852.4,
    y2: -507.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3852.4,
    y1: -517,
    x2: 3842.7,
    y2: -507.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3882.6,
    y1: -517,
    x2: 3892.3,
    y2: -507.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3892.3,
    y1: -517,
    x2: 3882.6,
    y2: -507.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3760.5,
    y1: -478.6,
    x2: 3770.2,
    y2: -468.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3770.2,
    y1: -478.6,
    x2: 3760.5,
    y2: -468.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3800.4,
    y1: -478.6,
    x2: 3810.2,
    y2: -468.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3810.2,
    y1: -478.6,
    x2: 3800.4,
    y2: -468.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3840.4,
    y1: -478.6,
    x2: 3850.1,
    y2: -468.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3850.1,
    y1: -478.6,
    x2: 3840.4,
    y2: -468.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3880.3,
    y1: -478.6,
    x2: 3890.1,
    y2: -468.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3890.1,
    y1: -478.6,
    x2: 3880.3,
    y2: -468.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3758.2,
    y1: -440.3,
    x2: 3767.9,
    y2: -430.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3767.9,
    y1: -440.3,
    x2: 3758.2,
    y2: -430.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3807.9,
    y1: -440.3,
    x2: 3798.2,
    y2: -430.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3798.2,
    y1: -440.3,
    x2: 3807.9,
    y2: -430.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3838.1,
    y1: -440.3,
    x2: 3847.8,
    y2: -430.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3847.8,
    y1: -440.3,
    x2: 3838.1,
    y2: -430.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3878.1,
    y1: -440.3,
    x2: 3887.8,
    y2: -430.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3887.8,
    y1: -440.3,
    x2: 3878.1,
    y2: -430.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3755.9,
    y1: -401.9,
    x2: 3765.7,
    y2: -392.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3765.7,
    y1: -401.9,
    x2: 3755.9,
    y2: -392.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3795.9,
    y1: -401.9,
    x2: 3805.6,
    y2: -392.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3805.6,
    y1: -401.9,
    x2: 3795.9,
    y2: -392.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3835.8,
    y1: -401.9,
    x2: 3845.6,
    y2: -392.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3845.6,
    y1: -401.9,
    x2: 3835.8,
    y2: -392.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3875.8,
    y1: -401.9,
    x2: 3885.5,
    y2: -392.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3885.5,
    y1: -401.9,
    x2: 3875.8,
    y2: -392.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4020.9-439.6c-10-1.9-20.8,1-30.3,6c-12.9,6.7-23.3,17.3-26.5,24.9c-0.8,1.9-1.9,5.4-3.3,10.1 c-12,41.7-42.7,179.9-42.7,179.9s-71.1-0.1-150.7-1.5c-102.4-1.8-218.8-5.9-216.8-14.8c3.4-14.9,28.2-156.9,70.2-198.8 c2.5-2.5,5.1-4.7,7.8-6.4c39.3-25.8,88-20.7,102.7-18.4c-0.1,4.5-0.1,8.9-0.1,13.3c-51.9,5.6-65.1,66.9-68.4,103.9 c-1.3,14.8-1,25.7-0.9,27.6c0,0.2,0,0.3,0,0.3h171.3c0,0,3.7-17.5,10.2-38.9c8.1-26.8,20.4-59.8,35-72.2 c13.1-11.2,27.1-18.3,41-22.6c1.3-0.4,2.6-0.8,4-1.1c25.7-6.9,51.1-4.4,71,0.3C4005-445.4,4014.1-442.3,4020.9-439.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M4075.8-223.2l-157.8,4.5c0,0,38.1-171,46-190c5.5-13.2,33.2-35.3,56.8-30.9c4.7,0.9,9.2,2.8,13.3,6 c0,0,0,0,0,0c5,3.9,9.5,9.6,13.1,17.8C4069-366.6,4075.8-223.2,4075.8-223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3994.4-447.9c-20-4.7-45.4-7.2-71-0.3c11.9-45.5,38.8-153.5,30.6-166.6c15.5,3.2,57.3,14.4,62.4,42.8 C4020.1-551.3,4006.3-492.4,3994.4-447.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3843.4-352.3c-6.5,21.4-10.2,38.9-10.2,38.9h-171.3c0,0,0-0.1,0-0.3c20.4-17.6,70.6-38.6,70.6-38.6H3843.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3732.4-352.3c0,0-50.2,21-70.6,38.6c-0.2-6.8-3.3-123.8,69.3-131.5c0-4.4,0-8.8,0.1-13.3L3732.4-352.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3952.1-574.3c-6.5,39.2-20.9,96.2-28.7,126.1c-1.3,0.4-2.6,0.7-4,1.1c-13.9,4.3-27.9,11.4-41,22.6 c-14.6,12.3-26.9,45.3-35,72.2h-102.7L3952.1-574.3z"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2727.2-350c0,0,6.5-51.7,33.3-73.2c26.8-21.4,28.6-54.7,28.6-54.7s36.3,126.1-10.1,149.3 C2732.6-305.4,2727.2-350,2727.2-350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M2789.1-477.8c0,0,12.5,111.2-56.2,163.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2715.3-941.5c0,0-67,218.4-16.3,406.7c50.8,188.4-19,257.6-19,257.6l52.8-53c0,0,22.5-166.8,17-251.5 l-17-8.6l17.8-15.1C2750.7-605.4,2703.8-800.2,2715.3-941.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M2715.3-941.5c-5.3,25-9.4,50.2-12.9,75.4c-3.4,25.3-6.2,50.6-8,76.1c-3.6,50.8-4,102.1,2.4,152.8 c0.4,3.2,0.8,6.3,1.3,9.5l1.5,9.4c1,6.3,2.1,12.6,3.2,18.9l1.6,9.4l1.5,9.4c1,6.3,2.1,12.6,3,18.9c4,25.2,7.4,50.5,10,75.9 c0.4,3.2,0.6,6.3,0.9,9.5l0.8,9.5c0.5,6.4,0.9,12.7,1.3,19.1l0.4,9.6c0.1,3.2,0.3,6.4,0.3,9.6c0.1,6.4,0.3,12.8,0.1,19.1 c-0.1,12.8-0.9,25.5-2,38.2l-1,9.5c-0.3,3.2-0.8,6.3-1.3,9.5l-0.7,4.7c-0.2,1.6-0.5,3.1-0.8,4.7l-1.6,9.4c0,0.1-0.2,0.3-0.3,0.2 c-0.1,0-0.3-0.2-0.2-0.3v0l0,0l1.6-9.4c0.3-1.6,0.6-3.1,0.8-4.7l0.7-4.7c0.4-3.2,0.9-6.3,1.3-9.5l1-9.5 c1.2-12.7,2-25.4,2.1-38.2c0.2-6.4,0-12.7-0.1-19.1c0-3.2-0.2-6.4-0.3-9.6l-0.4-9.6c-0.4-6.4-0.8-12.7-1.3-19.1l-0.8-9.5 c-0.3-3.2-0.5-6.4-0.9-9.5c-2.6-25.4-6-50.7-10-75.9c-0.9-6.3-2-12.6-3-18.9l-1.5-9.4l-1.6-9.4c-1.1-6.3-2.2-12.6-3.2-18.9 l-1.5-9.5c-0.5-3.1-0.8-6.3-1.3-9.5c-6.4-50.7-5.9-102-2.3-152.8c1.8-25.4,4.6-50.8,8.1-76.1 C2705.9-891.3,2710.1-916.5,2715.3-941.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2718.9-330.1c0,0,14.3-134-12.7-186.4h-17.4l10.3-18.2c0,0-56.3-123.3-214.1-171.5c0,0,99.5,65.8,140.2,188 c19.2-4.7,32.9-3.9,32.9-3.9l-14.4,19c0,0,58.7,95.2,50.8,184C2686.4-230.2,2718.9-330.1,2718.9-330.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2485-706.2c0,0,243.5,99.3,224.4,372.9"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "2814.1,-310.7 2813.3,-288.7 2809.1,-180.5 2673.1,-180.5 2653.9,-288.7 2651.7,-301.2  2743.6,-306.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2836.9-332.7v37.5c0,3.6-2.9,6.5-6.5,6.5h-198.7c-4.3,0-7.4-4.1-6.3-8.2l10.2-37.5c0.8-2.8,3.4-4.8,6.3-4.8 h188.6C2834-339.3,2836.9-336.3,2836.9-332.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 2989.9216,
    y1: -863.3833,
    x2: 3070.4246,
    y2: -795.5704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st200",
    points: "3062.2,-819.8 3044.1,-796.3 3034,-804.8 2990,-842 2989.6,-842.4 2989.6,-885.2 2990.9,-883.9  3010,-866.7  "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3137.7-785.5c0,0-0.4,2.5-0.8,6.5c-12.7,14.2-31.6,34-39.2,35.2c-3.4,0.5-10-3.8-17.9-10.3 c-19.8-16.5-47.2-47.3-47.3-49.9c-0.2-3.6,16.4-27,19.6-28.2c3.2-1.2,37.6,29.5,40,31.8c2.5,2.3,36.5-56.6,36.5-56.6 c4.6,5.4,7.3,13.2,8.9,21.8C3141.6-812.7,3137.7-785.5,3137.7-785.5z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3295.9-696.9c-0.3,1-9.4,12.4-15.8,20.3c-3.5,4.3-6.2,7.6-6.2,7.6s-1-1.4-2.6-3.9c-0.7-1.1-1.6-2.5-2.6-4 c-0.3-0.5-0.6-1-1-1.5c-0.2-0.4-0.5-0.7-0.7-1.1c-1-1.5-2-3.2-3.1-4.9c-0.8-1.2-1.6-2.5-2.4-3.9c-1.8-3-3.7-6.1-5.6-9.4 c-2-3.4-4-6.9-5.8-10.4c-4.8-8.9-8.7-17.5-10.1-23.7c-3.8-17,2.5-93,4.1-112.1c0.2-2.8,0.4-4.3,0.4-4.3s1.2,1.2,3.3,4.6 c0.7,1.1,1.4,2.4,2.2,3.9c2.6,5,6,12.6,9.7,24c3.5,10.5,7.3,24.3,11.2,42.3c11.3,52.6,21.5,69.8,24.3,74.8 C3295.7-697.7,3295.9-697.2,3295.9-696.9z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M3265.2-641.6c-0.2,2-0.6,3.8-1.2,5.5c-0.2,0.6-0.4,1.2-0.7,1.8c-0.8,1.9-2.3,3.5-4.3,4.9 c-2.6,1.8-6.1,3.3-10.3,4.4c-3,0.8-6.4,1.5-10.1,2c-4.9,0.7-10.3,1-16,1.2c-30.7,0.7-69.9-5.9-87.2-15.5c-2.5-1.4-4.6-2.9-6-4.4 c-3.3-3.4-5.3-7.6-6.3-12.4c-1-4.7-1.1-10.1-0.6-16c0.9-11.6,4.1-25.2,7-40c1-5.2,2-10.4,2.9-15.9c1.4-8.7,2.4-17.7,2.6-26.8 c0.2-10.1,1.2-20,1.9-26.2c0-0.3,0.1-0.5,0.1-0.8c0.4-3.6,0.8-5.7,0.8-5.7s7.5-51.7-9.1-71.4c15.4-6.9,24.6-11.2,31.2-14.2 c10.3-4.6,14.1-5.7,25.3-7.8c0,0,20.6,4.4,39.7,15.4c7.5,4.3,14.9,9.6,20.6,16.1c1,1.2,2,2.4,3,3.6c0,0,0,0,0,0 c1.3,1.7,2.1,4.8,2.7,8.8c1.1,8,1,20,0.3,33.3c-0.2,4.2-0.5,8.5-0.8,12.9c-1.7,24.6-4.3,50.4-3.9,62.4c0.2,5.2,1.5,11.4,3.4,18.2 c4.3,15.6,11.5,34.1,14.3,49.9C3265.4-652.2,3265.8-646.6,3265.2-641.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 3224.6641,
    y1: -974.7496,
    x2: 3153.2837,
    y2: -839.1266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M3211.7-887.9c0.3,12.6,3.5,38-17.8,37c-0.4,0-0.9,0-1.3-0.1c-20.6-1.8-12.7-21.8-14.7-27.9 c-1-3-3.6-3-6.8-3.2c-3.4-0.2-7.4-0.5-10.7-4.9c-3.7-4.8-5.8-18-6.9-28.4c-0.4-3.3-0.6-6.3-0.8-8.7c23.2-0.8,53.2-12.8,53.2-12.8 s-0.4,1.7-0.8,4.3c-0.4,3-0.9,7.3-0.7,11.7c0.3,8.3,4.2-10.4,10.7-6.8c6.5,3.6-0.9,17.9-5.4,22.8 C3206.7-901.5,3208.9-893.1,3211.7-887.9z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M3233.3-902c-8.3,10.7-16.4,18.4-17.7,18.5c-1,0.1-2.5-1.7-3.9-4.4c-2.7-5.2-5-13.6-2.1-16.9 c4.5-4.9,11.9-19.2,5.4-22.8c-6.6-3.6-10.4,15.2-10.7,6.8c-0.3-8.3,1.5-16.1,1.5-16.1s-30,12-53.2,12.8c-3.1,0.1-6.2,0-9-0.3 c-1.2-5.1-1.6-9.8-1.6-13.9c0-10.3,2.9-16.9,3.3-17.8c-0.5,0.7-3.1,4.9-7.7,17.8c3.9-36.5,16.7-45,49.1-48 c32.4-19.6,39.9,22,39.9,22s18.7-8.3,25,15.7C3255.1-934.8,3244.1-915.9,3233.3-902z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3300.1-679.1c-2.5,4.3-8.3,9.4-13.5,13.3c-2.2,1.6-4.2,3-6,4c-2.2,1.3-3.9,2-4.6,1.8 c-2.8-0.8-6.1-5.4-6-10.1c0-0.6,0.5-1.6,1.2-2.8c1.3-2.1,3.4-5,5.9-8.1c6.8-8.4,16-18.2,16-18.2c0.7-0.2,1.4,0,2.1,0.7 c2.6,2.2,5.3,8.9,6.3,15C3301.6-682.3,3301.1-680.8,3300.1-679.1z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3061.3-832.4c0,0-17.5,45-24.1,41.7c-6.5-3.3-13.4-9.8-10.7-17.9c2.7-8,18.1-31.5,27.1-28.6 C3062.5-834.2,3063.2-837.1,3061.3-832.4z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3211.8-869.9c0,0-1.4,17.5-13.9,18.9c8.2,10.8,12.8,9,15.2,7.3C3215.4-845.3,3218.4-864.7,3211.8-869.9z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M3287.6-227.7c-7.1,10.5-39.7,11.7-45.2,4c-5.6-7.8-11.1-250.8-35.5-336.2c-14.9,25.6-6.8,326.7-13,333.7 c-2.7,3.1-51.5,13.7-54.4-3.6c-14.4-86-9.6-277-5.8-368.7c0.7-16.6,1.3-30,1.8-38.8c26.3,14.7,103.3,22.1,123.7,8 c0.4,1.1,0.8,2.2,1.2,3.3C3300.3-512.7,3294.3-237.5,3287.6-227.7z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3194.5-180.8h-86c0,0,0.9-25.5,16.4-26.7c2.8-0.2,5.2,0.1,7.3,0.9c9.3,3.3,11.5,14.3,11.5,14.3h48.5 C3192.1-192.3,3194.8-186.1,3194.5-180.8z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M3190.3-192.3h-46.7c0,0-2.2-11-11.5-14.3c4.7-3.3,12.7-9.3,14.3-12.8c16.2-3.5,37.6-1.8,39.1,0 C3187-217.6,3190.3-192.3,3190.3-192.3z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M3138.5-211.4c0,0,9.9,2,13,1.6c3.1-0.4,14.4-26,12.9-29c-1.5-3-18.7-1.8-20.2,0 C3142.7-237,3142-217.5,3138.5-211.4z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3240.1-180.5l86-0.4c0,0-1-25.5-16.5-26.7c-2.8-0.2-5.2,0.2-7.3,0.9c-9.3,3.3-11.4,14.3-11.4,14.3 l-48.5,0.2C3242.4-192.1,3239.8-185.9,3240.1-180.5z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M3244.2-192.2l46.7-0.2c0,0,2.1-11,11.4-14.3c-4.7-3.3-12.7-9.2-14.3-12.7c-16.3-3.5-37.7-1.6-39.1,0.2 C3247.3-217.4,3244.2-192.2,3244.2-192.2z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M3295.9-211.4c0,0-9.9,2.1-13,1.7s-14.5-25.9-13.1-28.9c1.5-3,18.7-1.9,20.2-0.1 C3291.6-237,3292.3-217.5,3295.9-211.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 3267.1016,
    y1: -696.4402,
    x2: 3408.6616,
    y2: -483.5046
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M3338.8-592c-0.1,11.3-10.2,12.2-17.3,8.3c-6.1-3.3-14.4-30.7-20.7-45.3c-1.1-2.5-2.1-4.6-3.1-6.2 c-4.2-6.9-12-19-17-26.7c1.7-1,3.8-2.4,6-4c5.3-3.9,11-9,13.5-13.3c4.7,10.8,14.8,33.3,17.5,35.3c3.6,2.7,20.2,21.1,21.1,26.5 c0.9,5.4-5.6,1.5-8.3,1.2C3327.7-616.4,3338.9-603.3,3338.8-592z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3162-621.9c0,0,4.8,17.9-17.8,31.6"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3240.8-615.8c0,0,1.5,20.8,26.5,25.6"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3151.3-572.7c0,0-21.2,210.5,0,328"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3218.5-559.9c0,0,38.1,212.7,30.9,332.3"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3137.7-785.5c0,0-0.4,2.5-0.8,6.5c-12.7,14.2-31.6,34-39.2,35.2c-3.4,0.5-10-3.8-17.9-10.3 c4.7,0.2,10.8,0.1,16.7-0.4c10.8-1,37.9-57.6,41-80.6C3141.6-812.7,3137.7-785.5,3137.7-785.5z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3178.1-877.4c0,0-1.8,22.7,15.8,26.6c-0.1,8.2-12.6,14.2-15.8,10.5C3174.8-844.1,3165.3-868.6,3178.1-877.4z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 3007.2146,
    y1: -762.6967,
    x2: 3111.8982,
    y2: -832.2875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M3149.9-855.1c-8.9,2.1-36.1,6.3-40.4,10.7c-0.4,0.5-1.4,2.2-2.7,5c-11.4,23.5-52.1,120.8-77,117.6 c-0.5,0-0.9-0.1-1.4-0.2c-13.9-3-27.8-23.5-37.9-42.9c-4.9-9.4-9-18.5-11.8-25.2c14.8-3.2,32.9-15.8,39.3-22 c0.6,1.4,1.1,2.8,1.6,4.2c4.2,11.2,8,23.9,9.5,29.1c0.4,1.5,0.7,2.4,0.7,2.4s1-1,2.6-2.8c9.2-9.9,39.8-43.9,44.2-58.7 c5.2-17.4,12.7-43.6,17.5-40.4c4.8,3.2,0.4,19,7.5,17.8C3138.4-869,3156.7-856.7,3149.9-855.1z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2970.9-887.7c0,1.2,0,2.2-0.1,3c0,1-1.4,1.8-3.8,2.4c-18.3,5-97,1.2-109.7-15.5c-1.3-1.7-1.9-3.6-1.7-5.6 c0,0,16.7-39.5,67.2-34.2c41.1,4.4,47.2,30.6,47.9,45.2C2970.9-890.6,2970.9-889,2970.9-887.7z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M3020.3-815.5c0,0.6-0.8,1.7-2.3,3.2c-4.6,4.5-15.2,12.2-26.3,17.4c-2.8,1.3-5.6,2.5-8.3,3.3 c-1.3,0.4-2.6,0.8-3.9,1.1c-0.3,0.1-0.5,0.1-0.8,0.2c-1,0.2-2.1,0.4-3.1,0.6c0,0-0.1,0-0.1,0c-0.7,0.1-1.4,0.4-2.1,0.9 c-1,0.7-1.8,1.8-2.6,3.3c-2.4,4.7-3.8,13-4.5,23.3c-0.1,1.1-0.2,2.2-0.2,3.3c0,0.9-0.1,1.8-0.1,2.7c-0.1,1.1-0.1,2.2-0.1,3.3 c-0.3,7.3-0.3,15.2-0.1,23.3c0,1.1,0.1,2.2,0.1,3.3c0,0.9,0,1.8,0.1,2.7c0,1.1,0.1,2.2,0.1,3.3c0.3,7.9,0.7,15.8,1.2,23.3 c0.1,1.1,0.2,2.2,0.2,3.3c0.1,0.9,0.1,1.8,0.2,2.7c0.1,1.1,0.1,2.3,0.2,3.3c0.7,9.2,1.4,17.3,2,23.3c0,0.5,0.1,1,0.1,1.4 c0.1,0.7,0.1,1.3,0.2,1.9c0.1,1,0.2,1.9,0.3,2.7c0.2,1.4,0.3,2.5,0.4,3.3c0.1,0.9,0.2,1.4,0.3,1.6c0.3,1-12.2,4.1-29.4,6.1 c-14.7,1.8-32.9,2.7-49.4,0.9c-6.2-0.7-12.1-1.8-17.6-3.4c-4.7-1.3-8.9-3.1-12.7-5.2c-0.3-0.1-0.5-0.3-0.8-0.4 c-1.4-0.8-2.7-1.8-3.9-2.9c-0.9-0.8-1.8-1.7-2.6-2.7c-0.8-1-1.6-2.2-2.3-3.3c-0.1-0.2-0.3-0.4-0.4-0.7c-3.5-6.1-5.6-13.9-6.6-22.6 c-0.1-1.1-0.3-2.2-0.4-3.3c-0.1-0.9-0.2-1.8-0.2-2.7c-0.1-1.1-0.1-2.2-0.2-3.3c-0.3-7.6,0-15.5,0.6-23.3c0.1-1.1,0.2-2.2,0.3-3.3 c0.1-0.9,0.2-1.8,0.3-2.7c0.1-1.1,0.3-2.2,0.4-3.3c1-8.4,2.2-16.4,3.5-23.3c0.2-1.2,0.4-2.3,0.6-3.3c0.2-0.9,0.4-1.8,0.6-2.7 c0.2-1.2,0.5-2.3,0.7-3.3c1.8-8.6,3.3-14,3.3-14l-0.7-9.3l-0.3-3.3l-0.2-2.7l-0.3-3.3l-0.1-1.4l-0.8-10.1c0,0-2,5-4.6,11.5 c0,0.1-0.1,0.2-0.1,0.3c-0.4,1-0.8,2-1.3,3c-0.4,0.9-0.8,1.8-1.2,2.7c-0.4,0.9-0.8,1.7-1.1,2.6c-0.1,0.3-0.2,0.5-0.3,0.7 c-3.7,8.5-7.6,16.6-9.4,17.7c-0.4,0.2-1.1,0.3-1.9,0.2c-5.7-0.8-20.8-8.8-30.1-17.8c-1.1-1.1-2.2-2.2-3.1-3.3 c-0.5-0.6-1-1.2-1.4-1.7c-0.2-0.3-0.5-0.7-0.7-1c-0.8-1.1-1.4-2.2-1.8-3.3c-0.4-0.9-0.7-1.8-0.8-2.7c0,0,3.4-8.6,8.5-20.5 c0.5-1.1,1-2.2,1.4-3.3c0.4-0.9,0.8-1.8,1.2-2.7c0.5-1.1,1-2.2,1.5-3.3c1.6-3.5,3.2-7.2,4.9-10.8c1.9-4.2,3.9-8.4,6-12.4 c0.6-1.1,1.1-2.2,1.7-3.3c0.5-0.9,0.9-1.8,1.4-2.7c0.6-1.1,1.2-2.3,1.8-3.3c0.9-1.7,1.8-3.3,2.7-4.9c3.9-6.8,7.7-12.6,11-16.3 c0.3-0.4,0.6-0.7,1-1.1c0.3-0.3,0.6-0.7,1-1c1.2-1.1,2.4-2.2,3.8-3.3c1.1-0.9,2.3-1.8,3.6-2.7c1.6-1.2,3.3-2.3,5.1-3.3 c6.3-3.9,13.6-7.4,21.1-10.3c2.5-1,5.1-1.9,7.6-2.7c13.7-4.5,27.5-7.1,37.4-6.7c9,0.3,22.9,5,36.7,10.9c4.1,1.8,8.2,3.6,12.1,5.5 c2.3,1.1,4.5,2.2,6.7,3.3c2.2,1.1,4.4,2.2,6.4,3.3c1.7,0.9,3.4,1.9,4.9,2.7c0.7,0.4,1.3,0.8,2,1.1c1.3,0.8,2.5,1.5,3.7,2.2 c3.8,2.4,6.3,4.2,7.2,5.4c0.1,0.1,0.3,0.3,0.4,0.6c1.6,2.5,4.5,9.2,7.6,17.4c0.4,1.1,0.9,2.2,1.3,3.3c0.3,0.7,0.5,1.3,0.8,2 c0.1,0.2,0.2,0.5,0.3,0.7c0.4,1.1,0.8,2.2,1.2,3.3c3.1,8.2,6.1,16.7,8.3,23.3c0.4,1.2,0.8,2.3,1.1,3.3c0.3,1,0.6,1.9,0.9,2.7 c0.4,1.3,0.8,2.4,1,3.3C3020.1-816.8,3020.3-815.8,3020.3-815.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 2789.3557,
    y1: -672.0938,
    x2: 2721.9451,
    y2: -742.6766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M2832.5-767.7c-2.2,5-6.2,14-10.8,23.9c-9.5,20.6-21.4,45.3-24.4,46.6c-5.2,2.3-79.3-3.4-88.8-1.1 c-9.5,2.3-33.7,34.1-45.6,32.7c-11.9-1.3-0.8-30.5,17.2-42.6c-9.5-0.1-12.2-3.3-12.6-8.1c2.8-3.1,17.5-0.7,28.6-3.1 c11.1-2.4,73.9-14.3,80.7-15l16.8-44.7l4.4-11.6C2806-779.6,2825.8-768.7,2832.5-767.7z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M3001.9-240c-3,2.4-6.4,4-10.3,4.2c-10.4,0.6-21.1,0.3-29-3.8c-2.4-1.2-4.6-2.8-6.4-4.9 c-0.9-1-2.1-5.8-3.6-13.7c-5.3-27.9-13.8-93.8-21.4-157c-8.8-72.7-16.6-141.9-17.1-146.3l0-0.2c0,0-40.3,190.3-62.2,306.1 c-0.7,3.8-1.4,7.5-2.1,11.1c-2,3.4-4.8,6-8,7.9c-10.7,6.3-26.5,4.7-35.6-0.6c-3.4-2-5.9-4.5-6.9-7.3c-0.4-1.1-0.5-4.9-0.3-11 c1.5-52.5,21.6-273.6,29.9-364c0.7-7.4,1.3-13.9,1.8-19.3c13.8,14.8,36.9,10.8,41.6,3.9c0.7-1,1.5-6.3,2.4-14.8 c18.8,5.4,47.3,2.4,67.5,0c0.1,0.9,0.2,1.7,0.2,2.5c0,0.1,0,0.2,0,0.3c0.4,3.6,0.8,6,1.4,7.3c5.9,13.3,22.7,12.7,37.5,5.4 c7,81.1,27.7,321.3,31.3,363.7c0.3,3.4,0.5,5.6,0.5,6.2C3013.7-256.9,3009.4-245.9,3001.9-240z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2851-180.8h-53.8c0,0,0.4-4,1.1-9c1-6.7,2.6-15.3,4.8-18.9c0.5-0.8,1-1.3,1.5-1.6c3.3-1.4,3.5-8.1,7.1-12.4 c1.7-2,4.2-3.5,8-3.7c2.7-0.1,4.7,0.5,6.4,1.5c5.8,3.8,6.1,13.2,8.2,14.8c0.8,0.6,2.1,0.9,3.7,1.8c3,1.6,7,5,10.3,15.9 C2849.3-189.1,2850.2-185.3,2851-180.8z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M3071-180.8h-109.2c0,0,0.5-9.7,1.5-18.8c0.7-5.8,1.7-11.3,2.9-13.9c0.1-0.3,0.3-0.5,0.4-0.7 c4.1-5.2,20.3,7.2,24.8,6.6c4.8-0.6,5.7-12.8,10.4-15.5c0.1-0.1,0.3-0.1,0.4-0.2c1.2-0.3,3,0.6,5.1,2.3c6.8,5.2,17.8,17.5,29.9,19 c3.2,0.4,6.4,0.7,9.5,1.1c10.5,1.3,19.6,3.5,22.9,13C3070.5-185.7,3070.9-183.4,3071-180.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 2986.6431,
    y1: -406.2492,
    x2: 2979.5056,
    y2: -101.719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M3002.5-223.1c-0.1,0-0.3,0.1-0.4,0.2c-4.8,2.7-5.6,14.9-10.4,15.5c-4.6,0.6-20.8-11.8-24.8-6.6 c-0.8-5-1.7-10.9-2.6-16.1c-0.6-3.6-1.2-6.9-1.6-9.4c7.9,4.1,18.6,4.5,29,3.8c3.9-0.2,7.3-1.8,10.3-4.2l0.3,10.8L3002.5-223.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 2826.8066,
    y1: -409.9958,
    x2: 2819.6692,
    y2: -105.4632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M2841.8-236.6l-0.4,2.9l-3.4,25.6c-1.6-0.9-2.9-1.2-3.7-1.8c-2.1-1.6-2.4-11.1-8.2-14.8 c-1.6-1.1-3.7-1.7-6.4-1.5c-3.9,0.2-6.3,1.7-8,3.7c-3.7,4.3-3.9,11-7.1,12.4c-0.5,0.2-1,0.8-1.5,1.6l1.6-14.5l1.5-14.1 C2815.3-231.8,2831.1-230.3,2841.8-236.6z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2876.3-628.7c0,0-13.1,26.5-36.9,23"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 2855.7,
    y1: -598.6,
    x2: 2855.5,
    y2: -597.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st30",
    x1: 2855.3,
    y1: -595.3,
    x2: 2818.4,
    y2: -249.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 2818.2,
    y1: -248.7,
    x2: 2818.1,
    y2: -247.7
  })))), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st31",
    x1: 2920,
    y1: -559.9,
    x2: 2973.5,
    y2: -244.7
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2931.2-415.2c-8.8-72.7-16.6-141.9-17.1-146.3l0-0.2c0,0,11.5,0.6,32.6-11"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2851.9-255.6c-0.7,3.8-1.4,7.5-2.1,11.1c-2,3.4-4.8,6-8,7.9c-10.7,6.3-26.5,4.7-35.6-0.6 c-3.4-2-5.9-4.5-6.9-7.3c-0.4-1.1-0.5-4.9-0.3-11C2811.8-250.8,2831.6-246.7,2851.9-255.6z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3001.9-240c-3,2.4-6.4,4-10.3,4.2c-10.4,0.6-21.1,0.3-29-3.8c-2.4-1.2-4.6-2.8-6.4-4.9 c-0.9-1-2.1-5.8-3.6-13.7c13.3,6.1,41,14.3,60-12.3c0.3,3.4,0.5,5.6,0.5,6.2C3013.7-256.9,3009.4-245.9,3001.9-240z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3002.3-229.1c-14.3,2.9-29.1,0.8-38.1-1.1c-0.6-3.6-1.2-6.9-1.6-9.4c7.9,4.1,18.6,4.5,29,3.8 c3.9-0.2,7.3-1.8,10.3-4.2L3002.3-229.1z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M3046.9-200.7c-6.8,6.5-37.3-4.3-40.3-7.4c-2.5-2.5-0.5-8.7,1-12.8c6.8,5.2,17.8,17.5,29.9,19 C3040.6-201.4,3043.9-201.1,3046.9-200.7z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3071-180.8h-109.2c0,0,0.5-9.7,1.5-18.8c3.4,4.1,8.8,9.6,15,11.5c8.4,2.6,69.3,1,91.4,0.3 C3070.5-185.7,3070.9-183.4,3071-180.8z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M2815.3-220.9c0,0-6.1,8.1-6.1,12.8c0,4.7,4.6,11,9.9,12.2c5.4,1.2,9.5-5.6,9.9-10.1 C2829.3-210.6,2829.2-222.6,2815.3-220.9z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M2851-180.8h-53.8c0,0,0.4-4,1.1-9c11.1,0.9,39.4,2.6,50-2.5C2849.3-189.1,2850.2-185.3,2851-180.8z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2841.8-236.6l-0.4,2.9c-4.8,4.6-10.1,7.3-15.3,9c-1.6-1.1-3.7-1.7-6.4-1.5c-3.9,0.2-6.3,1.7-8,3.7 c-2.8,0-5.3-0.2-7.1-0.5l1.5-14.1C2815.3-231.8,2831.1-230.3,2841.8-236.6z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M2880-738.7c-1,24.5-2.1,47.4-3.4,65.4c-0.6,9.3-1.3,17.3-1.9,23.6c-0.8,8.5-1.6,13.8-2.4,14.8 c-4.8,6.9-27.8,10.9-41.6-3.9c-1.8-1.9-3.4-4-4.8-6.5c-12.2-21.8,25.2-118.2,21.8-149.3c-0.1-0.7-0.2-1.4-0.3-2 c-4-21.4-16-53.5-21.8-68.5c-2-5.1-3.3-8.2-3.3-8.2c-2.4-19,42.8-46.4,55.9-39.3c0.6,1.6,1,3.8,1.5,6.8c0.4,2.6,0.7,5.7,1,9.2 C2883.3-864.9,2882.3-797.3,2880-738.7z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M3000.4-885.9c0,0-1,3.1-2.6,8.3c-5.3,17.5-16.9,59.1-17.7,87v0.2c0,1.2-0.1,2.4,0,3.6c0,0.7,0,1.4,0,2.1 c1.2,35.1,26.1,133.2,10.1,145.1c-2.6,1.9-5.4,3.6-8.2,5.1c-0.2,0.1-0.5,0.2-0.7,0.3c-14.7,7.3-31.6,7.8-37.5-5.4 c-0.6-1.3-1-3.9-1.4-7.6v-0.1c-0.1-0.7-0.1-1.6-0.2-2.4c-0.4-5-0.6-11.6-0.8-19.4c-0.3-18.1,0-42.7,0.8-69.1 c0.2-6.5,0.4-13.1,0.7-19.7c0.5-13.4,1.1-27.1,1.8-40.3c2.1-40.4,4.8-77.2,7.7-94.4c0.2-1.1,0.4-2.1,0.5-3.1c0-0.1,0-0.1,0-0.2 c0.4-2.1,0.8-3.8,1.3-5c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0.1-0.2,0.1-0.3c0.3-0.6,0.6-1.2,1-1.7 C2965.5-918.4,3001.7-890.1,3000.4-885.9z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2880-738.7l-1.6,4.5c0,0-14.3-146.9-17.8-157.6c-3.6-10.7,17.8-20.9,17.8-20.9 C2883.8-897.4,2882.8-811.2,2880-738.7z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2942.3-738.2c0.2-6.5,0.4-13.1,0.7-19.7c2.1-57.1,6-117.3,10-137.8c0-0.1,0-0.1,0-0.2c0.5-2.2,0.9-3.9,1.3-5 c0.1-0.3,0.2-0.6,0.3-0.9c0.3-0.6,0.6-1.2,1-1.7c5.1,1.4,11.8,5.2,15.4,15.8C2975.1-875.3,2960.3-790.4,2942.3-738.2z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2862.9-717.8c0,0-1.8,13.6-20.8,20.9"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2953.4-717.8c0,0,1.8,13.6,20.8,20.9"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3032.4-779.4c-0.8,8-2.3,20.9-3.3,18.9c-1.5-3,0-18.4,0-18.4c0.4,1.5,0.7,2.4,0.7,2.4 S3030.8-777.6,3032.4-779.4z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M2992.1-998.5c-3.9,7.2-8.9,15.2-16.4,20.5c-2.8,2-5.8,3.5-9.3,4.6c-5.4,1.6-11.7,1.9-19.1,0.1 c-5.6-1.3-7.9-3.6-7.9-3.6s0.9,6.6,14.9,11.7c-8.9-1.6-19-0.4-23.2-11.9c0,0-1.5,1.7-3.3,4.8c-2.5,4.2-5.5,11.1-6.2,19.8 c-11.1-17.3-11.3-22.2-20-19.8c-8.7,2.4-3.8,15.7,1.8,18.6c4.2,2.3,0.2,12.9-2.6,18c-0.9,1.6-1.2,3-1.2,3s-1.4-19.2-16.6-27.8 c-4.1-2.3-7.8-5.9-10.7-10.4c-8-12.2-10.4-30.4,0.2-42.2c14.5-16.1,29.5-6.7,29.5-6.7s-1.4-33.1,23.8-42.4 c-12.2,12.7-13.8,25.5-13.9,26.5c0.2-1.2,4.2-20.5,29.5-23.3c26.2-3,26.6,24.2,26.6,24.2s0.6-8.1,15.7-6.7 c6.3,0.6,10.1,5.7,11.9,12.5C2998-1019.5,2996.5-1006.7,2992.1-998.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 2898.4036,
    y1: -953.7927,
    x2: 2980.094,
    y2: -897.4819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M2966.5-973.4c0,3.6-0.2,8.8-0.9,14.7c-1.8,15.9-7.2,36.5-23,42.2c-3.5,1.2-6.1-0.4-8.2-1.6 c0,0,0,0-0.1-0.1c-1.3-0.7-2.3-1.1-3.2-0.6c-1.5,0.8,0.1,6,0.9,12c0.6,4.4,0.8,9.3-0.9,13.1c-4.1,8.9-8.3,12.5-19.6,12.1 c-11.3-0.4-17.4-10.3-14.1-22c1.7-5.8,2.3-13.9,2.4-21.2c0-3.9-0.1-7.6-0.4-10.6c2.8-5.1,8.2-16.1,4-18.3 c-5.5-3-10.5-16.3-1.8-18.6c3.8-1.1,6-0.7,8.2,1.5c2.8,2.8,5.6,8.6,11.8,18.3c0.7-8.7,3.8-15.6,6.2-19.8c0.9-1.6,1.7-2.8,2.3-3.6 c0.1-0.2,0.3-0.4,0.4-0.5c0.4-0.5,0.6-0.7,0.6-0.7c4.2,11.5,14.3,10.3,23.2,11.9c-14-5.1-14.9-11.7-14.9-11.7s2.4,2.3,7.9,3.6 C2954.8-971.6,2961.1-971.8,2966.5-973.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M3432.8-952.2c0,0-41.4-62.4,11-89.4c52.3-27,88.9,18.9,79.6,57.1c-3.5,14.3,20.9,11.8,19.8,35.6 c-1.1,23.9-2.2,37,25.4,55c27.5,18,41,50.5,33.9,89c-7.1,38.5,46.8,74.2,32.5,121.7c-14.3,47.6-100,64.2-131.7,26.5 c-31.7-37.6-55.8-178.6-55.8-178.6l30.7-62.9l-12.9-48.2L3432.8-952.2z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M3584.9-262.7c0,0-0.4,0.4-1.1,1c-4,3.6-18.6,14.9-31.5,6.1c-0.5-0.4-1.1-1.1-1.8-2.1c0,0,0,0,0,0 c-3-4.8-7.1-16.7-11.8-33.3c-23.7-82.9-63.9-281.6-63.9-281.6l-13.5,148.2l-13.4,147.3l-3.3,35.7c0,0-25.4,5.7-43.2-6.2 c-0.4-5.5-0.6-12.2-0.8-20c-2.1-105.2,12.3-398.4,12.4-401.4c3.2,8.2,10.2,15.5,23.3,20c0,0,0,0,0,0c0.5,0.1,1,0.3,1.5,0.5 c4.5,1.4,9.6,2.5,15.5,3.2c37.5,4.4,69-3.8,81.5-17.3c0.6-0.7,1.2-1.4,1.8-2c5.4,12.5,10,32,12.9,54.5c2.8,21.6,4,46.1,2.6,69.8 c-2.7,45.5,20.3,198.9,29.2,256C3583.6-270.8,3584.9-262.7,3584.9-262.7z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M3554.6-885.7c-1.2,2.2-2.4,4.6-3.4,7.1c-0.4,1-0.9,2.1-1.3,3.1c-2.1,5.5-3.8,11.4-5.2,17.6 c-0.8,3.3-1.4,6.6-2,10c-0.3,1.4-0.5,2.9-0.7,4.3c-1.5,9.4-2.5,18.7-3.1,26.9c-0.1,1.4-0.2,2.8-0.3,4.1c-0.9,14-0.7,23.9-0.7,23.9 s-0.1,0.6-0.3,1.7c-0.2,1-0.4,2.5-0.7,4.3c-0.9,6-2.2,15.8-3.1,26.9c-0.1,1.3-0.2,2.7-0.3,4c-0.5,8.2-0.7,16.9-0.2,25.2 c0.1,1.3,0.2,2.5,0.3,3.8c0.5,5.5,1.3,10.7,2.5,15.3c0.7,2.6,1.3,4.9,1.9,7.1c0.3,1.2,0.6,2.3,0.9,3.3c3.3,11.8,5.1,17.6,3.7,22.8 c-0.5,1.8-1.4,3.6-2.7,5.5c-0.9,1.2-1.9,2.6-3.2,4c-0.6,0.6-1.2,1.3-1.8,2c-12.5,13.4-44,21.7-81.5,17.3 c-5.9-0.7-11.1-1.8-15.5-3.2c-14.1-4.4-21.5-12-24.9-20.5v0c-0.3-0.8-0.6-1.7-0.8-2.5c-0.4-1.1-0.6-2.3-0.8-3.4 c-0.8-4.2-0.7-8.4-0.2-12.6c0.5-3.5,1.6-8.3,3-14.2c0.4-1.4,0.7-2.9,1.1-4.5c1.6-6.7,3.5-14.4,5.2-22.5c0.3-1.1,0.5-2.3,0.7-3.5 c1.5-7.5,2.9-15.3,3.7-22.8c0.1-1.2,0.3-2.5,0.4-3.7c0.3-3.7,0.5-7.4,0.6-11c0-2.6,0-5.2-0.2-7.7c-0.2-2.3-0.4-4.5-0.8-6.7 c-0.3-1.6-0.6-3.1-1-4.5c0-0.1-0.1-0.3-0.1-0.4c-5.3-4.9-14.9-8.8-17.7-23.7c-0.2-0.9-0.3-1.9-0.5-2.9c0-0.2-0.1-0.5-0.1-0.7 c-0.5-4.4-0.4-9.8,0.4-16.2c0.5-3.5,0.8-6.8,1.2-9.9c0.2-1.4,0.3-2.8,0.4-4.1c1.1-10.9,1.5-19.5,2.3-26.5c0.2-1.5,0.4-2.9,0.6-4.2 c0.9-5.6,2.1-10.2,4.5-14.2c0.4-0.7,0.9-1.3,1.4-2c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.1-0.1 c6.4-7.5,21.1-14.1,37.8-19.2c6.1-1.8,12.4-3.4,18.7-4.8c12.6-2.8,23.9-2.2,33.8,0.2C3532.3-911.3,3548.6-892.9,3554.6-885.7z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M3574.6-800.3c-5.2,13.5-26.9,14.8-36.9,13.1c-2.3-0.4-3.9-0.9-4.7-1.4c-1.1-0.8-2.1-6.1-2.6-14.1 c-1.1-16.5-0.2-43.9,6-64.4c0.6-1.9,1.2-3.8,1.9-5.6c0.1-0.4,0.2-0.6,0.2-0.6c3-7.6,6.8-13.8,11.8-17.3c0,0,23.1,13.9,24.3,81.1 C3574.6-806.6,3574.7-803.5,3574.6-800.3z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M3425.6-777.3c-0.9,0.6-2.8,1-5.3,1.1c-3.1,0.1-7.1-0.2-11.5-1c-9.4-1.7-20.5-5.8-27.6-12.8 c-1.6-1.6-3-3.3-4.1-5.2c0.9-3.4,1.8-6.7,2.7-9.9c6.3-22.2,12.2-39.2,17.5-52.1c9.8-24,17-33.7,18.9-35.9c-0.5,0.7-1,1.3-1.4,2 c-6.5,11.3-4.8,26.8-8.9,58.9c-4.1,31.7,10.3,36.7,17.5,43.2c0.1,0.1,0.2,0.2,0.3,0.3C3424.7-785.3,3425.3-781.4,3425.6-777.3z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M3506.9-917.5c-5.8,14-18.1,41.4-27,43.6c-12.1,3-28.6-4.8-30.4-13.5c-1.3-6.6,2.8-19.5,4.9-25.5 c6.1-1.8,12.4-3.4,18.7-4.8C3485.7-920.5,3497-920,3506.9-917.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 3498.186,
    y1: -962.4501,
    x2: 3413.1289,
    y2: -924.3826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M3493.9-914.9c-0.3,3.1-1.2,8.8-8.9,21.1c-7.7,12.3-30.6,12.1-28,0c1.2-5.3,2.2-12.2,2.9-18.2 c1-7.7,1.6-14.1,1.6-14.1s-4.4,2.9-9.2,2.3c-0.1,0-0.2,0-0.2,0c-1.6-0.3-3.3-0.9-4.8-2.3c-13.1-11.2-16.8-32.2-17.5-48.7 c-0.6-13.2,0.8-23.6,0.8-23.6c19.9,19.3,44.6,10.7,48.5,11.6c0.9,0.2,2,0.7,3,1.4c3.3,2.3,6.5,7.4,4.4,15.6 c-2.7,10.7-5.7,12.5,7.4,23.5C3492.1-936.1,3494.2-918,3493.9-914.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 3598.8728,
    y1: -834.3294,
    x2: 3670.8428,
    y2: -623.1777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M3682.1-850.8c-3.1,9.1-20.2,8.8-37.3,24.2c-17.1,15.4-36.1,117.8-63.4,117.8c-29.8,0-41.8-31.4-46.7-56 c-0.2-0.9-0.4-1.8-0.5-2.7c-2.6-14.2-2.8-25.4-2.8-25.9c0.1,0.4,0.1,0.7,0.2,1s0.1,0.6,0.2,0.9c0,0.1,0.1,0.2,0.1,0.3 c0,0.2,0.1,0.5,0.2,0.7c0.2,0.6,0.4,1.1,0.6,1.5c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.6,2.5,1.1,4.7,1.4 c9.5,1.6,29.5,0.6,36-11c0.2-0.3,0.3-0.6,0.5-0.9c0.3,7.9,0.8,21.8,0.5,31.4c1.8-7.9,43-63.1,44.8-69.7c1.8-6.5-7.3-24.2,1.8-23.5 c9.1,0.8,11.3,16.1,15.5,16.1c4.2,0,15.2-5.8,23.3-7C3668.2-853,3683.7-855.5,3682.1-850.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 3421.8364,
    y1: -719.6588,
    x2: 3257.6726,
    y2: -927.4412
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCAAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCDAE"
    }
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M3420.4-776.3c-1.7,7.5-6.2,25.5-14.5,39.4c0,0,0,0,0,0c-6.1,10.1-14.2,18-24.6,18 c-24.7,0-44.3-53.8-61.9-116.3c-6.2-22.2-41-51.8-41.3-58.1c-0.3-6.3,34.2,9.1,46.1,15.8c7.1,4.1,4.2-14.2,9.8-17.3 c5.7-3.1,3.6,35.5,7.4,47.4c3.9,12,33.5,63.4,35.8,70c0.6-2.2,1.3-4.5,2.1-6.9c0.7-2,1.4-4,2-5.9c3.6,3.5,8.1,6.3,13,8.4 C3403.6-777.6,3414-776,3420.4-776.3z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M3550.5-257.8C3550.5-257.8,3550.5-257.8,3550.5-257.8"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3511.2-633.7c0,0,9.6,18.8,24.4,23.8"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3530-605.4c0,0,34.5,296.7,44.7,319.7"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3465.2-553.8c0,0-29.1,253.8-35.6,306.1"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M3444.6-180.8h-100.7c0,0-0.9-3.7-0.3-7.8c0.5-3.7,2.2-7.8,6.6-10.1c9.5-5,46-22.8,53.9-31.1 c7.9-8.3,6.3-12,10.1-12.2c0,0,21.7-1.7,24.2,1.5c2,2.5,4.5,36.3,5.6,52C3444.4-183.8,3444.6-180.8,3444.6-180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M3374-214c0,0,8.7,8.3,13.1,9.5s26.6-17.9,28.2-23.2c1.6-5.3,3.4-26.3,3.4-26.3s-13.5,0-18.1,0 s-4.1,24.8-4.1,24.8S3371.9-215.8,3374-214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M3444.6-180.8h-100.7c0,0-0.9-3.7-0.3-7.8H3444C3444.4-183.8,3444.6-180.8,3444.6-180.8z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M3609.9-180.8c0,0-3.6,0-60.8,0c0.2-1.8,0.5-4.5,0.9-7.8c1.3-13.5,3-36.5,0.5-46.4c-3-12-0.1-22.3,0-22.8 c0.7,1.1,1.3,1.8,1.8,2.1c12.9,8.8,27.5-2.5,31.5-6.1c7.9,12,18.6,59.7,22.9,67.6c1.1,2.1,1.9,3.9,2.4,5.5 C3610.8-183.4,3609.9-180.8,3609.9-180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M3553.2-267.9c0,0,4,26.2,5.2,30.1c1.2,4,7.5,28.6,12.3,31c4.8,2.3,9.5,4.6,10.7-0.9c1.2-5.5,0-34,0-38.4 c0-4.4,2.6-26.2,0.5-27.8C3579.8-275.4,3551.9-276.1,3553.2-267.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M3609.9-180.8c0,0-3.6,0-60.8,0c0.2-1.8,0.5-4.5,0.9-7.8h59.2C3610.8-183.4,3609.9-180.8,3609.9-180.8z"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M3238.7-1249.5v132.1c0,19.2-15.5,34.7-34.7,34.7h-169.3l-27.6,27.6c-3.9,3.9-10.5,1.1-10.5-4.3v-23.3 h-83.2c-3.4,0-6.1-2.8-6.1-6.1v-132.1c0-19.2,15.5-34.7,34.7-34.7h290.5C3236-1255.6,3238.7-1252.9,3238.7-1249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M3672.6-1222.3v134.5c0,2.8-2.2,5-5,5h-105.9l-27.6,27.6c-3.9,3.9-10.5,1.1-10.5-4.3v-23.3h-149 c-18.4,0-33.4-14.9-33.4-33.4v-134.5c0-2.8,2.2-5,5-5h292.9C3657.6-1255.6,3672.6-1240.7,3672.6-1222.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M3729.3-1084.4c0,32-25.9,57.9-57.9,57.9c-31.4,0-57-25-57.9-56.2h54.2c2.8,0,5-2.2,5-5v-54.6 C3704-1141.7,3729.3-1116,3729.3-1084.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3672.6-1142.4v54.6c0,2.8-2.2,5-5,5h-54.2c0-0.6,0-1.1,0-1.7c0-32,25.9-57.9,57.9-57.9 C3671.7-1142.4,3672.2-1142.4,3672.6-1142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2973.4-1277.2v21.5h-31.3c-19.2,0-34.7,15.5-34.7,34.7v37.2H2880c-13.1,0-23.7-10.6-23.7-23.7v-69.7 c0-13.1,10.6-23.7,23.7-23.7h69.7C2962.8-1300.9,2973.4-1290.3,2973.4-1277.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2973.4-1255.6v48.1c0,13.1-10.6,23.7-23.7,23.7h-42.2v-37.2c0-19.2,15.5-34.7,34.7-34.7H2973.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2734.7,
    y: -1049.6,
    className: "st6",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2762.5,
    y: -1024.2,
    className: "st3",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3759,
    y: -761.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 7582.2349 -1501.6853)",
    className: "st6",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3731.2,
    y: -735.8,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 7526.5781 -1450.9301)",
    className: "st3",
    width: 64.2,
    height: 20.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st211",
    x1: 2976.4,
    y1: -1203.6,
    x2: 3169.8,
    y2: -1203.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st211",
    x1: 2976.4,
    y1: -1167.7,
    x2: 3169.8,
    y2: -1167.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st211",
    x1: 2976.4,
    y1: -1131.8,
    x2: 3169.8,
    y2: -1131.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st211",
    x1: 3410.3,
    y1: -1205.3,
    x2: 3603.6,
    y2: -1205.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st211",
    x1: 3410.3,
    y1: -1169.4,
    x2: 3603.6,
    y2: -1169.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st211",
    x1: 3410.3,
    y1: -1133.4,
    x2: 3603.6,
    y2: -1133.4
  })))), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4106.2-154.6H2527.1c-7.2,0-13-5.8-13-13l0,0c0-7.2,5.8-13,13-13h1579.1c7.2,0,13,5.8,13,13l0,0 C4119.2-160.4,4113.4-154.6,4106.2-154.6z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 2428.1543 -1888.969)",
    style: {
      fontFamily: "'MyriadPro-Regular'",
      fontSize: "82.084px"
    }
  }, "37a000"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappiness);
export default __webpack_public_path__ + "static/media/happiness.bc5c687e661032d055e5783c681122f4.svg";
export { ForwardRef as ReactComponent };